// 2025 Federal Child Support Guidelines — Complete Table Data
// Applies: October 1, 2025 onward
// All 12 provinces/territories (Quebec excluded — not applicable)
// Source: justice.gc.ca official simplified PDFs
// Extracted: April 2026
// Over-$150k rates: monthly % applied directly to excess income

// Alberta — 2025 Federal Child Support Guidelines Table
const T_AB={
100000:[878, 1466, 1937, 2322],
100100:[879, 1467, 1939, 2324],
100200:[880, 1469, 1941, 2327],
100300:[881, 1470, 1943, 2329],
100400:[882, 1472, 1945, 2331],
100500:[883, 1473, 1946, 2333],
100600:[884, 1475, 1948, 2336],
100700:[885, 1476, 1950, 2338],
100800:[886, 1478, 1952, 2340],
100900:[887, 1479, 1954, 2342],
101000:[888, 1481, 1956, 2345],
101100:[889, 1482, 1958, 2347],
101200:[890, 1484, 1960, 2350],
101300:[891, 1485, 1962, 2352],
101400:[892, 1487, 1964, 2354],
101500:[893, 1488, 1966, 2356],
101600:[894, 1490, 1968, 2359],
101700:[895, 1491, 1970, 2361],
101800:[896, 1493, 1972, 2363],
101900:[896, 1494, 1974, 2366],
102000:[897, 1496, 1976, 2368],
102100:[898, 1497, 1978, 2370],
102200:[899, 1499, 1980, 2373],
102300:[900, 1500, 1982, 2375],
102400:[901, 1502, 1984, 2377],
102500:[902, 1503, 1986, 2380],
102600:[903, 1505, 1988, 2382],
102700:[904, 1506, 1989, 2384],
102800:[905, 1508, 1991, 2386],
102900:[906, 1509, 1993, 2389],
103000:[907, 1511, 1995, 2391],
103100:[908, 1512, 1997, 2393],
103200:[909, 1514, 1999, 2396],
103300:[910, 1515, 2001, 2398],
103400:[911, 1517, 2003, 2400],
103500:[912, 1518, 2004, 2403],
103600:[913, 1520, 2006, 2405],
103700:[914, 1521, 2008, 2407],
103800:[915, 1523, 2010, 2410],
103900:[916, 1524, 2012, 2412],
104000:[917, 1526, 2014, 2414],
104100:[918, 1527, 2016, 2416],
104200:[919, 1529, 2018, 2418],
104300:[920, 1530, 2020, 2421],
104400:[921, 1532, 2022, 2423],
104500:[922, 1533, 2024, 2425],
104600:[923, 1535, 2026, 2427],
104700:[924, 1536, 2028, 2430],
104800:[925, 1538, 2030, 2432],
104900:[925, 1539, 2032, 2434],
105000:[926, 1541, 2034, 2436],
105100:[927, 1542, 2036, 2438],
105200:[928, 1544, 2038, 2441],
105300:[929, 1545, 2040, 2443],
105400:[930, 1547, 2042, 2445],
105500:[931, 1548, 2044, 2447],
105600:[932, 1550, 2046, 2450],
105700:[933, 1551, 2048, 2452],
105800:[934, 1553, 2049, 2454],
105900:[935, 1554, 2051, 2456],
106000:[936, 1556, 2053, 2459],
106100:[937, 1558, 2055, 2461],
106200:[938, 1559, 2057, 2464],
106300:[939, 1561, 2059, 2466],
106400:[940, 1562, 2061, 2468],
106500:[941, 1564, 2063, 2470],
106600:[942, 1565, 2064, 2473],
106700:[943, 1567, 2066, 2475],
106800:[944, 1568, 2068, 2477],
106900:[945, 1570, 2070, 2479],
107000:[946, 1572, 2072, 2482],
107100:[947, 1573, 2074, 2484],
107200:[948, 1575, 2076, 2486],
107300:[949, 1576, 2078, 2489],
107400:[950, 1578, 2079, 2491],
107500:[951, 1579, 2081, 2493],
107600:[952, 1581, 2083, 2495],
107700:[953, 1582, 2085, 2497],
107800:[954, 1584, 2087, 2500],
107900:[955, 1585, 2089, 2502],
108000:[955, 1586, 2091, 2504],
108100:[956, 1587, 2093, 2506],
108200:[957, 1589, 2094, 2508],
108300:[958, 1590, 2096, 2510],
108400:[959, 1592, 2098, 2513],
108500:[960, 1593, 2100, 2515],
108600:[961, 1595, 2101, 2517],
108700:[962, 1596, 2103, 2519],
108800:[962, 1597, 2105, 2521],
108900:[963, 1599, 2107, 2523],
109000:[964, 1600, 2108, 2525],
109100:[965, 1601, 2110, 2527],
109200:[966, 1603, 2112, 2529],
109300:[967, 1604, 2113, 2531],
109400:[967, 1605, 2115, 2534],
109500:[968, 1607, 2117, 2536],
109600:[969, 1608, 2119, 2538],
109700:[970, 1609, 2120, 2540],
109800:[971, 1611, 2122, 2542],
109900:[972, 1612, 2124, 2544],
110000:[972, 1613, 2126, 2546],
110100:[973, 1614, 2128, 2548],
110200:[974, 1616, 2130, 2550],
110300:[975, 1617, 2131, 2552],
110400:[975, 1618, 2133, 2555],
110500:[976, 1620, 2135, 2557],
110600:[977, 1621, 2137, 2559],
110700:[978, 1623, 2138, 2561],
110800:[979, 1624, 2140, 2563],
110900:[980, 1625, 2142, 2565],
111000:[981, 1627, 2144, 2567],
111100:[982, 1628, 2146, 2569],
111200:[983, 1630, 2148, 2571],
111300:[984, 1631, 2149, 2573],
111400:[984, 1633, 2151, 2576],
111500:[985, 1634, 2153, 2578],
111600:[986, 1635, 2155, 2580],
111700:[987, 1637, 2157, 2582],
111800:[988, 1638, 2158, 2584],
111900:[989, 1639, 2160, 2586],
112000:[990, 1641, 2162, 2588],
112100:[991, 1642, 2164, 2590],
112200:[992, 1644, 2166, 2592],
112300:[993, 1645, 2167, 2594],
112400:[994, 1647, 2169, 2597],
112500:[994, 1648, 2171, 2599],
112600:[995, 1649, 2173, 2601],
112700:[996, 1651, 2175, 2603],
112800:[997, 1652, 2177, 2605],
112900:[998, 1654, 2178, 2607],
113000:[999, 1655, 2180, 2609],
113100:[1000, 1656, 2182, 2611],
113200:[1001, 1658, 2183, 2613],
113300:[1002, 1659, 2185, 2615],
113400:[1003, 1661, 2187, 2618],
113500:[1003, 1662, 2189, 2620],
113600:[1004, 1663, 2190, 2622],
113700:[1005, 1665, 2192, 2624],
113800:[1006, 1666, 2194, 2626],
113900:[1007, 1668, 2196, 2628],
114000:[1008, 1669, 2197, 2630],
114100:[1009, 1670, 2199, 2632],
114200:[1010, 1672, 2201, 2634],
114300:[1011, 1673, 2202, 2636],
114400:[1012, 1675, 2204, 2639],
114500:[1012, 1676, 2206, 2641],
114600:[1013, 1678, 2208, 2643],
114700:[1014, 1679, 2209, 2645],
114800:[1015, 1680, 2211, 2647],
114900:[1016, 1682, 2213, 2649],
115000:[1017, 1683, 2215, 2651],
115100:[1018, 1684, 2217, 2653],
115200:[1019, 1686, 2219, 2655],
115300:[1020, 1687, 2220, 2657],
115400:[1021, 1688, 2222, 2659],
115500:[1022, 1690, 2224, 2662],
115600:[1022, 1691, 2226, 2664],
115700:[1023, 1692, 2228, 2666],
115800:[1024, 1694, 2229, 2668],
115900:[1025, 1695, 2231, 2670],
116000:[1026, 1696, 2233, 2672],
116100:[1027, 1697, 2235, 2674],
116200:[1028, 1699, 2237, 2676],
116300:[1029, 1700, 2238, 2678],
116400:[1030, 1701, 2240, 2680],
116500:[1031, 1703, 2242, 2683],
116600:[1032, 1704, 2244, 2685],
116700:[1032, 1706, 2246, 2687],
116800:[1033, 1707, 2248, 2689],
116900:[1034, 1708, 2249, 2691],
117000:[1035, 1710, 2251, 2693],
117100:[1036, 1711, 2253, 2695],
117200:[1037, 1713, 2254, 2697],
117300:[1038, 1714, 2256, 2699],
117400:[1039, 1716, 2258, 2701],
117500:[1040, 1717, 2260, 2704],
117600:[1041, 1718, 2261, 2706],
117700:[1042, 1720, 2263, 2708],
117800:[1042, 1721, 2265, 2710],
117900:[1043, 1722, 2267, 2712],
118000:[1044, 1724, 2268, 2714],
118100:[1045, 1725, 2270, 2716],
118200:[1046, 1727, 2272, 2718],
118300:[1047, 1728, 2273, 2720],
118400:[1047, 1730, 2275, 2722],
118500:[1048, 1731, 2277, 2725],
118600:[1049, 1732, 2279, 2727],
118700:[1050, 1734, 2280, 2729],
118800:[1051, 1735, 2282, 2731],
118900:[1052, 1737, 2284, 2733],
119000:[1052, 1738, 2286, 2735],
119100:[1053, 1739, 2288, 2737],
119200:[1054, 1741, 2290, 2739],
119300:[1055, 1742, 2291, 2741],
119400:[1055, 1744, 2293, 2743],
119500:[1056, 1745, 2295, 2746],
119600:[1057, 1746, 2297, 2748],
119700:[1058, 1748, 2298, 2750],
119800:[1059, 1749, 2300, 2752],
119900:[1060, 1751, 2302, 2754],
120000:[1061, 1752, 2304, 2756],
120100:[1062, 1753, 2306, 2758],
120200:[1063, 1755, 2308, 2760],
120300:[1064, 1756, 2309, 2762],
120400:[1064, 1758, 2311, 2764],
120500:[1065, 1759, 2313, 2767],
120600:[1066, 1761, 2315, 2769],
120700:[1067, 1762, 2317, 2771],
120800:[1068, 1763, 2318, 2773],
120900:[1069, 1765, 2320, 2775],
121000:[1070, 1766, 2322, 2777],
121100:[1071, 1767, 2324, 2779],
121200:[1072, 1769, 2326, 2781],
121300:[1073, 1770, 2327, 2783],
121400:[1074, 1771, 2329, 2785],
121500:[1074, 1773, 2331, 2788],
121600:[1075, 1774, 2333, 2790],
121700:[1076, 1775, 2335, 2792],
121800:[1077, 1777, 2337, 2794],
121900:[1078, 1778, 2338, 2796],
122000:[1079, 1779, 2340, 2798],
122100:[1080, 1780, 2342, 2800],
122200:[1081, 1782, 2343, 2802],
122300:[1082, 1783, 2345, 2804],
122400:[1083, 1784, 2347, 2806],
122500:[1083, 1786, 2349, 2809],
122600:[1084, 1787, 2350, 2811],
122700:[1085, 1789, 2352, 2813],
122800:[1086, 1790, 2354, 2815],
122900:[1087, 1791, 2356, 2817],
123000:[1088, 1793, 2357, 2819],
123100:[1089, 1794, 2359, 2821],
123200:[1090, 1796, 2361, 2823],
123300:[1091, 1797, 2362, 2825],
123400:[1092, 1799, 2364, 2827],
123500:[1092, 1800, 2366, 2830],
123600:[1093, 1801, 2368, 2832],
123700:[1094, 1803, 2369, 2834],
123800:[1095, 1804, 2371, 2836],
123900:[1096, 1805, 2373, 2838],
124000:[1097, 1807, 2375, 2840],
124100:[1098, 1808, 2377, 2842],
124200:[1099, 1810, 2379, 2844],
124300:[1100, 1811, 2380, 2846],
124400:[1101, 1813, 2382, 2848],
124500:[1102, 1814, 2384, 2851],
124600:[1102, 1815, 2386, 2853],
124700:[1103, 1817, 2388, 2855],
124800:[1104, 1818, 2389, 2857],
124900:[1105, 1820, 2391, 2859],
125000:[1106, 1821, 2393, 2861],
125100:[1107, 1822, 2395, 2863],
125200:[1108, 1824, 2397, 2865],
125300:[1109, 1825, 2398, 2867],
125400:[1110, 1827, 2400, 2869],
125500:[1111, 1828, 2402, 2872],
125600:[1112, 1830, 2404, 2874],
125700:[1112, 1831, 2406, 2876],
125800:[1113, 1832, 2408, 2878],
125900:[1114, 1834, 2409, 2880],
126000:[1115, 1835, 2411, 2882],
126100:[1116, 1836, 2413, 2884],
126200:[1117, 1838, 2414, 2886],
126300:[1118, 1839, 2416, 2888],
126400:[1119, 1840, 2418, 2890],
126500:[1120, 1842, 2420, 2893],
126600:[1121, 1843, 2421, 2895],
126700:[1122, 1844, 2423, 2897],
126800:[1122, 1846, 2425, 2899],
126900:[1123, 1847, 2427, 2901],
127000:[1124, 1848, 2428, 2903],
127100:[1125, 1849, 2430, 2905],
127200:[1126, 1851, 2432, 2907],
127300:[1127, 1852, 2433, 2909],
127400:[1127, 1853, 2435, 2911],
127500:[1128, 1855, 2437, 2914],
127600:[1129, 1856, 2439, 2916],
127700:[1130, 1857, 2440, 2918],
127800:[1131, 1859, 2442, 2920],
127900:[1132, 1860, 2444, 2922],
128000:[1132, 1862, 2446, 2924],
128100:[1133, 1863, 2448, 2926],
128200:[1134, 1865, 2450, 2928],
128300:[1135, 1866, 2451, 2930],
128400:[1135, 1867, 2453, 2932],
128500:[1136, 1869, 2455, 2935],
128600:[1137, 1870, 2457, 2937],
128700:[1138, 1872, 2458, 2939],
128800:[1139, 1873, 2460, 2941],
128900:[1140, 1874, 2462, 2943],
129000:[1141, 1876, 2464, 2945],
129100:[1142, 1877, 2466, 2947],
129200:[1143, 1879, 2468, 2949],
129300:[1144, 1880, 2469, 2951],
129400:[1144, 1882, 2471, 2953],
129500:[1145, 1883, 2473, 2956],
129600:[1146, 1884, 2475, 2958],
129700:[1147, 1886, 2477, 2960],
129800:[1148, 1887, 2478, 2962],
129900:[1149, 1888, 2480, 2964],
130000:[1150, 1890, 2482, 2966],
130100:[1151, 1891, 2484, 2968],
130200:[1152, 1893, 2486, 2970],
130300:[1153, 1894, 2487, 2972],
130400:[1154, 1896, 2489, 2974],
130500:[1154, 1897, 2491, 2977],
130600:[1155, 1898, 2493, 2979],
130700:[1156, 1900, 2495, 2981],
130800:[1157, 1901, 2497, 2983],
130900:[1158, 1903, 2498, 2985],
131000:[1159, 1904, 2500, 2987],
131100:[1160, 1905, 2502, 2989],
131200:[1161, 1907, 2503, 2991],
131300:[1162, 1908, 2505, 2993],
131400:[1163, 1910, 2507, 2995],
131500:[1163, 1911, 2509, 2998],
131600:[1164, 1913, 2510, 3000],
131700:[1165, 1914, 2512, 3002],
131800:[1166, 1915, 2514, 3004],
131900:[1167, 1917, 2516, 3006],
132000:[1168, 1918, 2517, 3008],
132100:[1169, 1919, 2519, 3010],
132200:[1170, 1921, 2521, 3012],
132300:[1171, 1922, 2522, 3014],
132400:[1172, 1923, 2524, 3016],
132500:[1172, 1925, 2526, 3019],
132600:[1173, 1926, 2528, 3021],
132700:[1174, 1927, 2529, 3023],
132800:[1175, 1929, 2531, 3025],
132900:[1176, 1930, 2533, 3027],
133000:[1177, 1931, 2535, 3029],
133100:[1178, 1932, 2537, 3031],
133200:[1179, 1934, 2539, 3033],
133300:[1180, 1935, 2540, 3035],
133400:[1181, 1936, 2542, 3037],
133500:[1182, 1938, 2544, 3040],
133600:[1182, 1939, 2546, 3042],
133700:[1183, 1940, 2548, 3044],
133800:[1184, 1942, 2549, 3046],
133900:[1185, 1943, 2551, 3048],
134000:[1186, 1945, 2553, 3050],
134100:[1187, 1946, 2555, 3052],
134200:[1188, 1948, 2557, 3054],
134300:[1189, 1949, 2558, 3056],
134400:[1190, 1950, 2560, 3058],
134500:[1191, 1952, 2562, 3061],
134600:[1192, 1953, 2564, 3063],
134700:[1192, 1955, 2566, 3065],
134800:[1193, 1956, 2568, 3067],
134900:[1194, 1957, 2569, 3069],
135000:[1195, 1959, 2571, 3071],
135100:[1196, 1960, 2573, 3073],
135200:[1197, 1962, 2574, 3075],
135300:[1198, 1963, 2576, 3077],
135400:[1199, 1965, 2578, 3079],
135500:[1200, 1966, 2580, 3082],
135600:[1201, 1967, 2581, 3084],
135700:[1202, 1969, 2583, 3086],
135800:[1202, 1970, 2585, 3088],
135900:[1203, 1972, 2587, 3090],
136000:[1204, 1973, 2588, 3092],
136100:[1205, 1974, 2590, 3094],
136200:[1206, 1976, 2592, 3096],
136300:[1207, 1977, 2593, 3098],
136400:[1207, 1979, 2595, 3100],
136500:[1208, 1980, 2597, 3103],
136600:[1209, 1981, 2599, 3105],
136700:[1210, 1983, 2600, 3107],
136800:[1211, 1984, 2602, 3109],
136900:[1212, 1986, 2604, 3111],
137000:[1212, 1987, 2606, 3113],
137100:[1213, 1988, 2608, 3115],
137200:[1214, 1990, 2610, 3117],
137300:[1215, 1991, 2611, 3119],
137400:[1215, 1993, 2613, 3121],
137500:[1216, 1994, 2615, 3124],
137600:[1217, 1996, 2617, 3126],
137700:[1218, 1997, 2618, 3128],
137800:[1219, 1998, 2620, 3130],
137900:[1220, 2000, 2622, 3132],
138000:[1221, 2001, 2624, 3134],
138100:[1222, 2002, 2626, 3136],
138200:[1223, 2004, 2628, 3138],
138300:[1224, 2005, 2629, 3140],
138400:[1224, 2006, 2631, 3142],
138500:[1225, 2008, 2633, 3145],
138600:[1226, 2009, 2635, 3147],
138700:[1227, 2010, 2637, 3149],
138800:[1228, 2012, 2638, 3151],
138900:[1229, 2013, 2640, 3153],
139000:[1230, 2014, 2642, 3155],
139100:[1231, 2015, 2644, 3157],
139200:[1232, 2017, 2646, 3159],
139300:[1233, 2018, 2647, 3161],
139400:[1234, 2019, 2649, 3163],
139500:[1234, 2021, 2651, 3166],
139600:[1235, 2022, 2653, 3168],
139700:[1236, 2024, 2655, 3170],
139800:[1237, 2025, 2657, 3172],
139900:[1238, 2026, 2658, 3174],
140000:[1239, 2028, 2660, 3176],
140100:[1240, 2029, 2662, 3178],
140200:[1241, 2031, 2663, 3180],
140300:[1242, 2032, 2665, 3182],
140400:[1243, 2034, 2667, 3184],
140500:[1243, 2035, 2669, 3186],
140600:[1244, 2036, 2670, 3189],
140700:[1245, 2038, 2672, 3191],
140800:[1246, 2039, 2674, 3193],
140900:[1247, 2040, 2676, 3195],
141000:[1248, 2042, 2677, 3197],
141100:[1249, 2043, 2679, 3199],
141200:[1250, 2045, 2681, 3201],
141300:[1251, 2046, 2682, 3203],
141400:[1252, 2048, 2684, 3205],
141500:[1252, 2049, 2686, 3207],
141600:[1253, 2050, 2688, 3210],
141700:[1254, 2052, 2689, 3212],
141800:[1255, 2053, 2691, 3214],
141900:[1256, 2055, 2693, 3216],
142000:[1257, 2056, 2695, 3218],
142100:[1258, 2057, 2697, 3220],
142200:[1259, 2059, 2699, 3222],
142300:[1260, 2060, 2700, 3224],
142400:[1261, 2062, 2702, 3226],
142500:[1262, 2063, 2704, 3228],
142600:[1262, 2064, 2706, 3231],
142700:[1263, 2066, 2708, 3233],
142800:[1264, 2067, 2709, 3235],
142900:[1265, 2069, 2711, 3237],
143000:[1266, 2070, 2713, 3239],
143100:[1267, 2071, 2715, 3241],
143200:[1268, 2073, 2716, 3243],
143300:[1268, 2074, 2718, 3245],
143400:[1269, 2075, 2720, 3247],
143500:[1270, 2077, 2722, 3249],
143600:[1271, 2078, 2723, 3251],
143700:[1272, 2079, 2725, 3253],
143800:[1273, 2081, 2727, 3255],
143900:[1273, 2082, 2728, 3257],
144000:[1274, 2083, 2730, 3259],
144100:[1275, 2084, 2732, 3261],
144200:[1276, 2086, 2733, 3263],
144300:[1277, 2087, 2735, 3265],
144400:[1277, 2088, 2737, 3267],
144500:[1278, 2089, 2738, 3269],
144600:[1279, 2091, 2740, 3271],
144700:[1280, 2092, 2742, 3273],
144800:[1281, 2093, 2744, 3276],
144900:[1282, 2095, 2745, 3278],
145000:[1283, 2096, 2747, 3280],
145100:[1284, 2097, 2749, 3282],
145200:[1285, 2099, 2750, 3284],
145300:[1286, 2100, 2752, 3286],
145400:[1287, 2101, 2754, 3288],
145500:[1288, 2103, 2755, 3290],
145600:[1288, 2104, 2757, 3292],
145700:[1289, 2105, 2759, 3294],
145800:[1290, 2107, 2760, 3296],
145900:[1291, 2108, 2762, 3298],
146000:[1292, 2110, 2764, 3300],
146100:[1293, 2111, 2766, 3302],
146200:[1294, 2113, 2768, 3304],
146300:[1295, 2114, 2769, 3306],
146400:[1295, 2115, 2771, 3308],
146500:[1296, 2117, 2773, 3310],
146600:[1297, 2118, 2775, 3312],
146700:[1298, 2119, 2776, 3314],
146800:[1299, 2121, 2778, 3316],
146900:[1300, 2122, 2780, 3318],
147000:[1300, 2123, 2782, 3320],
147100:[1301, 2124, 2784, 3322],
147200:[1302, 2126, 2785, 3324],
147300:[1303, 2127, 2787, 3326],
147400:[1304, 2128, 2789, 3328],
147500:[1304, 2130, 2791, 3330],
147600:[1305, 2131, 2792, 3332],
147700:[1306, 2133, 2794, 3334],
147800:[1307, 2134, 2796, 3336],
147900:[1308, 2135, 2798, 3339],
148000:[1309, 2137, 2799, 3341],
148100:[1310, 2138, 2801, 3343],
148200:[1311, 2140, 2802, 3345],
148300:[1311, 2141, 2804, 3347],
148400:[1312, 2142, 2806, 3349],
148500:[1313, 2144, 2808, 3351],
148600:[1314, 2145, 2809, 3353],
148700:[1315, 2146, 2811, 3355],
148800:[1316, 2148, 2813, 3357],
148900:[1316, 2149, 2814, 3359],
149000:[1317, 2150, 2816, 3361],
149100:[1318, 2151, 2818, 3363],
149200:[1319, 2153, 2819, 3365],
149300:[1320, 2154, 2821, 3367],
149400:[1320, 2155, 2823, 3369],
149500:[1321, 2156, 2824, 3371],
149600:[1322, 2158, 2826, 3373],
149700:[1323, 2159, 2828, 3375],
149800:[1324, 2160, 2829, 3377],
149900:[1325, 2162, 2831, 3379],
150000:[1326, 2163, 2833, 3381],
16000:[0, 0, 0, 0],
16100:[8, 9, 10, 10],
16200:[16, 18, 19, 20],
16300:[25, 26, 29, 31],
16400:[33, 35, 38, 41],
16500:[41, 44, 48, 51],
16600:[49, 53, 57, 61],
16700:[57, 62, 67, 71],
16800:[66, 70, 76, 82],
16900:[74, 79, 86, 92],
17000:[82, 88, 95, 102],
17100:[83, 93, 100, 107],
17200:[84, 98, 105, 113],
17300:[85, 102, 111, 118],
17400:[86, 107, 116, 124],
17500:[87, 112, 121, 129],
17600:[88, 117, 126, 135],
17700:[89, 121, 131, 140],
17800:[90, 126, 136, 146],
17900:[91, 131, 142, 151],
18000:[92, 136, 147, 157],
18100:[93, 140, 152, 162],
18200:[94, 145, 156, 167],
18300:[95, 149, 161, 172],
18400:[96, 154, 166, 177],
18500:[97, 158, 171, 182],
18600:[98, 162, 175, 187],
18700:[99, 167, 180, 193],
18800:[100, 171, 185, 198],
18900:[101, 175, 190, 203],
19000:[102, 180, 194, 208],
19100:[103, 184, 199, 213],
19200:[104, 189, 203, 218],
19300:[105, 193, 208, 223],
19400:[106, 197, 213, 228],
19500:[107, 202, 217, 233],
19600:[108, 206, 222, 238],
19700:[109, 210, 226, 243],
19800:[110, 214, 231, 248],
19900:[111, 219, 236, 252],
20000:[112, 223, 240, 257],
20100:[113, 227, 245, 262],
20200:[114, 232, 249, 267],
20300:[115, 236, 254, 272],
20400:[116, 240, 259, 277],
20500:[117, 244, 263, 282],
20600:[118, 249, 268, 287],
20700:[119, 253, 273, 292],
20800:[120, 257, 277, 297],
20900:[121, 262, 282, 302],
21000:[121, 266, 287, 307],
21100:[122, 270, 292, 312],
21200:[123, 275, 296, 317],
21300:[124, 279, 301, 322],
21400:[125, 283, 306, 327],
21500:[126, 287, 310, 332],
21600:[127, 292, 315, 337],
21700:[128, 296, 319, 342],
21800:[129, 300, 324, 347],
21900:[130, 305, 329, 352],
22000:[131, 309, 333, 357],
22100:[132, 313, 337, 362],
22200:[133, 317, 342, 367],
22300:[134, 322, 346, 371],
22400:[135, 326, 351, 376],
22500:[136, 330, 355, 381],
22600:[137, 334, 360, 386],
22700:[138, 338, 364, 391],
22800:[139, 342, 369, 396],
22900:[140, 347, 373, 400],
23000:[141, 351, 378, 405],
23100:[142, 355, 382, 410],
23200:[143, 359, 387, 414],
23300:[144, 363, 391, 419],
23400:[145, 367, 396, 424],
23500:[146, 371, 400, 428],
23600:[147, 376, 404, 433],
23700:[148, 380, 409, 438],
23800:[149, 384, 413, 442],
23900:[150, 388, 417, 447],
24000:[151, 392, 422, 452],
24100:[152, 396, 426, 456],
24200:[153, 399, 430, 461],
24300:[154, 403, 434, 465],
24400:[155, 407, 438, 469],
24500:[156, 411, 442, 473],
24600:[157, 414, 446, 478],
24700:[158, 418, 450, 482],
24800:[159, 422, 454, 486],
24900:[160, 425, 458, 491],
25000:[161, 429, 462, 495],
25100:[162, 432, 466, 499],
25200:[163, 436, 469, 503],
25300:[164, 439, 473, 506],
25400:[165, 442, 476, 510],
25500:[166, 446, 480, 514],
25600:[167, 449, 483, 518],
25700:[168, 452, 487, 522],
25800:[169, 455, 490, 525],
25900:[170, 459, 494, 529],
26000:[171, 462, 497, 533],
26100:[172, 463, 500, 537],
26200:[173, 463, 504, 540],
26300:[174, 464, 507, 544],
26400:[175, 465, 511, 548],
26500:[176, 465, 514, 552],
26600:[177, 466, 518, 555],
26700:[178, 466, 521, 559],
26800:[179, 467, 525, 563],
26900:[180, 468, 528, 567],
27000:[181, 468, 532, 570],
27100:[182, 468, 536, 574],
27200:[183, 468, 539, 578],
27300:[184, 469, 543, 581],
27400:[185, 469, 546, 585],
27500:[186, 469, 550, 589],
27600:[187, 469, 553, 593],
27700:[188, 470, 557, 596],
27800:[189, 470, 560, 600],
27900:[190, 470, 564, 604],
28000:[191, 470, 568, 608],
28100:[192, 470, 572, 612],
28200:[193, 470, 575, 616],
28300:[194, 470, 579, 619],
28400:[195, 471, 582, 623],
28500:[196, 471, 586, 627],
28600:[197, 471, 589, 631],
28700:[198, 471, 593, 634],
28800:[199, 471, 596, 638],
28900:[200, 471, 600, 642],
29000:[201, 472, 603, 646],
29100:[202, 472, 607, 650],
29200:[203, 472, 610, 654],
29300:[204, 472, 614, 657],
29400:[205, 472, 617, 661],
29500:[206, 472, 621, 665],
29600:[207, 473, 624, 669],
29700:[208, 473, 628, 673],
29800:[209, 473, 631, 676],
29900:[210, 473, 635, 680],
30000:[211, 473, 638, 684],
30100:[212, 473, 640, 688],
30200:[213, 474, 642, 691],
30300:[214, 474, 644, 695],
30400:[215, 474, 646, 699],
30500:[216, 474, 648, 703],
30600:[217, 475, 650, 706],
30700:[218, 475, 652, 710],
30800:[219, 475, 654, 714],
30900:[220, 475, 656, 718],
31000:[221, 476, 658, 721],
31100:[222, 477, 659, 725],
31200:[223, 477, 660, 729],
31300:[224, 478, 661, 732],
31400:[225, 478, 662, 736],
31500:[226, 479, 663, 740],
31600:[227, 480, 664, 744],
31700:[228, 480, 665, 747],
31800:[229, 481, 666, 751],
31900:[230, 481, 667, 755],
32000:[231, 482, 668, 759],
32100:[232, 483, 669, 763],
32200:[233, 483, 670, 766],
32300:[234, 484, 671, 770],
32400:[235, 484, 672, 774],
32500:[236, 485, 673, 777],
32600:[237, 485, 674, 781],
32700:[238, 486, 675, 785],
32800:[239, 486, 676, 788],
32900:[240, 487, 677, 792],
33000:[241, 487, 678, 796],
33100:[242, 487, 679, 799],
33200:[242, 488, 680, 803],
33300:[243, 488, 681, 806],
33400:[244, 489, 681, 810],
33500:[244, 489, 682, 813],
33600:[245, 490, 683, 817],
33700:[246, 490, 684, 820],
33800:[247, 490, 685, 823],
33900:[247, 491, 686, 827],
34000:[248, 491, 686, 830],
34100:[248, 492, 687, 833],
34200:[248, 493, 688, 836],
34300:[249, 493, 690, 839],
34400:[249, 494, 691, 842],
34500:[249, 495, 692, 845],
34600:[249, 496, 693, 848],
34700:[250, 496, 694, 851],
34800:[250, 497, 695, 854],
34900:[250, 498, 697, 857],
35000:[250, 499, 698, 860],
35100:[251, 500, 700, 862],
35200:[251, 501, 701, 864],
35300:[252, 502, 703, 866],
35400:[253, 503, 704, 867],
35500:[253, 505, 706, 869],
35600:[254, 506, 707, 871],
35700:[255, 507, 709, 873],
35800:[255, 508, 710, 875],
35900:[256, 509, 712, 877],
36000:[257, 510, 713, 879],
36100:[258, 512, 715, 881],
36200:[259, 513, 717, 884],
36300:[260, 515, 719, 886],
36400:[261, 516, 721, 888],
36500:[262, 518, 723, 891],
36600:[263, 519, 725, 893],
36700:[264, 521, 727, 896],
36800:[265, 522, 729, 898],
36900:[266, 524, 731, 900],
37000:[267, 526, 733, 903],
37100:[268, 528, 735, 905],
37200:[269, 529, 737, 908],
37300:[270, 531, 739, 910],
37400:[271, 532, 741, 912],
37500:[272, 534, 743, 915],
37600:[273, 535, 745, 917],
37700:[274, 537, 747, 919],
37800:[275, 538, 749, 922],
37900:[276, 540, 751, 924],
38000:[277, 541, 753, 926],
38100:[278, 543, 755, 928],
38200:[279, 544, 757, 931],
38300:[280, 546, 759, 933],
38400:[281, 547, 761, 935],
38500:[282, 549, 763, 938],
38600:[283, 550, 765, 940],
38700:[284, 552, 766, 942],
38800:[285, 554, 768, 945],
38900:[286, 555, 770, 947],
39000:[287, 557, 772, 949],
39100:[288, 559, 774, 951],
39200:[289, 560, 776, 954],
39300:[290, 562, 778, 956],
39400:[291, 563, 780, 958],
39500:[292, 565, 782, 960],
39600:[293, 566, 784, 963],
39700:[294, 568, 786, 965],
39800:[295, 569, 788, 967],
39900:[296, 571, 790, 970],
40000:[297, 572, 792, 972],
40100:[298, 573, 794, 974],
40200:[299, 575, 796, 977],
40300:[300, 576, 798, 979],
40400:[301, 578, 800, 981],
40500:[302, 579, 801, 983],
40600:[303, 581, 803, 986],
40700:[303, 582, 805, 988],
40800:[304, 584, 807, 990],
40900:[305, 585, 809, 992],
41000:[306, 587, 811, 995],
41100:[307, 589, 813, 997],
41200:[308, 590, 815, 999],
41300:[309, 592, 817, 1002],
41400:[310, 593, 819, 1004],
41500:[311, 595, 820, 1006],
41600:[312, 596, 822, 1008],
41700:[313, 598, 824, 1011],
41800:[314, 599, 826, 1013],
41900:[315, 601, 828, 1015],
42000:[316, 602, 830, 1017],
42100:[317, 603, 832, 1019],
42200:[318, 605, 834, 1021],
42300:[319, 606, 836, 1024],
42400:[320, 608, 838, 1026],
42500:[321, 609, 839, 1028],
42600:[322, 611, 841, 1030],
42700:[323, 612, 843, 1032],
42800:[324, 613, 845, 1034],
42900:[325, 615, 847, 1037],
43000:[326, 616, 849, 1039],
43100:[327, 618, 851, 1041],
43200:[328, 619, 853, 1044],
43300:[329, 621, 855, 1046],
43400:[330, 622, 857, 1048],
43500:[331, 624, 858, 1050],
43600:[332, 625, 860, 1053],
43700:[333, 627, 862, 1055],
43800:[334, 628, 864, 1057],
43900:[335, 630, 866, 1059],
44000:[336, 632, 868, 1062],
44100:[337, 634, 870, 1064],
44200:[338, 635, 872, 1067],
44300:[339, 637, 874, 1069],
44400:[340, 638, 876, 1071],
44500:[341, 640, 878, 1074],
44600:[343, 642, 880, 1076],
44700:[344, 643, 882, 1078],
44800:[345, 645, 884, 1081],
44900:[346, 647, 886, 1083],
45000:[347, 648, 888, 1085],
45100:[348, 650, 890, 1087],
45200:[350, 652, 892, 1090],
45300:[351, 654, 895, 1092],
45400:[353, 655, 897, 1095],
45500:[354, 657, 899, 1097],
45600:[355, 659, 901, 1100],
45700:[357, 661, 903, 1102],
45800:[358, 663, 906, 1104],
45900:[359, 665, 908, 1107],
46000:[361, 666, 910, 1109],
46100:[362, 668, 912, 1112],
46200:[364, 670, 914, 1114],
46300:[365, 672, 917, 1117],
46400:[367, 673, 919, 1119],
46500:[368, 675, 921, 1122],
46600:[370, 677, 923, 1124],
46700:[371, 679, 926, 1127],
46800:[372, 681, 928, 1130],
46900:[374, 683, 930, 1132],
47000:[375, 684, 932, 1135],
47100:[376, 685, 934, 1137],
47200:[377, 687, 936, 1139],
47300:[378, 688, 938, 1142],
47400:[379, 690, 940, 1144],
47500:[380, 691, 942, 1146],
47600:[381, 693, 943, 1148],
47700:[382, 694, 945, 1151],
47800:[383, 696, 947, 1153],
47900:[384, 697, 949, 1155],
48000:[385, 699, 951, 1157],
48100:[386, 700, 953, 1159],
48200:[387, 702, 955, 1161],
48300:[388, 703, 956, 1163],
48400:[389, 705, 958, 1166],
48500:[390, 706, 960, 1168],
48600:[391, 707, 962, 1170],
48700:[391, 709, 964, 1172],
48800:[392, 710, 966, 1174],
48900:[393, 711, 967, 1176],
49000:[394, 713, 969, 1178],
49100:[395, 714, 971, 1180],
49200:[396, 716, 973, 1182],
49300:[397, 717, 974, 1185],
49400:[398, 719, 976, 1187],
49500:[399, 720, 978, 1189],
49600:[400, 722, 980, 1191],
49700:[400, 723, 982, 1193],
49800:[401, 725, 983, 1196],
49900:[402, 726, 985, 1198],
50000:[403, 728, 987, 1200],
50100:[404, 729, 989, 1202],
50200:[405, 731, 991, 1204],
50300:[406, 732, 993, 1207],
50400:[407, 734, 994, 1209],
50500:[408, 735, 996, 1211],
50600:[409, 737, 998, 1213],
50700:[410, 738, 1000, 1215],
50800:[411, 739, 1002, 1218],
50900:[412, 741, 1004, 1220],
51000:[413, 742, 1006, 1222],
51100:[414, 743, 1008, 1224],
51200:[415, 745, 1010, 1227],
51300:[416, 746, 1012, 1229],
51400:[417, 748, 1013, 1231],
51500:[418, 749, 1015, 1233],
51600:[419, 751, 1017, 1236],
51700:[420, 752, 1019, 1238],
51800:[421, 754, 1021, 1240],
51900:[422, 755, 1023, 1242],
52000:[422, 757, 1025, 1245],
52100:[423, 758, 1027, 1247],
52200:[424, 760, 1029, 1249],
52300:[425, 761, 1031, 1252],
52400:[426, 763, 1033, 1254],
52500:[427, 764, 1034, 1256],
52600:[427, 766, 1036, 1258],
52700:[428, 767, 1038, 1261],
52800:[429, 769, 1040, 1263],
52900:[430, 770, 1042, 1265],
53000:[431, 772, 1044, 1267],
53100:[432, 774, 1046, 1269],
53200:[433, 775, 1048, 1272],
53300:[434, 777, 1050, 1274],
53400:[435, 778, 1052, 1276],
53500:[436, 780, 1054, 1278],
53600:[437, 781, 1056, 1281],
53700:[438, 783, 1058, 1283],
53800:[439, 784, 1060, 1285],
53900:[440, 786, 1062, 1288],
54000:[441, 787, 1064, 1290],
54100:[442, 788, 1066, 1292],
54200:[443, 790, 1068, 1294],
54300:[444, 791, 1070, 1296],
54400:[445, 793, 1071, 1298],
54500:[445, 794, 1073, 1301],
54600:[446, 795, 1075, 1303],
54700:[447, 797, 1077, 1305],
54800:[448, 798, 1079, 1307],
54900:[449, 800, 1081, 1309],
55000:[450, 801, 1082, 1311],
55100:[451, 802, 1084, 1313],
55200:[452, 804, 1086, 1315],
55300:[453, 805, 1088, 1318],
55400:[454, 807, 1089, 1320],
55500:[454, 808, 1091, 1322],
55600:[455, 809, 1093, 1324],
55700:[456, 811, 1095, 1326],
55800:[457, 812, 1097, 1328],
55900:[458, 814, 1099, 1331],
56000:[459, 815, 1100, 1333],
56100:[460, 816, 1102, 1335],
56200:[461, 818, 1104, 1337],
56300:[462, 819, 1106, 1339],
56400:[463, 821, 1107, 1342],
56500:[463, 822, 1109, 1344],
56600:[464, 823, 1111, 1346],
56700:[465, 825, 1113, 1348],
56800:[466, 826, 1115, 1350],
56900:[467, 828, 1117, 1352],
57000:[468, 829, 1118, 1354],
57100:[469, 830, 1120, 1356],
57200:[470, 832, 1122, 1358],
57300:[471, 833, 1124, 1360],
57400:[472, 835, 1125, 1362],
57500:[472, 836, 1127, 1365],
57600:[473, 837, 1129, 1367],
57700:[474, 839, 1131, 1369],
57800:[475, 840, 1133, 1371],
57900:[476, 842, 1135, 1373],
58000:[477, 843, 1136, 1375],
58100:[478, 844, 1138, 1377],
58200:[479, 846, 1140, 1379],
58300:[480, 847, 1142, 1381],
58400:[481, 849, 1143, 1383],
58500:[481, 850, 1145, 1385],
58600:[482, 851, 1147, 1388],
58700:[483, 853, 1149, 1390],
58800:[484, 854, 1151, 1392],
58900:[485, 856, 1153, 1394],
59000:[486, 857, 1154, 1396],
59100:[487, 858, 1156, 1398],
59200:[488, 860, 1158, 1400],
59300:[489, 861, 1159, 1402],
59400:[490, 863, 1161, 1405],
59500:[490, 864, 1163, 1407],
59600:[491, 865, 1165, 1409],
59700:[492, 867, 1167, 1411],
59800:[493, 868, 1169, 1413],
59900:[494, 870, 1170, 1415],
60000:[495, 871, 1172, 1418],
60100:[496, 872, 1174, 1420],
60200:[497, 874, 1176, 1422],
60300:[498, 875, 1177, 1424],
60400:[499, 877, 1179, 1427],
60500:[499, 878, 1181, 1429],
60600:[500, 879, 1183, 1431],
60700:[501, 881, 1185, 1433],
60800:[502, 882, 1187, 1435],
60900:[503, 884, 1188, 1437],
61000:[504, 885, 1190, 1439],
61100:[505, 886, 1192, 1441],
61200:[506, 888, 1194, 1443],
61300:[507, 889, 1195, 1445],
61400:[508, 891, 1197, 1447],
61500:[508, 892, 1199, 1450],
61600:[509, 893, 1201, 1452],
61700:[510, 895, 1203, 1454],
61800:[511, 896, 1205, 1456],
61900:[512, 898, 1206, 1458],
62000:[513, 899, 1208, 1460],
62100:[514, 900, 1210, 1462],
62200:[515, 902, 1212, 1464],
62300:[516, 903, 1213, 1466],
62400:[517, 905, 1215, 1469],
62500:[518, 906, 1217, 1471],
62600:[519, 907, 1219, 1473],
62700:[520, 909, 1221, 1475],
62800:[521, 910, 1222, 1477],
62900:[522, 911, 1224, 1479],
63000:[523, 913, 1226, 1482],
63100:[524, 914, 1228, 1484],
63200:[525, 916, 1230, 1486],
63300:[526, 917, 1232, 1489],
63400:[527, 919, 1233, 1491],
63500:[528, 920, 1235, 1493],
63600:[529, 922, 1237, 1495],
63700:[530, 923, 1239, 1497],
63800:[531, 925, 1241, 1499],
63900:[532, 926, 1243, 1502],
64000:[532, 928, 1245, 1504],
64100:[533, 929, 1247, 1506],
64200:[534, 931, 1249, 1508],
64300:[535, 932, 1251, 1511],
64400:[536, 934, 1252, 1513],
64500:[537, 935, 1254, 1515],
64600:[538, 937, 1256, 1517],
64700:[539, 938, 1258, 1519],
64800:[539, 939, 1260, 1522],
64900:[540, 941, 1262, 1524],
65000:[541, 942, 1263, 1526],
65100:[542, 943, 1265, 1528],
65200:[543, 945, 1267, 1530],
65300:[544, 946, 1268, 1532],
65400:[545, 948, 1270, 1535],
65500:[546, 949, 1272, 1537],
65600:[546, 950, 1274, 1539],
65700:[547, 952, 1276, 1541],
65800:[548, 953, 1277, 1543],
65900:[549, 955, 1279, 1545],
66000:[550, 956, 1281, 1547],
66100:[551, 957, 1283, 1549],
66200:[552, 959, 1285, 1551],
66300:[553, 960, 1287, 1554],
66400:[554, 962, 1288, 1556],
66500:[554, 963, 1290, 1558],
66600:[555, 965, 1292, 1560],
66700:[556, 966, 1294, 1562],
66800:[557, 968, 1296, 1564],
66900:[558, 969, 1298, 1567],
67000:[559, 971, 1300, 1569],
67100:[560, 973, 1302, 1571],
67200:[561, 974, 1304, 1574],
67300:[562, 976, 1306, 1576],
67400:[563, 977, 1308, 1578],
67500:[564, 979, 1309, 1580],
67600:[565, 980, 1311, 1583],
67700:[566, 982, 1313, 1585],
67800:[567, 983, 1315, 1587],
67900:[568, 985, 1317, 1589],
68000:[569, 986, 1319, 1592],
68100:[570, 988, 1321, 1594],
68200:[571, 989, 1323, 1597],
68300:[572, 991, 1325, 1599],
68400:[573, 992, 1327, 1601],
68500:[574, 994, 1329, 1603],
68600:[575, 995, 1331, 1606],
68700:[576, 997, 1333, 1608],
68800:[577, 998, 1335, 1610],
68900:[578, 1000, 1337, 1612],
69000:[579, 1001, 1339, 1615],
69100:[580, 1003, 1341, 1617],
69200:[581, 1004, 1343, 1620],
69300:[582, 1006, 1345, 1622],
69400:[583, 1007, 1347, 1624],
69500:[584, 1009, 1349, 1626],
69600:[585, 1010, 1351, 1629],
69700:[585, 1012, 1353, 1631],
69800:[586, 1013, 1354, 1633],
69900:[587, 1015, 1356, 1636],
70000:[588, 1016, 1358, 1638],
70100:[589, 1018, 1360, 1640],
70200:[590, 1019, 1362, 1643],
70300:[591, 1021, 1364, 1645],
70400:[592, 1022, 1366, 1647],
70500:[593, 1024, 1368, 1650],
70600:[594, 1025, 1369, 1652],
70700:[595, 1027, 1371, 1654],
70800:[596, 1028, 1373, 1657],
70900:[597, 1030, 1375, 1659],
71000:[598, 1031, 1377, 1661],
71100:[599, 1033, 1379, 1663],
71200:[600, 1034, 1381, 1665],
71300:[601, 1036, 1383, 1668],
71400:[602, 1037, 1385, 1670],
71500:[603, 1039, 1387, 1672],
71600:[604, 1040, 1389, 1674],
71700:[605, 1042, 1391, 1677],
71800:[606, 1043, 1393, 1679],
71900:[607, 1045, 1395, 1681],
72000:[608, 1046, 1397, 1683],
72100:[609, 1048, 1399, 1685],
72200:[610, 1049, 1401, 1688],
72300:[611, 1051, 1403, 1690],
72400:[612, 1052, 1405, 1692],
72500:[613, 1054, 1407, 1694],
72600:[614, 1055, 1409, 1697],
72700:[615, 1057, 1411, 1699],
72800:[615, 1058, 1413, 1701],
72900:[616, 1060, 1414, 1703],
73000:[617, 1061, 1416, 1706],
73100:[618, 1063, 1418, 1708],
73200:[619, 1064, 1420, 1711],
73300:[620, 1066, 1422, 1713],
73400:[621, 1067, 1424, 1715],
73500:[622, 1069, 1426, 1717],
73600:[623, 1070, 1427, 1720],
73700:[624, 1072, 1429, 1722],
73800:[625, 1073, 1431, 1724],
73900:[626, 1075, 1433, 1726],
74000:[627, 1076, 1435, 1729],
74100:[628, 1077, 1437, 1731],
74200:[629, 1079, 1439, 1734],
74300:[630, 1080, 1441, 1736],
74400:[631, 1082, 1443, 1738],
74500:[632, 1083, 1445, 1740],
74600:[633, 1085, 1447, 1743],
74700:[634, 1086, 1449, 1745],
74800:[635, 1088, 1451, 1747],
74900:[636, 1089, 1453, 1750],
75000:[637, 1091, 1455, 1752],
75100:[638, 1092, 1457, 1754],
75200:[639, 1094, 1459, 1757],
75300:[640, 1095, 1461, 1759],
75400:[641, 1097, 1463, 1761],
75500:[642, 1098, 1465, 1764],
75600:[643, 1100, 1467, 1766],
75700:[644, 1101, 1469, 1768],
75800:[644, 1103, 1471, 1770],
75900:[645, 1104, 1473, 1773],
76000:[646, 1106, 1474, 1775],
76100:[647, 1107, 1476, 1777],
76200:[648, 1109, 1478, 1780],
76300:[649, 1110, 1480, 1782],
76400:[650, 1112, 1482, 1784],
76500:[651, 1113, 1484, 1787],
76600:[652, 1115, 1486, 1789],
76700:[653, 1116, 1487, 1791],
76800:[654, 1118, 1489, 1794],
76900:[655, 1119, 1491, 1796],
77000:[656, 1121, 1493, 1798],
77100:[657, 1122, 1495, 1800],
77200:[658, 1124, 1497, 1802],
77300:[659, 1125, 1499, 1805],
77400:[660, 1127, 1501, 1807],
77500:[661, 1128, 1502, 1809],
77600:[662, 1130, 1504, 1811],
77700:[663, 1131, 1506, 1814],
77800:[664, 1133, 1508, 1816],
77900:[665, 1134, 1510, 1818],
78000:[666, 1136, 1512, 1820],
78100:[667, 1137, 1514, 1822],
78200:[668, 1139, 1516, 1825],
78300:[669, 1140, 1518, 1827],
78400:[670, 1142, 1520, 1829],
78500:[671, 1143, 1522, 1831],
78600:[672, 1145, 1524, 1834],
78700:[673, 1146, 1526, 1836],
78800:[674, 1148, 1528, 1838],
78900:[674, 1149, 1530, 1840],
79000:[675, 1151, 1532, 1843],
79100:[676, 1152, 1534, 1845],
79200:[677, 1154, 1536, 1848],
79300:[678, 1155, 1538, 1850],
79400:[679, 1157, 1540, 1852],
79500:[680, 1158, 1542, 1854],
79600:[681, 1160, 1544, 1857],
79700:[682, 1161, 1545, 1859],
79800:[683, 1163, 1547, 1861],
79900:[684, 1164, 1549, 1864],
80000:[685, 1166, 1551, 1866],
80100:[686, 1167, 1553, 1868],
80200:[687, 1169, 1555, 1871],
80300:[688, 1170, 1557, 1873],
80400:[689, 1172, 1559, 1875],
80500:[690, 1173, 1560, 1877],
80600:[691, 1175, 1562, 1880],
80700:[692, 1176, 1564, 1882],
80800:[693, 1178, 1566, 1884],
80900:[694, 1179, 1568, 1887],
81000:[695, 1181, 1570, 1889],
81100:[696, 1182, 1572, 1891],
81200:[697, 1184, 1574, 1894],
81300:[698, 1185, 1576, 1896],
81400:[699, 1187, 1578, 1898],
81500:[700, 1188, 1580, 1901],
81600:[701, 1190, 1582, 1903],
81700:[702, 1191, 1584, 1905],
81800:[703, 1193, 1586, 1908],
81900:[704, 1194, 1588, 1910],
82000:[704, 1196, 1590, 1912],
82100:[705, 1197, 1592, 1914],
82200:[706, 1199, 1594, 1916],
82300:[707, 1200, 1596, 1919],
82400:[708, 1202, 1598, 1921],
82500:[709, 1203, 1600, 1923],
82600:[710, 1205, 1602, 1925],
82700:[711, 1206, 1604, 1928],
82800:[712, 1208, 1605, 1930],
82900:[713, 1209, 1607, 1932],
83000:[714, 1211, 1609, 1934],
83100:[715, 1212, 1611, 1936],
83200:[716, 1214, 1613, 1939],
83300:[717, 1215, 1615, 1941],
83400:[718, 1217, 1617, 1943],
83500:[719, 1218, 1619, 1945],
83600:[720, 1220, 1620, 1948],
83700:[721, 1221, 1622, 1950],
83800:[722, 1223, 1624, 1952],
83900:[723, 1224, 1626, 1954],
84000:[724, 1226, 1628, 1957],
84100:[725, 1227, 1630, 1959],
84200:[726, 1229, 1632, 1962],
84300:[727, 1230, 1634, 1964],
84400:[728, 1232, 1636, 1966],
84500:[729, 1233, 1638, 1968],
84600:[730, 1235, 1640, 1971],
84700:[731, 1236, 1642, 1973],
84800:[732, 1238, 1644, 1975],
84900:[733, 1239, 1646, 1977],
85000:[733, 1241, 1648, 1980],
85100:[734, 1242, 1650, 1982],
85200:[735, 1244, 1652, 1985],
85300:[736, 1245, 1654, 1987],
85400:[737, 1247, 1656, 1989],
85500:[738, 1248, 1658, 1991],
85600:[739, 1250, 1660, 1994],
85700:[740, 1251, 1662, 1996],
85800:[741, 1253, 1664, 1998],
85900:[742, 1254, 1665, 2001],
86000:[743, 1256, 1667, 2003],
86100:[744, 1257, 1669, 2005],
86200:[745, 1259, 1671, 2008],
86300:[746, 1260, 1673, 2010],
86400:[747, 1262, 1675, 2012],
86500:[748, 1263, 1677, 2015],
86600:[749, 1265, 1678, 2017],
86700:[749, 1266, 1680, 2019],
86800:[750, 1268, 1682, 2021],
86900:[751, 1269, 1684, 2024],
87000:[752, 1271, 1686, 2026],
87100:[753, 1272, 1688, 2028],
87200:[754, 1274, 1690, 2031],
87300:[755, 1275, 1692, 2033],
87400:[756, 1277, 1694, 2035],
87500:[757, 1278, 1695, 2038],
87600:[758, 1280, 1697, 2040],
87700:[759, 1281, 1699, 2042],
87800:[760, 1283, 1701, 2045],
87900:[761, 1284, 1703, 2047],
88000:[762, 1286, 1705, 2049],
88100:[763, 1287, 1707, 2051],
88200:[764, 1289, 1709, 2053],
88300:[765, 1290, 1711, 2056],
88400:[766, 1292, 1713, 2058],
88500:[767, 1293, 1715, 2060],
88600:[768, 1295, 1717, 2062],
88700:[769, 1296, 1719, 2065],
88800:[770, 1298, 1721, 2067],
88900:[771, 1299, 1723, 2069],
89000:[772, 1301, 1725, 2071],
89100:[773, 1302, 1727, 2073],
89200:[774, 1304, 1729, 2076],
89300:[775, 1305, 1731, 2078],
89400:[776, 1307, 1733, 2080],
89500:[777, 1308, 1735, 2082],
89600:[778, 1310, 1737, 2085],
89700:[778, 1311, 1738, 2087],
89800:[779, 1313, 1740, 2089],
89900:[780, 1314, 1742, 2091],
90000:[781, 1316, 1744, 2094],
90100:[782, 1317, 1746, 2096],
90200:[783, 1319, 1748, 2099],
90300:[784, 1320, 1750, 2101],
90400:[785, 1322, 1752, 2103],
90500:[786, 1323, 1753, 2105],
90600:[787, 1325, 1755, 2108],
90700:[788, 1326, 1757, 2110],
90800:[789, 1328, 1759, 2112],
90900:[790, 1329, 1761, 2115],
91000:[791, 1331, 1763, 2117],
91100:[792, 1332, 1765, 2119],
91200:[793, 1334, 1767, 2122],
91300:[794, 1335, 1769, 2124],
91400:[795, 1337, 1771, 2126],
91500:[796, 1338, 1773, 2129],
91600:[797, 1340, 1775, 2131],
91700:[798, 1341, 1777, 2133],
91800:[799, 1343, 1779, 2135],
91900:[800, 1344, 1781, 2138],
92000:[801, 1346, 1783, 2140],
92100:[802, 1347, 1785, 2142],
92200:[803, 1349, 1787, 2145],
92300:[804, 1350, 1789, 2147],
92400:[805, 1352, 1791, 2149],
92500:[806, 1353, 1793, 2152],
92600:[807, 1355, 1795, 2154],
92700:[807, 1356, 1796, 2156],
92800:[808, 1358, 1798, 2159],
92900:[809, 1359, 1800, 2161],
93000:[810, 1361, 1802, 2163],
93100:[811, 1362, 1804, 2165],
93200:[812, 1364, 1806, 2167],
93300:[813, 1365, 1808, 2170],
93400:[814, 1367, 1810, 2172],
93500:[815, 1368, 1811, 2174],
93600:[816, 1370, 1813, 2176],
93700:[817, 1371, 1815, 2179],
93800:[818, 1373, 1817, 2181],
93900:[819, 1374, 1819, 2183],
94000:[820, 1376, 1821, 2185],
94100:[821, 1377, 1823, 2187],
94200:[822, 1379, 1825, 2190],
94300:[823, 1380, 1827, 2192],
94400:[824, 1382, 1829, 2194],
94500:[825, 1383, 1831, 2196],
94600:[826, 1385, 1833, 2199],
94700:[827, 1386, 1835, 2201],
94800:[828, 1388, 1837, 2203],
94900:[829, 1389, 1839, 2205],
95000:[830, 1391, 1841, 2208],
95100:[831, 1392, 1843, 2210],
95200:[832, 1394, 1845, 2213],
95300:[833, 1395, 1847, 2215],
95400:[834, 1397, 1849, 2217],
95500:[835, 1398, 1851, 2219],
95600:[836, 1400, 1853, 2222],
95700:[837, 1401, 1855, 2224],
95800:[837, 1403, 1856, 2226],
95900:[838, 1404, 1858, 2228],
96000:[839, 1406, 1860, 2231],
96100:[840, 1407, 1862, 2233],
96200:[841, 1409, 1864, 2236],
96300:[842, 1410, 1866, 2238],
96400:[843, 1412, 1868, 2240],
96500:[844, 1413, 1870, 2242],
96600:[845, 1415, 1871, 2245],
96700:[846, 1416, 1873, 2247],
96800:[847, 1418, 1875, 2249],
96900:[848, 1419, 1877, 2252],
97000:[849, 1421, 1879, 2254],
97100:[850, 1422, 1881, 2256],
97200:[851, 1424, 1883, 2259],
97300:[852, 1425, 1885, 2261],
97400:[853, 1427, 1887, 2263],
97500:[854, 1428, 1889, 2266],
97600:[855, 1430, 1891, 2268],
97700:[856, 1431, 1893, 2270],
97800:[857, 1433, 1895, 2272],
97900:[858, 1434, 1897, 2275],
98000:[859, 1436, 1899, 2277],
98100:[860, 1437, 1901, 2279],
98200:[861, 1439, 1903, 2282],
98300:[862, 1440, 1905, 2284],
98400:[863, 1442, 1907, 2286],
98500:[864, 1443, 1909, 2289],
98600:[865, 1445, 1911, 2291],
98700:[866, 1446, 1913, 2293],
98800:[866, 1448, 1915, 2296],
98900:[867, 1449, 1917, 2298],
99000:[868, 1451, 1918, 2300],
99100:[869, 1452, 1920, 2302],
99200:[870, 1454, 1922, 2304],
99300:[871, 1455, 1924, 2307],
99400:[872, 1457, 1926, 2309],
99500:[873, 1458, 1928, 2311],
99600:[874, 1460, 1929, 2313],
99700:[875, 1461, 1931, 2316],
99800:[876, 1463, 1933, 2318],
99900:[877, 1464, 1935, 2320],
};
const OR_AB=[0.86, 1.3, 1.68, 1.98];

// British Columbia — 2025 Federal Child Support Guidelines Table
const T_BC={
100000:[955, 1549, 2025, 2414],
100100:[956, 1550, 2027, 2416],
100200:[957, 1552, 2029, 2418],
100300:[958, 1553, 2031, 2421],
100400:[959, 1555, 2033, 2423],
100500:[960, 1556, 2035, 2425],
100600:[961, 1558, 2037, 2427],
100700:[962, 1559, 2039, 2430],
100800:[963, 1561, 2041, 2432],
100900:[963, 1562, 2042, 2434],
101000:[964, 1564, 2044, 2436],
101100:[965, 1566, 2046, 2438],
101200:[966, 1567, 2048, 2441],
101300:[967, 1569, 2050, 2443],
101400:[968, 1570, 2052, 2445],
101500:[969, 1572, 2054, 2447],
101600:[970, 1573, 2056, 2450],
101700:[971, 1575, 2057, 2452],
101800:[972, 1576, 2059, 2454],
101900:[973, 1578, 2061, 2456],
102000:[974, 1579, 2063, 2459],
102100:[975, 1581, 2065, 2461],
102200:[976, 1582, 2067, 2464],
102300:[977, 1584, 2069, 2466],
102400:[978, 1585, 2071, 2468],
102500:[979, 1587, 2073, 2470],
102600:[980, 1588, 2074, 2473],
102700:[980, 1590, 2076, 2475],
102800:[981, 1591, 2078, 2477],
102900:[982, 1593, 2080, 2480],
103000:[983, 1594, 2082, 2482],
103100:[984, 1596, 2084, 2484],
103200:[985, 1597, 2086, 2486],
103300:[986, 1599, 2088, 2489],
103400:[987, 1600, 2090, 2491],
103500:[988, 1602, 2091, 2493],
103600:[989, 1603, 2093, 2495],
103700:[990, 1605, 2095, 2498],
103800:[991, 1606, 2097, 2500],
103900:[992, 1608, 2099, 2502],
104000:[993, 1609, 2101, 2504],
104100:[994, 1611, 2103, 2506],
104200:[995, 1612, 2105, 2509],
104300:[996, 1614, 2107, 2511],
104400:[997, 1615, 2108, 2513],
104500:[998, 1617, 2110, 2515],
104600:[999, 1618, 2112, 2518],
104700:[1000, 1620, 2114, 2520],
104800:[1001, 1621, 2116, 2522],
104900:[1002, 1623, 2118, 2524],
105000:[1003, 1624, 2120, 2527],
105100:[1004, 1625, 2122, 2529],
105200:[1005, 1627, 2124, 2531],
105300:[1006, 1628, 2126, 2534],
105400:[1007, 1630, 2127, 2536],
105500:[1008, 1631, 2129, 2538],
105600:[1009, 1633, 2131, 2540],
105700:[1010, 1634, 2133, 2542],
105800:[1011, 1636, 2135, 2545],
105900:[1012, 1637, 2137, 2547],
106000:[1012, 1638, 2139, 2549],
106100:[1013, 1639, 2141, 2551],
106200:[1014, 1641, 2143, 2553],
106300:[1015, 1642, 2145, 2556],
106400:[1016, 1644, 2146, 2558],
106500:[1017, 1645, 2148, 2560],
106600:[1017, 1647, 2150, 2562],
106700:[1018, 1648, 2152, 2564],
106800:[1019, 1650, 2154, 2566],
106900:[1020, 1651, 2156, 2569],
107000:[1021, 1653, 2158, 2571],
107100:[1022, 1654, 2160, 2573],
107200:[1023, 1656, 2162, 2575],
107300:[1024, 1657, 2163, 2577],
107400:[1024, 1659, 2165, 2579],
107500:[1025, 1660, 2167, 2581],
107600:[1026, 1662, 2169, 2583],
107700:[1027, 1663, 2171, 2585],
107800:[1028, 1664, 2172, 2588],
107900:[1029, 1666, 2174, 2590],
108000:[1030, 1667, 2176, 2592],
108100:[1031, 1668, 2178, 2594],
108200:[1032, 1670, 2179, 2596],
108300:[1033, 1671, 2181, 2598],
108400:[1034, 1672, 2183, 2600],
108500:[1034, 1674, 2185, 2602],
108600:[1035, 1675, 2186, 2604],
108700:[1036, 1676, 2188, 2607],
108800:[1037, 1678, 2190, 2609],
108900:[1038, 1679, 2192, 2611],
109000:[1039, 1680, 2193, 2613],
109100:[1040, 1681, 2195, 2615],
109200:[1041, 1683, 2196, 2617],
109300:[1041, 1684, 2198, 2619],
109400:[1042, 1685, 2200, 2621],
109500:[1043, 1687, 2202, 2623],
109600:[1044, 1688, 2203, 2625],
109700:[1045, 1689, 2205, 2627],
109800:[1046, 1690, 2207, 2629],
109900:[1046, 1692, 2208, 2631],
110000:[1047, 1693, 2210, 2633],
110100:[1048, 1694, 2212, 2635],
110200:[1049, 1696, 2213, 2637],
110300:[1050, 1697, 2215, 2639],
110400:[1050, 1699, 2217, 2641],
110500:[1051, 1700, 2219, 2643],
110600:[1052, 1701, 2220, 2645],
110700:[1053, 1703, 2222, 2647],
110800:[1054, 1704, 2224, 2649],
110900:[1055, 1705, 2225, 2651],
111000:[1056, 1707, 2227, 2653],
111100:[1057, 1708, 2229, 2655],
111200:[1058, 1710, 2230, 2657],
111300:[1058, 1711, 2232, 2659],
111400:[1059, 1712, 2234, 2661],
111500:[1060, 1714, 2235, 2663],
111600:[1061, 1715, 2237, 2665],
111700:[1062, 1716, 2239, 2667],
111800:[1063, 1718, 2241, 2669],
111900:[1063, 1719, 2242, 2671],
112000:[1064, 1720, 2244, 2673],
112100:[1065, 1721, 2246, 2675],
112200:[1066, 1723, 2247, 2677],
112300:[1067, 1724, 2249, 2679],
112400:[1067, 1725, 2251, 2681],
112500:[1068, 1727, 2252, 2683],
112600:[1069, 1728, 2254, 2685],
112700:[1070, 1729, 2256, 2687],
112800:[1071, 1730, 2257, 2690],
112900:[1072, 1732, 2259, 2692],
113000:[1073, 1733, 2261, 2694],
113100:[1074, 1734, 2263, 2696],
113200:[1075, 1736, 2265, 2698],
113300:[1076, 1737, 2266, 2700],
113400:[1077, 1739, 2268, 2702],
113500:[1077, 1740, 2270, 2704],
113600:[1078, 1741, 2272, 2706],
113700:[1079, 1743, 2273, 2708],
113800:[1080, 1744, 2275, 2710],
113900:[1081, 1745, 2277, 2712],
114000:[1082, 1747, 2279, 2714],
114100:[1083, 1748, 2281, 2716],
114200:[1084, 1750, 2282, 2718],
114300:[1085, 1751, 2284, 2720],
114400:[1085, 1752, 2286, 2722],
114500:[1086, 1754, 2288, 2724],
114600:[1087, 1755, 2289, 2726],
114700:[1088, 1756, 2291, 2728],
114800:[1089, 1758, 2293, 2730],
114900:[1090, 1759, 2295, 2732],
115000:[1090, 1760, 2296, 2734],
115100:[1091, 1761, 2298, 2736],
115200:[1092, 1763, 2299, 2738],
115300:[1093, 1764, 2301, 2740],
115400:[1094, 1765, 2303, 2742],
115500:[1094, 1767, 2305, 2744],
115600:[1095, 1768, 2306, 2746],
115700:[1096, 1769, 2308, 2748],
115800:[1097, 1770, 2310, 2750],
115900:[1098, 1772, 2312, 2752],
116000:[1099, 1773, 2313, 2754],
116100:[1100, 1774, 2315, 2756],
116200:[1101, 1776, 2316, 2758],
116300:[1101, 1777, 2318, 2760],
116400:[1102, 1779, 2320, 2762],
116500:[1103, 1780, 2322, 2764],
116600:[1104, 1781, 2323, 2766],
116700:[1105, 1783, 2325, 2768],
116800:[1106, 1784, 2327, 2771],
116900:[1106, 1785, 2328, 2773],
117000:[1107, 1787, 2330, 2775],
117100:[1108, 1788, 2332, 2777],
117200:[1109, 1790, 2333, 2779],
117300:[1110, 1791, 2335, 2781],
117400:[1110, 1792, 2337, 2783],
117500:[1111, 1794, 2339, 2785],
117600:[1112, 1795, 2340, 2787],
117700:[1113, 1796, 2342, 2789],
117800:[1114, 1798, 2344, 2791],
117900:[1115, 1799, 2345, 2793],
118000:[1116, 1800, 2347, 2795],
118100:[1117, 1801, 2349, 2797],
118200:[1118, 1803, 2350, 2799],
118300:[1118, 1804, 2352, 2801],
118400:[1119, 1805, 2354, 2803],
118500:[1120, 1807, 2355, 2805],
118600:[1121, 1808, 2357, 2807],
118700:[1122, 1809, 2359, 2809],
118800:[1123, 1810, 2361, 2811],
118900:[1123, 1812, 2362, 2813],
119000:[1124, 1813, 2364, 2815],
119100:[1125, 1814, 2366, 2817],
119200:[1126, 1816, 2367, 2819],
119300:[1127, 1817, 2369, 2821],
119400:[1127, 1819, 2371, 2823],
119500:[1128, 1820, 2372, 2825],
119600:[1129, 1821, 2374, 2827],
119700:[1130, 1823, 2376, 2829],
119800:[1131, 1824, 2377, 2831],
119900:[1132, 1825, 2379, 2833],
120000:[1133, 1827, 2381, 2835],
120100:[1134, 1828, 2383, 2837],
120200:[1135, 1830, 2385, 2839],
120300:[1136, 1831, 2386, 2841],
120400:[1137, 1832, 2388, 2843],
120500:[1137, 1834, 2390, 2845],
120600:[1138, 1835, 2392, 2847],
120700:[1139, 1836, 2393, 2849],
120800:[1140, 1838, 2395, 2852],
120900:[1141, 1839, 2397, 2854],
121000:[1142, 1840, 2399, 2856],
121100:[1143, 1841, 2401, 2858],
121200:[1144, 1843, 2402, 2860],
121300:[1145, 1844, 2404, 2862],
121400:[1145, 1845, 2406, 2864],
121500:[1146, 1847, 2408, 2866],
121600:[1147, 1848, 2409, 2868],
121700:[1148, 1849, 2411, 2870],
121800:[1149, 1850, 2413, 2872],
121900:[1150, 1852, 2415, 2874],
122000:[1150, 1853, 2416, 2876],
122100:[1151, 1854, 2418, 2878],
122200:[1152, 1856, 2419, 2880],
122300:[1153, 1857, 2421, 2882],
122400:[1154, 1859, 2423, 2884],
122500:[1154, 1860, 2425, 2886],
122600:[1155, 1861, 2426, 2888],
122700:[1156, 1863, 2428, 2890],
122800:[1157, 1864, 2430, 2892],
122900:[1158, 1865, 2432, 2894],
123000:[1159, 1867, 2433, 2896],
123100:[1160, 1868, 2435, 2898],
123200:[1161, 1870, 2436, 2900],
123300:[1161, 1871, 2438, 2902],
123400:[1162, 1872, 2440, 2904],
123500:[1163, 1874, 2442, 2906],
123600:[1164, 1875, 2443, 2908],
123700:[1165, 1876, 2445, 2910],
123800:[1166, 1878, 2447, 2912],
123900:[1166, 1879, 2448, 2914],
124000:[1167, 1880, 2450, 2916],
124100:[1168, 1881, 2452, 2918],
124200:[1169, 1883, 2453, 2920],
124300:[1170, 1884, 2455, 2922],
124400:[1170, 1885, 2457, 2924],
124500:[1171, 1887, 2459, 2926],
124600:[1172, 1888, 2460, 2928],
124700:[1173, 1889, 2462, 2930],
124800:[1174, 1890, 2464, 2932],
124900:[1175, 1892, 2465, 2935],
125000:[1176, 1893, 2467, 2937],
125100:[1177, 1894, 2469, 2939],
125200:[1178, 1896, 2470, 2941],
125300:[1178, 1897, 2472, 2943],
125400:[1179, 1899, 2474, 2945],
125500:[1180, 1900, 2475, 2947],
125600:[1181, 1901, 2477, 2949],
125700:[1182, 1903, 2479, 2951],
125800:[1183, 1904, 2481, 2953],
125900:[1183, 1905, 2482, 2955],
126000:[1184, 1907, 2484, 2957],
126100:[1185, 1908, 2486, 2959],
126200:[1186, 1910, 2487, 2961],
126300:[1187, 1911, 2489, 2963],
126400:[1187, 1912, 2491, 2965],
126500:[1188, 1914, 2492, 2967],
126600:[1189, 1915, 2494, 2969],
126700:[1190, 1916, 2496, 2971],
126800:[1191, 1918, 2497, 2973],
126900:[1192, 1919, 2499, 2975],
127000:[1193, 1920, 2501, 2977],
127100:[1194, 1921, 2503, 2979],
127200:[1195, 1923, 2504, 2981],
127300:[1196, 1924, 2506, 2983],
127400:[1197, 1925, 2508, 2985],
127500:[1197, 1927, 2509, 2987],
127600:[1198, 1928, 2511, 2989],
127700:[1199, 1929, 2513, 2991],
127800:[1200, 1930, 2514, 2993],
127900:[1201, 1932, 2516, 2995],
128000:[1202, 1933, 2518, 2997],
128100:[1203, 1934, 2520, 2999],
128200:[1204, 1936, 2521, 3001],
128300:[1205, 1937, 2523, 3003],
128400:[1205, 1938, 2525, 3005],
128500:[1206, 1939, 2526, 3007],
128600:[1207, 1941, 2528, 3009],
128700:[1208, 1942, 2530, 3011],
128800:[1209, 1943, 2531, 3013],
128900:[1210, 1945, 2533, 3015],
129000:[1210, 1946, 2535, 3017],
129100:[1211, 1947, 2537, 3019],
129200:[1212, 1949, 2538, 3021],
129300:[1212, 1950, 2540, 3023],
129400:[1213, 1951, 2541, 3025],
129500:[1214, 1953, 2543, 3027],
129600:[1215, 1954, 2545, 3028],
129700:[1216, 1955, 2546, 3030],
129800:[1217, 1956, 2548, 3032],
129900:[1217, 1958, 2549, 3034],
130000:[1218, 1959, 2551, 3036],
130100:[1219, 1960, 2553, 3038],
130200:[1220, 1962, 2554, 3040],
130300:[1220, 1963, 2556, 3042],
130400:[1221, 1964, 2558, 3044],
130500:[1222, 1966, 2559, 3046],
130600:[1223, 1967, 2561, 3048],
130700:[1224, 1968, 2563, 3050],
130800:[1224, 1970, 2564, 3052],
130900:[1225, 1971, 2566, 3054],
131000:[1226, 1972, 2568, 3056],
131100:[1227, 1973, 2570, 3058],
131200:[1228, 1974, 2571, 3060],
131300:[1228, 1976, 2573, 3062],
131400:[1229, 1977, 2574, 3064],
131500:[1230, 1978, 2576, 3066],
131600:[1231, 1979, 2578, 3068],
131700:[1231, 1981, 2579, 3069],
131800:[1232, 1982, 2581, 3071],
131900:[1233, 1983, 2582, 3073],
132000:[1234, 1984, 2584, 3075],
132100:[1235, 1985, 2586, 3077],
132200:[1236, 1987, 2587, 3079],
132300:[1237, 1988, 2589, 3081],
132400:[1237, 1989, 2591, 3083],
132500:[1238, 1990, 2592, 3085],
132600:[1239, 1992, 2594, 3087],
132700:[1240, 1993, 2596, 3089],
132800:[1241, 1994, 2597, 3091],
132900:[1242, 1995, 2599, 3093],
133000:[1243, 1997, 2601, 3095],
133100:[1244, 1998, 2603, 3097],
133200:[1245, 2000, 2604, 3099],
133300:[1245, 2001, 2606, 3101],
133400:[1246, 2002, 2607, 3103],
133500:[1247, 2003, 2609, 3105],
133600:[1248, 2005, 2611, 3107],
133700:[1249, 2006, 2612, 3109],
133800:[1250, 2007, 2614, 3110],
133900:[1250, 2008, 2616, 3112],
134000:[1251, 2010, 2617, 3114],
134100:[1252, 2011, 2619, 3116],
134200:[1253, 2013, 2620, 3118],
134300:[1253, 2014, 2622, 3120],
134400:[1254, 2015, 2624, 3122],
134500:[1255, 2016, 2625, 3124],
134600:[1256, 2018, 2627, 3126],
134700:[1257, 2019, 2629, 3128],
134800:[1257, 2020, 2630, 3130],
134900:[1258, 2022, 2632, 3132],
135000:[1259, 2023, 2634, 3134],
135100:[1260, 2024, 2636, 3136],
135200:[1261, 2026, 2637, 3138],
135300:[1261, 2027, 2639, 3140],
135400:[1262, 2028, 2640, 3142],
135500:[1263, 2030, 2642, 3144],
135600:[1264, 2031, 2644, 3146],
135700:[1264, 2032, 2645, 3148],
135800:[1265, 2034, 2647, 3149],
135900:[1266, 2035, 2649, 3151],
136000:[1267, 2036, 2650, 3153],
136100:[1268, 2037, 2652, 3155],
136200:[1269, 2038, 2653, 3157],
136300:[1270, 2040, 2655, 3159],
136400:[1270, 2041, 2657, 3161],
136500:[1271, 2042, 2658, 3163],
136600:[1272, 2043, 2660, 3165],
136700:[1273, 2045, 2662, 3167],
136800:[1274, 2046, 2663, 3169],
136900:[1275, 2047, 2665, 3171],
137000:[1276, 2048, 2667, 3173],
137100:[1277, 2049, 2669, 3175],
137200:[1278, 2051, 2670, 3177],
137300:[1278, 2052, 2672, 3179],
137400:[1279, 2053, 2674, 3181],
137500:[1280, 2054, 2675, 3183],
137600:[1281, 2056, 2677, 3185],
137700:[1282, 2057, 2678, 3187],
137800:[1283, 2058, 2680, 3189],
137900:[1283, 2059, 2682, 3190],
138000:[1284, 2061, 2683, 3192],
138100:[1285, 2062, 2685, 3194],
138200:[1286, 2064, 2686, 3196],
138300:[1286, 2065, 2688, 3198],
138400:[1287, 2066, 2690, 3200],
138500:[1288, 2067, 2691, 3202],
138600:[1289, 2069, 2693, 3204],
138700:[1290, 2070, 2695, 3206],
138800:[1290, 2071, 2696, 3208],
138900:[1291, 2072, 2698, 3210],
139000:[1292, 2074, 2700, 3212],
139100:[1293, 2075, 2702, 3214],
139200:[1294, 2077, 2703, 3216],
139300:[1294, 2078, 2705, 3218],
139400:[1295, 2079, 2707, 3220],
139500:[1296, 2080, 2708, 3222],
139600:[1297, 2082, 2710, 3224],
139700:[1297, 2083, 2711, 3226],
139800:[1298, 2084, 2713, 3228],
139900:[1299, 2086, 2715, 3230],
140000:[1300, 2087, 2716, 3231],
140100:[1301, 2088, 2718, 3233],
140200:[1302, 2090, 2719, 3235],
140300:[1303, 2091, 2721, 3237],
140400:[1303, 2092, 2723, 3239],
140500:[1304, 2094, 2724, 3241],
140600:[1305, 2095, 2726, 3242],
140700:[1306, 2096, 2728, 3244],
140800:[1307, 2097, 2729, 3246],
140900:[1308, 2099, 2731, 3248],
141000:[1309, 2100, 2733, 3250],
141100:[1310, 2101, 2735, 3252],
141200:[1311, 2103, 2736, 3254],
141300:[1312, 2104, 2738, 3256],
141400:[1312, 2105, 2740, 3258],
141500:[1313, 2107, 2741, 3260],
141600:[1314, 2108, 2743, 3262],
141700:[1315, 2109, 2744, 3264],
141800:[1316, 2111, 2746, 3266],
141900:[1317, 2112, 2748, 3268],
142000:[1317, 2113, 2749, 3270],
142100:[1318, 2114, 2751, 3272],
142200:[1319, 2115, 2752, 3274],
142300:[1319, 2117, 2754, 3276],
142400:[1320, 2118, 2756, 3278],
142500:[1321, 2119, 2757, 3280],
142600:[1322, 2120, 2759, 3281],
142700:[1323, 2122, 2761, 3283],
142800:[1324, 2123, 2763, 3285],
142900:[1324, 2124, 2764, 3287],
143000:[1325, 2125, 2766, 3289],
143100:[1326, 2126, 2768, 3291],
143200:[1327, 2128, 2769, 3293],
143300:[1327, 2129, 2771, 3295],
143400:[1328, 2130, 2773, 3297],
143500:[1329, 2131, 2774, 3299],
143600:[1330, 2133, 2776, 3301],
143700:[1331, 2134, 2778, 3303],
143800:[1331, 2135, 2779, 3305],
143900:[1332, 2136, 2781, 3307],
144000:[1333, 2138, 2782, 3309],
144100:[1334, 2139, 2784, 3311],
144200:[1335, 2141, 2785, 3313],
144300:[1336, 2142, 2787, 3315],
144400:[1336, 2143, 2789, 3317],
144500:[1337, 2144, 2790, 3319],
144600:[1338, 2146, 2792, 3320],
144700:[1339, 2147, 2794, 3322],
144800:[1340, 2148, 2796, 3324],
144900:[1341, 2150, 2797, 3326],
145000:[1342, 2151, 2799, 3328],
145100:[1343, 2152, 2801, 3330],
145200:[1344, 2154, 2802, 3332],
145300:[1345, 2155, 2804, 3334],
145400:[1345, 2156, 2806, 3336],
145500:[1346, 2158, 2807, 3338],
145600:[1347, 2159, 2809, 3340],
145700:[1348, 2160, 2811, 3342],
145800:[1349, 2161, 2812, 3344],
145900:[1350, 2163, 2814, 3346],
146000:[1350, 2164, 2815, 3348],
146100:[1351, 2165, 2817, 3350],
146200:[1352, 2167, 2818, 3352],
146300:[1352, 2168, 2820, 3354],
146400:[1353, 2169, 2821, 3356],
146500:[1354, 2171, 2823, 3358],
146600:[1355, 2172, 2825, 3360],
146700:[1356, 2173, 2826, 3361],
146800:[1357, 2175, 2828, 3363],
146900:[1357, 2176, 2829, 3365],
147000:[1358, 2177, 2831, 3367],
147100:[1359, 2178, 2833, 3369],
147200:[1360, 2179, 2834, 3371],
147300:[1360, 2181, 2836, 3373],
147400:[1361, 2182, 2838, 3375],
147500:[1362, 2183, 2839, 3377],
147600:[1363, 2184, 2841, 3379],
147700:[1364, 2186, 2843, 3381],
147800:[1364, 2187, 2844, 3383],
147900:[1365, 2188, 2846, 3385],
148000:[1366, 2189, 2848, 3387],
148100:[1367, 2190, 2850, 3389],
148200:[1368, 2192, 2851, 3391],
148300:[1369, 2193, 2853, 3393],
148400:[1369, 2194, 2854, 3395],
148500:[1370, 2195, 2856, 3397],
148600:[1371, 2197, 2858, 3399],
148700:[1372, 2198, 2859, 3401],
148800:[1373, 2199, 2861, 3402],
148900:[1374, 2200, 2862, 3404],
149000:[1375, 2202, 2864, 3406],
149100:[1376, 2203, 2866, 3408],
149200:[1377, 2205, 2867, 3410],
149300:[1378, 2206, 2869, 3412],
149400:[1378, 2207, 2871, 3414],
149500:[1379, 2208, 2872, 3416],
149600:[1380, 2210, 2874, 3418],
149700:[1381, 2211, 2876, 3420],
149800:[1382, 2212, 2877, 3422],
149900:[1383, 2213, 2879, 3424],
150000:[1383, 2215, 2881, 3426],
16000:[0, 0, 0, 0],
16100:[8, 9, 9, 10],
16200:[16, 17, 19, 20],
16300:[24, 26, 28, 30],
16400:[32, 34, 37, 40],
16500:[40, 43, 47, 50],
16600:[48, 52, 56, 60],
16700:[56, 60, 65, 70],
16800:[64, 69, 74, 80],
16900:[72, 77, 84, 90],
17000:[80, 86, 93, 100],
17100:[82, 91, 98, 105],
17200:[83, 95, 103, 111],
17300:[85, 100, 108, 116],
17400:[86, 105, 113, 122],
17500:[88, 109, 118, 127],
17600:[89, 114, 123, 133],
17700:[91, 119, 128, 138],
17800:[92, 123, 133, 143],
17900:[94, 128, 138, 149],
18000:[95, 133, 143, 154],
18100:[97, 137, 148, 159],
18200:[98, 142, 152, 164],
18300:[100, 146, 157, 169],
18400:[101, 150, 161, 174],
18500:[103, 154, 166, 179],
18600:[104, 159, 170, 184],
18700:[106, 163, 175, 189],
18800:[107, 167, 180, 194],
18900:[109, 172, 184, 198],
19000:[110, 176, 189, 203],
19100:[111, 180, 194, 208],
19200:[113, 185, 198, 213],
19300:[114, 189, 203, 218],
19400:[116, 193, 208, 223],
19500:[117, 198, 212, 228],
19600:[119, 202, 217, 233],
19700:[120, 206, 222, 238],
19800:[122, 211, 226, 243],
19900:[123, 215, 231, 248],
20000:[125, 219, 236, 253],
20100:[127, 223, 241, 258],
20200:[128, 228, 245, 263],
20300:[130, 232, 250, 268],
20400:[131, 236, 254, 273],
20500:[133, 240, 259, 278],
20600:[134, 245, 264, 283],
20700:[136, 249, 268, 288],
20800:[137, 253, 273, 292],
20900:[139, 258, 278, 297],
21000:[141, 262, 282, 302],
21100:[143, 266, 287, 307],
21200:[144, 271, 291, 312],
21300:[146, 275, 296, 317],
21400:[147, 279, 301, 322],
21500:[149, 283, 305, 327],
21600:[150, 288, 310, 332],
21700:[152, 292, 315, 337],
21800:[153, 296, 319, 342],
21900:[155, 301, 324, 347],
22000:[156, 305, 329, 352],
22100:[158, 309, 334, 357],
22200:[159, 314, 338, 362],
22300:[161, 318, 343, 367],
22400:[162, 322, 348, 372],
22500:[164, 326, 352, 377],
22600:[165, 331, 357, 382],
22700:[167, 335, 361, 387],
22800:[168, 339, 366, 392],
22900:[170, 344, 371, 397],
23000:[171, 348, 375, 402],
23100:[172, 352, 380, 407],
23200:[174, 357, 384, 412],
23300:[175, 361, 389, 417],
23400:[177, 365, 394, 422],
23500:[178, 370, 398, 428],
23600:[180, 374, 403, 433],
23700:[181, 379, 408, 438],
23800:[183, 383, 413, 443],
23900:[184, 387, 417, 448],
24000:[186, 392, 422, 453],
24100:[188, 396, 426, 458],
24200:[189, 400, 431, 462],
24300:[191, 405, 435, 467],
24400:[192, 409, 440, 472],
24500:[194, 413, 444, 477],
24600:[195, 417, 449, 481],
24700:[197, 421, 453, 486],
24800:[198, 425, 458, 491],
24900:[200, 430, 462, 496],
25000:[202, 434, 467, 500],
25100:[204, 437, 471, 504],
25200:[205, 441, 474, 508],
25300:[207, 444, 478, 512],
25400:[208, 447, 482, 516],
25500:[210, 451, 486, 520],
25600:[211, 454, 489, 524],
25700:[213, 457, 493, 528],
25800:[214, 461, 497, 532],
25900:[216, 464, 500, 536],
26000:[217, 467, 504, 540],
26100:[219, 467, 508, 544],
26200:[220, 468, 511, 548],
26300:[222, 468, 515, 552],
26400:[223, 468, 518, 555],
26500:[225, 468, 522, 559],
26600:[226, 469, 525, 563],
26700:[228, 469, 529, 567],
26800:[229, 469, 532, 571],
26900:[231, 469, 536, 575],
27000:[232, 470, 540, 579],
27100:[233, 470, 544, 583],
27200:[235, 470, 547, 587],
27300:[236, 471, 551, 590],
27400:[238, 471, 554, 594],
27500:[239, 471, 558, 598],
27600:[241, 471, 561, 602],
27700:[242, 472, 565, 606],
27800:[244, 472, 569, 610],
27900:[245, 472, 572, 613],
28000:[247, 472, 576, 617],
28100:[248, 472, 580, 621],
28200:[249, 473, 583, 625],
28300:[250, 473, 587, 629],
28400:[251, 473, 590, 633],
28500:[252, 474, 594, 636],
28600:[253, 474, 598, 640],
28700:[254, 474, 601, 644],
28800:[255, 475, 605, 648],
28900:[257, 475, 608, 652],
29000:[258, 475, 612, 656],
29100:[258, 476, 616, 660],
29200:[258, 476, 619, 664],
29300:[258, 477, 623, 668],
29400:[258, 478, 626, 671],
29500:[258, 478, 630, 675],
29600:[259, 479, 634, 679],
29700:[259, 479, 637, 683],
29800:[259, 480, 641, 687],
29900:[259, 481, 644, 691],
30000:[259, 481, 648, 694],
30100:[259, 482, 650, 698],
30200:[260, 483, 653, 702],
30300:[260, 484, 655, 705],
30400:[261, 485, 658, 709],
30500:[261, 485, 660, 713],
30600:[261, 486, 663, 717],
30700:[262, 487, 665, 721],
30800:[262, 488, 667, 724],
30900:[263, 489, 670, 728],
31000:[263, 490, 672, 732],
31100:[263, 491, 673, 736],
31200:[264, 492, 675, 740],
31300:[264, 493, 676, 744],
31400:[264, 494, 677, 747],
31500:[265, 494, 678, 751],
31600:[265, 495, 680, 755],
31700:[265, 496, 681, 759],
31800:[266, 497, 682, 763],
31900:[266, 498, 684, 767],
32000:[266, 499, 685, 771],
32100:[266, 500, 686, 775],
32200:[267, 501, 687, 778],
32300:[267, 501, 688, 782],
32400:[267, 502, 690, 786],
32500:[267, 503, 691, 790],
32600:[268, 504, 692, 793],
32700:[268, 504, 693, 797],
32800:[268, 505, 694, 801],
32900:[268, 506, 695, 804],
33000:[269, 507, 697, 808],
33100:[269, 508, 698, 812],
33200:[270, 509, 699, 815],
33300:[270, 509, 700, 819],
33400:[270, 510, 702, 822],
33500:[270, 511, 703, 826],
33600:[271, 512, 704, 829],
33700:[271, 513, 705, 833],
33800:[271, 513, 706, 836],
33900:[272, 514, 707, 840],
34000:[272, 515, 709, 843],
34100:[273, 516, 710, 846],
34200:[273, 517, 712, 850],
34300:[274, 518, 713, 853],
34400:[275, 519, 715, 857],
34500:[275, 520, 716, 860],
34600:[276, 521, 717, 864],
34700:[276, 522, 719, 867],
34800:[277, 523, 720, 871],
34900:[278, 524, 722, 874],
35000:[278, 525, 723, 878],
35100:[279, 527, 725, 881],
35200:[280, 528, 727, 884],
35300:[281, 530, 729, 887],
35400:[282, 531, 731, 890],
35500:[283, 533, 732, 893],
35600:[284, 534, 734, 896],
35700:[285, 536, 736, 899],
35800:[286, 538, 738, 902],
35900:[287, 539, 740, 905],
36000:[288, 541, 742, 908],
36100:[289, 543, 744, 911],
36200:[291, 545, 747, 913],
36300:[292, 547, 749, 916],
36400:[294, 548, 751, 918],
36500:[295, 550, 753, 921],
36600:[296, 552, 756, 923],
36700:[298, 554, 758, 926],
36800:[299, 556, 760, 928],
36900:[300, 558, 762, 931],
37000:[302, 559, 765, 933],
37100:[303, 561, 767, 936],
37200:[305, 563, 770, 938],
37300:[306, 564, 772, 941],
37400:[307, 566, 774, 943],
37500:[309, 568, 777, 946],
37600:[310, 570, 779, 948],
37700:[311, 572, 781, 951],
37800:[313, 573, 783, 953],
37900:[314, 575, 786, 956],
38000:[315, 577, 788, 959],
38100:[316, 579, 790, 962],
38200:[318, 581, 793, 964],
38300:[319, 583, 795, 967],
38400:[321, 585, 797, 970],
38500:[322, 587, 800, 972],
38600:[323, 589, 802, 975],
38700:[325, 591, 804, 978],
38800:[326, 593, 807, 980],
38900:[328, 595, 809, 983],
39000:[329, 597, 811, 986],
39100:[330, 599, 813, 989],
39200:[332, 601, 816, 991],
39300:[333, 603, 818, 994],
39400:[335, 605, 820, 997],
39500:[336, 607, 823, 999],
39600:[338, 609, 825, 1002],
39700:[339, 611, 827, 1005],
39800:[340, 613, 829, 1007],
39900:[342, 614, 832, 1010],
40000:[343, 616, 834, 1013],
40100:[344, 618, 836, 1016],
40200:[346, 620, 839, 1018],
40300:[347, 622, 841, 1021],
40400:[348, 624, 843, 1024],
40500:[350, 626, 845, 1026],
40600:[351, 628, 848, 1029],
40700:[352, 629, 850, 1032],
40800:[354, 631, 852, 1034],
40900:[355, 633, 854, 1037],
41000:[356, 635, 857, 1040],
41100:[357, 637, 859, 1043],
41200:[359, 639, 862, 1045],
41300:[360, 641, 864, 1048],
41400:[362, 642, 866, 1051],
41500:[363, 644, 868, 1053],
41600:[364, 646, 871, 1056],
41700:[366, 648, 873, 1058],
41800:[367, 650, 875, 1061],
41900:[369, 652, 877, 1064],
42000:[370, 653, 880, 1066],
42100:[371, 655, 882, 1069],
42200:[373, 657, 885, 1071],
42300:[374, 659, 887, 1074],
42400:[376, 661, 889, 1076],
42500:[377, 662, 891, 1079],
42600:[379, 664, 894, 1082],
42700:[380, 666, 896, 1084],
42800:[382, 668, 898, 1087],
42900:[383, 670, 901, 1089],
43000:[384, 672, 903, 1092],
43100:[385, 674, 905, 1095],
43200:[387, 676, 908, 1097],
43300:[388, 678, 910, 1100],
43400:[390, 680, 912, 1103],
43500:[391, 682, 915, 1105],
43600:[393, 684, 917, 1108],
43700:[394, 686, 920, 1111],
43800:[396, 688, 922, 1113],
43900:[397, 690, 924, 1116],
44000:[398, 692, 927, 1119],
44100:[399, 694, 929, 1122],
44200:[401, 696, 932, 1124],
44300:[402, 698, 934, 1127],
44400:[404, 700, 936, 1130],
44500:[405, 702, 939, 1132],
44600:[407, 704, 941, 1135],
44700:[408, 706, 943, 1138],
44800:[410, 708, 945, 1141],
44900:[411, 710, 948, 1143],
45000:[413, 712, 950, 1146],
45100:[414, 714, 952, 1149],
45200:[416, 716, 955, 1151],
45300:[417, 718, 957, 1154],
45400:[419, 720, 959, 1156],
45500:[420, 722, 962, 1159],
45600:[422, 724, 964, 1162],
45700:[423, 725, 966, 1164],
45800:[425, 727, 969, 1167],
45900:[426, 729, 971, 1170],
46000:[428, 731, 974, 1172],
46100:[429, 733, 976, 1174],
46200:[430, 734, 978, 1177],
46300:[431, 736, 980, 1179],
46400:[432, 738, 982, 1181],
46500:[433, 739, 984, 1184],
46600:[434, 741, 986, 1186],
46700:[436, 743, 988, 1188],
46800:[437, 744, 990, 1191],
46900:[438, 746, 992, 1193],
47000:[439, 748, 994, 1196],
47100:[440, 749, 996, 1198],
47200:[441, 751, 998, 1200],
47300:[442, 752, 1000, 1203],
47400:[443, 754, 1002, 1205],
47500:[444, 755, 1003, 1207],
47600:[445, 757, 1005, 1209],
47700:[446, 758, 1007, 1211],
47800:[447, 759, 1009, 1214],
47900:[448, 761, 1011, 1216],
48000:[449, 762, 1013, 1218],
48100:[450, 763, 1015, 1220],
48200:[451, 765, 1017, 1222],
48300:[452, 766, 1019, 1225],
48400:[453, 768, 1021, 1227],
48500:[454, 769, 1023, 1229],
48600:[455, 771, 1024, 1231],
48700:[455, 772, 1026, 1233],
48800:[456, 774, 1028, 1236],
48900:[457, 775, 1030, 1238],
49000:[458, 777, 1032, 1240],
49100:[459, 779, 1034, 1242],
49200:[460, 780, 1036, 1245],
49300:[461, 782, 1038, 1247],
49400:[462, 783, 1040, 1249],
49500:[463, 785, 1042, 1251],
49600:[464, 786, 1044, 1254],
49700:[465, 788, 1046, 1256],
49800:[466, 789, 1047, 1258],
49900:[467, 791, 1049, 1261],
50000:[468, 792, 1051, 1263],
50100:[469, 794, 1053, 1265],
50200:[470, 795, 1055, 1268],
50300:[471, 797, 1057, 1270],
50400:[472, 798, 1059, 1272],
50500:[473, 800, 1061, 1275],
50600:[474, 801, 1063, 1277],
50700:[475, 803, 1064, 1279],
50800:[475, 804, 1066, 1282],
50900:[476, 806, 1068, 1284],
51000:[477, 807, 1070, 1286],
51100:[478, 809, 1072, 1288],
51200:[479, 810, 1074, 1291],
51300:[480, 812, 1076, 1293],
51400:[481, 813, 1078, 1295],
51500:[482, 815, 1080, 1298],
51600:[483, 816, 1082, 1300],
51700:[484, 818, 1084, 1302],
51800:[485, 819, 1086, 1305],
51900:[486, 821, 1088, 1307],
52000:[487, 822, 1090, 1309],
52100:[488, 824, 1092, 1311],
52200:[489, 825, 1094, 1314],
52300:[490, 827, 1096, 1316],
52400:[491, 828, 1098, 1318],
52500:[492, 830, 1100, 1321],
52600:[493, 831, 1102, 1323],
52700:[494, 833, 1104, 1325],
52800:[495, 834, 1106, 1328],
52900:[496, 836, 1108, 1330],
53000:[497, 837, 1109, 1332],
53100:[498, 838, 1111, 1334],
53200:[499, 840, 1113, 1337],
53300:[500, 841, 1115, 1339],
53400:[501, 843, 1117, 1341],
53500:[502, 844, 1119, 1344],
53600:[503, 846, 1121, 1346],
53700:[504, 847, 1123, 1348],
53800:[505, 849, 1125, 1351],
53900:[506, 850, 1127, 1353],
54000:[507, 852, 1129, 1355],
54100:[508, 853, 1131, 1357],
54200:[509, 855, 1133, 1359],
54300:[510, 856, 1135, 1362],
54400:[511, 858, 1137, 1364],
54500:[512, 859, 1138, 1366],
54600:[513, 861, 1140, 1368],
54700:[513, 862, 1142, 1370],
54800:[514, 864, 1144, 1372],
54900:[515, 865, 1146, 1375],
55000:[516, 867, 1148, 1377],
55100:[517, 868, 1150, 1379],
55200:[518, 870, 1152, 1381],
55300:[519, 871, 1154, 1384],
55400:[520, 873, 1155, 1386],
55500:[520, 874, 1157, 1388],
55600:[521, 875, 1159, 1390],
55700:[522, 877, 1161, 1392],
55800:[523, 878, 1163, 1394],
55900:[524, 880, 1165, 1397],
56000:[525, 881, 1166, 1399],
56100:[526, 882, 1168, 1401],
56200:[527, 884, 1170, 1403],
56300:[528, 885, 1172, 1406],
56400:[529, 887, 1174, 1408],
56500:[530, 888, 1175, 1410],
56600:[531, 890, 1177, 1412],
56700:[532, 891, 1179, 1414],
56800:[533, 893, 1181, 1416],
56900:[534, 894, 1183, 1419],
57000:[535, 896, 1185, 1421],
57100:[536, 897, 1187, 1423],
57200:[537, 899, 1189, 1425],
57300:[538, 900, 1190, 1428],
57400:[539, 902, 1192, 1430],
57500:[540, 903, 1194, 1432],
57600:[541, 905, 1196, 1434],
57700:[542, 906, 1198, 1436],
57800:[542, 907, 1200, 1439],
57900:[543, 909, 1201, 1441],
58000:[544, 910, 1203, 1443],
58100:[545, 911, 1205, 1445],
58200:[546, 913, 1207, 1447],
58300:[547, 914, 1209, 1450],
58400:[548, 916, 1210, 1452],
58500:[549, 917, 1212, 1454],
58600:[549, 919, 1214, 1456],
58700:[550, 920, 1216, 1458],
58800:[551, 922, 1218, 1461],
58900:[552, 923, 1220, 1463],
59000:[553, 925, 1222, 1465],
59100:[554, 926, 1224, 1467],
59200:[555, 928, 1226, 1469],
59300:[556, 929, 1227, 1472],
59400:[557, 931, 1229, 1474],
59500:[558, 932, 1231, 1476],
59600:[559, 934, 1233, 1478],
59700:[560, 935, 1235, 1480],
59800:[561, 936, 1237, 1483],
59900:[562, 938, 1238, 1485],
60000:[563, 939, 1240, 1487],
60100:[564, 940, 1242, 1489],
60200:[565, 942, 1244, 1491],
60300:[566, 943, 1246, 1494],
60400:[567, 945, 1247, 1496],
60500:[568, 946, 1249, 1498],
60600:[569, 948, 1251, 1500],
60700:[570, 949, 1253, 1502],
60800:[571, 951, 1255, 1505],
60900:[572, 952, 1257, 1507],
61000:[572, 954, 1259, 1509],
61100:[573, 955, 1261, 1511],
61200:[574, 957, 1263, 1513],
61300:[575, 958, 1265, 1516],
61400:[576, 960, 1267, 1518],
61500:[577, 961, 1269, 1520],
61600:[578, 963, 1270, 1522],
61700:[578, 964, 1272, 1525],
61800:[579, 966, 1274, 1527],
61900:[580, 967, 1276, 1529],
62000:[581, 968, 1278, 1531],
62100:[582, 969, 1280, 1533],
62200:[583, 971, 1282, 1535],
62300:[584, 972, 1284, 1538],
62400:[585, 974, 1286, 1540],
62500:[586, 975, 1288, 1542],
62600:[587, 977, 1290, 1544],
62700:[588, 978, 1292, 1546],
62800:[589, 980, 1293, 1549],
62900:[590, 981, 1295, 1551],
63000:[591, 983, 1297, 1553],
63100:[592, 985, 1299, 1555],
63200:[593, 986, 1301, 1558],
63300:[594, 988, 1303, 1560],
63400:[595, 989, 1305, 1562],
63500:[596, 991, 1307, 1564],
63600:[597, 992, 1309, 1567],
63700:[598, 994, 1311, 1569],
63800:[599, 995, 1313, 1571],
63900:[599, 997, 1314, 1573],
64000:[600, 998, 1316, 1576],
64100:[601, 999, 1318, 1578],
64200:[602, 1001, 1320, 1580],
64300:[603, 1002, 1322, 1583],
64400:[604, 1004, 1323, 1585],
64500:[605, 1005, 1325, 1587],
64600:[606, 1007, 1327, 1589],
64700:[607, 1008, 1329, 1592],
64800:[608, 1010, 1331, 1594],
64900:[609, 1011, 1333, 1596],
65000:[610, 1012, 1334, 1598],
65100:[611, 1013, 1336, 1600],
65200:[612, 1015, 1338, 1602],
65300:[613, 1016, 1340, 1605],
65400:[614, 1018, 1341, 1607],
65500:[615, 1019, 1343, 1609],
65600:[616, 1021, 1345, 1611],
65700:[617, 1022, 1347, 1613],
65800:[618, 1024, 1349, 1616],
65900:[619, 1025, 1351, 1618],
66000:[619, 1027, 1353, 1620],
66100:[620, 1029, 1355, 1622],
66200:[621, 1030, 1357, 1625],
66300:[622, 1032, 1359, 1627],
66400:[623, 1033, 1361, 1629],
66500:[624, 1035, 1363, 1631],
66600:[625, 1036, 1365, 1634],
66700:[626, 1038, 1367, 1636],
66800:[627, 1039, 1369, 1638],
66900:[628, 1041, 1371, 1640],
67000:[629, 1042, 1373, 1643],
67100:[630, 1044, 1375, 1645],
67200:[631, 1045, 1377, 1648],
67300:[632, 1047, 1379, 1650],
67400:[633, 1048, 1381, 1652],
67500:[634, 1050, 1383, 1655],
67600:[635, 1052, 1385, 1657],
67700:[636, 1053, 1387, 1660],
67800:[637, 1055, 1389, 1662],
67900:[638, 1056, 1391, 1664],
68000:[639, 1058, 1393, 1667],
68100:[640, 1060, 1395, 1669],
68200:[641, 1061, 1397, 1672],
68300:[642, 1063, 1399, 1674],
68400:[643, 1064, 1401, 1676],
68500:[644, 1066, 1403, 1679],
68600:[645, 1067, 1405, 1681],
68700:[646, 1069, 1407, 1683],
68800:[647, 1070, 1409, 1686],
68900:[648, 1072, 1411, 1688],
69000:[649, 1073, 1413, 1690],
69100:[650, 1075, 1415, 1692],
69200:[651, 1076, 1417, 1695],
69300:[652, 1078, 1419, 1697],
69400:[653, 1079, 1421, 1699],
69500:[654, 1081, 1423, 1702],
69600:[655, 1083, 1425, 1704],
69700:[656, 1084, 1427, 1706],
69800:[657, 1086, 1429, 1709],
69900:[658, 1087, 1431, 1711],
70000:[659, 1089, 1433, 1714],
70100:[660, 1091, 1435, 1716],
70200:[661, 1092, 1437, 1719],
70300:[662, 1094, 1439, 1721],
70400:[663, 1095, 1441, 1724],
70500:[664, 1097, 1443, 1726],
70600:[665, 1098, 1445, 1728],
70700:[666, 1100, 1447, 1731],
70800:[667, 1101, 1449, 1733],
70900:[668, 1103, 1451, 1736],
71000:[669, 1104, 1453, 1738],
71100:[670, 1106, 1455, 1740],
71200:[671, 1107, 1457, 1743],
71300:[672, 1109, 1459, 1745],
71400:[673, 1110, 1461, 1747],
71500:[674, 1112, 1463, 1750],
71600:[675, 1114, 1465, 1752],
71700:[676, 1115, 1467, 1754],
71800:[677, 1117, 1469, 1757],
71900:[678, 1118, 1471, 1759],
72000:[679, 1120, 1472, 1761],
72100:[680, 1122, 1474, 1763],
72200:[681, 1123, 1476, 1766],
72300:[682, 1125, 1478, 1768],
72400:[683, 1126, 1480, 1771],
72500:[684, 1128, 1482, 1773],
72600:[685, 1129, 1484, 1775],
72700:[686, 1131, 1486, 1778],
72800:[687, 1132, 1488, 1780],
72900:[688, 1134, 1490, 1782],
73000:[689, 1135, 1492, 1785],
73100:[690, 1137, 1494, 1787],
73200:[691, 1138, 1496, 1790],
73300:[692, 1140, 1498, 1792],
73400:[693, 1141, 1500, 1794],
73500:[694, 1143, 1502, 1797],
73600:[695, 1145, 1504, 1799],
73700:[696, 1146, 1506, 1801],
73800:[697, 1148, 1508, 1804],
73900:[698, 1149, 1510, 1806],
74000:[698, 1151, 1512, 1808],
74100:[699, 1153, 1514, 1810],
74200:[700, 1154, 1516, 1813],
74300:[701, 1156, 1518, 1815],
74400:[702, 1157, 1520, 1817],
74500:[703, 1159, 1522, 1820],
74600:[704, 1160, 1524, 1822],
74700:[705, 1162, 1526, 1825],
74800:[706, 1163, 1528, 1827],
74900:[707, 1165, 1530, 1829],
75000:[708, 1166, 1532, 1832],
75100:[709, 1168, 1534, 1834],
75200:[710, 1169, 1536, 1837],
75300:[711, 1171, 1538, 1839],
75400:[712, 1172, 1540, 1841],
75500:[713, 1174, 1542, 1844],
75600:[714, 1176, 1544, 1846],
75700:[715, 1177, 1546, 1848],
75800:[716, 1179, 1548, 1851],
75900:[717, 1180, 1550, 1853],
76000:[718, 1182, 1552, 1855],
76100:[719, 1184, 1554, 1857],
76200:[720, 1185, 1556, 1860],
76300:[721, 1187, 1558, 1862],
76400:[722, 1188, 1560, 1864],
76500:[723, 1190, 1562, 1867],
76600:[724, 1191, 1564, 1869],
76700:[725, 1193, 1566, 1872],
76800:[726, 1194, 1568, 1874],
76900:[727, 1196, 1570, 1876],
77000:[728, 1197, 1572, 1879],
77100:[729, 1199, 1574, 1881],
77200:[730, 1200, 1576, 1884],
77300:[731, 1202, 1578, 1886],
77400:[732, 1203, 1580, 1889],
77500:[733, 1205, 1582, 1891],
77600:[734, 1207, 1584, 1893],
77700:[735, 1208, 1586, 1896],
77800:[736, 1210, 1588, 1898],
77900:[737, 1211, 1590, 1901],
78000:[738, 1213, 1592, 1903],
78100:[739, 1215, 1594, 1905],
78200:[740, 1216, 1596, 1908],
78300:[741, 1218, 1598, 1910],
78400:[742, 1219, 1600, 1912],
78500:[743, 1221, 1602, 1915],
78600:[744, 1222, 1604, 1917],
78700:[745, 1224, 1606, 1919],
78800:[746, 1225, 1608, 1922],
78900:[747, 1227, 1610, 1924],
79000:[748, 1228, 1612, 1926],
79100:[749, 1230, 1614, 1928],
79200:[750, 1231, 1616, 1931],
79300:[751, 1233, 1618, 1933],
79400:[752, 1234, 1620, 1936],
79500:[753, 1236, 1622, 1938],
79600:[754, 1237, 1624, 1940],
79700:[755, 1239, 1626, 1943],
79800:[756, 1241, 1628, 1945],
79900:[757, 1242, 1630, 1947],
80000:[758, 1244, 1632, 1950],
80100:[759, 1246, 1634, 1952],
80200:[760, 1247, 1636, 1955],
80300:[761, 1249, 1638, 1957],
80400:[762, 1250, 1640, 1959],
80500:[763, 1252, 1642, 1962],
80600:[764, 1253, 1644, 1964],
80700:[765, 1255, 1646, 1966],
80800:[766, 1256, 1648, 1969],
80900:[767, 1258, 1650, 1971],
81000:[768, 1259, 1652, 1973],
81100:[769, 1261, 1654, 1975],
81200:[770, 1262, 1656, 1978],
81300:[771, 1264, 1658, 1980],
81400:[772, 1265, 1660, 1982],
81500:[773, 1267, 1662, 1985],
81600:[774, 1268, 1664, 1987],
81700:[775, 1270, 1666, 1990],
81800:[776, 1272, 1668, 1992],
81900:[777, 1273, 1670, 1994],
82000:[778, 1275, 1672, 1997],
82100:[779, 1277, 1674, 1999],
82200:[780, 1278, 1676, 2002],
82300:[781, 1280, 1678, 2004],
82400:[782, 1281, 1680, 2006],
82500:[783, 1283, 1682, 2009],
82600:[784, 1284, 1684, 2011],
82700:[785, 1286, 1686, 2013],
82800:[786, 1287, 1688, 2016],
82900:[787, 1289, 1690, 2018],
83000:[788, 1290, 1692, 2020],
83100:[789, 1292, 1694, 2022],
83200:[790, 1293, 1696, 2025],
83300:[791, 1295, 1698, 2027],
83400:[792, 1296, 1700, 2029],
83500:[793, 1298, 1702, 2032],
83600:[794, 1299, 1704, 2034],
83700:[795, 1301, 1706, 2037],
83800:[796, 1303, 1708, 2039],
83900:[797, 1304, 1710, 2041],
84000:[798, 1306, 1712, 2044],
84100:[799, 1308, 1714, 2046],
84200:[800, 1309, 1716, 2049],
84300:[801, 1311, 1718, 2051],
84400:[802, 1312, 1720, 2054],
84500:[803, 1314, 1722, 2056],
84600:[804, 1315, 1724, 2058],
84700:[805, 1317, 1726, 2061],
84800:[806, 1318, 1728, 2063],
84900:[807, 1320, 1730, 2066],
85000:[808, 1321, 1732, 2068],
85100:[809, 1323, 1734, 2070],
85200:[810, 1324, 1736, 2073],
85300:[811, 1326, 1738, 2075],
85400:[812, 1327, 1740, 2077],
85500:[813, 1329, 1742, 2080],
85600:[814, 1330, 1744, 2082],
85700:[815, 1332, 1746, 2084],
85800:[816, 1334, 1748, 2087],
85900:[817, 1335, 1750, 2089],
86000:[818, 1337, 1752, 2091],
86100:[819, 1339, 1754, 2093],
86200:[820, 1340, 1756, 2096],
86300:[821, 1342, 1758, 2098],
86400:[822, 1343, 1760, 2101],
86500:[823, 1345, 1762, 2103],
86600:[824, 1346, 1764, 2105],
86700:[825, 1348, 1766, 2108],
86800:[826, 1349, 1768, 2110],
86900:[827, 1351, 1770, 2112],
87000:[828, 1352, 1772, 2115],
87100:[829, 1354, 1774, 2117],
87200:[830, 1355, 1776, 2120],
87300:[831, 1357, 1778, 2122],
87400:[832, 1358, 1780, 2124],
87500:[833, 1360, 1782, 2127],
87600:[834, 1361, 1784, 2129],
87700:[835, 1363, 1786, 2131],
87800:[836, 1365, 1788, 2134],
87900:[837, 1366, 1790, 2136],
88000:[838, 1368, 1792, 2138],
88100:[839, 1370, 1794, 2140],
88200:[840, 1371, 1796, 2143],
88300:[841, 1373, 1798, 2145],
88400:[842, 1374, 1800, 2147],
88500:[843, 1376, 1802, 2150],
88600:[844, 1377, 1804, 2152],
88700:[845, 1379, 1806, 2155],
88800:[846, 1380, 1808, 2157],
88900:[847, 1382, 1810, 2159],
89000:[848, 1383, 1812, 2162],
89100:[849, 1385, 1814, 2164],
89200:[850, 1386, 1816, 2167],
89300:[851, 1388, 1818, 2169],
89400:[852, 1389, 1820, 2171],
89500:[853, 1391, 1822, 2174],
89600:[854, 1392, 1824, 2176],
89700:[855, 1394, 1826, 2178],
89800:[856, 1396, 1828, 2181],
89900:[857, 1397, 1830, 2183],
90000:[858, 1399, 1831, 2185],
90100:[859, 1401, 1833, 2187],
90200:[860, 1402, 1835, 2190],
90300:[861, 1404, 1837, 2192],
90400:[862, 1405, 1839, 2194],
90500:[863, 1407, 1841, 2197],
90600:[864, 1408, 1843, 2199],
90700:[865, 1410, 1845, 2202],
90800:[866, 1411, 1847, 2204],
90900:[867, 1413, 1849, 2206],
91000:[868, 1414, 1851, 2209],
91100:[869, 1416, 1853, 2211],
91200:[870, 1417, 1855, 2214],
91300:[871, 1419, 1857, 2216],
91400:[872, 1420, 1859, 2219],
91500:[873, 1422, 1861, 2221],
91600:[874, 1423, 1863, 2223],
91700:[875, 1425, 1865, 2226],
91800:[876, 1427, 1867, 2228],
91900:[877, 1428, 1869, 2231],
92000:[878, 1430, 1871, 2233],
92100:[879, 1432, 1873, 2235],
92200:[880, 1433, 1875, 2237],
92300:[881, 1435, 1877, 2240],
92400:[882, 1436, 1878, 2242],
92500:[883, 1438, 1880, 2244],
92600:[884, 1439, 1882, 2246],
92700:[885, 1441, 1884, 2249],
92800:[886, 1442, 1886, 2251],
92900:[887, 1444, 1888, 2253],
93000:[888, 1445, 1890, 2255],
93100:[889, 1447, 1892, 2257],
93200:[890, 1448, 1894, 2260],
93300:[891, 1450, 1896, 2262],
93400:[892, 1451, 1898, 2264],
93500:[893, 1453, 1900, 2266],
93600:[894, 1454, 1902, 2269],
93700:[895, 1456, 1904, 2271],
93800:[896, 1457, 1906, 2273],
93900:[897, 1459, 1908, 2276],
94000:[897, 1460, 1910, 2278],
94100:[898, 1462, 1912, 2280],
94200:[899, 1463, 1914, 2282],
94300:[900, 1465, 1916, 2285],
94400:[901, 1466, 1918, 2287],
94500:[902, 1468, 1920, 2289],
94600:[903, 1469, 1922, 2291],
94700:[904, 1471, 1924, 2294],
94800:[905, 1472, 1926, 2296],
94900:[906, 1474, 1927, 2298],
95000:[907, 1475, 1929, 2300],
95100:[908, 1476, 1931, 2302],
95200:[909, 1478, 1933, 2305],
95300:[910, 1479, 1935, 2307],
95400:[911, 1481, 1937, 2309],
95500:[912, 1482, 1939, 2311],
95600:[913, 1484, 1941, 2314],
95700:[914, 1485, 1942, 2316],
95800:[914, 1487, 1944, 2318],
95900:[915, 1488, 1946, 2320],
96000:[916, 1489, 1948, 2323],
96100:[917, 1490, 1950, 2325],
96200:[918, 1492, 1952, 2328],
96300:[919, 1493, 1954, 2330],
96400:[920, 1495, 1956, 2332],
96500:[921, 1496, 1958, 2334],
96600:[922, 1498, 1959, 2337],
96700:[923, 1499, 1961, 2339],
96800:[924, 1501, 1963, 2341],
96900:[925, 1502, 1965, 2344],
97000:[926, 1504, 1967, 2346],
97100:[927, 1505, 1969, 2348],
97200:[928, 1507, 1971, 2350],
97300:[929, 1508, 1973, 2353],
97400:[930, 1510, 1975, 2355],
97500:[931, 1511, 1976, 2357],
97600:[931, 1513, 1978, 2359],
97700:[932, 1514, 1980, 2362],
97800:[933, 1516, 1982, 2364],
97900:[934, 1517, 1984, 2366],
98000:[935, 1519, 1986, 2368],
98100:[936, 1520, 1988, 2370],
98200:[937, 1522, 1990, 2373],
98300:[938, 1523, 1992, 2375],
98400:[939, 1525, 1993, 2377],
98500:[940, 1526, 1995, 2379],
98600:[941, 1528, 1997, 2382],
98700:[942, 1529, 1999, 2384],
98800:[943, 1531, 2001, 2386],
98900:[944, 1532, 2003, 2388],
99000:[945, 1534, 2005, 2391],
99100:[946, 1535, 2007, 2393],
99200:[947, 1537, 2009, 2396],
99300:[948, 1538, 2011, 2398],
99400:[949, 1540, 2013, 2400],
99500:[950, 1541, 2015, 2402],
99600:[951, 1543, 2017, 2405],
99700:[952, 1544, 2019, 2407],
99800:[953, 1546, 2021, 2409],
99900:[954, 1547, 2023, 2412],
};
const OR_BC=[0.84, 1.28, 1.66, 1.98];

// Manitoba — 2025 Federal Child Support Guidelines Table
const T_MB={
100000:[870, 1428, 1872, 2230],
100100:[871, 1429, 1874, 2232],
100200:[872, 1431, 1876, 2234],
100300:[872, 1432, 1877, 2236],
100400:[873, 1433, 1879, 2238],
100500:[874, 1435, 1881, 2240],
100600:[875, 1436, 1883, 2243],
100700:[876, 1437, 1884, 2245],
100800:[877, 1439, 1886, 2247],
100900:[877, 1440, 1888, 2249],
101000:[878, 1441, 1890, 2251],
101100:[879, 1442, 1892, 2253],
101200:[880, 1444, 1893, 2255],
101300:[881, 1445, 1895, 2257],
101400:[881, 1447, 1897, 2259],
101500:[882, 1448, 1899, 2261],
101600:[883, 1449, 1900, 2263],
101700:[884, 1451, 1902, 2265],
101800:[885, 1452, 1904, 2267],
101900:[886, 1453, 1906, 2269],
102000:[887, 1455, 1907, 2271],
102100:[888, 1456, 1909, 2273],
102200:[889, 1458, 1911, 2275],
102300:[890, 1459, 1912, 2277],
102400:[891, 1460, 1914, 2279],
102500:[892, 1462, 1916, 2281],
102600:[892, 1463, 1918, 2283],
102700:[893, 1464, 1919, 2285],
102800:[894, 1466, 1921, 2287],
102900:[895, 1467, 1923, 2290],
103000:[896, 1468, 1925, 2292],
103100:[897, 1469, 1927, 2294],
103200:[898, 1471, 1928, 2296],
103300:[899, 1472, 1930, 2298],
103400:[899, 1473, 1932, 2300],
103500:[900, 1474, 1934, 2302],
103600:[901, 1476, 1935, 2305],
103700:[902, 1477, 1937, 2307],
103800:[903, 1478, 1939, 2309],
103900:[904, 1480, 1941, 2311],
104000:[904, 1481, 1942, 2313],
104100:[905, 1482, 1944, 2315],
104200:[906, 1484, 1946, 2317],
104300:[907, 1485, 1947, 2319],
104400:[908, 1486, 1949, 2321],
104500:[908, 1488, 1951, 2323],
104600:[909, 1489, 1953, 2325],
104700:[910, 1490, 1954, 2327],
104800:[911, 1492, 1956, 2329],
104900:[912, 1493, 1958, 2331],
105000:[913, 1495, 1960, 2333],
105100:[914, 1496, 1962, 2335],
105200:[915, 1498, 1963, 2337],
105300:[915, 1499, 1965, 2339],
105400:[916, 1500, 1967, 2341],
105500:[917, 1502, 1969, 2343],
105600:[918, 1503, 1970, 2345],
105700:[919, 1504, 1972, 2348],
105800:[920, 1506, 1974, 2350],
105900:[920, 1507, 1976, 2352],
106000:[921, 1508, 1977, 2354],
106100:[922, 1509, 1979, 2356],
106200:[923, 1511, 1981, 2358],
106300:[924, 1512, 1982, 2360],
106400:[924, 1513, 1984, 2362],
106500:[925, 1515, 1986, 2365],
106600:[926, 1516, 1988, 2367],
106700:[927, 1518, 1989, 2369],
106800:[928, 1519, 1991, 2371],
106900:[929, 1520, 1993, 2373],
107000:[930, 1522, 1995, 2375],
107100:[931, 1523, 1997, 2377],
107200:[932, 1524, 1998, 2379],
107300:[932, 1526, 2000, 2381],
107400:[933, 1527, 2001, 2383],
107500:[934, 1528, 2003, 2385],
107600:[935, 1529, 2005, 2387],
107700:[936, 1531, 2006, 2389],
107800:[936, 1532, 2008, 2391],
107900:[937, 1533, 2010, 2393],
108000:[938, 1534, 2011, 2394],
108100:[939, 1535, 2013, 2396],
108200:[940, 1537, 2014, 2398],
108300:[940, 1538, 2016, 2400],
108400:[941, 1539, 2017, 2402],
108500:[942, 1540, 2019, 2403],
108600:[943, 1542, 2020, 2405],
108700:[943, 1543, 2022, 2407],
108800:[944, 1544, 2024, 2409],
108900:[945, 1545, 2025, 2411],
109000:[946, 1547, 2027, 2413],
109100:[947, 1548, 2029, 2415],
109200:[948, 1549, 2030, 2417],
109300:[948, 1551, 2032, 2419],
109400:[949, 1552, 2033, 2421],
109500:[950, 1553, 2035, 2423],
109600:[951, 1554, 2037, 2425],
109700:[952, 1556, 2038, 2426],
109800:[952, 1557, 2040, 2428],
109900:[953, 1558, 2041, 2430],
110000:[954, 1559, 2043, 2432],
110100:[955, 1560, 2045, 2434],
110200:[956, 1561, 2046, 2436],
110300:[956, 1563, 2048, 2438],
110400:[957, 1564, 2049, 2439],
110500:[958, 1565, 2051, 2441],
110600:[959, 1566, 2052, 2443],
110700:[960, 1568, 2054, 2445],
110800:[960, 1569, 2055, 2447],
110900:[961, 1570, 2057, 2449],
111000:[962, 1571, 2058, 2450],
111100:[963, 1572, 2060, 2452],
111200:[964, 1573, 2061, 2454],
111300:[964, 1575, 2063, 2456],
111400:[965, 1576, 2064, 2457],
111500:[966, 1577, 2066, 2459],
111600:[967, 1578, 2067, 2461],
111700:[968, 1579, 2069, 2463],
111800:[969, 1581, 2070, 2465],
111900:[969, 1582, 2072, 2467],
112000:[970, 1583, 2074, 2469],
112100:[971, 1584, 2076, 2471],
112200:[971, 1585, 2077, 2473],
112300:[972, 1587, 2079, 2475],
112400:[973, 1588, 2080, 2476],
112500:[974, 1589, 2082, 2478],
112600:[974, 1590, 2084, 2480],
112700:[975, 1591, 2085, 2482],
112800:[976, 1592, 2087, 2484],
112900:[977, 1594, 2088, 2486],
113000:[977, 1595, 2090, 2488],
113100:[978, 1596, 2092, 2490],
113200:[979, 1598, 2093, 2492],
113300:[979, 1599, 2095, 2494],
113400:[980, 1600, 2096, 2496],
113500:[981, 1601, 2098, 2497],
113600:[982, 1603, 2100, 2499],
113700:[982, 1604, 2101, 2501],
113800:[983, 1605, 2103, 2503],
113900:[984, 1606, 2105, 2505],
114000:[985, 1608, 2106, 2507],
114100:[986, 1609, 2108, 2509],
114200:[987, 1610, 2109, 2511],
114300:[987, 1612, 2111, 2513],
114400:[988, 1613, 2112, 2515],
114500:[989, 1614, 2114, 2517],
114600:[990, 1615, 2115, 2518],
114700:[990, 1617, 2117, 2520],
114800:[991, 1618, 2118, 2522],
114900:[992, 1619, 2120, 2524],
115000:[993, 1620, 2121, 2526],
115100:[994, 1621, 2123, 2528],
115200:[995, 1622, 2124, 2530],
115300:[995, 1624, 2126, 2532],
115400:[996, 1625, 2127, 2534],
115500:[997, 1626, 2129, 2536],
115600:[998, 1627, 2130, 2538],
115700:[998, 1628, 2132, 2539],
115800:[999, 1630, 2134, 2541],
115900:[1000, 1631, 2135, 2543],
116000:[1001, 1632, 2137, 2545],
116100:[1002, 1633, 2139, 2547],
116200:[1003, 1634, 2140, 2549],
116300:[1003, 1636, 2142, 2551],
116400:[1004, 1637, 2143, 2552],
116500:[1005, 1638, 2145, 2554],
116600:[1006, 1639, 2147, 2556],
116700:[1007, 1640, 2148, 2558],
116800:[1007, 1641, 2150, 2560],
116900:[1008, 1643, 2151, 2562],
117000:[1009, 1644, 2153, 2563],
117100:[1010, 1645, 2155, 2565],
117200:[1011, 1647, 2156, 2567],
117300:[1011, 1648, 2158, 2569],
117400:[1012, 1649, 2159, 2570],
117500:[1013, 1650, 2161, 2572],
117600:[1014, 1652, 2162, 2574],
117700:[1015, 1653, 2164, 2576],
117800:[1015, 1654, 2165, 2578],
117900:[1016, 1655, 2167, 2580],
118000:[1017, 1657, 2168, 2582],
118100:[1018, 1658, 2170, 2584],
118200:[1019, 1659, 2171, 2586],
118300:[1019, 1661, 2173, 2588],
118400:[1020, 1662, 2174, 2589],
118500:[1021, 1663, 2176, 2591],
118600:[1022, 1664, 2177, 2593],
118700:[1023, 1666, 2179, 2595],
118800:[1024, 1667, 2180, 2597],
118900:[1024, 1668, 2182, 2599],
119000:[1025, 1669, 2184, 2601],
119100:[1026, 1670, 2186, 2603],
119200:[1027, 1671, 2187, 2605],
119300:[1028, 1673, 2189, 2607],
119400:[1028, 1674, 2190, 2609],
119500:[1029, 1675, 2192, 2610],
119600:[1030, 1676, 2193, 2612],
119700:[1031, 1678, 2195, 2614],
119800:[1032, 1679, 2197, 2616],
119900:[1033, 1680, 2198, 2618],
120000:[1033, 1681, 2200, 2620],
120100:[1034, 1682, 2202, 2622],
120200:[1034, 1683, 2203, 2624],
120300:[1035, 1685, 2205, 2626],
120400:[1036, 1686, 2206, 2628],
120500:[1037, 1687, 2208, 2630],
120600:[1037, 1688, 2210, 2631],
120700:[1038, 1689, 2211, 2633],
120800:[1039, 1691, 2213, 2635],
120900:[1040, 1692, 2214, 2637],
121000:[1040, 1693, 2216, 2639],
121100:[1041, 1694, 2218, 2641],
121200:[1042, 1696, 2219, 2643],
121300:[1042, 1697, 2221, 2645],
121400:[1043, 1698, 2222, 2647],
121500:[1044, 1699, 2224, 2649],
121600:[1045, 1701, 2225, 2651],
121700:[1045, 1702, 2227, 2652],
121800:[1046, 1703, 2228, 2654],
121900:[1047, 1704, 2230, 2656],
122000:[1048, 1706, 2231, 2658],
122100:[1049, 1707, 2233, 2660],
122200:[1050, 1708, 2234, 2662],
122300:[1050, 1710, 2236, 2664],
122400:[1051, 1711, 2237, 2665],
122500:[1052, 1712, 2239, 2667],
122600:[1053, 1713, 2240, 2669],
122700:[1053, 1715, 2242, 2671],
122800:[1054, 1716, 2244, 2673],
122900:[1055, 1717, 2245, 2675],
123000:[1056, 1718, 2247, 2676],
123100:[1057, 1719, 2249, 2678],
123200:[1058, 1720, 2250, 2680],
123300:[1058, 1722, 2252, 2682],
123400:[1059, 1723, 2253, 2683],
123500:[1060, 1724, 2255, 2685],
123600:[1061, 1725, 2257, 2687],
123700:[1062, 1727, 2258, 2689],
123800:[1062, 1728, 2260, 2691],
123900:[1063, 1729, 2261, 2693],
124000:[1064, 1730, 2263, 2695],
124100:[1065, 1731, 2265, 2697],
124200:[1066, 1732, 2266, 2699],
124300:[1066, 1734, 2268, 2701],
124400:[1067, 1735, 2269, 2703],
124500:[1068, 1736, 2271, 2704],
124600:[1069, 1737, 2273, 2706],
124700:[1070, 1738, 2274, 2708],
124800:[1070, 1740, 2276, 2710],
124900:[1071, 1741, 2278, 2712],
125000:[1072, 1742, 2279, 2714],
125100:[1073, 1743, 2281, 2716],
125200:[1074, 1744, 2282, 2718],
125300:[1074, 1746, 2284, 2720],
125400:[1075, 1747, 2285, 2722],
125500:[1076, 1748, 2287, 2723],
125600:[1077, 1749, 2288, 2725],
125700:[1078, 1750, 2290, 2727],
125800:[1079, 1751, 2291, 2729],
125900:[1079, 1753, 2293, 2731],
126000:[1080, 1754, 2294, 2733],
126100:[1081, 1755, 2296, 2735],
126200:[1082, 1757, 2297, 2737],
126300:[1082, 1758, 2299, 2739],
126400:[1083, 1759, 2300, 2741],
126500:[1084, 1760, 2302, 2743],
126600:[1085, 1762, 2303, 2744],
126700:[1086, 1763, 2305, 2746],
126800:[1087, 1764, 2307, 2748],
126900:[1087, 1765, 2308, 2750],
127000:[1088, 1767, 2310, 2752],
127100:[1089, 1768, 2312, 2754],
127200:[1089, 1769, 2313, 2756],
127300:[1090, 1771, 2315, 2758],
127400:[1091, 1772, 2316, 2760],
127500:[1092, 1773, 2318, 2762],
127600:[1092, 1774, 2320, 2764],
127700:[1093, 1776, 2321, 2766],
127800:[1094, 1777, 2323, 2767],
127900:[1095, 1778, 2324, 2769],
128000:[1095, 1779, 2326, 2771],
128100:[1096, 1780, 2328, 2773],
128200:[1097, 1781, 2329, 2775],
128300:[1097, 1783, 2331, 2777],
128400:[1098, 1784, 2332, 2778],
128500:[1099, 1785, 2334, 2780],
128600:[1100, 1786, 2335, 2782],
128700:[1100, 1787, 2337, 2784],
128800:[1101, 1789, 2338, 2786],
128900:[1102, 1790, 2340, 2788],
129000:[1103, 1791, 2341, 2789],
129100:[1104, 1792, 2343, 2791],
129200:[1105, 1793, 2344, 2793],
129300:[1105, 1795, 2346, 2795],
129400:[1106, 1796, 2347, 2796],
129500:[1107, 1797, 2349, 2798],
129600:[1108, 1798, 2350, 2800],
129700:[1108, 1799, 2352, 2802],
129800:[1109, 1801, 2353, 2804],
129900:[1110, 1802, 2355, 2806],
130000:[1111, 1803, 2357, 2808],
130100:[1112, 1804, 2359, 2810],
130200:[1113, 1806, 2360, 2812],
130300:[1113, 1807, 2362, 2814],
130400:[1114, 1808, 2363, 2816],
130500:[1115, 1809, 2365, 2817],
130600:[1116, 1811, 2367, 2819],
130700:[1117, 1812, 2368, 2821],
130800:[1117, 1813, 2370, 2823],
130900:[1118, 1814, 2371, 2825],
131000:[1119, 1816, 2373, 2827],
131100:[1120, 1817, 2375, 2829],
131200:[1121, 1818, 2376, 2831],
131300:[1121, 1820, 2378, 2833],
131400:[1122, 1821, 2379, 2835],
131500:[1123, 1822, 2381, 2836],
131600:[1124, 1823, 2383, 2838],
131700:[1125, 1825, 2384, 2840],
131800:[1125, 1826, 2386, 2842],
131900:[1126, 1827, 2388, 2844],
132000:[1127, 1828, 2389, 2846],
132100:[1128, 1829, 2391, 2848],
132200:[1129, 1830, 2392, 2850],
132300:[1129, 1832, 2394, 2852],
132400:[1130, 1833, 2395, 2854],
132500:[1131, 1834, 2397, 2856],
132600:[1132, 1835, 2398, 2858],
132700:[1133, 1837, 2400, 2859],
132800:[1134, 1838, 2401, 2861],
132900:[1134, 1839, 2403, 2863],
133000:[1135, 1840, 2404, 2865],
133100:[1136, 1841, 2406, 2867],
133200:[1137, 1842, 2407, 2869],
133300:[1137, 1844, 2409, 2871],
133400:[1138, 1845, 2410, 2872],
133500:[1139, 1846, 2412, 2874],
133600:[1140, 1847, 2413, 2876],
133700:[1141, 1848, 2415, 2878],
133800:[1142, 1850, 2417, 2880],
133900:[1142, 1851, 2418, 2882],
134000:[1143, 1852, 2420, 2883],
134100:[1144, 1853, 2422, 2885],
134200:[1144, 1854, 2423, 2887],
134300:[1145, 1856, 2425, 2889],
134400:[1146, 1857, 2426, 2890],
134500:[1147, 1858, 2428, 2892],
134600:[1147, 1859, 2430, 2894],
134700:[1148, 1860, 2431, 2896],
134800:[1149, 1861, 2433, 2898],
134900:[1150, 1863, 2434, 2900],
135000:[1150, 1864, 2436, 2902],
135100:[1151, 1865, 2438, 2904],
135200:[1152, 1867, 2439, 2906],
135300:[1152, 1868, 2441, 2908],
135400:[1153, 1869, 2442, 2909],
135500:[1154, 1870, 2444, 2911],
135600:[1155, 1872, 2445, 2913],
135700:[1155, 1873, 2447, 2915],
135800:[1156, 1874, 2448, 2917],
135900:[1157, 1875, 2450, 2919],
136000:[1158, 1877, 2451, 2921],
136100:[1159, 1878, 2453, 2923],
136200:[1160, 1879, 2454, 2925],
136300:[1160, 1881, 2456, 2927],
136400:[1161, 1882, 2457, 2929],
136500:[1162, 1883, 2459, 2930],
136600:[1163, 1884, 2460, 2932],
136700:[1163, 1886, 2462, 2934],
136800:[1164, 1887, 2463, 2936],
136900:[1165, 1888, 2465, 2938],
137000:[1166, 1889, 2467, 2940],
137100:[1167, 1890, 2469, 2942],
137200:[1168, 1891, 2470, 2944],
137300:[1168, 1893, 2472, 2946],
137400:[1169, 1894, 2473, 2948],
137500:[1170, 1895, 2475, 2950],
137600:[1171, 1896, 2476, 2951],
137700:[1171, 1897, 2478, 2953],
137800:[1172, 1899, 2480, 2955],
137900:[1173, 1900, 2481, 2957],
138000:[1174, 1901, 2483, 2959],
138100:[1175, 1902, 2485, 2961],
138200:[1176, 1903, 2486, 2963],
138300:[1176, 1905, 2488, 2964],
138400:[1177, 1906, 2489, 2966],
138500:[1178, 1907, 2491, 2968],
138600:[1179, 1908, 2493, 2970],
138700:[1180, 1909, 2494, 2972],
138800:[1180, 1910, 2496, 2974],
138900:[1181, 1912, 2497, 2975],
139000:[1182, 1913, 2499, 2977],
139100:[1183, 1914, 2501, 2979],
139200:[1184, 1916, 2502, 2981],
139300:[1184, 1917, 2504, 2983],
139400:[1185, 1918, 2505, 2984],
139500:[1186, 1919, 2507, 2986],
139600:[1187, 1921, 2508, 2988],
139700:[1188, 1922, 2510, 2990],
139800:[1188, 1923, 2511, 2992],
139900:[1189, 1924, 2513, 2994],
140000:[1190, 1926, 2514, 2996],
140100:[1191, 1927, 2516, 2998],
140200:[1192, 1928, 2517, 3000],
140300:[1192, 1930, 2519, 3002],
140400:[1193, 1931, 2520, 3004],
140500:[1194, 1932, 2522, 3005],
140600:[1195, 1933, 2523, 3007],
140700:[1196, 1935, 2525, 3009],
140800:[1197, 1936, 2527, 3011],
140900:[1197, 1937, 2528, 3013],
141000:[1198, 1938, 2530, 3015],
141100:[1199, 1939, 2532, 3017],
141200:[1199, 1940, 2533, 3019],
141300:[1200, 1942, 2535, 3021],
141400:[1201, 1943, 2536, 3022],
141500:[1202, 1944, 2538, 3024],
141600:[1202, 1945, 2540, 3026],
141700:[1203, 1946, 2541, 3028],
141800:[1204, 1948, 2543, 3030],
141900:[1205, 1949, 2544, 3032],
142000:[1205, 1950, 2546, 3033],
142100:[1206, 1951, 2548, 3035],
142200:[1207, 1952, 2549, 3037],
142300:[1207, 1954, 2551, 3039],
142400:[1208, 1955, 2552, 3041],
142500:[1209, 1956, 2554, 3042],
142600:[1210, 1957, 2556, 3044],
142700:[1210, 1958, 2557, 3046],
142800:[1211, 1960, 2559, 3048],
142900:[1212, 1961, 2561, 3050],
143000:[1213, 1962, 2562, 3052],
143100:[1214, 1963, 2564, 3054],
143200:[1215, 1965, 2565, 3056],
143300:[1215, 1966, 2567, 3057],
143400:[1216, 1967, 2568, 3059],
143500:[1217, 1968, 2570, 3061],
143600:[1218, 1970, 2571, 3063],
143700:[1218, 1971, 2573, 3065],
143800:[1219, 1972, 2574, 3067],
143900:[1220, 1973, 2576, 3068],
144000:[1221, 1975, 2577, 3070],
144100:[1222, 1976, 2579, 3072],
144200:[1223, 1977, 2580, 3074],
144300:[1223, 1979, 2582, 3076],
144400:[1224, 1980, 2583, 3077],
144500:[1225, 1981, 2585, 3079],
144600:[1226, 1982, 2586, 3081],
144700:[1226, 1984, 2588, 3083],
144800:[1227, 1985, 2590, 3085],
144900:[1228, 1986, 2591, 3087],
145000:[1229, 1987, 2593, 3089],
145100:[1230, 1988, 2595, 3091],
145200:[1231, 1989, 2596, 3093],
145300:[1231, 1991, 2598, 3094],
145400:[1232, 1992, 2599, 3096],
145500:[1233, 1993, 2601, 3098],
145600:[1234, 1994, 2603, 3100],
145700:[1235, 1996, 2604, 3102],
145800:[1235, 1997, 2606, 3103],
145900:[1236, 1998, 2607, 3105],
146000:[1237, 1999, 2609, 3107],
146100:[1238, 2000, 2611, 3109],
146200:[1239, 2001, 2612, 3111],
146300:[1239, 2003, 2614, 3113],
146400:[1240, 2004, 2615, 3114],
146500:[1241, 2005, 2617, 3116],
146600:[1242, 2006, 2618, 3118],
146700:[1243, 2007, 2620, 3120],
146800:[1243, 2009, 2621, 3122],
146900:[1244, 2010, 2623, 3124],
147000:[1245, 2011, 2624, 3126],
147100:[1246, 2012, 2626, 3128],
147200:[1247, 2013, 2627, 3130],
147300:[1247, 2015, 2629, 3132],
147400:[1248, 2016, 2630, 3134],
147500:[1249, 2017, 2632, 3135],
147600:[1250, 2018, 2633, 3137],
147700:[1251, 2019, 2635, 3139],
147800:[1252, 2020, 2636, 3141],
147900:[1252, 2022, 2638, 3143],
148000:[1253, 2023, 2640, 3145],
148100:[1254, 2024, 2642, 3147],
148200:[1254, 2026, 2643, 3149],
148300:[1255, 2027, 2645, 3151],
148400:[1256, 2028, 2646, 3152],
148500:[1257, 2029, 2648, 3154],
148600:[1257, 2031, 2650, 3156],
148700:[1258, 2032, 2651, 3158],
148800:[1259, 2033, 2653, 3160],
148900:[1260, 2034, 2654, 3162],
149000:[1260, 2036, 2656, 3163],
149100:[1261, 2037, 2658, 3165],
149200:[1262, 2038, 2659, 3167],
149300:[1262, 2040, 2661, 3169],
149400:[1263, 2041, 2662, 3171],
149500:[1264, 2042, 2664, 3172],
149600:[1265, 2043, 2666, 3174],
149700:[1265, 2045, 2667, 3176],
149800:[1266, 2046, 2669, 3178],
149900:[1267, 2047, 2671, 3180],
150000:[1268, 2048, 2672, 3182],
16000:[0, 0, 0, 0],
16100:[8, 8, 9, 10],
16200:[15, 17, 18, 19],
16300:[23, 25, 27, 29],
16400:[31, 34, 36, 38],
16500:[39, 42, 45, 48],
16600:[46, 50, 54, 58],
16700:[54, 59, 63, 67],
16800:[62, 67, 72, 77],
16900:[69, 76, 81, 86],
17000:[77, 84, 90, 96],
17100:[78, 88, 94, 101],
17200:[79, 92, 99, 106],
17300:[81, 96, 103, 110],
17400:[82, 101, 108, 115],
17500:[83, 105, 112, 120],
17600:[84, 109, 117, 125],
17700:[85, 113, 121, 129],
17800:[86, 117, 126, 134],
17900:[88, 121, 130, 139],
18000:[89, 125, 135, 144],
18100:[90, 129, 139, 148],
18200:[91, 132, 143, 153],
18300:[93, 136, 147, 157],
18400:[94, 140, 151, 161],
18500:[95, 144, 155, 165],
18600:[96, 147, 159, 170],
18700:[97, 151, 163, 174],
18800:[98, 155, 167, 178],
18900:[100, 158, 171, 183],
19000:[101, 162, 175, 187],
19100:[102, 166, 179, 191],
19200:[103, 169, 183, 196],
19300:[105, 173, 187, 200],
19400:[106, 177, 191, 204],
19500:[107, 180, 195, 208],
19600:[108, 184, 199, 213],
19700:[109, 188, 203, 217],
19800:[110, 192, 207, 221],
19900:[112, 195, 210, 226],
20000:[113, 199, 214, 230],
20100:[114, 203, 218, 234],
20200:[115, 206, 222, 239],
20300:[117, 210, 226, 243],
20400:[118, 214, 230, 247],
20500:[119, 217, 234, 252],
20600:[120, 221, 238, 256],
20700:[121, 225, 242, 260],
20800:[122, 229, 246, 265],
20900:[124, 232, 250, 269],
21000:[125, 236, 254, 273],
21100:[126, 240, 258, 277],
21200:[127, 243, 262, 281],
21300:[129, 247, 266, 286],
21400:[130, 251, 270, 290],
21500:[131, 254, 274, 294],
21600:[132, 258, 278, 298],
21700:[133, 262, 282, 303],
21800:[134, 265, 286, 307],
21900:[136, 269, 290, 311],
22000:[137, 273, 294, 315],
22100:[138, 277, 298, 319],
22200:[139, 281, 302, 324],
22300:[140, 284, 306, 328],
22400:[142, 288, 310, 332],
22500:[143, 292, 314, 336],
22600:[144, 296, 318, 341],
22700:[145, 299, 322, 345],
22800:[146, 303, 326, 349],
22900:[147, 307, 330, 353],
23000:[149, 311, 334, 358],
23100:[150, 315, 338, 363],
23200:[151, 319, 343, 367],
23300:[152, 323, 347, 372],
23400:[154, 327, 351, 376],
23500:[155, 331, 355, 381],
23600:[156, 335, 360, 385],
23700:[157, 339, 364, 390],
23800:[158, 343, 368, 395],
23900:[159, 347, 372, 399],
24000:[161, 350, 377, 404],
24100:[162, 354, 381, 409],
24200:[164, 358, 386, 413],
24300:[165, 362, 390, 418],
24400:[166, 366, 394, 423],
24500:[167, 370, 399, 427],
24600:[169, 374, 403, 432],
24700:[170, 378, 408, 437],
24800:[171, 382, 412, 441],
24900:[172, 386, 416, 446],
25000:[174, 391, 421, 451],
25100:[175, 394, 425, 455],
25200:[176, 397, 428, 459],
25300:[178, 400, 432, 463],
25400:[179, 403, 435, 467],
25500:[180, 406, 439, 471],
25600:[181, 409, 443, 474],
25700:[183, 411, 446, 478],
25800:[184, 414, 450, 482],
25900:[185, 417, 454, 486],
26000:[186, 420, 457, 490],
26100:[187, 420, 460, 494],
26200:[188, 420, 464, 497],
26300:[190, 421, 467, 501],
26400:[191, 421, 471, 505],
26500:[192, 421, 474, 508],
26600:[193, 421, 478, 512],
26700:[195, 421, 481, 516],
26800:[196, 422, 485, 520],
26900:[197, 422, 488, 523],
27000:[198, 422, 492, 527],
27100:[199, 422, 495, 531],
27200:[200, 422, 499, 535],
27300:[202, 422, 502, 538],
27400:[203, 422, 506, 542],
27500:[204, 423, 509, 546],
27600:[205, 423, 513, 550],
27700:[207, 423, 516, 553],
27800:[208, 423, 520, 557],
27900:[209, 423, 523, 561],
28000:[210, 423, 527, 565],
28100:[211, 423, 531, 569],
28200:[212, 424, 534, 572],
28300:[213, 424, 538, 576],
28400:[213, 424, 541, 580],
28500:[214, 424, 545, 584],
28600:[215, 425, 548, 587],
28700:[216, 425, 552, 591],
28800:[217, 425, 555, 595],
28900:[218, 425, 559, 599],
29000:[218, 426, 562, 602],
29100:[218, 427, 566, 606],
29200:[219, 427, 569, 609],
29300:[219, 428, 573, 613],
29400:[220, 428, 576, 617],
29500:[220, 429, 580, 621],
29600:[221, 429, 583, 624],
29700:[221, 430, 587, 628],
29800:[221, 430, 590, 632],
29900:[222, 431, 594, 635],
30000:[222, 431, 597, 639],
30100:[222, 432, 599, 643],
30200:[223, 433, 601, 647],
30300:[223, 433, 603, 650],
30400:[224, 434, 605, 654],
30500:[224, 435, 607, 658],
30600:[224, 436, 609, 662],
30700:[225, 436, 611, 665],
30800:[225, 437, 613, 669],
30900:[226, 438, 614, 673],
31000:[226, 439, 616, 677],
31100:[226, 440, 617, 681],
31200:[227, 441, 618, 684],
31300:[227, 442, 619, 688],
31400:[228, 443, 620, 692],
31500:[228, 444, 621, 696],
31600:[228, 445, 622, 699],
31700:[229, 446, 623, 703],
31800:[229, 447, 624, 707],
31900:[230, 448, 626, 711],
32000:[230, 449, 627, 714],
32100:[230, 450, 628, 718],
32200:[231, 451, 629, 721],
32300:[231, 452, 630, 725],
32400:[231, 452, 631, 728],
32500:[231, 453, 632, 732],
32600:[232, 454, 633, 736],
32700:[232, 455, 634, 739],
32800:[232, 456, 634, 743],
32900:[232, 457, 635, 747],
33000:[233, 457, 636, 750],
33100:[233, 458, 637, 753],
33200:[234, 458, 638, 757],
33300:[234, 459, 639, 760],
33400:[234, 460, 641, 764],
33500:[234, 461, 642, 767],
33600:[235, 461, 643, 771],
33700:[235, 462, 644, 774],
33800:[235, 463, 645, 777],
33900:[235, 464, 646, 781],
34000:[236, 464, 647, 784],
34100:[237, 465, 648, 787],
34200:[237, 466, 650, 790],
34300:[238, 467, 651, 794],
34400:[239, 468, 653, 797],
34500:[239, 469, 654, 800],
34600:[240, 470, 655, 803],
34700:[241, 471, 657, 806],
34800:[241, 472, 658, 810],
34900:[242, 474, 660, 813],
35000:[243, 475, 661, 816],
35100:[244, 477, 663, 818],
35200:[245, 478, 665, 820],
35300:[246, 480, 667, 822],
35400:[247, 481, 669, 824],
35500:[249, 483, 670, 826],
35600:[250, 484, 672, 828],
35700:[251, 486, 674, 830],
35800:[252, 488, 676, 832],
35900:[253, 489, 678, 834],
36000:[254, 491, 680, 836],
36100:[255, 493, 682, 839],
36200:[257, 495, 685, 841],
36300:[258, 496, 687, 844],
36400:[260, 498, 689, 846],
36500:[261, 500, 691, 849],
36600:[263, 502, 694, 851],
36700:[264, 504, 696, 854],
36800:[265, 506, 698, 856],
36900:[267, 507, 700, 859],
37000:[268, 509, 703, 861],
37100:[269, 511, 705, 864],
37200:[271, 513, 707, 866],
37300:[272, 515, 710, 869],
37400:[273, 516, 712, 871],
37500:[275, 518, 714, 874],
37600:[276, 520, 716, 876],
37700:[277, 522, 718, 879],
37800:[279, 524, 721, 881],
37900:[280, 526, 723, 884],
38000:[281, 528, 725, 887],
38100:[282, 530, 727, 890],
38200:[284, 532, 729, 892],
38300:[285, 533, 732, 895],
38400:[287, 535, 734, 897],
38500:[288, 537, 736, 900],
38600:[289, 539, 738, 902],
38700:[291, 541, 740, 905],
38800:[292, 543, 742, 907],
38900:[294, 544, 745, 910],
39000:[295, 546, 747, 912],
39100:[296, 548, 749, 915],
39200:[298, 550, 751, 917],
39300:[299, 551, 754, 920],
39400:[300, 553, 756, 922],
39500:[302, 555, 758, 925],
39600:[303, 557, 760, 927],
39700:[304, 559, 762, 930],
39800:[306, 560, 764, 932],
39900:[307, 562, 767, 935],
40000:[308, 564, 769, 937],
40100:[309, 566, 771, 939],
40200:[311, 568, 773, 942],
40300:[312, 569, 775, 944],
40400:[313, 571, 778, 947],
40500:[315, 573, 780, 949],
40600:[316, 575, 782, 952],
40700:[317, 576, 784, 954],
40800:[319, 578, 786, 957],
40900:[320, 580, 788, 959],
41000:[321, 582, 791, 962],
41100:[322, 584, 793, 964],
41200:[324, 586, 795, 967],
41300:[325, 587, 797, 969],
41400:[326, 589, 799, 972],
41500:[328, 591, 802, 974],
41600:[329, 593, 804, 977],
41700:[330, 595, 806, 979],
41800:[332, 596, 808, 982],
41900:[333, 598, 810, 984],
42000:[334, 600, 812, 986],
42100:[335, 602, 814, 988],
42200:[337, 604, 816, 991],
42300:[338, 605, 819, 993],
42400:[339, 607, 821, 996],
42500:[341, 609, 823, 998],
42600:[342, 611, 825, 1000],
42700:[343, 613, 827, 1003],
42800:[345, 615, 829, 1005],
42900:[346, 616, 832, 1008],
43000:[347, 618, 834, 1010],
43100:[348, 620, 836, 1012],
43200:[350, 622, 838, 1015],
43300:[351, 623, 841, 1017],
43400:[353, 625, 843, 1020],
43500:[354, 627, 845, 1022],
43600:[355, 629, 847, 1025],
43700:[357, 631, 849, 1027],
43800:[358, 633, 852, 1030],
43900:[360, 634, 854, 1032],
44000:[361, 636, 856, 1035],
44100:[362, 638, 858, 1037],
44200:[364, 640, 860, 1040],
44300:[365, 642, 863, 1042],
44400:[367, 644, 865, 1045],
44500:[368, 645, 867, 1047],
44600:[369, 647, 869, 1050],
44700:[371, 649, 871, 1052],
44800:[372, 651, 874, 1055],
44900:[373, 653, 876, 1057],
45000:[375, 655, 878, 1060],
45100:[376, 657, 880, 1062],
45200:[378, 659, 882, 1065],
45300:[379, 661, 885, 1067],
45400:[381, 662, 887, 1070],
45500:[382, 664, 889, 1072],
45600:[384, 666, 891, 1075],
45700:[385, 668, 893, 1077],
45800:[387, 670, 896, 1080],
45900:[388, 672, 898, 1082],
46000:[390, 673, 900, 1085],
46100:[391, 675, 902, 1087],
46200:[392, 676, 904, 1089],
46300:[393, 678, 906, 1092],
46400:[394, 679, 908, 1094],
46500:[395, 681, 910, 1096],
46600:[396, 682, 912, 1098],
46700:[397, 684, 913, 1100],
46800:[398, 685, 915, 1103],
46900:[399, 687, 917, 1105],
47000:[400, 688, 919, 1107],
47100:[401, 689, 921, 1109],
47200:[402, 691, 923, 1111],
47300:[403, 692, 924, 1113],
47400:[404, 693, 926, 1115],
47500:[404, 695, 928, 1117],
47600:[405, 696, 930, 1119],
47700:[406, 697, 932, 1121],
47800:[407, 699, 933, 1123],
47900:[408, 700, 935, 1126],
48000:[409, 702, 937, 1128],
48100:[410, 703, 939, 1130],
48200:[411, 705, 940, 1132],
48300:[412, 706, 942, 1134],
48400:[413, 707, 944, 1136],
48500:[414, 709, 946, 1138],
48600:[414, 710, 947, 1140],
48700:[415, 712, 949, 1143],
48800:[416, 713, 951, 1145],
48900:[417, 714, 953, 1147],
49000:[418, 716, 954, 1149],
49100:[419, 717, 956, 1151],
49200:[420, 719, 958, 1153],
49300:[421, 720, 959, 1155],
49400:[422, 722, 961, 1157],
49500:[423, 723, 963, 1159],
49600:[424, 724, 965, 1162],
49700:[425, 726, 966, 1164],
49800:[426, 727, 968, 1166],
49900:[426, 728, 970, 1168],
50000:[427, 730, 972, 1170],
50100:[428, 731, 974, 1172],
50200:[429, 733, 976, 1174],
50300:[430, 734, 978, 1176],
50400:[431, 736, 979, 1179],
50500:[432, 737, 981, 1181],
50600:[433, 739, 983, 1183],
50700:[434, 740, 985, 1185],
50800:[435, 742, 987, 1187],
50900:[436, 743, 989, 1189],
51000:[436, 745, 991, 1192],
51100:[437, 746, 993, 1194],
51200:[438, 748, 995, 1196],
51300:[439, 749, 996, 1199],
51400:[440, 751, 998, 1201],
51500:[441, 752, 1000, 1203],
51600:[442, 754, 1002, 1205],
51700:[443, 755, 1004, 1207],
51800:[444, 756, 1006, 1210],
51900:[444, 758, 1007, 1212],
52000:[445, 759, 1009, 1214],
52100:[446, 760, 1011, 1216],
52200:[447, 762, 1013, 1218],
52300:[448, 763, 1015, 1221],
52400:[449, 765, 1017, 1223],
52500:[450, 766, 1018, 1225],
52600:[451, 768, 1020, 1227],
52700:[452, 769, 1022, 1230],
52800:[453, 771, 1024, 1232],
52900:[453, 772, 1026, 1234],
53000:[454, 774, 1028, 1236],
53100:[455, 775, 1030, 1238],
53200:[456, 777, 1032, 1240],
53300:[457, 778, 1034, 1243],
53400:[458, 780, 1036, 1245],
53500:[459, 781, 1038, 1247],
53600:[460, 783, 1040, 1249],
53700:[460, 784, 1041, 1252],
53800:[461, 785, 1043, 1254],
53900:[462, 787, 1045, 1256],
54000:[463, 788, 1047, 1258],
54100:[464, 789, 1049, 1260],
54200:[465, 791, 1050, 1262],
54300:[466, 792, 1052, 1264],
54400:[467, 793, 1054, 1266],
54500:[467, 795, 1056, 1268],
54600:[468, 796, 1057, 1270],
54700:[469, 798, 1059, 1272],
54800:[470, 799, 1061, 1274],
54900:[471, 800, 1063, 1276],
55000:[472, 802, 1064, 1278],
55100:[473, 803, 1066, 1280],
55200:[474, 805, 1068, 1282],
55300:[474, 806, 1069, 1284],
55400:[475, 808, 1071, 1286],
55500:[476, 809, 1073, 1288],
55600:[477, 810, 1075, 1290],
55700:[478, 812, 1077, 1292],
55800:[479, 813, 1078, 1294],
55900:[479, 814, 1080, 1296],
56000:[480, 816, 1082, 1299],
56100:[481, 817, 1084, 1301],
56200:[482, 819, 1085, 1303],
56300:[483, 820, 1087, 1305],
56400:[483, 822, 1089, 1307],
56500:[484, 823, 1091, 1309],
56600:[485, 824, 1092, 1312],
56700:[486, 826, 1094, 1314],
56800:[487, 827, 1096, 1316],
56900:[488, 829, 1098, 1318],
57000:[489, 830, 1099, 1320],
57100:[490, 831, 1101, 1322],
57200:[491, 833, 1103, 1324],
57300:[492, 834, 1104, 1326],
57400:[493, 835, 1106, 1328],
57500:[493, 837, 1108, 1330],
57600:[494, 838, 1110, 1332],
57700:[495, 839, 1111, 1334],
57800:[496, 841, 1113, 1336],
57900:[497, 842, 1115, 1338],
58000:[498, 843, 1117, 1340],
58100:[499, 844, 1119, 1342],
58200:[500, 846, 1120, 1344],
58300:[501, 847, 1122, 1346],
58400:[501, 848, 1124, 1348],
58500:[502, 850, 1126, 1350],
58600:[503, 851, 1127, 1352],
58700:[504, 853, 1129, 1354],
58800:[505, 854, 1131, 1356],
58900:[506, 855, 1133, 1358],
59000:[506, 857, 1134, 1361],
59100:[507, 858, 1136, 1363],
59200:[508, 860, 1138, 1365],
59300:[509, 861, 1139, 1367],
59400:[509, 863, 1141, 1369],
59500:[510, 864, 1143, 1371],
59600:[511, 865, 1145, 1374],
59700:[512, 867, 1146, 1376],
59800:[513, 868, 1148, 1378],
59900:[514, 870, 1150, 1380],
60000:[515, 871, 1152, 1382],
60100:[516, 872, 1154, 1384],
60200:[517, 874, 1155, 1386],
60300:[518, 875, 1157, 1388],
60400:[519, 877, 1159, 1390],
60500:[520, 878, 1161, 1392],
60600:[520, 880, 1162, 1394],
60700:[521, 881, 1164, 1396],
60800:[522, 882, 1166, 1398],
60900:[523, 884, 1167, 1400],
61000:[524, 885, 1169, 1402],
61100:[525, 886, 1171, 1404],
61200:[526, 888, 1173, 1406],
61300:[527, 889, 1174, 1408],
61400:[527, 890, 1176, 1410],
61500:[528, 892, 1178, 1412],
61600:[529, 893, 1180, 1414],
61700:[530, 894, 1181, 1416],
61800:[531, 896, 1183, 1418],
61900:[532, 897, 1185, 1421],
62000:[532, 898, 1187, 1423],
62100:[533, 899, 1189, 1425],
62200:[534, 901, 1191, 1427],
62300:[535, 902, 1192, 1429],
62400:[535, 903, 1194, 1431],
62500:[536, 905, 1196, 1433],
62600:[537, 906, 1198, 1435],
62700:[538, 908, 1200, 1437],
62800:[539, 909, 1201, 1440],
62900:[540, 910, 1203, 1442],
63000:[541, 912, 1205, 1444],
63100:[542, 913, 1207, 1446],
63200:[543, 915, 1209, 1448],
63300:[544, 916, 1210, 1450],
63400:[545, 917, 1212, 1452],
63500:[545, 919, 1214, 1454],
63600:[546, 920, 1216, 1456],
63700:[547, 922, 1218, 1458],
63800:[548, 923, 1219, 1461],
63900:[549, 924, 1221, 1463],
64000:[550, 926, 1223, 1465],
64100:[551, 927, 1225, 1467],
64200:[552, 929, 1227, 1469],
64300:[553, 930, 1228, 1471],
64400:[554, 931, 1230, 1473],
64500:[555, 933, 1232, 1475],
64600:[555, 934, 1234, 1477],
64700:[556, 936, 1236, 1479],
64800:[557, 937, 1238, 1481],
64900:[558, 938, 1239, 1484],
65000:[559, 940, 1241, 1486],
65100:[560, 941, 1243, 1488],
65200:[561, 943, 1245, 1490],
65300:[562, 944, 1246, 1492],
65400:[563, 945, 1248, 1495],
65500:[564, 947, 1250, 1497],
65600:[565, 948, 1252, 1499],
65700:[566, 950, 1254, 1501],
65800:[566, 951, 1256, 1503],
65900:[567, 952, 1257, 1505],
66000:[568, 954, 1259, 1508],
66100:[569, 955, 1261, 1510],
66200:[570, 957, 1263, 1512],
66300:[571, 958, 1265, 1514],
66400:[572, 960, 1266, 1517],
66500:[573, 961, 1268, 1519],
66600:[574, 963, 1270, 1521],
66700:[575, 964, 1272, 1523],
66800:[576, 966, 1274, 1525],
66900:[577, 967, 1276, 1527],
67000:[577, 969, 1277, 1529],
67100:[578, 970, 1279, 1531],
67200:[579, 972, 1281, 1533],
67300:[580, 973, 1283, 1536],
67400:[581, 975, 1285, 1538],
67500:[582, 976, 1287, 1540],
67600:[583, 978, 1288, 1542],
67700:[584, 979, 1290, 1544],
67800:[585, 980, 1292, 1547],
67900:[586, 982, 1294, 1549],
68000:[586, 983, 1296, 1551],
68100:[587, 984, 1298, 1553],
68200:[588, 986, 1300, 1555],
68300:[589, 987, 1301, 1558],
68400:[590, 989, 1303, 1560],
68500:[591, 990, 1305, 1562],
68600:[592, 992, 1307, 1564],
68700:[592, 993, 1309, 1566],
68800:[593, 995, 1311, 1568],
68900:[594, 996, 1312, 1571],
69000:[595, 998, 1314, 1573],
69100:[596, 999, 1316, 1575],
69200:[597, 1001, 1318, 1578],
69300:[598, 1002, 1320, 1580],
69400:[599, 1004, 1321, 1582],
69500:[599, 1005, 1323, 1584],
69600:[600, 1007, 1325, 1587],
69700:[601, 1008, 1327, 1589],
69800:[602, 1010, 1329, 1591],
69900:[603, 1011, 1331, 1593],
70000:[604, 1013, 1333, 1596],
70100:[605, 1015, 1335, 1598],
70200:[606, 1016, 1337, 1600],
70300:[607, 1018, 1339, 1603],
70400:[608, 1019, 1340, 1605],
70500:[609, 1021, 1342, 1607],
70600:[610, 1022, 1344, 1609],
70700:[611, 1024, 1346, 1612],
70800:[612, 1025, 1348, 1614],
70900:[613, 1027, 1350, 1616],
71000:[614, 1028, 1352, 1618],
71100:[615, 1029, 1354, 1620],
71200:[616, 1031, 1356, 1622],
71300:[617, 1032, 1358, 1625],
71400:[618, 1034, 1360, 1627],
71500:[619, 1035, 1361, 1629],
71600:[620, 1037, 1363, 1631],
71700:[621, 1038, 1365, 1634],
71800:[622, 1040, 1367, 1636],
71900:[622, 1041, 1369, 1638],
72000:[623, 1042, 1371, 1640],
72100:[624, 1043, 1373, 1642],
72200:[625, 1045, 1375, 1644],
72300:[626, 1046, 1377, 1647],
72400:[627, 1048, 1379, 1649],
72500:[628, 1049, 1381, 1651],
72600:[628, 1051, 1382, 1653],
72700:[629, 1052, 1384, 1656],
72800:[630, 1054, 1386, 1658],
72900:[631, 1055, 1388, 1660],
73000:[632, 1057, 1390, 1662],
73100:[633, 1059, 1392, 1664],
73200:[634, 1060, 1394, 1666],
73300:[635, 1062, 1396, 1669],
73400:[636, 1063, 1398, 1671],
73500:[636, 1065, 1400, 1673],
73600:[637, 1066, 1402, 1675],
73700:[638, 1068, 1403, 1677],
73800:[639, 1069, 1405, 1680],
73900:[640, 1071, 1407, 1682],
74000:[641, 1072, 1409, 1684],
74100:[642, 1073, 1411, 1686],
74200:[643, 1075, 1413, 1688],
74300:[644, 1076, 1415, 1691],
74400:[645, 1078, 1416, 1693],
74500:[646, 1079, 1418, 1695],
74600:[647, 1081, 1420, 1697],
74700:[648, 1082, 1422, 1699],
74800:[649, 1083, 1424, 1701],
74900:[650, 1085, 1426, 1704],
75000:[651, 1086, 1427, 1706],
75100:[652, 1087, 1429, 1708],
75200:[653, 1089, 1431, 1710],
75300:[654, 1090, 1433, 1713],
75400:[655, 1092, 1434, 1715],
75500:[656, 1093, 1436, 1717],
75600:[657, 1095, 1438, 1719],
75700:[658, 1096, 1440, 1721],
75800:[658, 1098, 1442, 1723],
75900:[659, 1099, 1444, 1726],
76000:[660, 1101, 1446, 1728],
76100:[661, 1102, 1448, 1730],
76200:[662, 1104, 1450, 1733],
76300:[663, 1105, 1452, 1735],
76400:[664, 1107, 1454, 1737],
76500:[665, 1108, 1455, 1739],
76600:[665, 1110, 1457, 1742],
76700:[666, 1111, 1459, 1744],
76800:[667, 1113, 1461, 1746],
76900:[668, 1114, 1463, 1748],
77000:[669, 1116, 1465, 1751],
77100:[670, 1117, 1467, 1753],
77200:[671, 1119, 1469, 1755],
77300:[672, 1120, 1471, 1758],
77400:[673, 1122, 1473, 1760],
77500:[673, 1123, 1475, 1762],
77600:[674, 1124, 1476, 1764],
77700:[675, 1126, 1478, 1767],
77800:[676, 1127, 1480, 1769],
77900:[677, 1129, 1482, 1771],
78000:[678, 1130, 1484, 1773],
78100:[679, 1131, 1486, 1775],
78200:[680, 1133, 1488, 1777],
78300:[681, 1134, 1490, 1780],
78400:[682, 1136, 1492, 1782],
78500:[683, 1137, 1494, 1784],
78600:[684, 1139, 1496, 1786],
78700:[685, 1140, 1497, 1789],
78800:[686, 1142, 1499, 1791],
78900:[687, 1143, 1501, 1793],
79000:[688, 1145, 1503, 1795],
79100:[689, 1146, 1505, 1797],
79200:[690, 1148, 1507, 1799],
79300:[691, 1149, 1509, 1802],
79400:[692, 1151, 1510, 1804],
79500:[693, 1152, 1512, 1806],
79600:[694, 1154, 1514, 1808],
79700:[694, 1155, 1516, 1810],
79800:[695, 1156, 1518, 1813],
79900:[696, 1158, 1520, 1815],
80000:[697, 1159, 1521, 1817],
80100:[698, 1160, 1523, 1819],
80200:[699, 1162, 1525, 1821],
80300:[700, 1163, 1526, 1823],
80400:[701, 1165, 1528, 1825],
80500:[701, 1166, 1530, 1827],
80600:[702, 1167, 1532, 1830],
80700:[703, 1169, 1533, 1832],
80800:[704, 1170, 1535, 1834],
80900:[705, 1171, 1537, 1836],
81000:[706, 1173, 1539, 1838],
81100:[707, 1174, 1541, 1840],
81200:[708, 1176, 1543, 1842],
81300:[708, 1177, 1544, 1844],
81400:[709, 1178, 1546, 1846],
81500:[710, 1180, 1548, 1848],
81600:[711, 1181, 1550, 1851],
81700:[712, 1182, 1551, 1853],
81800:[713, 1184, 1553, 1855],
81900:[713, 1185, 1555, 1857],
82000:[714, 1186, 1557, 1859],
82100:[715, 1187, 1559, 1861],
82200:[716, 1189, 1560, 1863],
82300:[717, 1190, 1562, 1865],
82400:[717, 1191, 1564, 1867],
82500:[718, 1193, 1566, 1869],
82600:[719, 1194, 1567, 1871],
82700:[720, 1196, 1569, 1873],
82800:[721, 1197, 1571, 1875],
82900:[722, 1198, 1572, 1877],
83000:[723, 1200, 1574, 1879],
83100:[724, 1201, 1576, 1881],
83200:[725, 1203, 1578, 1883],
83300:[726, 1204, 1579, 1885],
83400:[727, 1205, 1581, 1887],
83500:[727, 1207, 1583, 1889],
83600:[728, 1208, 1585, 1891],
83700:[729, 1209, 1586, 1893],
83800:[730, 1211, 1588, 1895],
83900:[731, 1212, 1590, 1898],
84000:[732, 1213, 1592, 1900],
84100:[733, 1214, 1594, 1902],
84200:[734, 1216, 1595, 1904],
84300:[734, 1217, 1597, 1906],
84400:[735, 1219, 1599, 1908],
84500:[736, 1220, 1601, 1910],
84600:[737, 1221, 1602, 1913],
84700:[738, 1223, 1604, 1915],
84800:[739, 1224, 1606, 1917],
84900:[739, 1226, 1607, 1919],
85000:[740, 1227, 1609, 1921],
85100:[741, 1228, 1611, 1923],
85200:[742, 1230, 1613, 1925],
85300:[743, 1231, 1614, 1927],
85400:[743, 1232, 1616, 1929],
85500:[744, 1234, 1618, 1931],
85600:[745, 1235, 1620, 1933],
85700:[746, 1236, 1621, 1935],
85800:[747, 1238, 1623, 1937],
85900:[748, 1239, 1625, 1939],
86000:[749, 1240, 1627, 1941],
86100:[750, 1241, 1629, 1943],
86200:[751, 1243, 1630, 1945],
86300:[752, 1244, 1632, 1947],
86400:[753, 1245, 1634, 1949],
86500:[754, 1247, 1636, 1951],
86600:[754, 1248, 1637, 1953],
86700:[755, 1249, 1639, 1956],
86800:[756, 1250, 1641, 1958],
86900:[757, 1252, 1642, 1960],
87000:[758, 1253, 1644, 1962],
87100:[759, 1254, 1646, 1964],
87200:[760, 1256, 1648, 1966],
87300:[761, 1257, 1649, 1968],
87400:[761, 1258, 1651, 1970],
87500:[762, 1260, 1653, 1973],
87600:[763, 1261, 1655, 1975],
87700:[764, 1263, 1656, 1977],
87800:[765, 1264, 1658, 1979],
87900:[766, 1265, 1660, 1981],
88000:[766, 1267, 1662, 1983],
88100:[767, 1268, 1664, 1985],
88200:[768, 1270, 1665, 1987],
88300:[769, 1271, 1667, 1989],
88400:[770, 1272, 1669, 1991],
88500:[770, 1274, 1671, 1993],
88600:[771, 1275, 1672, 1995],
88700:[772, 1276, 1674, 1997],
88800:[773, 1278, 1676, 1999],
88900:[774, 1279, 1677, 2001],
89000:[775, 1280, 1679, 2003],
89100:[776, 1281, 1681, 2005],
89200:[777, 1283, 1683, 2007],
89300:[777, 1284, 1684, 2009],
89400:[778, 1286, 1686, 2011],
89500:[779, 1287, 1688, 2013],
89600:[780, 1288, 1690, 2015],
89700:[781, 1290, 1691, 2018],
89800:[782, 1291, 1693, 2020],
89900:[782, 1292, 1695, 2022],
90000:[783, 1294, 1697, 2024],
90100:[784, 1295, 1699, 2026],
90200:[785, 1297, 1700, 2028],
90300:[786, 1298, 1702, 2030],
90400:[786, 1299, 1704, 2032],
90500:[787, 1301, 1706, 2034],
90600:[788, 1302, 1707, 2036],
90700:[789, 1303, 1709, 2038],
90800:[790, 1305, 1711, 2040],
90900:[791, 1306, 1712, 2042],
91000:[792, 1307, 1714, 2044],
91100:[793, 1308, 1716, 2046],
91200:[794, 1310, 1718, 2048],
91300:[795, 1311, 1719, 2050],
91400:[796, 1312, 1721, 2052],
91500:[796, 1313, 1723, 2054],
91600:[797, 1315, 1725, 2056],
91700:[798, 1316, 1726, 2058],
91800:[799, 1317, 1728, 2060],
91900:[800, 1319, 1730, 2063],
92000:[801, 1320, 1732, 2065],
92100:[802, 1321, 1734, 2067],
92200:[803, 1323, 1736, 2069],
92300:[803, 1324, 1737, 2071],
92400:[804, 1325, 1739, 2073],
92500:[805, 1327, 1741, 2075],
92600:[806, 1328, 1743, 2078],
92700:[807, 1329, 1745, 2080],
92800:[808, 1331, 1746, 2082],
92900:[808, 1332, 1748, 2084],
93000:[809, 1334, 1750, 2086],
93100:[810, 1335, 1752, 2088],
93200:[811, 1337, 1753, 2090],
93300:[812, 1338, 1755, 2092],
93400:[812, 1339, 1757, 2094],
93500:[813, 1341, 1759, 2096],
93600:[814, 1342, 1760, 2098],
93700:[815, 1343, 1762, 2100],
93800:[816, 1345, 1764, 2102],
93900:[817, 1346, 1766, 2104],
94000:[818, 1347, 1767, 2106],
94100:[819, 1348, 1769, 2108],
94200:[820, 1350, 1771, 2110],
94300:[821, 1351, 1772, 2112],
94400:[822, 1352, 1774, 2114],
94500:[823, 1354, 1776, 2116],
94600:[823, 1355, 1778, 2118],
94700:[824, 1357, 1780, 2120],
94800:[825, 1358, 1781, 2123],
94900:[826, 1359, 1783, 2125],
95000:[827, 1361, 1785, 2127],
95100:[828, 1362, 1787, 2129],
95200:[829, 1364, 1788, 2131],
95300:[830, 1365, 1790, 2133],
95400:[830, 1366, 1792, 2135],
95500:[831, 1368, 1794, 2138],
95600:[832, 1369, 1795, 2140],
95700:[833, 1370, 1797, 2142],
95800:[834, 1372, 1799, 2144],
95900:[835, 1373, 1801, 2146],
96000:[835, 1374, 1802, 2148],
96100:[836, 1375, 1804, 2150],
96200:[837, 1377, 1806, 2152],
96300:[838, 1378, 1807, 2154],
96400:[839, 1380, 1809, 2156],
96500:[839, 1381, 1811, 2158],
96600:[840, 1382, 1813, 2160],
96700:[841, 1384, 1815, 2162],
96800:[842, 1385, 1816, 2164],
96900:[843, 1387, 1818, 2166],
97000:[844, 1388, 1820, 2168],
97100:[845, 1389, 1822, 2170],
97200:[846, 1391, 1823, 2172],
97300:[846, 1392, 1825, 2174],
97400:[847, 1393, 1827, 2176],
97500:[848, 1395, 1829, 2178],
97600:[849, 1396, 1830, 2180],
97700:[850, 1397, 1832, 2183],
97800:[851, 1399, 1834, 2185],
97900:[851, 1400, 1836, 2187],
98000:[852, 1401, 1837, 2189],
98100:[853, 1402, 1839, 2191],
98200:[854, 1404, 1841, 2193],
98300:[855, 1405, 1842, 2195],
98400:[855, 1406, 1844, 2197],
98500:[856, 1408, 1846, 2199],
98600:[857, 1409, 1848, 2201],
98700:[858, 1410, 1850, 2203],
98800:[859, 1411, 1851, 2205],
98900:[860, 1413, 1853, 2207],
99000:[861, 1414, 1855, 2209],
99100:[862, 1415, 1857, 2211],
99200:[863, 1417, 1858, 2213],
99300:[864, 1418, 1860, 2215],
99400:[865, 1419, 1862, 2217],
99500:[865, 1421, 1864, 2219],
99600:[866, 1422, 1865, 2221],
99700:[867, 1424, 1867, 2223],
99800:[868, 1425, 1869, 2225],
99900:[869, 1426, 1871, 2227],
};
const OR_MB=[0.76, 1.24, 1.62, 1.88];

// New Brunswick — 2025 Federal Child Support Guidelines Table
const T_NB={
100000:[880, 1442, 1892, 2260],
100100:[881, 1443, 1894, 2262],
100200:[882, 1445, 1896, 2264],
100300:[883, 1446, 1897, 2266],
100400:[884, 1448, 1899, 2268],
100500:[885, 1449, 1901, 2271],
100600:[885, 1450, 1903, 2273],
100700:[886, 1452, 1905, 2275],
100800:[887, 1453, 1906, 2277],
100900:[888, 1454, 1908, 2279],
101000:[889, 1456, 1910, 2281],
101100:[890, 1457, 1912, 2283],
101200:[891, 1459, 1913, 2285],
101300:[892, 1460, 1915, 2287],
101400:[893, 1462, 1917, 2290],
101500:[894, 1463, 1919, 2292],
101600:[895, 1464, 1920, 2294],
101700:[895, 1466, 1922, 2296],
101800:[896, 1467, 1924, 2298],
101900:[897, 1469, 1926, 2300],
102000:[898, 1470, 1927, 2302],
102100:[899, 1471, 1929, 2304],
102200:[900, 1473, 1931, 2306],
102300:[901, 1474, 1932, 2308],
102400:[901, 1475, 1934, 2310],
102500:[902, 1477, 1936, 2312],
102600:[903, 1478, 1938, 2314],
102700:[904, 1479, 1939, 2316],
102800:[905, 1481, 1941, 2318],
102900:[906, 1482, 1943, 2320],
103000:[906, 1483, 1945, 2322],
103100:[907, 1484, 1947, 2324],
103200:[908, 1486, 1948, 2326],
103300:[909, 1487, 1950, 2328],
103400:[909, 1488, 1952, 2330],
103500:[910, 1490, 1954, 2332],
103600:[911, 1491, 1955, 2334],
103700:[912, 1493, 1957, 2336],
103800:[913, 1494, 1959, 2338],
103900:[914, 1495, 1960, 2341],
104000:[915, 1497, 1962, 2343],
104100:[916, 1498, 1964, 2345],
104200:[917, 1500, 1966, 2347],
104300:[918, 1501, 1967, 2349],
104400:[919, 1503, 1969, 2351],
104500:[919, 1504, 1971, 2353],
104600:[920, 1505, 1973, 2355],
104700:[921, 1507, 1974, 2358],
104800:[922, 1508, 1976, 2360],
104900:[923, 1510, 1978, 2362],
105000:[924, 1511, 1980, 2364],
105100:[925, 1512, 1982, 2366],
105200:[926, 1514, 1984, 2368],
105300:[927, 1515, 1985, 2370],
105400:[928, 1516, 1987, 2372],
105500:[928, 1518, 1989, 2374],
105600:[929, 1519, 1991, 2377],
105700:[930, 1520, 1993, 2379],
105800:[931, 1522, 1994, 2381],
105900:[932, 1523, 1996, 2383],
106000:[933, 1524, 1998, 2385],
106100:[934, 1525, 2000, 2387],
106200:[935, 1527, 2001, 2389],
106300:[936, 1528, 2003, 2391],
106400:[937, 1529, 2005, 2393],
106500:[938, 1531, 2007, 2396],
106600:[938, 1532, 2008, 2398],
106700:[939, 1533, 2010, 2400],
106800:[940, 1535, 2012, 2402],
106900:[941, 1536, 2014, 2404],
107000:[942, 1538, 2015, 2406],
107100:[943, 1539, 2017, 2408],
107200:[944, 1541, 2018, 2410],
107300:[944, 1542, 2020, 2412],
107400:[945, 1543, 2022, 2414],
107500:[946, 1544, 2023, 2416],
107600:[947, 1546, 2025, 2418],
107700:[948, 1547, 2027, 2419],
107800:[949, 1548, 2028, 2421],
107900:[949, 1550, 2030, 2423],
108000:[950, 1551, 2032, 2425],
108100:[951, 1552, 2034, 2427],
108200:[952, 1554, 2035, 2429],
108300:[952, 1555, 2037, 2431],
108400:[953, 1556, 2038, 2432],
108500:[954, 1557, 2040, 2434],
108600:[955, 1559, 2042, 2436],
108700:[956, 1560, 2043, 2438],
108800:[956, 1561, 2045, 2440],
108900:[957, 1563, 2046, 2442],
109000:[958, 1564, 2048, 2444],
109100:[959, 1565, 2050, 2446],
109200:[960, 1566, 2051, 2448],
109300:[960, 1568, 2053, 2450],
109400:[961, 1569, 2054, 2452],
109500:[962, 1570, 2056, 2454],
109600:[963, 1571, 2058, 2456],
109700:[964, 1573, 2059, 2458],
109800:[964, 1574, 2061, 2460],
109900:[965, 1575, 2062, 2462],
110000:[966, 1576, 2064, 2464],
110100:[967, 1577, 2066, 2466],
110200:[968, 1579, 2067, 2468],
110300:[968, 1580, 2069, 2470],
110400:[969, 1581, 2070, 2472],
110500:[970, 1582, 2072, 2474],
110600:[971, 1584, 2073, 2476],
110700:[972, 1585, 2075, 2478],
110800:[972, 1586, 2077, 2480],
110900:[973, 1588, 2078, 2482],
111000:[974, 1589, 2080, 2483],
111100:[975, 1590, 2082, 2485],
111200:[976, 1591, 2083, 2487],
111300:[976, 1593, 2085, 2489],
111400:[977, 1594, 2086, 2491],
111500:[978, 1595, 2088, 2493],
111600:[979, 1596, 2089, 2495],
111700:[979, 1598, 2091, 2497],
111800:[980, 1599, 2093, 2499],
111900:[981, 1600, 2094, 2500],
112000:[982, 1601, 2096, 2502],
112100:[983, 1602, 2098, 2504],
112200:[984, 1604, 2099, 2506],
112300:[984, 1605, 2101, 2508],
112400:[985, 1606, 2103, 2510],
112500:[986, 1607, 2104, 2512],
112600:[987, 1609, 2106, 2514],
112700:[987, 1610, 2108, 2516],
112800:[988, 1611, 2109, 2518],
112900:[989, 1612, 2111, 2519],
113000:[990, 1614, 2113, 2521],
113100:[991, 1615, 2115, 2523],
113200:[992, 1616, 2116, 2525],
113300:[992, 1618, 2118, 2527],
113400:[993, 1619, 2120, 2529],
113500:[994, 1620, 2121, 2531],
113600:[995, 1621, 2123, 2533],
113700:[995, 1623, 2125, 2535],
113800:[996, 1624, 2126, 2536],
113900:[997, 1625, 2128, 2538],
114000:[998, 1626, 2129, 2540],
114100:[999, 1627, 2131, 2542],
114200:[1000, 1629, 2132, 2544],
114300:[1000, 1630, 2134, 2546],
114400:[1001, 1631, 2136, 2548],
114500:[1002, 1632, 2137, 2550],
114600:[1003, 1634, 2139, 2552],
114700:[1003, 1635, 2140, 2554],
114800:[1004, 1636, 2142, 2555],
114900:[1005, 1637, 2144, 2557],
115000:[1006, 1639, 2145, 2559],
115100:[1007, 1640, 2147, 2561],
115200:[1008, 1641, 2148, 2563],
115300:[1008, 1643, 2150, 2565],
115400:[1009, 1644, 2151, 2567],
115500:[1010, 1645, 2153, 2569],
115600:[1011, 1646, 2155, 2571],
115700:[1011, 1648, 2156, 2572],
115800:[1012, 1649, 2158, 2574],
115900:[1013, 1650, 2160, 2576],
116000:[1014, 1651, 2161, 2578],
116100:[1015, 1652, 2163, 2580],
116200:[1016, 1654, 2164, 2582],
116300:[1017, 1655, 2166, 2584],
116400:[1017, 1656, 2167, 2586],
116500:[1018, 1657, 2169, 2588],
116600:[1019, 1659, 2171, 2590],
116700:[1020, 1660, 2172, 2591],
116800:[1021, 1661, 2174, 2593],
116900:[1022, 1662, 2176, 2595],
117000:[1023, 1664, 2177, 2597],
117100:[1024, 1665, 2179, 2599],
117200:[1025, 1666, 2180, 2601],
117300:[1026, 1668, 2182, 2603],
117400:[1026, 1669, 2183, 2605],
117500:[1027, 1670, 2185, 2607],
117600:[1028, 1671, 2187, 2609],
117700:[1029, 1672, 2188, 2610],
117800:[1030, 1674, 2190, 2612],
117900:[1031, 1675, 2191, 2614],
118000:[1031, 1676, 2193, 2616],
118100:[1032, 1677, 2195, 2618],
118200:[1033, 1679, 2196, 2620],
118300:[1034, 1680, 2198, 2622],
118400:[1034, 1681, 2199, 2624],
118500:[1035, 1682, 2201, 2626],
118600:[1036, 1684, 2203, 2627],
118700:[1037, 1685, 2204, 2629],
118800:[1038, 1686, 2206, 2631],
118900:[1039, 1687, 2207, 2633],
119000:[1039, 1689, 2209, 2635],
119100:[1040, 1690, 2211, 2637],
119200:[1041, 1691, 2212, 2639],
119300:[1042, 1693, 2214, 2641],
119400:[1042, 1694, 2215, 2643],
119500:[1043, 1695, 2217, 2645],
119600:[1044, 1696, 2218, 2646],
119700:[1045, 1697, 2220, 2648],
119800:[1046, 1699, 2222, 2650],
119900:[1047, 1700, 2223, 2652],
120000:[1047, 1701, 2225, 2654],
120100:[1048, 1702, 2227, 2656],
120200:[1049, 1704, 2228, 2658],
120300:[1049, 1705, 2230, 2660],
120400:[1050, 1706, 2231, 2662],
120500:[1051, 1707, 2233, 2664],
120600:[1052, 1709, 2234, 2665],
120700:[1053, 1710, 2236, 2667],
120800:[1054, 1711, 2238, 2669],
120900:[1054, 1712, 2239, 2671],
121000:[1055, 1714, 2241, 2673],
121100:[1056, 1715, 2243, 2675],
121200:[1057, 1717, 2244, 2677],
121300:[1057, 1718, 2246, 2679],
121400:[1058, 1719, 2248, 2681],
121500:[1059, 1720, 2249, 2683],
121600:[1060, 1722, 2251, 2684],
121700:[1061, 1723, 2253, 2686],
121800:[1062, 1724, 2254, 2688],
121900:[1062, 1726, 2256, 2690],
122000:[1063, 1727, 2258, 2692],
122100:[1064, 1728, 2260, 2694],
122200:[1065, 1729, 2261, 2696],
122300:[1065, 1731, 2263, 2698],
122400:[1066, 1732, 2265, 2700],
122500:[1067, 1733, 2266, 2701],
122600:[1068, 1734, 2268, 2703],
122700:[1069, 1736, 2270, 2705],
122800:[1070, 1737, 2271, 2707],
122900:[1070, 1738, 2273, 2709],
123000:[1071, 1739, 2274, 2711],
123100:[1072, 1740, 2276, 2713],
123200:[1073, 1742, 2277, 2715],
123300:[1073, 1743, 2279, 2717],
123400:[1074, 1744, 2281, 2719],
123500:[1075, 1745, 2282, 2720],
123600:[1076, 1747, 2284, 2722],
123700:[1077, 1748, 2285, 2724],
123800:[1078, 1749, 2287, 2726],
123900:[1078, 1751, 2289, 2728],
124000:[1079, 1752, 2290, 2730],
124100:[1080, 1753, 2292, 2732],
124200:[1081, 1754, 2293, 2734],
124300:[1081, 1756, 2295, 2736],
124400:[1082, 1757, 2296, 2738],
124500:[1083, 1758, 2298, 2739],
124600:[1084, 1759, 2300, 2741],
124700:[1085, 1761, 2301, 2743],
124800:[1085, 1762, 2303, 2745],
124900:[1086, 1763, 2305, 2747],
125000:[1087, 1764, 2306, 2749],
125100:[1088, 1765, 2308, 2751],
125200:[1089, 1767, 2309, 2753],
125300:[1089, 1768, 2311, 2755],
125400:[1090, 1769, 2312, 2757],
125500:[1091, 1770, 2314, 2758],
125600:[1092, 1772, 2316, 2760],
125700:[1093, 1773, 2317, 2762],
125800:[1093, 1774, 2319, 2764],
125900:[1094, 1776, 2321, 2766],
126000:[1095, 1777, 2322, 2768],
126100:[1096, 1778, 2324, 2770],
126200:[1097, 1779, 2325, 2772],
126300:[1097, 1781, 2327, 2774],
126400:[1098, 1782, 2328, 2776],
126500:[1099, 1783, 2330, 2777],
126600:[1100, 1784, 2332, 2779],
126700:[1101, 1786, 2333, 2781],
126800:[1101, 1787, 2335, 2783],
126900:[1102, 1788, 2336, 2785],
127000:[1103, 1789, 2338, 2787],
127100:[1104, 1790, 2340, 2789],
127200:[1105, 1792, 2341, 2791],
127300:[1105, 1793, 2343, 2793],
127400:[1106, 1794, 2344, 2795],
127500:[1107, 1795, 2346, 2796],
127600:[1108, 1797, 2348, 2798],
127700:[1109, 1798, 2349, 2800],
127800:[1109, 1799, 2351, 2802],
127900:[1110, 1801, 2352, 2804],
128000:[1111, 1802, 2354, 2806],
128100:[1112, 1803, 2356, 2808],
128200:[1113, 1804, 2357, 2810],
128300:[1113, 1806, 2359, 2812],
128400:[1114, 1807, 2360, 2813],
128500:[1115, 1808, 2362, 2815],
128600:[1116, 1809, 2363, 2817],
128700:[1117, 1811, 2365, 2819],
128800:[1117, 1812, 2367, 2821],
128900:[1118, 1813, 2368, 2823],
129000:[1119, 1814, 2370, 2825],
129100:[1120, 1815, 2372, 2827],
129200:[1121, 1817, 2373, 2829],
129300:[1121, 1818, 2375, 2831],
129400:[1122, 1819, 2376, 2832],
129500:[1123, 1820, 2378, 2834],
129600:[1124, 1822, 2379, 2836],
129700:[1124, 1823, 2381, 2838],
129800:[1125, 1824, 2383, 2840],
129900:[1126, 1825, 2384, 2842],
130000:[1127, 1827, 2386, 2844],
130100:[1128, 1828, 2388, 2846],
130200:[1129, 1829, 2389, 2848],
130300:[1129, 1831, 2391, 2850],
130400:[1130, 1832, 2393, 2851],
130500:[1131, 1833, 2394, 2853],
130600:[1132, 1834, 2396, 2855],
130700:[1132, 1836, 2398, 2857],
130800:[1133, 1837, 2399, 2859],
130900:[1134, 1838, 2401, 2861],
131000:[1135, 1839, 2403, 2863],
131100:[1136, 1840, 2405, 2865],
131200:[1137, 1842, 2406, 2867],
131300:[1137, 1843, 2408, 2869],
131400:[1138, 1844, 2410, 2870],
131500:[1139, 1845, 2411, 2872],
131600:[1140, 1847, 2413, 2874],
131700:[1140, 1848, 2415, 2876],
131800:[1141, 1849, 2416, 2878],
131900:[1142, 1850, 2418, 2880],
132000:[1143, 1852, 2419, 2882],
132100:[1144, 1853, 2421, 2884],
132200:[1145, 1854, 2422, 2886],
132300:[1145, 1856, 2424, 2888],
132400:[1146, 1857, 2426, 2889],
132500:[1147, 1858, 2427, 2891],
132600:[1148, 1859, 2429, 2893],
132700:[1148, 1861, 2430, 2895],
132800:[1149, 1862, 2432, 2897],
132900:[1150, 1863, 2434, 2899],
133000:[1151, 1864, 2435, 2901],
133100:[1152, 1865, 2437, 2903],
133200:[1153, 1867, 2438, 2905],
133300:[1153, 1868, 2440, 2907],
133400:[1154, 1869, 2441, 2909],
133500:[1155, 1870, 2443, 2911],
133600:[1156, 1872, 2445, 2913],
133700:[1156, 1873, 2446, 2915],
133800:[1157, 1874, 2448, 2917],
133900:[1158, 1875, 2450, 2919],
134000:[1159, 1877, 2451, 2921],
134100:[1160, 1878, 2453, 2923],
134200:[1161, 1879, 2454, 2925],
134300:[1162, 1881, 2456, 2927],
134400:[1162, 1882, 2457, 2929],
134500:[1163, 1883, 2459, 2931],
134600:[1164, 1884, 2461, 2933],
134700:[1165, 1885, 2462, 2935],
134800:[1166, 1887, 2464, 2937],
134900:[1167, 1888, 2466, 2939],
135000:[1168, 1889, 2467, 2940],
135100:[1169, 1890, 2469, 2942],
135200:[1170, 1892, 2470, 2944],
135300:[1171, 1893, 2472, 2946],
135400:[1171, 1894, 2473, 2948],
135500:[1172, 1895, 2475, 2950],
135600:[1173, 1897, 2477, 2952],
135700:[1174, 1898, 2478, 2954],
135800:[1175, 1899, 2480, 2956],
135900:[1176, 1900, 2481, 2958],
136000:[1176, 1902, 2483, 2959],
136100:[1177, 1903, 2485, 2961],
136200:[1178, 1905, 2486, 2963],
136300:[1179, 1906, 2488, 2965],
136400:[1179, 1907, 2489, 2967],
136500:[1180, 1909, 2491, 2969],
136600:[1181, 1910, 2493, 2971],
136700:[1182, 1911, 2494, 2973],
136800:[1183, 1912, 2496, 2975],
136900:[1184, 1914, 2497, 2976],
137000:[1184, 1915, 2499, 2978],
137100:[1185, 1916, 2501, 2980],
137200:[1186, 1917, 2502, 2982],
137300:[1187, 1919, 2504, 2984],
137400:[1187, 1920, 2505, 2986],
137500:[1188, 1921, 2507, 2988],
137600:[1189, 1922, 2508, 2990],
137700:[1190, 1924, 2510, 2992],
137800:[1191, 1925, 2512, 2994],
137900:[1192, 1926, 2513, 2995],
138000:[1192, 1927, 2515, 2997],
138100:[1193, 1928, 2517, 2999],
138200:[1194, 1930, 2518, 3001],
138300:[1194, 1931, 2520, 3003],
138400:[1195, 1932, 2521, 3005],
138500:[1196, 1933, 2523, 3007],
138600:[1197, 1935, 2524, 3009],
138700:[1198, 1936, 2526, 3011],
138800:[1199, 1937, 2528, 3012],
138900:[1199, 1939, 2529, 3014],
139000:[1200, 1940, 2531, 3016],
139100:[1201, 1941, 2533, 3018],
139200:[1202, 1942, 2534, 3020],
139300:[1202, 1944, 2536, 3022],
139400:[1203, 1945, 2538, 3024],
139500:[1204, 1946, 2539, 3026],
139600:[1205, 1947, 2541, 3028],
139700:[1206, 1949, 2543, 3030],
139800:[1207, 1950, 2544, 3031],
139900:[1207, 1951, 2546, 3033],
140000:[1208, 1952, 2548, 3035],
140100:[1209, 1953, 2550, 3037],
140200:[1210, 1955, 2551, 3039],
140300:[1210, 1956, 2553, 3041],
140400:[1211, 1957, 2555, 3043],
140500:[1212, 1958, 2556, 3045],
140600:[1213, 1960, 2558, 3047],
140700:[1214, 1961, 2560, 3048],
140800:[1215, 1962, 2561, 3050],
140900:[1215, 1964, 2563, 3052],
141000:[1216, 1965, 2564, 3054],
141100:[1217, 1966, 2566, 3056],
141200:[1218, 1967, 2567, 3058],
141300:[1218, 1969, 2569, 3060],
141400:[1219, 1970, 2571, 3062],
141500:[1220, 1971, 2572, 3064],
141600:[1221, 1972, 2574, 3066],
141700:[1222, 1974, 2575, 3067],
141800:[1223, 1975, 2577, 3069],
141900:[1223, 1976, 2579, 3071],
142000:[1224, 1977, 2580, 3073],
142100:[1225, 1978, 2582, 3075],
142200:[1226, 1980, 2583, 3077],
142300:[1226, 1981, 2585, 3079],
142400:[1227, 1982, 2586, 3081],
142500:[1228, 1983, 2588, 3083],
142600:[1229, 1985, 2590, 3085],
142700:[1230, 1986, 2591, 3086],
142800:[1230, 1987, 2593, 3088],
142900:[1231, 1989, 2595, 3090],
143000:[1232, 1990, 2596, 3092],
143100:[1233, 1991, 2598, 3094],
143200:[1234, 1992, 2599, 3096],
143300:[1234, 1994, 2601, 3098],
143400:[1235, 1995, 2602, 3100],
143500:[1236, 1996, 2604, 3102],
143600:[1237, 1997, 2606, 3103],
143700:[1238, 1999, 2607, 3105],
143800:[1238, 2000, 2609, 3107],
143900:[1239, 2001, 2611, 3109],
144000:[1240, 2002, 2612, 3111],
144100:[1241, 2003, 2614, 3113],
144200:[1242, 2005, 2615, 3115],
144300:[1242, 2006, 2617, 3117],
144400:[1243, 2007, 2618, 3119],
144500:[1244, 2008, 2620, 3121],
144600:[1245, 2010, 2622, 3122],
144700:[1246, 2011, 2623, 3124],
144800:[1246, 2012, 2625, 3126],
144900:[1247, 2013, 2626, 3128],
145000:[1248, 2015, 2628, 3130],
145100:[1249, 2016, 2630, 3132],
145200:[1250, 2017, 2631, 3134],
145300:[1250, 2019, 2633, 3136],
145400:[1251, 2020, 2634, 3138],
145500:[1252, 2021, 2636, 3140],
145600:[1253, 2022, 2638, 3141],
145700:[1254, 2024, 2639, 3143],
145800:[1254, 2025, 2641, 3145],
145900:[1255, 2026, 2642, 3147],
146000:[1256, 2027, 2644, 3149],
146100:[1257, 2028, 2646, 3151],
146200:[1258, 2030, 2647, 3153],
146300:[1258, 2031, 2649, 3155],
146400:[1259, 2032, 2650, 3157],
146500:[1260, 2033, 2652, 3159],
146600:[1261, 2035, 2653, 3160],
146700:[1262, 2036, 2655, 3162],
146800:[1262, 2037, 2657, 3164],
146900:[1263, 2038, 2658, 3166],
147000:[1264, 2040, 2660, 3168],
147100:[1265, 2041, 2662, 3170],
147200:[1266, 2042, 2663, 3172],
147300:[1266, 2044, 2665, 3174],
147400:[1267, 2045, 2666, 3176],
147500:[1268, 2046, 2668, 3177],
147600:[1269, 2047, 2669, 3179],
147700:[1269, 2049, 2671, 3181],
147800:[1270, 2050, 2673, 3183],
147900:[1271, 2051, 2674, 3185],
148000:[1272, 2052, 2676, 3187],
148100:[1273, 2053, 2678, 3189],
148200:[1274, 2055, 2679, 3191],
148300:[1274, 2056, 2681, 3193],
148400:[1275, 2057, 2683, 3195],
148500:[1276, 2058, 2684, 3196],
148600:[1277, 2060, 2686, 3198],
148700:[1277, 2061, 2688, 3200],
148800:[1278, 2062, 2689, 3202],
148900:[1279, 2063, 2691, 3204],
149000:[1280, 2065, 2693, 3206],
149100:[1281, 2066, 2695, 3208],
149200:[1282, 2067, 2696, 3210],
149300:[1282, 2069, 2698, 3212],
149400:[1283, 2070, 2700, 3214],
149500:[1284, 2071, 2701, 3215],
149600:[1285, 2072, 2703, 3217],
149700:[1285, 2073, 2705, 3219],
149800:[1286, 2075, 2706, 3221],
149900:[1287, 2076, 2708, 3223],
150000:[1288, 2077, 2709, 3225],
16000:[0, 0, 0, 0],
16100:[9, 10, 11, 12],
16200:[19, 20, 22, 23],
16300:[28, 30, 32, 35],
16400:[37, 40, 43, 46],
16500:[47, 51, 54, 58],
16600:[56, 61, 65, 70],
16700:[65, 71, 76, 81],
16800:[74, 81, 86, 93],
16900:[84, 91, 97, 104],
17000:[93, 101, 108, 116],
17100:[94, 106, 113, 121],
17200:[95, 110, 118, 127],
17300:[95, 115, 124, 132],
17400:[96, 120, 129, 138],
17500:[97, 125, 134, 143],
17600:[98, 129, 139, 149],
17700:[99, 134, 144, 154],
17800:[100, 139, 149, 160],
17900:[100, 144, 155, 165],
18000:[101, 148, 160, 171],
18100:[102, 152, 165, 176],
18200:[103, 157, 169, 181],
18300:[104, 161, 174, 186],
18400:[104, 165, 179, 191],
18500:[105, 170, 184, 196],
18600:[106, 174, 188, 201],
18700:[107, 179, 193, 207],
18800:[108, 183, 198, 212],
18900:[109, 187, 202, 217],
19000:[110, 192, 207, 222],
19100:[111, 196, 212, 227],
19200:[112, 201, 216, 232],
19300:[113, 205, 221, 237],
19400:[114, 209, 225, 242],
19500:[115, 213, 230, 247],
19600:[115, 218, 235, 252],
19700:[116, 222, 239, 257],
19800:[117, 226, 244, 262],
19900:[118, 231, 249, 266],
20000:[119, 235, 253, 271],
20100:[120, 239, 258, 276],
20200:[121, 244, 262, 281],
20300:[122, 248, 267, 286],
20400:[122, 252, 272, 291],
20500:[123, 256, 276, 296],
20600:[124, 261, 281, 301],
20700:[125, 265, 286, 306],
20800:[126, 269, 290, 311],
20900:[127, 273, 295, 316],
21000:[127, 278, 300, 321],
21100:[128, 282, 304, 326],
21200:[129, 286, 309, 330],
21300:[130, 290, 313, 335],
21400:[131, 294, 317, 339],
21500:[131, 298, 322, 344],
21600:[132, 302, 326, 348],
21700:[133, 306, 330, 353],
21800:[134, 310, 335, 358],
21900:[135, 314, 339, 362],
22000:[136, 318, 343, 367],
22100:[137, 322, 347, 371],
22200:[138, 325, 351, 376],
22300:[139, 329, 355, 380],
22400:[139, 333, 359, 384],
22500:[140, 336, 363, 388],
22600:[141, 340, 366, 393],
22700:[142, 344, 370, 397],
22800:[143, 347, 374, 401],
22900:[144, 351, 378, 405],
23000:[144, 355, 382, 410],
23100:[145, 359, 386, 415],
23200:[146, 363, 391, 419],
23300:[147, 367, 395, 424],
23400:[148, 371, 399, 428],
23500:[148, 374, 403, 433],
23600:[149, 378, 408, 437],
23700:[150, 382, 412, 442],
23800:[151, 386, 416, 446],
23900:[152, 390, 420, 451],
24000:[153, 394, 425, 455],
24100:[154, 398, 429, 460],
24200:[155, 402, 433, 464],
24300:[155, 406, 438, 469],
24400:[156, 410, 442, 473],
24500:[157, 414, 446, 478],
24600:[158, 418, 450, 482],
24700:[159, 422, 455, 487],
24800:[160, 426, 459, 491],
24900:[160, 430, 463, 496],
25000:[161, 434, 467, 500],
25100:[162, 436, 471, 504],
25200:[163, 438, 474, 508],
25300:[164, 441, 478, 511],
25400:[164, 443, 481, 515],
25500:[165, 445, 485, 519],
25600:[166, 447, 489, 523],
25700:[167, 450, 492, 526],
25800:[168, 452, 496, 530],
25900:[169, 454, 499, 534],
26000:[170, 456, 503, 538],
26100:[171, 456, 506, 542],
26200:[172, 456, 510, 545],
26300:[172, 456, 513, 549],
26400:[173, 456, 516, 553],
26500:[174, 456, 520, 556],
26600:[175, 456, 523, 560],
26700:[176, 456, 526, 564],
26800:[177, 456, 530, 567],
26900:[177, 457, 533, 571],
27000:[178, 457, 536, 575],
27100:[179, 457, 539, 579],
27200:[180, 457, 543, 582],
27300:[181, 457, 546, 586],
27400:[181, 457, 549, 590],
27500:[182, 457, 553, 593],
27600:[183, 457, 556, 597],
27700:[184, 457, 560, 600],
27800:[185, 457, 563, 604],
27900:[186, 457, 566, 608],
28000:[187, 457, 570, 611],
28100:[188, 457, 573, 615],
28200:[189, 457, 577, 618],
28300:[190, 457, 580, 622],
28400:[191, 457, 584, 625],
28500:[192, 457, 587, 629],
28600:[192, 458, 590, 633],
28700:[193, 458, 594, 636],
28800:[194, 458, 597, 640],
28900:[195, 458, 600, 643],
29000:[196, 458, 604, 647],
29100:[197, 458, 607, 651],
29200:[198, 459, 611, 654],
29300:[199, 459, 614, 658],
29400:[199, 460, 618, 661],
29500:[200, 460, 621, 665],
29600:[201, 461, 624, 668],
29700:[202, 461, 628, 672],
29800:[203, 462, 631, 676],
29900:[204, 462, 635, 679],
30000:[204, 463, 638, 683],
30100:[205, 463, 639, 687],
30200:[206, 464, 640, 690],
30300:[207, 464, 642, 694],
30400:[208, 465, 643, 698],
30500:[208, 465, 644, 701],
30600:[209, 466, 645, 705],
30700:[210, 466, 646, 709],
30800:[211, 467, 648, 712],
30900:[212, 467, 649, 716],
31000:[213, 468, 650, 720],
31100:[214, 468, 651, 724],
31200:[215, 469, 652, 727],
31300:[216, 469, 653, 731],
31400:[216, 470, 654, 735],
31500:[217, 470, 654, 738],
31600:[218, 471, 655, 742],
31700:[219, 471, 656, 745],
31800:[220, 471, 657, 749],
31900:[221, 472, 658, 753],
32000:[221, 472, 659, 756],
32100:[222, 472, 660, 760],
32200:[223, 473, 661, 763],
32300:[224, 473, 661, 767],
32400:[225, 473, 662, 770],
32500:[225, 474, 663, 774],
32600:[226, 474, 664, 777],
32700:[227, 475, 664, 781],
32800:[228, 475, 665, 784],
32900:[229, 475, 666, 788],
33000:[230, 476, 667, 791],
33100:[231, 476, 668, 794],
33200:[231, 477, 668, 798],
33300:[232, 477, 669, 801],
33400:[232, 477, 670, 804],
33500:[233, 478, 671, 808],
33600:[233, 478, 671, 811],
33700:[234, 478, 672, 814],
33800:[234, 479, 673, 818],
33900:[235, 479, 673, 821],
34000:[235, 479, 674, 824],
34100:[235, 480, 675, 826],
34200:[235, 480, 676, 829],
34300:[236, 481, 677, 831],
34400:[236, 481, 678, 833],
34500:[236, 482, 679, 836],
34600:[236, 483, 680, 838],
34700:[236, 483, 681, 840],
34800:[237, 484, 682, 842],
34900:[237, 484, 683, 845],
35000:[237, 485, 684, 847],
35100:[238, 486, 686, 849],
35200:[238, 487, 687, 851],
35300:[239, 488, 689, 853],
35400:[240, 490, 690, 854],
35500:[240, 491, 692, 856],
35600:[241, 492, 693, 858],
35700:[242, 493, 695, 860],
35800:[242, 494, 696, 862],
35900:[243, 495, 698, 864],
36000:[243, 497, 700, 866],
36100:[244, 499, 702, 868],
36200:[246, 500, 704, 871],
36300:[247, 502, 706, 873],
36400:[248, 504, 709, 876],
36500:[249, 506, 711, 878],
36600:[251, 507, 713, 881],
36700:[252, 509, 715, 883],
36800:[253, 511, 717, 885],
36900:[255, 513, 719, 888],
37000:[256, 514, 721, 890],
37100:[257, 516, 723, 892],
37200:[258, 517, 725, 895],
37300:[260, 519, 727, 897],
37400:[261, 521, 730, 900],
37500:[262, 522, 732, 902],
37600:[263, 524, 734, 904],
37700:[265, 526, 736, 907],
37800:[266, 528, 738, 909],
37900:[267, 529, 740, 912],
38000:[268, 531, 742, 914],
38100:[269, 533, 744, 916],
38200:[271, 535, 746, 919],
38300:[272, 536, 748, 921],
38400:[273, 538, 750, 924],
38500:[274, 540, 753, 926],
38600:[276, 542, 755, 928],
38700:[277, 543, 757, 931],
38800:[278, 545, 759, 933],
38900:[280, 547, 761, 936],
39000:[281, 549, 763, 938],
39100:[282, 551, 765, 940],
39200:[283, 552, 767, 943],
39300:[285, 554, 769, 945],
39400:[286, 556, 771, 948],
39500:[287, 558, 774, 950],
39600:[288, 559, 776, 952],
39700:[290, 561, 778, 955],
39800:[291, 563, 780, 957],
39900:[292, 565, 782, 959],
40000:[293, 566, 784, 962],
40100:[294, 568, 786, 964],
40200:[296, 569, 788, 967],
40300:[297, 571, 790, 969],
40400:[298, 573, 792, 971],
40500:[299, 575, 794, 974],
40600:[301, 576, 796, 976],
40700:[302, 578, 798, 979],
40800:[303, 580, 800, 981],
40900:[304, 581, 802, 983],
41000:[306, 583, 804, 986],
41100:[307, 585, 806, 988],
41200:[308, 586, 808, 991],
41300:[310, 588, 810, 993],
41400:[311, 590, 812, 995],
41500:[312, 591, 814, 998],
41600:[313, 593, 816, 1000],
41700:[315, 594, 819, 1002],
41800:[316, 596, 821, 1005],
41900:[317, 598, 823, 1007],
42000:[318, 599, 825, 1009],
42100:[319, 601, 827, 1011],
42200:[321, 603, 829, 1014],
42300:[322, 604, 831, 1016],
42400:[323, 606, 833, 1018],
42500:[325, 608, 835, 1021],
42600:[326, 610, 837, 1023],
42700:[327, 611, 839, 1025],
42800:[328, 613, 841, 1027],
42900:[330, 615, 843, 1030],
43000:[331, 617, 845, 1032],
43100:[332, 619, 847, 1034],
43200:[334, 620, 849, 1037],
43300:[335, 622, 851, 1039],
43400:[336, 624, 853, 1041],
43500:[338, 626, 855, 1044],
43600:[339, 627, 857, 1046],
43700:[340, 629, 859, 1048],
43800:[342, 631, 862, 1051],
43900:[343, 633, 864, 1053],
44000:[344, 634, 866, 1056],
44100:[345, 636, 868, 1058],
44200:[347, 638, 870, 1061],
44300:[348, 639, 872, 1063],
44400:[349, 641, 874, 1066],
44500:[351, 643, 876, 1068],
44600:[352, 645, 878, 1070],
44700:[354, 646, 880, 1073],
44800:[355, 648, 882, 1075],
44900:[356, 650, 885, 1077],
45000:[358, 652, 887, 1080],
45100:[359, 654, 889, 1082],
45200:[361, 656, 891, 1085],
45300:[362, 657, 893, 1087],
45400:[364, 659, 896, 1090],
45500:[365, 661, 898, 1092],
45600:[366, 663, 900, 1094],
45700:[368, 665, 902, 1097],
45800:[369, 666, 904, 1099],
45900:[371, 668, 906, 1102],
46000:[372, 670, 909, 1104],
46100:[373, 672, 911, 1106],
46200:[374, 673, 913, 1109],
46300:[376, 675, 915, 1111],
46400:[377, 677, 917, 1113],
46500:[378, 678, 919, 1115],
46600:[379, 680, 921, 1118],
46700:[380, 682, 923, 1120],
46800:[382, 683, 925, 1122],
46900:[383, 685, 927, 1124],
47000:[384, 687, 929, 1127],
47100:[385, 688, 931, 1129],
47200:[386, 690, 933, 1131],
47300:[387, 691, 935, 1133],
47400:[388, 693, 937, 1136],
47500:[389, 694, 938, 1138],
47600:[390, 696, 940, 1140],
47700:[391, 697, 942, 1142],
47800:[392, 698, 944, 1144],
47900:[393, 700, 946, 1146],
48000:[394, 701, 948, 1149],
48100:[395, 702, 950, 1151],
48200:[396, 704, 951, 1153],
48300:[397, 705, 953, 1155],
48400:[398, 706, 955, 1157],
48500:[399, 708, 957, 1159],
48600:[400, 709, 958, 1162],
48700:[400, 710, 960, 1164],
48800:[401, 712, 962, 1166],
48900:[402, 713, 964, 1168],
49000:[403, 715, 965, 1170],
49100:[404, 716, 967, 1172],
49200:[405, 718, 969, 1174],
49300:[406, 719, 970, 1176],
49400:[407, 720, 972, 1178],
49500:[408, 722, 974, 1180],
49600:[409, 723, 976, 1182],
49700:[410, 725, 977, 1184],
49800:[411, 726, 979, 1186],
49900:[412, 727, 981, 1188],
50000:[413, 729, 983, 1190],
50100:[414, 730, 985, 1192],
50200:[415, 732, 987, 1194],
50300:[416, 733, 988, 1197],
50400:[417, 735, 990, 1199],
50500:[418, 736, 992, 1201],
50600:[419, 738, 994, 1203],
50700:[420, 739, 996, 1205],
50800:[421, 741, 997, 1207],
50900:[421, 742, 999, 1210],
51000:[422, 744, 1001, 1212],
51100:[423, 745, 1003, 1214],
51200:[424, 747, 1005, 1216],
51300:[425, 748, 1007, 1219],
51400:[426, 750, 1008, 1221],
51500:[427, 751, 1010, 1223],
51600:[428, 753, 1012, 1225],
51700:[429, 754, 1014, 1228],
51800:[430, 756, 1016, 1230],
51900:[431, 757, 1018, 1232],
52000:[432, 759, 1020, 1234],
52100:[433, 761, 1022, 1236],
52200:[434, 762, 1024, 1238],
52300:[435, 764, 1026, 1241],
52400:[436, 765, 1028, 1243],
52500:[437, 767, 1030, 1245],
52600:[438, 768, 1031, 1247],
52700:[439, 770, 1033, 1250],
52800:[440, 771, 1035, 1252],
52900:[441, 773, 1037, 1254],
53000:[442, 774, 1039, 1256],
53100:[443, 776, 1041, 1258],
53200:[444, 777, 1043, 1260],
53300:[445, 779, 1045, 1263],
53400:[446, 780, 1047, 1265],
53500:[447, 782, 1049, 1267],
53600:[448, 783, 1051, 1269],
53700:[449, 785, 1053, 1272],
53800:[450, 786, 1054, 1274],
53900:[451, 788, 1056, 1276],
54000:[452, 789, 1058, 1278],
54100:[453, 790, 1060, 1280],
54200:[454, 792, 1061, 1282],
54300:[455, 793, 1063, 1284],
54400:[456, 795, 1065, 1286],
54500:[457, 796, 1067, 1289],
54600:[458, 798, 1068, 1291],
54700:[459, 799, 1070, 1293],
54800:[460, 800, 1072, 1295],
54900:[461, 802, 1074, 1297],
55000:[462, 803, 1075, 1299],
55100:[463, 804, 1077, 1301],
55200:[464, 806, 1079, 1303],
55300:[465, 807, 1080, 1305],
55400:[466, 809, 1082, 1307],
55500:[467, 810, 1084, 1309],
55600:[467, 812, 1086, 1311],
55700:[468, 813, 1087, 1313],
55800:[469, 814, 1089, 1315],
55900:[470, 816, 1091, 1317],
56000:[471, 817, 1093, 1319],
56100:[472, 818, 1095, 1321],
56200:[473, 820, 1097, 1323],
56300:[474, 821, 1098, 1325],
56400:[475, 823, 1100, 1327],
56500:[476, 824, 1102, 1329],
56600:[477, 825, 1104, 1331],
56700:[478, 827, 1105, 1333],
56800:[479, 828, 1107, 1336],
56900:[480, 830, 1109, 1338],
57000:[481, 831, 1111, 1340],
57100:[482, 832, 1113, 1342],
57200:[483, 834, 1115, 1344],
57300:[484, 835, 1116, 1346],
57400:[485, 837, 1118, 1348],
57500:[486, 838, 1120, 1350],
57600:[486, 839, 1122, 1353],
57700:[487, 841, 1124, 1355],
57800:[488, 842, 1125, 1357],
57900:[489, 844, 1127, 1359],
58000:[490, 845, 1129, 1361],
58100:[491, 846, 1131, 1363],
58200:[492, 848, 1132, 1365],
58300:[493, 849, 1134, 1367],
58400:[494, 851, 1136, 1369],
58500:[495, 852, 1138, 1371],
58600:[496, 853, 1139, 1373],
58700:[497, 855, 1141, 1375],
58800:[498, 856, 1143, 1377],
58900:[499, 858, 1145, 1379],
59000:[500, 859, 1146, 1381],
59100:[501, 860, 1148, 1383],
59200:[502, 862, 1150, 1385],
59300:[503, 863, 1151, 1387],
59400:[504, 865, 1153, 1389],
59500:[505, 866, 1155, 1391],
59600:[505, 867, 1157, 1393],
59700:[506, 869, 1158, 1395],
59800:[507, 870, 1160, 1397],
59900:[508, 872, 1162, 1399],
60000:[509, 873, 1164, 1402],
60100:[510, 874, 1166, 1404],
60200:[511, 876, 1168, 1406],
60300:[512, 877, 1169, 1408],
60400:[513, 879, 1171, 1410],
60500:[514, 880, 1173, 1412],
60600:[515, 881, 1175, 1414],
60700:[516, 883, 1177, 1417],
60800:[517, 884, 1178, 1419],
60900:[518, 885, 1180, 1421],
61000:[519, 887, 1182, 1423],
61100:[520, 888, 1184, 1425],
61200:[521, 890, 1186, 1427],
61300:[522, 891, 1187, 1429],
61400:[523, 893, 1189, 1431],
61500:[524, 894, 1191, 1434],
61600:[524, 895, 1193, 1436],
61700:[525, 897, 1195, 1438],
61800:[526, 898, 1197, 1440],
61900:[527, 899, 1198, 1442],
62000:[528, 901, 1200, 1444],
62100:[529, 902, 1202, 1446],
62200:[530, 904, 1204, 1448],
62300:[531, 905, 1205, 1450],
62400:[532, 907, 1207, 1452],
62500:[533, 908, 1209, 1455],
62600:[534, 910, 1211, 1457],
62700:[535, 911, 1213, 1459],
62800:[536, 913, 1215, 1461],
62900:[537, 914, 1216, 1463],
63000:[538, 916, 1218, 1465],
63100:[539, 917, 1220, 1467],
63200:[540, 919, 1222, 1469],
63300:[541, 920, 1223, 1471],
63400:[542, 922, 1225, 1473],
63500:[543, 923, 1227, 1475],
63600:[544, 925, 1229, 1478],
63700:[545, 926, 1231, 1480],
63800:[546, 927, 1233, 1482],
63900:[547, 929, 1234, 1484],
64000:[548, 930, 1236, 1486],
64100:[549, 931, 1238, 1488],
64200:[550, 933, 1240, 1490],
64300:[551, 934, 1241, 1492],
64400:[552, 936, 1243, 1494],
64500:[553, 937, 1245, 1496],
64600:[554, 938, 1247, 1499],
64700:[554, 940, 1249, 1501],
64800:[555, 941, 1250, 1503],
64900:[556, 943, 1252, 1505],
65000:[557, 944, 1254, 1507],
65100:[558, 945, 1256, 1509],
65200:[559, 947, 1258, 1511],
65300:[560, 948, 1259, 1513],
65400:[561, 950, 1261, 1515],
65500:[562, 951, 1263, 1517],
65600:[563, 953, 1265, 1519],
65700:[564, 954, 1267, 1521],
65800:[565, 956, 1268, 1524],
65900:[566, 957, 1270, 1526],
66000:[567, 959, 1272, 1528],
66100:[568, 960, 1274, 1530],
66200:[569, 962, 1276, 1532],
66300:[570, 963, 1278, 1534],
66400:[571, 965, 1280, 1537],
66500:[572, 966, 1281, 1539],
66600:[573, 968, 1283, 1541],
66700:[574, 969, 1285, 1543],
66800:[575, 970, 1287, 1545],
66900:[576, 972, 1289, 1547],
67000:[577, 973, 1291, 1550],
67100:[578, 974, 1293, 1552],
67200:[579, 976, 1295, 1554],
67300:[580, 977, 1297, 1557],
67400:[581, 979, 1299, 1559],
67500:[582, 980, 1301, 1561],
67600:[583, 982, 1303, 1563],
67700:[584, 983, 1305, 1565],
67800:[585, 985, 1307, 1568],
67900:[586, 986, 1309, 1570],
68000:[587, 988, 1310, 1572],
68100:[588, 990, 1312, 1574],
68200:[589, 991, 1314, 1577],
68300:[590, 993, 1316, 1579],
68400:[591, 994, 1318, 1581],
68500:[592, 996, 1320, 1583],
68600:[593, 997, 1322, 1586],
68700:[594, 999, 1324, 1588],
68800:[595, 1000, 1326, 1590],
68900:[596, 1002, 1327, 1592],
69000:[597, 1004, 1329, 1595],
69100:[598, 1006, 1331, 1597],
69200:[599, 1007, 1333, 1599],
69300:[600, 1009, 1335, 1602],
69400:[601, 1010, 1337, 1604],
69500:[602, 1012, 1339, 1606],
69600:[603, 1013, 1341, 1608],
69700:[604, 1015, 1343, 1611],
69800:[605, 1016, 1345, 1613],
69900:[606, 1018, 1346, 1615],
70000:[607, 1019, 1348, 1617],
70100:[608, 1020, 1350, 1619],
70200:[609, 1022, 1352, 1621],
70300:[610, 1023, 1354, 1624],
70400:[611, 1025, 1355, 1626],
70500:[612, 1026, 1357, 1628],
70600:[613, 1028, 1359, 1630],
70700:[614, 1029, 1361, 1633],
70800:[615, 1031, 1363, 1635],
70900:[616, 1032, 1365, 1637],
71000:[617, 1033, 1366, 1639],
71100:[618, 1034, 1368, 1641],
71200:[619, 1036, 1370, 1643],
71300:[620, 1037, 1372, 1645],
71400:[621, 1039, 1373, 1647],
71500:[621, 1040, 1375, 1650],
71600:[622, 1042, 1377, 1652],
71700:[623, 1043, 1379, 1654],
71800:[624, 1045, 1381, 1656],
71900:[625, 1046, 1383, 1658],
72000:[626, 1048, 1385, 1660],
72100:[627, 1049, 1387, 1662],
72200:[628, 1051, 1389, 1664],
72300:[629, 1052, 1391, 1666],
72400:[629, 1054, 1392, 1669],
72500:[630, 1055, 1394, 1671],
72600:[631, 1057, 1396, 1673],
72700:[632, 1058, 1398, 1675],
72800:[633, 1060, 1400, 1677],
72900:[634, 1061, 1402, 1679],
73000:[635, 1062, 1403, 1682],
73100:[636, 1063, 1405, 1684],
73200:[637, 1065, 1407, 1686],
73300:[638, 1066, 1408, 1688],
73400:[639, 1068, 1410, 1690],
73500:[640, 1069, 1412, 1693],
73600:[641, 1071, 1414, 1695],
73700:[642, 1072, 1416, 1697],
73800:[643, 1073, 1418, 1699],
73900:[644, 1075, 1419, 1701],
74000:[645, 1076, 1421, 1703],
74100:[646, 1077, 1423, 1705],
74200:[647, 1079, 1425, 1707],
74300:[648, 1080, 1426, 1709],
74400:[649, 1082, 1428, 1712],
74500:[650, 1083, 1430, 1714],
74600:[651, 1084, 1432, 1716],
74700:[652, 1086, 1434, 1718],
74800:[653, 1087, 1435, 1720],
74900:[654, 1089, 1437, 1722],
75000:[654, 1090, 1439, 1725],
75100:[655, 1091, 1441, 1727],
75200:[656, 1093, 1443, 1729],
75300:[657, 1094, 1444, 1731],
75400:[658, 1096, 1446, 1733],
75500:[659, 1097, 1448, 1736],
75600:[660, 1098, 1450, 1738],
75700:[661, 1100, 1451, 1740],
75800:[662, 1101, 1453, 1742],
75900:[662, 1103, 1455, 1744],
76000:[663, 1104, 1457, 1746],
76100:[664, 1105, 1459, 1748],
76200:[665, 1107, 1461, 1750],
76300:[666, 1108, 1463, 1752],
76400:[667, 1110, 1464, 1755],
76500:[668, 1111, 1466, 1757],
76600:[669, 1112, 1468, 1759],
76700:[670, 1114, 1470, 1761],
76800:[670, 1115, 1472, 1763],
76900:[671, 1116, 1474, 1765],
77000:[672, 1118, 1476, 1768],
77100:[673, 1119, 1478, 1770],
77200:[674, 1121, 1480, 1772],
77300:[675, 1122, 1482, 1774],
77400:[676, 1124, 1483, 1776],
77500:[677, 1125, 1485, 1779],
77600:[678, 1127, 1487, 1781],
77700:[678, 1128, 1489, 1783],
77800:[679, 1130, 1491, 1785],
77900:[680, 1131, 1493, 1787],
78000:[681, 1133, 1494, 1789],
78100:[682, 1134, 1496, 1791],
78200:[683, 1136, 1498, 1793],
78300:[684, 1137, 1499, 1795],
78400:[685, 1139, 1501, 1798],
78500:[686, 1140, 1503, 1800],
78600:[686, 1142, 1505, 1802],
78700:[687, 1143, 1507, 1804],
78800:[688, 1145, 1509, 1806],
78900:[689, 1146, 1510, 1808],
79000:[690, 1147, 1512, 1811],
79100:[691, 1148, 1514, 1813],
79200:[692, 1150, 1516, 1815],
79300:[693, 1151, 1517, 1817],
79400:[694, 1153, 1519, 1819],
79500:[695, 1154, 1521, 1822],
79600:[695, 1156, 1523, 1824],
79700:[696, 1157, 1525, 1826],
79800:[697, 1158, 1526, 1828],
79900:[698, 1160, 1528, 1830],
80000:[699, 1161, 1530, 1832],
80100:[700, 1162, 1532, 1834],
80200:[701, 1164, 1534, 1836],
80300:[702, 1165, 1535, 1838],
80400:[703, 1167, 1537, 1841],
80500:[703, 1168, 1539, 1843],
80600:[704, 1170, 1541, 1845],
80700:[705, 1171, 1542, 1847],
80800:[706, 1172, 1544, 1849],
80900:[707, 1174, 1546, 1851],
81000:[708, 1175, 1548, 1854],
81100:[709, 1176, 1550, 1856],
81200:[710, 1178, 1552, 1858],
81300:[711, 1179, 1554, 1860],
81400:[712, 1181, 1555, 1862],
81500:[712, 1182, 1557, 1865],
81600:[713, 1183, 1559, 1867],
81700:[714, 1185, 1561, 1869],
81800:[715, 1186, 1563, 1871],
81900:[716, 1188, 1565, 1873],
82000:[717, 1189, 1567, 1875],
82100:[718, 1190, 1569, 1877],
82200:[719, 1192, 1571, 1879],
82300:[720, 1193, 1573, 1881],
82400:[720, 1195, 1574, 1884],
82500:[721, 1196, 1576, 1886],
82600:[722, 1197, 1578, 1888],
82700:[723, 1199, 1580, 1890],
82800:[724, 1200, 1582, 1892],
82900:[725, 1201, 1584, 1894],
83000:[726, 1203, 1585, 1897],
83100:[727, 1204, 1587, 1899],
83200:[728, 1206, 1589, 1901],
83300:[729, 1207, 1590, 1903],
83400:[729, 1208, 1592, 1905],
83500:[730, 1210, 1594, 1908],
83600:[731, 1211, 1596, 1910],
83700:[732, 1213, 1598, 1912],
83800:[733, 1214, 1600, 1914],
83900:[734, 1215, 1601, 1916],
84000:[735, 1217, 1603, 1918],
84100:[736, 1218, 1605, 1920],
84200:[737, 1220, 1607, 1922],
84300:[738, 1221, 1608, 1924],
84400:[739, 1223, 1610, 1927],
84500:[740, 1224, 1612, 1929],
84600:[741, 1226, 1614, 1931],
84700:[742, 1227, 1616, 1933],
84800:[743, 1229, 1617, 1935],
84900:[744, 1230, 1619, 1937],
85000:[745, 1232, 1621, 1940],
85100:[746, 1233, 1623, 1942],
85200:[747, 1235, 1625, 1944],
85300:[748, 1236, 1626, 1946],
85400:[749, 1238, 1628, 1948],
85500:[750, 1239, 1630, 1951],
85600:[751, 1241, 1632, 1953],
85700:[752, 1242, 1633, 1955],
85800:[753, 1244, 1635, 1957],
85900:[753, 1245, 1637, 1959],
86000:[754, 1246, 1639, 1961],
86100:[755, 1247, 1641, 1963],
86200:[756, 1249, 1643, 1965],
86300:[757, 1250, 1645, 1967],
86400:[758, 1252, 1646, 1970],
86500:[759, 1253, 1648, 1972],
86600:[760, 1255, 1650, 1974],
86700:[761, 1256, 1652, 1976],
86800:[761, 1257, 1654, 1978],
86900:[762, 1259, 1656, 1980],
87000:[763, 1260, 1658, 1983],
87100:[764, 1261, 1660, 1985],
87200:[765, 1263, 1662, 1987],
87300:[766, 1264, 1664, 1989],
87400:[767, 1266, 1665, 1991],
87500:[768, 1267, 1667, 1994],
87600:[769, 1268, 1669, 1996],
87700:[769, 1270, 1671, 1998],
87800:[770, 1271, 1673, 2000],
87900:[771, 1273, 1675, 2002],
88000:[772, 1274, 1676, 2004],
88100:[773, 1275, 1678, 2006],
88200:[774, 1277, 1680, 2008],
88300:[775, 1278, 1681, 2010],
88400:[776, 1280, 1683, 2013],
88500:[777, 1281, 1685, 2015],
88600:[777, 1282, 1687, 2017],
88700:[778, 1284, 1689, 2019],
88800:[779, 1285, 1691, 2021],
88900:[780, 1287, 1692, 2023],
89000:[781, 1288, 1694, 2026],
89100:[782, 1289, 1696, 2028],
89200:[783, 1291, 1698, 2030],
89300:[784, 1292, 1699, 2032],
89400:[785, 1294, 1701, 2034],
89500:[786, 1295, 1703, 2037],
89600:[786, 1296, 1705, 2039],
89700:[787, 1298, 1707, 2041],
89800:[788, 1299, 1708, 2043],
89900:[789, 1300, 1710, 2045],
90000:[790, 1302, 1712, 2047],
90100:[791, 1303, 1714, 2049],
90200:[792, 1305, 1716, 2051],
90300:[793, 1306, 1717, 2053],
90400:[794, 1307, 1719, 2056],
90500:[794, 1309, 1721, 2058],
90600:[795, 1310, 1723, 2060],
90700:[796, 1312, 1725, 2062],
90800:[797, 1313, 1726, 2064],
90900:[798, 1314, 1728, 2066],
91000:[799, 1316, 1730, 2069],
91100:[800, 1317, 1732, 2071],
91200:[801, 1319, 1734, 2073],
91300:[802, 1320, 1736, 2075],
91400:[803, 1322, 1737, 2077],
91500:[803, 1323, 1739, 2080],
91600:[804, 1325, 1741, 2082],
91700:[805, 1326, 1743, 2084],
91800:[806, 1328, 1745, 2086],
91900:[807, 1329, 1747, 2088],
92000:[808, 1331, 1749, 2090],
92100:[809, 1332, 1751, 2092],
92200:[810, 1334, 1753, 2094],
92300:[811, 1335, 1755, 2096],
92400:[811, 1337, 1756, 2099],
92500:[812, 1338, 1758, 2101],
92600:[813, 1340, 1760, 2103],
92700:[814, 1341, 1762, 2105],
92800:[815, 1342, 1764, 2107],
92900:[816, 1344, 1766, 2109],
93000:[817, 1345, 1767, 2112],
93100:[818, 1346, 1769, 2114],
93200:[819, 1348, 1771, 2116],
93300:[820, 1349, 1772, 2118],
93400:[820, 1351, 1774, 2120],
93500:[821, 1352, 1776, 2123],
93600:[822, 1354, 1778, 2125],
93700:[823, 1355, 1780, 2127],
93800:[824, 1356, 1782, 2129],
93900:[825, 1358, 1783, 2131],
94000:[826, 1359, 1785, 2133],
94100:[827, 1360, 1787, 2135],
94200:[828, 1362, 1789, 2137],
94300:[829, 1363, 1790, 2139],
94400:[830, 1365, 1792, 2142],
94500:[831, 1366, 1794, 2144],
94600:[832, 1367, 1796, 2146],
94700:[833, 1369, 1798, 2148],
94800:[834, 1370, 1799, 2150],
94900:[835, 1372, 1801, 2152],
95000:[836, 1373, 1803, 2155],
95100:[837, 1374, 1805, 2157],
95200:[838, 1376, 1807, 2159],
95300:[839, 1377, 1808, 2161],
95400:[840, 1379, 1810, 2163],
95500:[841, 1380, 1812, 2166],
95600:[842, 1381, 1814, 2168],
95700:[843, 1383, 1816, 2170],
95800:[844, 1384, 1817, 2172],
95900:[845, 1386, 1819, 2174],
96000:[845, 1387, 1821, 2176],
96100:[846, 1388, 1823, 2178],
96200:[847, 1390, 1825, 2180],
96300:[848, 1391, 1826, 2182],
96400:[848, 1393, 1828, 2184],
96500:[849, 1394, 1830, 2186],
96600:[850, 1395, 1832, 2188],
96700:[851, 1397, 1833, 2190],
96800:[852, 1398, 1835, 2192],
96900:[853, 1399, 1837, 2195],
97000:[853, 1401, 1839, 2197],
97100:[854, 1402, 1841, 2199],
97200:[855, 1404, 1843, 2201],
97300:[856, 1405, 1844, 2203],
97400:[856, 1407, 1846, 2205],
97500:[857, 1408, 1848, 2207],
97600:[858, 1409, 1850, 2209],
97700:[859, 1411, 1852, 2211],
97800:[860, 1412, 1853, 2214],
97900:[861, 1414, 1855, 2216],
98000:[862, 1415, 1857, 2218],
98100:[863, 1416, 1859, 2220],
98200:[864, 1418, 1860, 2222],
98300:[865, 1419, 1862, 2224],
98400:[865, 1420, 1864, 2226],
98500:[866, 1422, 1866, 2228],
98600:[867, 1423, 1867, 2230],
98700:[868, 1424, 1869, 2233],
98800:[869, 1426, 1871, 2235],
98900:[870, 1427, 1873, 2237],
99000:[871, 1428, 1874, 2239],
99100:[872, 1429, 1876, 2241],
99200:[873, 1431, 1878, 2243],
99300:[874, 1432, 1879, 2245],
99400:[875, 1433, 1881, 2247],
99500:[875, 1435, 1883, 2249],
99600:[876, 1436, 1885, 2252],
99700:[877, 1438, 1886, 2254],
99800:[878, 1439, 1888, 2256],
99900:[879, 1440, 1890, 2258],
};
const OR_NB=[0.78, 1.22, 1.64, 1.88];

// Newfoundland & Labrador — 2025 Federal Child Support Guidelines Table
const T_NL={
100000:[876, 1432, 1877, 2241],
100100:[877, 1433, 1879, 2243],
100200:[878, 1435, 1881, 2245],
100300:[879, 1436, 1882, 2247],
100400:[880, 1438, 1884, 2249],
100500:[880, 1439, 1886, 2252],
100600:[881, 1440, 1888, 2254],
100700:[882, 1442, 1890, 2256],
100800:[883, 1443, 1891, 2258],
100900:[884, 1444, 1893, 2260],
101000:[885, 1446, 1895, 2262],
101100:[886, 1447, 1897, 2264],
101200:[887, 1449, 1898, 2266],
101300:[888, 1450, 1900, 2268],
101400:[889, 1452, 1902, 2271],
101500:[889, 1453, 1904, 2273],
101600:[890, 1454, 1905, 2275],
101700:[891, 1456, 1907, 2277],
101800:[892, 1457, 1909, 2279],
101900:[893, 1459, 1911, 2281],
102000:[894, 1460, 1912, 2283],
102100:[895, 1461, 1914, 2285],
102200:[896, 1463, 1916, 2287],
102300:[897, 1464, 1917, 2289],
102400:[898, 1465, 1919, 2292],
102500:[899, 1467, 1921, 2294],
102600:[899, 1468, 1923, 2296],
102700:[900, 1469, 1924, 2298],
102800:[901, 1471, 1926, 2300],
102900:[902, 1472, 1928, 2302],
103000:[903, 1473, 1930, 2304],
103100:[904, 1474, 1932, 2306],
103200:[905, 1476, 1934, 2308],
103300:[906, 1477, 1935, 2310],
103400:[907, 1478, 1937, 2312],
103500:[908, 1480, 1939, 2314],
103600:[909, 1481, 1941, 2316],
103700:[909, 1482, 1943, 2318],
103800:[910, 1484, 1944, 2320],
103900:[911, 1485, 1946, 2322],
104000:[912, 1487, 1948, 2324],
104100:[913, 1488, 1950, 2326],
104200:[914, 1490, 1951, 2328],
104300:[915, 1491, 1953, 2330],
104400:[915, 1493, 1955, 2332],
104500:[916, 1494, 1957, 2334],
104600:[917, 1495, 1958, 2336],
104700:[918, 1497, 1960, 2338],
104800:[919, 1498, 1962, 2340],
104900:[920, 1499, 1964, 2343],
105000:[920, 1501, 1965, 2345],
105100:[921, 1502, 1967, 2347],
105200:[922, 1504, 1969, 2349],
105300:[923, 1505, 1970, 2351],
105400:[923, 1507, 1972, 2353],
105500:[924, 1508, 1974, 2355],
105600:[925, 1509, 1976, 2357],
105700:[926, 1511, 1977, 2359],
105800:[927, 1512, 1979, 2362],
105900:[928, 1514, 1981, 2364],
106000:[929, 1515, 1983, 2366],
106100:[930, 1516, 1985, 2368],
106200:[931, 1518, 1987, 2370],
106300:[932, 1519, 1988, 2372],
106400:[932, 1520, 1990, 2374],
106500:[933, 1522, 1992, 2376],
106600:[934, 1523, 1994, 2378],
106700:[935, 1524, 1996, 2381],
106800:[936, 1526, 1997, 2383],
106900:[937, 1527, 1999, 2385],
107000:[938, 1528, 2001, 2387],
107100:[939, 1529, 2003, 2389],
107200:[940, 1531, 2004, 2391],
107300:[940, 1532, 2006, 2393],
107400:[941, 1533, 2007, 2395],
107500:[942, 1534, 2009, 2397],
107600:[943, 1536, 2011, 2399],
107700:[944, 1537, 2012, 2401],
107800:[944, 1538, 2014, 2403],
107900:[945, 1539, 2016, 2405],
108000:[946, 1541, 2017, 2407],
108100:[947, 1542, 2019, 2409],
108200:[948, 1544, 2020, 2411],
108300:[949, 1545, 2022, 2413],
108400:[949, 1546, 2024, 2415],
108500:[950, 1547, 2025, 2417],
108600:[951, 1549, 2027, 2418],
108700:[952, 1550, 2029, 2420],
108800:[953, 1551, 2030, 2422],
108900:[954, 1552, 2032, 2424],
109000:[955, 1554, 2034, 2426],
109100:[956, 1555, 2036, 2428],
109200:[957, 1557, 2037, 2430],
109300:[958, 1558, 2039, 2432],
109400:[958, 1559, 2041, 2434],
109500:[959, 1560, 2042, 2435],
109600:[960, 1562, 2044, 2437],
109700:[961, 1563, 2045, 2439],
109800:[962, 1564, 2047, 2441],
109900:[963, 1566, 2049, 2443],
110000:[963, 1567, 2050, 2445],
110100:[964, 1568, 2052, 2447],
110200:[965, 1569, 2053, 2449],
110300:[966, 1571, 2055, 2451],
110400:[966, 1572, 2056, 2453],
110500:[967, 1573, 2058, 2454],
110600:[968, 1574, 2060, 2456],
110700:[969, 1576, 2061, 2458],
110800:[970, 1577, 2063, 2460],
110900:[971, 1578, 2065, 2462],
111000:[971, 1579, 2066, 2464],
111100:[972, 1580, 2068, 2466],
111200:[973, 1582, 2069, 2468],
111300:[973, 1583, 2071, 2470],
111400:[974, 1584, 2072, 2472],
111500:[975, 1585, 2074, 2473],
111600:[976, 1587, 2076, 2475],
111700:[977, 1588, 2077, 2477],
111800:[978, 1589, 2079, 2479],
111900:[978, 1591, 2080, 2481],
112000:[979, 1592, 2082, 2483],
112100:[980, 1593, 2084, 2485],
112200:[981, 1594, 2085, 2487],
112300:[981, 1596, 2087, 2489],
112400:[982, 1597, 2088, 2490],
112500:[983, 1598, 2090, 2492],
112600:[984, 1599, 2092, 2494],
112700:[985, 1601, 2093, 2496],
112800:[986, 1602, 2095, 2498],
112900:[986, 1603, 2096, 2500],
113000:[987, 1604, 2098, 2502],
113100:[988, 1605, 2100, 2504],
113200:[989, 1607, 2101, 2506],
113300:[989, 1608, 2103, 2508],
113400:[990, 1609, 2104, 2510],
113500:[991, 1610, 2106, 2512],
113600:[992, 1612, 2107, 2514],
113700:[993, 1613, 2109, 2516],
113800:[993, 1614, 2111, 2518],
113900:[994, 1615, 2112, 2520],
114000:[995, 1617, 2114, 2522],
114100:[996, 1618, 2116, 2524],
114200:[997, 1619, 2117, 2526],
114300:[997, 1621, 2119, 2528],
114400:[998, 1622, 2121, 2530],
114500:[999, 1623, 2122, 2532],
114600:[1000, 1624, 2124, 2534],
114700:[1001, 1625, 2126, 2536],
114800:[1001, 1627, 2127, 2538],
114900:[1002, 1628, 2129, 2540],
115000:[1003, 1629, 2131, 2541],
115100:[1004, 1630, 2133, 2543],
115200:[1005, 1632, 2134, 2545],
115300:[1005, 1633, 2136, 2547],
115400:[1006, 1634, 2138, 2549],
115500:[1007, 1635, 2139, 2551],
115600:[1008, 1637, 2141, 2553],
115700:[1009, 1638, 2142, 2555],
115800:[1009, 1639, 2144, 2556],
115900:[1010, 1640, 2146, 2558],
116000:[1011, 1642, 2147, 2560],
116100:[1012, 1643, 2149, 2562],
116200:[1013, 1645, 2150, 2564],
116300:[1013, 1646, 2152, 2566],
116400:[1014, 1647, 2153, 2568],
116500:[1015, 1648, 2155, 2570],
116600:[1016, 1650, 2157, 2572],
116700:[1016, 1651, 2158, 2573],
116800:[1017, 1652, 2160, 2575],
116900:[1018, 1654, 2162, 2577],
117000:[1019, 1655, 2163, 2579],
117100:[1020, 1656, 2165, 2581],
117200:[1021, 1657, 2166, 2583],
117300:[1021, 1659, 2168, 2585],
117400:[1022, 1660, 2169, 2587],
117500:[1023, 1661, 2171, 2589],
117600:[1024, 1662, 2173, 2590],
117700:[1024, 1664, 2174, 2592],
117800:[1025, 1665, 2176, 2594],
117900:[1026, 1666, 2177, 2596],
118000:[1027, 1667, 2179, 2598],
118100:[1028, 1668, 2181, 2600],
118200:[1029, 1670, 2182, 2602],
118300:[1029, 1671, 2184, 2604],
118400:[1030, 1672, 2185, 2606],
118500:[1031, 1673, 2187, 2608],
118600:[1032, 1675, 2189, 2609],
118700:[1032, 1676, 2190, 2611],
118800:[1033, 1677, 2192, 2613],
118900:[1034, 1679, 2193, 2615],
119000:[1035, 1680, 2195, 2617],
119100:[1036, 1681, 2197, 2619],
119200:[1037, 1682, 2198, 2621],
119300:[1037, 1684, 2200, 2623],
119400:[1038, 1685, 2201, 2625],
119500:[1039, 1686, 2203, 2626],
119600:[1040, 1687, 2204, 2628],
119700:[1040, 1689, 2206, 2630],
119800:[1041, 1690, 2208, 2632],
119900:[1042, 1691, 2209, 2634],
120000:[1043, 1692, 2211, 2636],
120100:[1044, 1693, 2213, 2638],
120200:[1045, 1695, 2214, 2640],
120300:[1046, 1696, 2216, 2642],
120400:[1046, 1697, 2218, 2644],
120500:[1047, 1698, 2219, 2645],
120600:[1048, 1700, 2221, 2647],
120700:[1049, 1701, 2223, 2649],
120800:[1050, 1702, 2224, 2651],
120900:[1051, 1703, 2226, 2653],
121000:[1052, 1705, 2228, 2655],
121100:[1053, 1706, 2230, 2657],
121200:[1054, 1708, 2231, 2659],
121300:[1055, 1709, 2233, 2661],
121400:[1055, 1710, 2235, 2662],
121500:[1056, 1712, 2236, 2664],
121600:[1057, 1713, 2238, 2666],
121700:[1058, 1714, 2239, 2668],
121800:[1059, 1715, 2241, 2670],
121900:[1060, 1717, 2243, 2672],
122000:[1060, 1718, 2244, 2674],
122100:[1061, 1719, 2246, 2676],
122200:[1062, 1720, 2247, 2678],
122300:[1063, 1722, 2249, 2680],
122400:[1063, 1723, 2250, 2682],
122500:[1064, 1724, 2252, 2684],
122600:[1065, 1725, 2254, 2686],
122700:[1066, 1727, 2255, 2688],
122800:[1067, 1728, 2257, 2690],
122900:[1068, 1729, 2259, 2692],
123000:[1068, 1730, 2260, 2694],
123100:[1069, 1731, 2262, 2696],
123200:[1070, 1733, 2263, 2698],
123300:[1070, 1734, 2265, 2700],
123400:[1071, 1735, 2266, 2702],
123500:[1072, 1736, 2268, 2704],
123600:[1073, 1738, 2270, 2706],
123700:[1074, 1739, 2271, 2708],
123800:[1075, 1740, 2273, 2710],
123900:[1075, 1742, 2274, 2712],
124000:[1076, 1743, 2276, 2713],
124100:[1077, 1744, 2278, 2715],
124200:[1078, 1745, 2279, 2717],
124300:[1078, 1747, 2281, 2719],
124400:[1079, 1748, 2282, 2721],
124500:[1080, 1749, 2284, 2723],
124600:[1081, 1750, 2286, 2725],
124700:[1082, 1752, 2287, 2727],
124800:[1083, 1753, 2289, 2729],
124900:[1083, 1754, 2290, 2730],
125000:[1084, 1755, 2292, 2732],
125100:[1085, 1756, 2294, 2734],
125200:[1086, 1758, 2295, 2736],
125300:[1086, 1759, 2297, 2738],
125400:[1087, 1760, 2298, 2740],
125500:[1088, 1761, 2300, 2742],
125600:[1089, 1763, 2301, 2744],
125700:[1090, 1764, 2303, 2746],
125800:[1090, 1765, 2305, 2747],
125900:[1091, 1766, 2306, 2749],
126000:[1092, 1768, 2308, 2751],
126100:[1093, 1769, 2310, 2753],
126200:[1094, 1770, 2311, 2755],
126300:[1094, 1772, 2313, 2757],
126400:[1095, 1773, 2315, 2759],
126500:[1096, 1774, 2316, 2761],
126600:[1097, 1775, 2318, 2763],
126700:[1098, 1777, 2320, 2764],
126800:[1098, 1778, 2321, 2766],
126900:[1099, 1779, 2323, 2768],
127000:[1100, 1780, 2325, 2770],
127100:[1101, 1781, 2327, 2772],
127200:[1102, 1783, 2328, 2774],
127300:[1102, 1784, 2330, 2776],
127400:[1103, 1785, 2332, 2778],
127500:[1104, 1786, 2333, 2780],
127600:[1105, 1788, 2335, 2781],
127700:[1106, 1789, 2336, 2783],
127800:[1106, 1790, 2338, 2785],
127900:[1107, 1791, 2340, 2787],
128000:[1108, 1793, 2341, 2789],
128100:[1109, 1794, 2343, 2791],
128200:[1110, 1796, 2344, 2793],
128300:[1110, 1797, 2346, 2795],
128400:[1111, 1798, 2347, 2797],
128500:[1112, 1800, 2349, 2798],
128600:[1113, 1801, 2351, 2800],
128700:[1113, 1802, 2352, 2802],
128800:[1114, 1803, 2354, 2804],
128900:[1115, 1805, 2356, 2806],
129000:[1116, 1806, 2357, 2808],
129100:[1117, 1807, 2359, 2810],
129200:[1118, 1808, 2360, 2812],
129300:[1118, 1810, 2362, 2814],
129400:[1119, 1811, 2363, 2816],
129500:[1120, 1812, 2365, 2817],
129600:[1121, 1813, 2367, 2819],
129700:[1121, 1815, 2368, 2821],
129800:[1122, 1816, 2370, 2823],
129900:[1123, 1817, 2371, 2825],
130000:[1124, 1818, 2373, 2827],
130100:[1125, 1819, 2375, 2829],
130200:[1126, 1821, 2376, 2831],
130300:[1126, 1822, 2378, 2833],
130400:[1127, 1823, 2379, 2835],
130500:[1128, 1824, 2381, 2836],
130600:[1129, 1826, 2383, 2838],
130700:[1129, 1827, 2384, 2840],
130800:[1130, 1828, 2386, 2842],
130900:[1131, 1830, 2387, 2844],
131000:[1132, 1831, 2389, 2846],
131100:[1133, 1832, 2391, 2848],
131200:[1134, 1833, 2392, 2850],
131300:[1134, 1835, 2394, 2852],
131400:[1135, 1836, 2395, 2853],
131500:[1136, 1837, 2397, 2855],
131600:[1137, 1838, 2398, 2857],
131700:[1137, 1840, 2400, 2859],
131800:[1138, 1841, 2402, 2861],
131900:[1139, 1842, 2403, 2863],
132000:[1140, 1843, 2405, 2865],
132100:[1141, 1844, 2407, 2867],
132200:[1142, 1846, 2408, 2869],
132300:[1143, 1847, 2410, 2871],
132400:[1143, 1848, 2412, 2873],
132500:[1144, 1849, 2413, 2875],
132600:[1145, 1851, 2415, 2877],
132700:[1146, 1852, 2417, 2879],
132800:[1147, 1853, 2418, 2881],
132900:[1148, 1854, 2420, 2883],
133000:[1149, 1856, 2422, 2885],
133100:[1150, 1857, 2424, 2887],
133200:[1151, 1858, 2425, 2889],
133300:[1152, 1860, 2427, 2891],
133400:[1152, 1861, 2429, 2893],
133500:[1153, 1862, 2430, 2895],
133600:[1154, 1863, 2432, 2897],
133700:[1155, 1865, 2433, 2899],
133800:[1156, 1866, 2435, 2901],
133900:[1157, 1867, 2437, 2902],
134000:[1157, 1868, 2438, 2904],
134100:[1158, 1869, 2440, 2906],
134200:[1159, 1871, 2441, 2908],
134300:[1160, 1872, 2443, 2910],
134400:[1160, 1873, 2444, 2912],
134500:[1161, 1874, 2446, 2914],
134600:[1162, 1876, 2448, 2916],
134700:[1163, 1877, 2449, 2918],
134800:[1164, 1878, 2451, 2919],
134900:[1165, 1879, 2453, 2921],
135000:[1165, 1881, 2454, 2923],
135100:[1166, 1882, 2456, 2925],
135200:[1167, 1884, 2457, 2927],
135300:[1167, 1885, 2459, 2929],
135400:[1168, 1886, 2460, 2931],
135500:[1169, 1888, 2462, 2933],
135600:[1170, 1889, 2464, 2935],
135700:[1171, 1890, 2465, 2936],
135800:[1172, 1891, 2467, 2938],
135900:[1172, 1893, 2468, 2940],
136000:[1173, 1894, 2470, 2942],
136100:[1174, 1895, 2472, 2944],
136200:[1175, 1896, 2473, 2946],
136300:[1175, 1898, 2475, 2948],
136400:[1176, 1899, 2476, 2950],
136500:[1177, 1900, 2478, 2952],
136600:[1178, 1901, 2480, 2953],
136700:[1179, 1903, 2481, 2955],
136800:[1180, 1904, 2483, 2957],
136900:[1180, 1905, 2484, 2959],
137000:[1181, 1906, 2486, 2961],
137100:[1182, 1907, 2488, 2963],
137200:[1183, 1909, 2489, 2965],
137300:[1183, 1910, 2491, 2967],
137400:[1184, 1911, 2492, 2969],
137500:[1185, 1912, 2494, 2971],
137600:[1186, 1914, 2495, 2972],
137700:[1187, 1915, 2497, 2974],
137800:[1187, 1916, 2499, 2976],
137900:[1188, 1918, 2500, 2978],
138000:[1189, 1919, 2502, 2980],
138100:[1190, 1920, 2504, 2982],
138200:[1191, 1921, 2505, 2984],
138300:[1191, 1923, 2507, 2986],
138400:[1192, 1924, 2509, 2988],
138500:[1193, 1925, 2510, 2989],
138600:[1194, 1926, 2512, 2991],
138700:[1195, 1928, 2514, 2993],
138800:[1195, 1929, 2515, 2995],
138900:[1196, 1930, 2517, 2997],
139000:[1197, 1931, 2519, 2999],
139100:[1198, 1932, 2521, 3001],
139200:[1199, 1934, 2522, 3003],
139300:[1199, 1935, 2524, 3005],
139400:[1200, 1936, 2526, 3007],
139500:[1201, 1937, 2527, 3008],
139600:[1202, 1939, 2529, 3010],
139700:[1203, 1940, 2530, 3012],
139800:[1203, 1941, 2532, 3014],
139900:[1204, 1942, 2534, 3016],
140000:[1205, 1944, 2535, 3018],
140100:[1206, 1945, 2537, 3020],
140200:[1207, 1946, 2538, 3022],
140300:[1207, 1948, 2540, 3024],
140400:[1208, 1949, 2541, 3025],
140500:[1209, 1950, 2543, 3027],
140600:[1210, 1951, 2545, 3029],
140700:[1210, 1953, 2546, 3031],
140800:[1211, 1954, 2548, 3033],
140900:[1212, 1955, 2550, 3035],
141000:[1213, 1956, 2551, 3037],
141100:[1214, 1957, 2553, 3039],
141200:[1215, 1959, 2554, 3041],
141300:[1215, 1960, 2556, 3043],
141400:[1216, 1961, 2557, 3045],
141500:[1217, 1962, 2559, 3047],
141600:[1218, 1964, 2561, 3049],
141700:[1218, 1965, 2562, 3051],
141800:[1219, 1966, 2564, 3053],
141900:[1220, 1967, 2565, 3055],
142000:[1221, 1969, 2567, 3057],
142100:[1222, 1970, 2569, 3059],
142200:[1223, 1972, 2570, 3061],
142300:[1223, 1973, 2572, 3063],
142400:[1224, 1974, 2573, 3065],
142500:[1225, 1976, 2575, 3067],
142600:[1226, 1977, 2577, 3069],
142700:[1226, 1978, 2578, 3071],
142800:[1227, 1979, 2580, 3073],
142900:[1228, 1981, 2581, 3075],
143000:[1229, 1982, 2583, 3076],
143100:[1230, 1983, 2585, 3078],
143200:[1231, 1984, 2586, 3080],
143300:[1231, 1986, 2588, 3082],
143400:[1232, 1987, 2589, 3084],
143500:[1233, 1988, 2591, 3086],
143600:[1234, 1989, 2592, 3088],
143700:[1234, 1991, 2594, 3090],
143800:[1235, 1992, 2596, 3092],
143900:[1236, 1993, 2597, 3093],
144000:[1237, 1994, 2599, 3095],
144100:[1238, 1995, 2601, 3097],
144200:[1239, 1997, 2602, 3099],
144300:[1240, 1998, 2604, 3101],
144400:[1240, 1999, 2606, 3103],
144500:[1241, 2000, 2607, 3105],
144600:[1242, 2002, 2609, 3107],
144700:[1243, 2003, 2611, 3108],
144800:[1244, 2004, 2612, 3110],
144900:[1245, 2006, 2614, 3112],
145000:[1246, 2007, 2616, 3114],
145100:[1247, 2008, 2618, 3116],
145200:[1248, 2009, 2619, 3118],
145300:[1249, 2011, 2621, 3120],
145400:[1249, 2012, 2623, 3122],
145500:[1250, 2013, 2624, 3124],
145600:[1251, 2014, 2626, 3125],
145700:[1252, 2016, 2627, 3127],
145800:[1253, 2017, 2629, 3129],
145900:[1254, 2018, 2631, 3131],
146000:[1254, 2019, 2632, 3133],
146100:[1255, 2020, 2634, 3135],
146200:[1256, 2022, 2635, 3137],
146300:[1257, 2023, 2637, 3139],
146400:[1257, 2024, 2638, 3141],
146500:[1258, 2025, 2640, 3143],
146600:[1259, 2027, 2642, 3144],
146700:[1260, 2028, 2643, 3146],
146800:[1261, 2029, 2645, 3148],
146900:[1262, 2030, 2647, 3150],
147000:[1262, 2032, 2648, 3152],
147100:[1263, 2033, 2650, 3154],
147200:[1264, 2034, 2651, 3156],
147300:[1264, 2036, 2653, 3158],
147400:[1265, 2037, 2654, 3160],
147500:[1266, 2038, 2656, 3161],
147600:[1267, 2039, 2658, 3163],
147700:[1268, 2040, 2659, 3165],
147800:[1269, 2042, 2661, 3167],
147900:[1269, 2043, 2662, 3169],
148000:[1270, 2044, 2664, 3171],
148100:[1271, 2045, 2666, 3173],
148200:[1272, 2047, 2667, 3175],
148300:[1272, 2048, 2669, 3177],
148400:[1273, 2049, 2670, 3179],
148500:[1274, 2050, 2672, 3180],
148600:[1275, 2052, 2674, 3182],
148700:[1276, 2053, 2675, 3184],
148800:[1277, 2054, 2677, 3186],
148900:[1277, 2055, 2678, 3188],
149000:[1278, 2057, 2680, 3190],
149100:[1279, 2058, 2682, 3192],
149200:[1280, 2059, 2683, 3194],
149300:[1280, 2061, 2685, 3195],
149400:[1281, 2062, 2686, 3197],
149500:[1282, 2063, 2688, 3199],
149600:[1283, 2064, 2690, 3201],
149700:[1284, 2065, 2691, 3203],
149800:[1285, 2067, 2693, 3204],
149900:[1285, 2068, 2694, 3206],
150000:[1286, 2069, 2696, 3208],
16000:[0, 0, 0, 0],
16100:[9, 10, 11, 12],
16200:[19, 20, 22, 24],
16300:[28, 31, 33, 35],
16400:[38, 41, 44, 47],
16500:[47, 51, 55, 59],
16600:[56, 61, 66, 71],
16700:[66, 71, 77, 83],
16800:[75, 82, 88, 94],
16900:[85, 92, 99, 106],
17000:[94, 102, 110, 118],
17100:[95, 107, 115, 124],
17200:[96, 112, 121, 130],
17300:[96, 117, 126, 135],
17400:[97, 122, 132, 141],
17500:[98, 127, 137, 147],
17600:[99, 132, 143, 153],
17700:[99, 137, 148, 159],
17800:[100, 143, 154, 164],
17900:[101, 148, 159, 170],
18000:[102, 153, 165, 176],
18100:[103, 158, 170, 181],
18200:[103, 162, 175, 187],
18300:[104, 167, 180, 192],
18400:[105, 171, 185, 197],
18500:[106, 176, 190, 203],
18600:[106, 181, 195, 208],
18700:[107, 185, 200, 214],
18800:[108, 190, 205, 219],
18900:[108, 195, 210, 224],
19000:[109, 199, 214, 230],
19100:[110, 204, 219, 235],
19200:[111, 208, 224, 241],
19300:[111, 213, 229, 246],
19400:[112, 217, 234, 251],
19500:[113, 222, 239, 257],
19600:[114, 227, 244, 262],
19700:[114, 231, 249, 267],
19800:[115, 236, 254, 273],
19900:[116, 240, 259, 278],
20000:[117, 245, 264, 283],
20100:[118, 249, 269, 288],
20200:[118, 254, 273, 293],
20300:[119, 258, 278, 298],
20400:[120, 262, 283, 303],
20500:[121, 267, 288, 308],
20600:[121, 271, 292, 313],
20700:[122, 275, 297, 318],
20800:[123, 279, 302, 323],
20900:[124, 284, 306, 328],
21000:[124, 288, 311, 333],
21100:[125, 292, 316, 338],
21200:[126, 297, 320, 343],
21300:[126, 301, 325, 348],
21400:[127, 305, 330, 353],
21500:[128, 309, 334, 358],
21600:[129, 314, 339, 363],
21700:[130, 318, 344, 367],
21800:[130, 322, 348, 372],
21900:[131, 326, 353, 377],
22000:[132, 331, 357, 382],
22100:[133, 335, 361, 386],
22200:[133, 339, 365, 391],
22300:[134, 343, 369, 395],
22400:[135, 346, 373, 400],
22500:[136, 350, 378, 404],
22600:[136, 354, 382, 409],
22700:[137, 358, 386, 413],
22800:[138, 362, 390, 418],
22900:[139, 366, 394, 422],
23000:[139, 370, 398, 427],
23100:[140, 373, 401, 431],
23200:[140, 376, 405, 434],
23300:[141, 380, 408, 438],
23400:[142, 383, 412, 442],
23500:[143, 386, 415, 446],
23600:[143, 389, 419, 449],
23700:[144, 392, 422, 453],
23800:[145, 396, 426, 457],
23900:[145, 399, 429, 460],
24000:[146, 402, 433, 464],
24100:[147, 405, 437, 468],
24200:[148, 409, 440, 472],
24300:[148, 412, 444, 475],
24400:[149, 415, 447, 479],
24500:[150, 418, 451, 483],
24600:[151, 422, 454, 487],
24700:[151, 425, 458, 490],
24800:[152, 428, 462, 494],
24900:[153, 431, 465, 498],
25000:[154, 435, 469, 502],
25100:[155, 436, 472, 505],
25200:[155, 438, 475, 508],
25300:[156, 439, 477, 511],
25400:[157, 440, 480, 514],
25500:[158, 441, 483, 517],
25600:[158, 443, 486, 520],
25700:[159, 444, 489, 524],
25800:[160, 445, 492, 527],
25900:[160, 446, 494, 530],
26000:[161, 448, 497, 533],
26100:[162, 448, 500, 536],
26200:[163, 448, 502, 539],
26300:[163, 448, 505, 542],
26400:[164, 448, 508, 544],
26500:[165, 448, 510, 547],
26600:[166, 448, 513, 550],
26700:[166, 448, 516, 553],
26800:[167, 448, 519, 556],
26900:[168, 449, 521, 559],
27000:[169, 449, 524, 561],
27100:[170, 449, 527, 564],
27200:[170, 449, 529, 567],
27300:[171, 449, 532, 570],
27400:[172, 449, 534, 573],
27500:[173, 449, 537, 575],
27600:[173, 449, 540, 578],
27700:[174, 449, 542, 581],
27800:[175, 449, 545, 584],
27900:[176, 449, 548, 587],
28000:[176, 449, 550, 590],
28100:[177, 449, 553, 593],
28200:[177, 449, 556, 597],
28300:[178, 449, 559, 600],
28400:[179, 449, 562, 603],
28500:[179, 449, 565, 607],
28600:[180, 449, 568, 610],
28700:[181, 449, 571, 613],
28800:[182, 450, 574, 617],
28900:[182, 450, 577, 620],
29000:[183, 450, 581, 623],
29100:[184, 450, 584, 627],
29200:[185, 450, 588, 631],
29300:[185, 450, 591, 634],
29400:[186, 450, 595, 638],
29500:[187, 450, 598, 642],
29600:[188, 450, 602, 646],
29700:[188, 450, 605, 650],
29800:[189, 450, 609, 653],
29900:[190, 450, 612, 657],
30000:[191, 450, 616, 661],
30100:[192, 450, 617, 665],
30200:[192, 450, 618, 669],
30300:[193, 450, 619, 673],
30400:[194, 450, 620, 676],
30500:[195, 450, 621, 680],
30600:[195, 450, 622, 684],
30700:[196, 450, 623, 688],
30800:[197, 451, 624, 692],
30900:[197, 451, 625, 696],
31000:[198, 451, 627, 700],
31100:[199, 451, 628, 704],
31200:[200, 451, 629, 708],
31300:[200, 451, 630, 711],
31400:[201, 451, 632, 715],
31500:[202, 452, 633, 719],
31600:[203, 452, 634, 723],
31700:[203, 452, 635, 727],
31800:[204, 452, 636, 730],
31900:[205, 452, 637, 734],
32000:[206, 452, 639, 738],
32100:[207, 453, 640, 742],
32200:[207, 453, 641, 745],
32300:[208, 454, 642, 749],
32400:[209, 454, 643, 753],
32500:[210, 455, 644, 756],
32600:[210, 455, 645, 760],
32700:[211, 456, 646, 764],
32800:[212, 456, 647, 767],
32900:[213, 457, 648, 771],
33000:[213, 457, 648, 775],
33100:[213, 457, 649, 779],
33200:[214, 458, 650, 782],
33300:[214, 458, 651, 786],
33400:[215, 459, 652, 789],
33500:[215, 459, 653, 793],
33600:[216, 460, 654, 796],
33700:[216, 460, 655, 800],
33800:[217, 461, 656, 803],
33900:[217, 461, 657, 807],
34000:[218, 462, 658, 811],
34100:[218, 463, 659, 813],
34200:[219, 464, 660, 815],
34300:[219, 465, 662, 818],
34400:[219, 465, 663, 820],
34500:[220, 466, 664, 822],
34600:[220, 467, 665, 824],
34700:[221, 468, 667, 826],
34800:[221, 469, 668, 829],
34900:[221, 470, 669, 831],
35000:[222, 471, 670, 833],
35100:[223, 472, 672, 835],
35200:[223, 473, 673, 837],
35300:[224, 475, 675, 839],
35400:[225, 476, 677, 841],
35500:[226, 477, 679, 843],
35600:[226, 478, 680, 845],
35700:[227, 480, 682, 847],
35800:[228, 481, 684, 849],
35900:[229, 482, 686, 851],
36000:[229, 483, 687, 853],
36100:[230, 485, 689, 855],
36200:[231, 486, 691, 858],
36300:[232, 488, 693, 860],
36400:[233, 489, 695, 863],
36500:[234, 491, 697, 865],
36600:[235, 492, 699, 867],
36700:[236, 494, 701, 870],
36800:[238, 495, 703, 872],
36900:[239, 497, 705, 875],
37000:[240, 499, 707, 877],
37100:[241, 501, 709, 879],
37200:[242, 502, 711, 882],
37300:[243, 504, 713, 884],
37400:[244, 506, 715, 887],
37500:[246, 507, 717, 889],
37600:[247, 509, 720, 891],
37700:[248, 511, 722, 894],
37800:[249, 512, 724, 896],
37900:[250, 514, 726, 899],
38000:[251, 516, 728, 901],
38100:[253, 518, 730, 904],
38200:[254, 520, 733, 907],
38300:[256, 522, 735, 909],
38400:[258, 525, 738, 912],
38500:[259, 527, 740, 915],
38600:[261, 529, 743, 918],
38700:[263, 531, 745, 921],
38800:[264, 533, 748, 923],
38900:[266, 535, 750, 926],
39000:[267, 537, 752, 929],
39100:[269, 539, 755, 932],
39200:[271, 542, 757, 935],
39300:[273, 544, 760, 938],
39400:[275, 546, 763, 941],
39500:[277, 549, 765, 944],
39600:[279, 551, 768, 947],
39700:[280, 553, 771, 950],
39800:[282, 556, 773, 953],
39900:[284, 558, 776, 956],
40000:[286, 560, 779, 959],
40100:[288, 562, 781, 962],
40200:[289, 564, 784, 964],
40300:[291, 566, 786, 967],
40400:[293, 568, 789, 970],
40500:[295, 571, 791, 972],
40600:[296, 573, 794, 975],
40700:[298, 575, 796, 978],
40800:[300, 577, 799, 981],
40900:[302, 579, 801, 983],
41000:[303, 581, 804, 986],
41100:[305, 583, 806, 989],
41200:[306, 585, 809, 991],
41300:[308, 587, 811, 994],
41400:[310, 589, 813, 996],
41500:[311, 591, 816, 999],
41600:[313, 593, 818, 1002],
41700:[315, 595, 820, 1004],
41800:[316, 598, 823, 1007],
41900:[318, 600, 825, 1009],
42000:[320, 602, 827, 1012],
42100:[322, 604, 829, 1014],
42200:[323, 606, 832, 1017],
42300:[325, 608, 834, 1019],
42400:[327, 610, 836, 1022],
42500:[328, 612, 838, 1024],
42600:[330, 614, 841, 1026],
42700:[332, 616, 843, 1029],
42800:[333, 618, 845, 1031],
42900:[335, 620, 847, 1034],
43000:[337, 622, 850, 1036],
43100:[339, 624, 852, 1038],
43200:[341, 626, 855, 1041],
43300:[342, 628, 857, 1043],
43400:[344, 630, 859, 1046],
43500:[346, 632, 861, 1048],
43600:[348, 634, 864, 1051],
43700:[349, 637, 866, 1053],
43800:[351, 639, 868, 1056],
43900:[353, 641, 871, 1058],
44000:[355, 643, 873, 1061],
44100:[357, 645, 875, 1063],
44200:[359, 647, 878, 1066],
44300:[360, 649, 880, 1068],
44400:[362, 651, 882, 1071],
44500:[364, 654, 885, 1073],
44600:[366, 656, 887, 1076],
44700:[367, 658, 889, 1078],
44800:[369, 660, 891, 1081],
44900:[371, 662, 894, 1083],
45000:[373, 664, 896, 1086],
45100:[375, 666, 898, 1089],
45200:[377, 668, 901, 1091],
45300:[379, 670, 903, 1094],
45400:[381, 673, 906, 1096],
45500:[382, 675, 908, 1099],
45600:[384, 677, 910, 1102],
45700:[386, 679, 913, 1104],
45800:[388, 681, 915, 1107],
45900:[390, 683, 918, 1109],
46000:[392, 685, 920, 1112],
46100:[394, 687, 922, 1115],
46200:[395, 689, 924, 1117],
46300:[397, 691, 927, 1120],
46400:[398, 693, 929, 1122],
46500:[400, 695, 931, 1125],
46600:[401, 697, 933, 1127],
46700:[403, 699, 936, 1130],
46800:[404, 701, 938, 1132],
46900:[406, 703, 940, 1135],
47000:[407, 705, 942, 1137],
47100:[408, 707, 944, 1139],
47200:[409, 708, 946, 1141],
47300:[411, 710, 948, 1144],
47400:[412, 711, 950, 1146],
47500:[413, 713, 952, 1148],
47600:[414, 714, 954, 1150],
47700:[415, 716, 956, 1152],
47800:[416, 717, 958, 1155],
47900:[418, 719, 960, 1157],
48000:[419, 720, 962, 1159],
48100:[420, 721, 964, 1161],
48200:[421, 723, 965, 1163],
48300:[422, 724, 967, 1165],
48400:[422, 725, 969, 1167],
48500:[423, 726, 971, 1169],
48600:[424, 728, 972, 1171],
48700:[425, 729, 974, 1173],
48800:[426, 730, 976, 1175],
48900:[427, 731, 978, 1177],
49000:[427, 733, 979, 1179],
49100:[428, 734, 981, 1181],
49200:[429, 736, 982, 1183],
49300:[430, 737, 984, 1185],
49400:[431, 738, 986, 1187],
49500:[432, 740, 988, 1189],
49600:[432, 741, 989, 1192],
49700:[433, 743, 991, 1194],
49800:[434, 744, 993, 1196],
49900:[435, 745, 995, 1198],
50000:[436, 747, 996, 1200],
50100:[437, 748, 998, 1202],
50200:[438, 750, 999, 1204],
50300:[439, 751, 1001, 1206],
50400:[439, 753, 1003, 1208],
50500:[440, 754, 1005, 1210],
50600:[441, 755, 1006, 1212],
50700:[442, 757, 1008, 1214],
50800:[443, 758, 1010, 1216],
50900:[444, 760, 1011, 1218],
51000:[444, 761, 1013, 1220],
51100:[445, 762, 1015, 1222],
51200:[446, 764, 1017, 1224],
51300:[447, 765, 1018, 1226],
51400:[447, 766, 1020, 1228],
51500:[448, 768, 1022, 1230],
51600:[449, 769, 1024, 1232],
51700:[450, 770, 1025, 1235],
51800:[451, 772, 1027, 1237],
51900:[452, 773, 1029, 1239],
52000:[453, 774, 1031, 1241],
52100:[454, 775, 1033, 1243],
52200:[455, 777, 1035, 1245],
52300:[456, 778, 1036, 1247],
52400:[457, 780, 1038, 1249],
52500:[457, 781, 1040, 1251],
52600:[458, 782, 1042, 1254],
52700:[459, 784, 1044, 1256],
52800:[460, 785, 1045, 1258],
52900:[461, 786, 1047, 1260],
53000:[462, 788, 1049, 1262],
53100:[463, 789, 1051, 1264],
53200:[464, 791, 1053, 1266],
53300:[465, 792, 1054, 1268],
53400:[466, 794, 1056, 1270],
53500:[466, 795, 1058, 1272],
53600:[467, 796, 1060, 1275],
53700:[468, 798, 1062, 1277],
53800:[469, 799, 1064, 1279],
53900:[470, 801, 1065, 1281],
54000:[471, 802, 1067, 1283],
54100:[472, 803, 1069, 1285],
54200:[473, 805, 1070, 1287],
54300:[474, 806, 1072, 1289],
54400:[475, 807, 1074, 1291],
54500:[475, 808, 1076, 1293],
54600:[476, 810, 1077, 1295],
54700:[477, 811, 1079, 1297],
54800:[478, 812, 1081, 1299],
54900:[479, 814, 1082, 1301],
55000:[480, 815, 1084, 1303],
55100:[481, 816, 1086, 1305],
55200:[482, 818, 1087, 1307],
55300:[483, 819, 1089, 1309],
55400:[483, 820, 1091, 1311],
55500:[484, 821, 1092, 1313],
55600:[485, 823, 1094, 1315],
55700:[486, 824, 1095, 1317],
55800:[487, 825, 1097, 1319],
55900:[488, 827, 1099, 1321],
56000:[488, 828, 1100, 1323],
56100:[489, 829, 1102, 1325],
56200:[490, 831, 1103, 1327],
56300:[490, 832, 1105, 1329],
56400:[491, 833, 1107, 1331],
56500:[492, 834, 1108, 1333],
56600:[493, 836, 1110, 1335],
56700:[494, 837, 1112, 1337],
56800:[494, 838, 1113, 1339],
56900:[495, 840, 1115, 1341],
57000:[496, 841, 1117, 1343],
57100:[497, 842, 1119, 1345],
57200:[498, 844, 1120, 1347],
57300:[499, 845, 1122, 1349],
57400:[499, 846, 1124, 1351],
57500:[500, 847, 1125, 1353],
57600:[501, 849, 1127, 1355],
57700:[502, 850, 1129, 1357],
57800:[503, 851, 1130, 1359],
57900:[504, 852, 1132, 1361],
58000:[505, 854, 1134, 1363],
58100:[506, 855, 1136, 1365],
58200:[507, 857, 1137, 1367],
58300:[507, 858, 1139, 1369],
58400:[508, 859, 1141, 1371],
58500:[509, 860, 1143, 1373],
58600:[510, 862, 1144, 1375],
58700:[511, 863, 1146, 1377],
58800:[512, 864, 1148, 1379],
58900:[512, 865, 1149, 1381],
59000:[513, 867, 1151, 1383],
59100:[514, 868, 1153, 1385],
59200:[515, 870, 1154, 1387],
59300:[515, 871, 1156, 1389],
59400:[516, 872, 1158, 1391],
59500:[517, 873, 1159, 1393],
59600:[518, 875, 1161, 1395],
59700:[519, 876, 1162, 1397],
59800:[519, 877, 1164, 1399],
59900:[520, 878, 1166, 1401],
60000:[521, 880, 1167, 1402],
60100:[522, 881, 1169, 1404],
60200:[523, 883, 1170, 1406],
60300:[524, 884, 1172, 1408],
60400:[524, 885, 1174, 1410],
60500:[525, 886, 1175, 1412],
60600:[526, 888, 1177, 1414],
60700:[527, 889, 1179, 1416],
60800:[528, 890, 1180, 1418],
60900:[529, 891, 1182, 1420],
61000:[530, 893, 1184, 1422],
61100:[531, 894, 1186, 1424],
61200:[532, 896, 1187, 1426],
61300:[532, 897, 1189, 1428],
61400:[533, 898, 1191, 1430],
61500:[534, 900, 1192, 1432],
61600:[535, 901, 1194, 1434],
61700:[536, 903, 1196, 1436],
61800:[537, 904, 1197, 1438],
61900:[537, 905, 1199, 1440],
62000:[538, 907, 1201, 1442],
62100:[539, 908, 1203, 1444],
62200:[540, 910, 1204, 1446],
62300:[541, 911, 1206, 1448],
62400:[541, 912, 1208, 1450],
62500:[542, 914, 1209, 1452],
62600:[543, 915, 1211, 1454],
62700:[544, 916, 1213, 1456],
62800:[545, 918, 1215, 1458],
62900:[546, 919, 1216, 1460],
63000:[547, 920, 1218, 1462],
63100:[548, 921, 1220, 1464],
63200:[549, 923, 1221, 1466],
63300:[549, 924, 1223, 1468],
63400:[550, 925, 1225, 1470],
63500:[551, 927, 1226, 1472],
63600:[552, 928, 1228, 1474],
63700:[553, 929, 1230, 1476],
63800:[554, 931, 1231, 1479],
63900:[554, 932, 1233, 1481],
64000:[555, 933, 1235, 1483],
64100:[556, 934, 1237, 1485],
64200:[557, 936, 1238, 1487],
64300:[558, 937, 1240, 1489],
64400:[558, 938, 1242, 1491],
64500:[559, 939, 1243, 1493],
64600:[560, 941, 1245, 1495],
64700:[561, 942, 1247, 1497],
64800:[562, 943, 1248, 1499],
64900:[563, 945, 1250, 1501],
65000:[564, 946, 1252, 1503],
65100:[565, 947, 1254, 1505],
65200:[566, 949, 1256, 1507],
65300:[567, 950, 1257, 1509],
65400:[568, 951, 1259, 1511],
65500:[569, 953, 1261, 1513],
65600:[569, 954, 1263, 1515],
65700:[570, 955, 1264, 1517],
65800:[571, 957, 1266, 1519],
65900:[572, 958, 1268, 1521],
66000:[573, 960, 1270, 1523],
66100:[574, 961, 1272, 1525],
66200:[575, 963, 1273, 1527],
66300:[576, 964, 1275, 1529],
66400:[576, 965, 1277, 1531],
66500:[577, 967, 1279, 1534],
66600:[578, 968, 1280, 1536],
66700:[579, 969, 1282, 1538],
66800:[580, 971, 1284, 1540],
66900:[581, 972, 1286, 1542],
67000:[581, 973, 1287, 1544],
67100:[582, 974, 1289, 1546],
67200:[583, 976, 1291, 1548],
67300:[584, 977, 1292, 1550],
67400:[584, 978, 1294, 1553],
67500:[585, 980, 1296, 1555],
67600:[586, 981, 1298, 1557],
67700:[587, 983, 1300, 1559],
67800:[588, 984, 1301, 1561],
67900:[589, 985, 1303, 1563],
68000:[590, 987, 1305, 1565],
68100:[591, 988, 1307, 1567],
68200:[592, 990, 1309, 1569],
68300:[593, 991, 1310, 1571],
68400:[593, 992, 1312, 1573],
68500:[594, 994, 1314, 1576],
68600:[595, 995, 1316, 1578],
68700:[596, 997, 1318, 1580],
68800:[597, 998, 1319, 1582],
68900:[598, 999, 1321, 1584],
69000:[599, 1001, 1323, 1586],
69100:[600, 1002, 1325, 1588],
69200:[601, 1004, 1327, 1590],
69300:[602, 1005, 1328, 1593],
69400:[602, 1006, 1330, 1595],
69500:[603, 1008, 1332, 1597],
69600:[604, 1009, 1334, 1599],
69700:[605, 1010, 1336, 1601],
69800:[606, 1012, 1337, 1603],
69900:[607, 1013, 1339, 1606],
70000:[608, 1015, 1341, 1608],
70100:[609, 1016, 1343, 1610],
70200:[610, 1018, 1345, 1612],
70300:[611, 1019, 1346, 1614],
70400:[611, 1021, 1348, 1617],
70500:[612, 1022, 1350, 1619],
70600:[613, 1024, 1352, 1621],
70700:[614, 1025, 1353, 1623],
70800:[615, 1027, 1355, 1625],
70900:[616, 1028, 1357, 1627],
71000:[617, 1030, 1359, 1629],
71100:[618, 1031, 1361, 1631],
71200:[619, 1033, 1363, 1633],
71300:[620, 1034, 1364, 1635],
71400:[620, 1036, 1366, 1637],
71500:[621, 1037, 1368, 1639],
71600:[622, 1039, 1370, 1642],
71700:[623, 1040, 1371, 1644],
71800:[624, 1042, 1373, 1646],
71900:[625, 1043, 1375, 1648],
72000:[626, 1044, 1377, 1650],
72100:[627, 1045, 1379, 1652],
72200:[628, 1047, 1381, 1654],
72300:[629, 1048, 1382, 1656],
72400:[629, 1050, 1384, 1659],
72500:[630, 1051, 1386, 1661],
72600:[631, 1053, 1388, 1663],
72700:[632, 1054, 1389, 1665],
72800:[633, 1056, 1391, 1667],
72900:[634, 1057, 1393, 1669],
73000:[635, 1058, 1395, 1672],
73100:[636, 1059, 1397, 1674],
73200:[637, 1061, 1399, 1676],
73300:[638, 1062, 1400, 1678],
73400:[638, 1064, 1402, 1681],
73500:[639, 1065, 1404, 1683],
73600:[640, 1067, 1406, 1685],
73700:[641, 1068, 1407, 1687],
73800:[642, 1070, 1409, 1689],
73900:[643, 1071, 1411, 1691],
74000:[644, 1072, 1413, 1693],
74100:[645, 1073, 1415, 1695],
74200:[646, 1075, 1417, 1697],
74300:[647, 1076, 1418, 1699],
74400:[647, 1078, 1420, 1701],
74500:[648, 1079, 1422, 1703],
74600:[649, 1081, 1424, 1706],
74700:[650, 1082, 1425, 1708],
74800:[651, 1083, 1427, 1710],
74900:[652, 1085, 1429, 1712],
75000:[653, 1086, 1431, 1714],
75100:[654, 1087, 1433, 1716],
75200:[655, 1089, 1435, 1718],
75300:[656, 1090, 1437, 1720],
75400:[657, 1092, 1438, 1723],
75500:[658, 1093, 1440, 1725],
75600:[659, 1095, 1442, 1727],
75700:[660, 1096, 1444, 1729],
75800:[661, 1097, 1446, 1731],
75900:[662, 1099, 1448, 1733],
76000:[663, 1100, 1450, 1736],
76100:[664, 1101, 1452, 1738],
76200:[665, 1103, 1454, 1740],
76300:[666, 1104, 1456, 1742],
76400:[667, 1106, 1457, 1745],
76500:[668, 1107, 1459, 1747],
76600:[669, 1109, 1461, 1749],
76700:[670, 1110, 1463, 1751],
76800:[671, 1111, 1465, 1753],
76900:[672, 1113, 1467, 1755],
77000:[672, 1114, 1468, 1757],
77100:[673, 1115, 1470, 1759],
77200:[674, 1117, 1472, 1761],
77300:[675, 1118, 1474, 1763],
77400:[676, 1120, 1475, 1765],
77500:[677, 1121, 1477, 1767],
77600:[678, 1123, 1479, 1770],
77700:[679, 1124, 1481, 1772],
77800:[680, 1125, 1483, 1774],
77900:[681, 1127, 1485, 1776],
78000:[681, 1128, 1486, 1778],
78100:[682, 1129, 1488, 1780],
78200:[683, 1131, 1490, 1782],
78300:[684, 1132, 1492, 1784],
78400:[685, 1134, 1493, 1787],
78500:[686, 1135, 1495, 1789],
78600:[687, 1137, 1497, 1791],
78700:[688, 1138, 1499, 1793],
78800:[689, 1139, 1501, 1795],
78900:[689, 1141, 1503, 1797],
79000:[690, 1142, 1504, 1800],
79100:[691, 1143, 1506, 1802],
79200:[692, 1145, 1508, 1804],
79300:[693, 1146, 1509, 1806],
79400:[694, 1148, 1511, 1809],
79500:[695, 1149, 1513, 1811],
79600:[696, 1150, 1515, 1813],
79700:[697, 1152, 1517, 1815],
79800:[698, 1153, 1519, 1817],
79900:[698, 1155, 1520, 1819],
80000:[699, 1156, 1522, 1821],
80100:[700, 1157, 1524, 1823],
80200:[701, 1159, 1526, 1825],
80300:[702, 1160, 1527, 1827],
80400:[703, 1162, 1529, 1829],
80500:[704, 1163, 1531, 1831],
80600:[705, 1164, 1533, 1834],
80700:[706, 1166, 1535, 1836],
80800:[707, 1167, 1537, 1838],
80900:[707, 1169, 1538, 1840],
81000:[708, 1170, 1540, 1842],
81100:[709, 1171, 1542, 1844],
81200:[710, 1173, 1544, 1846],
81300:[711, 1174, 1545, 1848],
81400:[712, 1176, 1547, 1851],
81500:[713, 1177, 1549, 1853],
81600:[714, 1178, 1551, 1855],
81700:[715, 1180, 1553, 1857],
81800:[715, 1181, 1555, 1859],
81900:[716, 1183, 1556, 1861],
82000:[717, 1184, 1558, 1864],
82100:[718, 1185, 1560, 1866],
82200:[719, 1187, 1562, 1868],
82300:[720, 1188, 1563, 1870],
82400:[721, 1190, 1565, 1873],
82500:[722, 1191, 1567, 1875],
82600:[723, 1192, 1569, 1877],
82700:[724, 1194, 1571, 1879],
82800:[724, 1195, 1573, 1881],
82900:[725, 1197, 1574, 1883],
83000:[726, 1198, 1576, 1885],
83100:[727, 1199, 1578, 1887],
83200:[728, 1201, 1580, 1889],
83300:[729, 1202, 1581, 1891],
83400:[730, 1204, 1583, 1893],
83500:[731, 1205, 1585, 1895],
83600:[732, 1206, 1587, 1898],
83700:[733, 1208, 1589, 1900],
83800:[733, 1209, 1590, 1902],
83900:[734, 1211, 1592, 1904],
84000:[735, 1212, 1594, 1906],
84100:[736, 1213, 1596, 1908],
84200:[737, 1215, 1597, 1910],
84300:[738, 1216, 1599, 1912],
84400:[738, 1218, 1601, 1914],
84500:[739, 1219, 1603, 1916],
84600:[740, 1220, 1604, 1918],
84700:[741, 1222, 1606, 1921],
84800:[742, 1223, 1608, 1923],
84900:[743, 1225, 1609, 1925],
85000:[743, 1226, 1611, 1927],
85100:[744, 1227, 1613, 1929],
85200:[745, 1229, 1615, 1931],
85300:[746, 1230, 1616, 1933],
85400:[746, 1231, 1618, 1935],
85500:[747, 1233, 1620, 1937],
85600:[748, 1234, 1622, 1940],
85700:[749, 1235, 1623, 1942],
85800:[750, 1237, 1625, 1944],
85900:[751, 1238, 1627, 1946],
86000:[752, 1239, 1629, 1948],
86100:[753, 1240, 1631, 1950],
86200:[754, 1242, 1633, 1952],
86300:[755, 1243, 1634, 1954],
86400:[755, 1244, 1636, 1956],
86500:[756, 1246, 1638, 1958],
86600:[757, 1247, 1640, 1961],
86700:[758, 1248, 1641, 1963],
86800:[759, 1250, 1643, 1965],
86900:[760, 1251, 1645, 1967],
87000:[761, 1253, 1647, 1969],
87100:[762, 1254, 1649, 1971],
87200:[763, 1256, 1651, 1973],
87300:[764, 1257, 1652, 1975],
87400:[765, 1259, 1654, 1977],
87500:[765, 1260, 1656, 1980],
87600:[766, 1261, 1658, 1982],
87700:[767, 1263, 1660, 1984],
87800:[768, 1264, 1661, 1986],
87900:[769, 1265, 1663, 1988],
88000:[770, 1267, 1665, 1990],
88100:[771, 1268, 1667, 1992],
88200:[772, 1270, 1668, 1994],
88300:[773, 1271, 1670, 1996],
88400:[774, 1273, 1672, 1998],
88500:[774, 1274, 1674, 2001],
88600:[775, 1275, 1675, 2003],
88700:[776, 1277, 1677, 2005],
88800:[777, 1278, 1679, 2007],
88900:[778, 1280, 1681, 2009],
89000:[779, 1281, 1682, 2011],
89100:[780, 1282, 1684, 2013],
89200:[781, 1284, 1686, 2015],
89300:[782, 1285, 1687, 2017],
89400:[783, 1287, 1689, 2019],
89500:[784, 1288, 1691, 2022],
89600:[784, 1290, 1693, 2024],
89700:[785, 1291, 1694, 2026],
89800:[786, 1292, 1696, 2028],
89900:[787, 1294, 1698, 2030],
90000:[788, 1295, 1700, 2032],
90100:[789, 1296, 1702, 2034],
90200:[790, 1298, 1704, 2036],
90300:[791, 1299, 1705, 2038],
90400:[792, 1300, 1707, 2041],
90500:[793, 1302, 1709, 2043],
90600:[794, 1303, 1711, 2045],
90700:[794, 1304, 1713, 2047],
90800:[795, 1306, 1714, 2049],
90900:[796, 1307, 1716, 2051],
91000:[797, 1308, 1718, 2053],
91100:[798, 1309, 1720, 2055],
91200:[799, 1311, 1721, 2057],
91300:[800, 1312, 1723, 2059],
91400:[800, 1313, 1725, 2062],
91500:[801, 1315, 1727, 2064],
91600:[802, 1316, 1728, 2066],
91700:[803, 1318, 1730, 2068],
91800:[804, 1319, 1732, 2070],
91900:[805, 1320, 1734, 2072],
92000:[805, 1322, 1735, 2074],
92100:[806, 1323, 1737, 2076],
92200:[807, 1325, 1739, 2078],
92300:[808, 1326, 1740, 2080],
92400:[808, 1328, 1742, 2082],
92500:[809, 1329, 1744, 2084],
92600:[810, 1330, 1746, 2086],
92700:[811, 1332, 1747, 2088],
92800:[812, 1333, 1749, 2090],
92900:[813, 1335, 1751, 2092],
93000:[814, 1336, 1753, 2094],
93100:[815, 1337, 1755, 2096],
93200:[816, 1339, 1757, 2098],
93300:[817, 1340, 1758, 2100],
93400:[817, 1342, 1760, 2102],
93500:[818, 1343, 1762, 2104],
93600:[819, 1345, 1764, 2106],
93700:[820, 1346, 1766, 2108],
93800:[821, 1347, 1767, 2110],
93900:[822, 1349, 1769, 2113],
94000:[823, 1350, 1771, 2115],
94100:[824, 1351, 1773, 2117],
94200:[825, 1353, 1774, 2119],
94300:[826, 1354, 1776, 2121],
94400:[827, 1355, 1778, 2123],
94500:[827, 1357, 1780, 2125],
94600:[828, 1358, 1781, 2127],
94700:[829, 1359, 1783, 2129],
94800:[830, 1361, 1785, 2132],
94900:[831, 1362, 1787, 2134],
95000:[832, 1363, 1788, 2136],
95100:[833, 1364, 1790, 2138],
95200:[834, 1366, 1792, 2140],
95300:[835, 1367, 1793, 2142],
95400:[836, 1368, 1795, 2144],
95500:[837, 1370, 1797, 2146],
95600:[837, 1371, 1799, 2148],
95700:[838, 1373, 1800, 2151],
95800:[839, 1374, 1802, 2153],
95900:[840, 1375, 1804, 2155],
96000:[841, 1377, 1806, 2157],
96100:[842, 1378, 1808, 2159],
96200:[843, 1380, 1810, 2161],
96300:[844, 1381, 1811, 2163],
96400:[845, 1383, 1813, 2165],
96500:[846, 1384, 1815, 2167],
96600:[847, 1385, 1817, 2170],
96700:[847, 1387, 1819, 2172],
96800:[848, 1388, 1820, 2174],
96900:[849, 1390, 1822, 2176],
97000:[850, 1391, 1824, 2178],
97100:[851, 1392, 1826, 2180],
97200:[852, 1394, 1828, 2182],
97300:[853, 1395, 1829, 2184],
97400:[854, 1397, 1831, 2186],
97500:[855, 1398, 1833, 2188],
97600:[856, 1399, 1835, 2191],
97700:[857, 1401, 1837, 2193],
97800:[857, 1402, 1839, 2195],
97900:[858, 1404, 1840, 2197],
98000:[859, 1405, 1842, 2199],
98100:[860, 1406, 1844, 2201],
98200:[861, 1408, 1845, 2203],
98300:[862, 1409, 1847, 2205],
98400:[862, 1410, 1849, 2207],
98500:[863, 1412, 1851, 2210],
98600:[864, 1413, 1852, 2212],
98700:[865, 1414, 1854, 2214],
98800:[866, 1416, 1856, 2216],
98900:[867, 1417, 1858, 2218],
99000:[867, 1418, 1859, 2220],
99100:[868, 1419, 1861, 2222],
99200:[869, 1421, 1863, 2224],
99300:[870, 1422, 1864, 2226],
99400:[870, 1423, 1866, 2228],
99500:[871, 1425, 1868, 2231],
99600:[872, 1426, 1870, 2233],
99700:[873, 1428, 1871, 2235],
99800:[874, 1429, 1873, 2237],
99900:[875, 1430, 1875, 2239],
};
const OR_NL=[0.82, 1.22, 1.58, 1.8];

// Nova Scotia — 2025 Federal Child Support Guidelines Table
const T_NS={
100000:[852, 1395, 1829, 2184],
100100:[853, 1396, 1831, 2186],
100200:[854, 1398, 1832, 2188],
100300:[855, 1399, 1834, 2190],
100400:[856, 1400, 1836, 2192],
100500:[856, 1402, 1837, 2194],
100600:[857, 1403, 1839, 2196],
100700:[858, 1404, 1841, 2198],
100800:[859, 1405, 1843, 2201],
100900:[860, 1407, 1844, 2203],
101000:[861, 1408, 1846, 2205],
101100:[862, 1409, 1848, 2207],
101200:[863, 1411, 1850, 2209],
101300:[863, 1412, 1851, 2211],
101400:[864, 1413, 1853, 2213],
101500:[865, 1415, 1855, 2215],
101600:[866, 1416, 1857, 2217],
101700:[867, 1418, 1858, 2219],
101800:[868, 1419, 1860, 2221],
101900:[868, 1420, 1862, 2223],
102000:[869, 1422, 1864, 2225],
102100:[870, 1423, 1866, 2227],
102200:[871, 1425, 1867, 2229],
102300:[872, 1426, 1869, 2231],
102400:[872, 1427, 1871, 2233],
102500:[873, 1429, 1873, 2235],
102600:[874, 1430, 1874, 2237],
102700:[875, 1431, 1876, 2239],
102800:[876, 1433, 1878, 2241],
102900:[877, 1434, 1880, 2243],
103000:[878, 1435, 1881, 2245],
103100:[879, 1436, 1883, 2247],
103200:[880, 1438, 1884, 2249],
103300:[881, 1439, 1886, 2251],
103400:[882, 1440, 1888, 2253],
103500:[883, 1441, 1890, 2255],
103600:[883, 1443, 1891, 2257],
103700:[884, 1444, 1893, 2259],
103800:[885, 1445, 1895, 2261],
103900:[886, 1447, 1897, 2264],
104000:[887, 1448, 1898, 2266],
104100:[888, 1449, 1900, 2268],
104200:[889, 1451, 1901, 2270],
104300:[890, 1452, 1903, 2272],
104400:[890, 1453, 1905, 2274],
104500:[891, 1455, 1907, 2276],
104600:[892, 1456, 1908, 2278],
104700:[893, 1457, 1910, 2280],
104800:[894, 1459, 1912, 2282],
104900:[895, 1460, 1913, 2284],
105000:[895, 1462, 1915, 2286],
105100:[896, 1463, 1917, 2288],
105200:[897, 1465, 1918, 2290],
105300:[898, 1466, 1920, 2292],
105400:[899, 1467, 1922, 2294],
105500:[899, 1469, 1923, 2296],
105600:[900, 1470, 1925, 2298],
105700:[901, 1471, 1927, 2300],
105800:[902, 1472, 1928, 2302],
105900:[903, 1474, 1930, 2304],
106000:[904, 1475, 1932, 2306],
106100:[905, 1476, 1934, 2308],
106200:[906, 1478, 1936, 2310],
106300:[906, 1479, 1937, 2312],
106400:[907, 1480, 1939, 2314],
106500:[908, 1482, 1941, 2316],
106600:[909, 1483, 1943, 2318],
106700:[910, 1485, 1944, 2320],
106800:[911, 1486, 1946, 2322],
106900:[911, 1487, 1948, 2324],
107000:[912, 1489, 1950, 2327],
107100:[913, 1490, 1952, 2329],
107200:[914, 1491, 1953, 2331],
107300:[915, 1493, 1955, 2333],
107400:[915, 1494, 1957, 2335],
107500:[916, 1495, 1958, 2337],
107600:[917, 1496, 1960, 2338],
107700:[918, 1498, 1961, 2340],
107800:[919, 1499, 1963, 2342],
107900:[920, 1500, 1965, 2344],
108000:[921, 1501, 1966, 2346],
108100:[922, 1502, 1968, 2348],
108200:[922, 1503, 1969, 2350],
108300:[923, 1505, 1971, 2352],
108400:[924, 1506, 1972, 2354],
108500:[925, 1507, 1974, 2355],
108600:[925, 1508, 1976, 2357],
108700:[926, 1509, 1977, 2359],
108800:[927, 1510, 1979, 2361],
108900:[928, 1512, 1980, 2363],
109000:[928, 1513, 1982, 2365],
109100:[929, 1514, 1984, 2367],
109200:[930, 1516, 1985, 2369],
109300:[930, 1517, 1987, 2371],
109400:[931, 1518, 1988, 2372],
109500:[932, 1519, 1990, 2374],
109600:[933, 1521, 1991, 2376],
109700:[933, 1522, 1993, 2378],
109800:[934, 1523, 1994, 2380],
109900:[935, 1524, 1996, 2382],
110000:[936, 1526, 1997, 2383],
110100:[937, 1527, 1999, 2385],
110200:[938, 1528, 2000, 2387],
110300:[938, 1530, 2002, 2389],
110400:[939, 1531, 2003, 2391],
110500:[940, 1532, 2005, 2392],
110600:[941, 1533, 2006, 2394],
110700:[941, 1535, 2008, 2396],
110800:[942, 1536, 2010, 2398],
110900:[943, 1537, 2011, 2400],
111000:[944, 1538, 2013, 2402],
111100:[945, 1539, 2015, 2404],
111200:[946, 1540, 2016, 2406],
111300:[946, 1542, 2018, 2408],
111400:[947, 1543, 2019, 2409],
111500:[948, 1544, 2021, 2411],
111600:[949, 1545, 2023, 2413],
111700:[950, 1546, 2024, 2415],
111800:[950, 1548, 2026, 2417],
111900:[951, 1549, 2027, 2419],
112000:[952, 1550, 2029, 2420],
112100:[953, 1551, 2031, 2422],
112200:[954, 1552, 2032, 2424],
112300:[954, 1554, 2034, 2426],
112400:[955, 1555, 2035, 2428],
112500:[956, 1556, 2037, 2429],
112600:[957, 1557, 2038, 2431],
112700:[958, 1558, 2040, 2433],
112800:[958, 1560, 2041, 2435],
112900:[959, 1561, 2043, 2437],
113000:[960, 1562, 2044, 2439],
113100:[961, 1563, 2046, 2441],
113200:[962, 1565, 2047, 2443],
113300:[962, 1566, 2049, 2444],
113400:[963, 1567, 2050, 2446],
113500:[964, 1568, 2052, 2448],
113600:[965, 1570, 2053, 2450],
113700:[966, 1571, 2055, 2452],
113800:[967, 1572, 2057, 2454],
113900:[967, 1573, 2058, 2455],
114000:[968, 1575, 2060, 2457],
114100:[969, 1576, 2062, 2459],
114200:[969, 1577, 2063, 2461],
114300:[970, 1579, 2065, 2463],
114400:[971, 1580, 2066, 2464],
114500:[972, 1581, 2068, 2466],
114600:[972, 1582, 2070, 2468],
114700:[973, 1584, 2071, 2470],
114800:[974, 1585, 2073, 2472],
114900:[975, 1586, 2074, 2474],
115000:[975, 1587, 2076, 2476],
115100:[976, 1588, 2078, 2478],
115200:[977, 1589, 2079, 2480],
115300:[977, 1591, 2081, 2481],
115400:[978, 1592, 2082, 2483],
115500:[979, 1593, 2084, 2485],
115600:[980, 1594, 2085, 2487],
115700:[980, 1596, 2087, 2489],
115800:[981, 1597, 2088, 2491],
115900:[982, 1598, 2090, 2492],
116000:[983, 1599, 2091, 2494],
116100:[984, 1600, 2093, 2496],
116200:[985, 1601, 2094, 2498],
116300:[985, 1603, 2096, 2500],
116400:[986, 1604, 2097, 2501],
116500:[987, 1605, 2099, 2503],
116600:[988, 1606, 2100, 2505],
116700:[988, 1607, 2102, 2507],
116800:[989, 1609, 2103, 2509],
116900:[990, 1610, 2105, 2511],
117000:[991, 1611, 2107, 2513],
117100:[992, 1612, 2109, 2515],
117200:[993, 1613, 2110, 2517],
117300:[993, 1615, 2112, 2518],
117400:[994, 1616, 2113, 2520],
117500:[995, 1617, 2115, 2522],
117600:[996, 1618, 2117, 2524],
117700:[996, 1619, 2118, 2526],
117800:[997, 1620, 2120, 2527],
117900:[998, 1622, 2121, 2529],
118000:[999, 1623, 2123, 2531],
118100:[1000, 1624, 2125, 2533],
118200:[1001, 1626, 2126, 2535],
118300:[1001, 1627, 2128, 2537],
118400:[1002, 1628, 2129, 2538],
118500:[1003, 1629, 2131, 2540],
118600:[1004, 1631, 2133, 2542],
118700:[1005, 1632, 2134, 2544],
118800:[1005, 1633, 2136, 2546],
118900:[1006, 1634, 2138, 2548],
119000:[1007, 1636, 2139, 2550],
119100:[1008, 1637, 2141, 2552],
119200:[1009, 1638, 2142, 2554],
119300:[1009, 1640, 2144, 2556],
119400:[1010, 1641, 2145, 2558],
119500:[1011, 1642, 2147, 2559],
119600:[1012, 1643, 2148, 2561],
119700:[1013, 1645, 2150, 2563],
119800:[1014, 1646, 2151, 2565],
119900:[1014, 1647, 2153, 2567],
120000:[1015, 1648, 2154, 2569],
120100:[1016, 1649, 2156, 2571],
120200:[1017, 1650, 2157, 2573],
120300:[1017, 1652, 2159, 2575],
120400:[1018, 1653, 2160, 2576],
120500:[1019, 1654, 2162, 2578],
120600:[1020, 1655, 2163, 2580],
120700:[1021, 1657, 2165, 2582],
120800:[1022, 1658, 2167, 2584],
120900:[1022, 1659, 2168, 2586],
121000:[1023, 1660, 2170, 2587],
121100:[1024, 1661, 2172, 2589],
121200:[1024, 1662, 2173, 2591],
121300:[1025, 1664, 2175, 2593],
121400:[1026, 1665, 2176, 2595],
121500:[1027, 1666, 2178, 2596],
121600:[1027, 1667, 2180, 2598],
121700:[1028, 1668, 2181, 2600],
121800:[1029, 1670, 2183, 2602],
121900:[1030, 1671, 2184, 2604],
122000:[1030, 1672, 2186, 2606],
122100:[1031, 1673, 2188, 2608],
122200:[1032, 1674, 2189, 2610],
122300:[1032, 1676, 2191, 2611],
122400:[1033, 1677, 2192, 2613],
122500:[1034, 1678, 2194, 2615],
122600:[1035, 1679, 2195, 2617],
122700:[1035, 1680, 2197, 2619],
122800:[1036, 1681, 2198, 2621],
122900:[1037, 1683, 2200, 2622],
123000:[1038, 1684, 2201, 2624],
123100:[1039, 1685, 2203, 2626],
123200:[1040, 1687, 2204, 2628],
123300:[1040, 1688, 2206, 2630],
123400:[1041, 1689, 2207, 2632],
123500:[1042, 1690, 2209, 2633],
123600:[1043, 1692, 2210, 2635],
123700:[1043, 1693, 2212, 2637],
123800:[1044, 1694, 2214, 2639],
123900:[1045, 1695, 2215, 2641],
124000:[1046, 1697, 2217, 2643],
124100:[1047, 1698, 2219, 2645],
124200:[1048, 1699, 2220, 2647],
124300:[1048, 1701, 2222, 2648],
124400:[1049, 1702, 2223, 2650],
124500:[1050, 1703, 2225, 2652],
124600:[1051, 1704, 2227, 2654],
124700:[1052, 1706, 2228, 2656],
124800:[1052, 1707, 2230, 2658],
124900:[1053, 1708, 2231, 2659],
125000:[1054, 1709, 2233, 2661],
125100:[1055, 1710, 2235, 2663],
125200:[1056, 1711, 2236, 2665],
125300:[1056, 1713, 2238, 2667],
125400:[1057, 1714, 2239, 2668],
125500:[1058, 1715, 2241, 2670],
125600:[1059, 1716, 2242, 2672],
125700:[1060, 1718, 2244, 2674],
125800:[1060, 1719, 2245, 2676],
125900:[1061, 1720, 2247, 2678],
126000:[1062, 1721, 2248, 2680],
126100:[1063, 1722, 2250, 2682],
126200:[1064, 1723, 2251, 2684],
126300:[1064, 1725, 2253, 2685],
126400:[1065, 1726, 2254, 2687],
126500:[1066, 1727, 2256, 2689],
126600:[1067, 1728, 2257, 2691],
126700:[1068, 1729, 2259, 2693],
126800:[1069, 1731, 2260, 2694],
126900:[1069, 1732, 2262, 2696],
127000:[1070, 1733, 2264, 2698],
127100:[1071, 1734, 2266, 2700],
127200:[1071, 1735, 2267, 2702],
127300:[1072, 1737, 2269, 2704],
127400:[1073, 1738, 2270, 2705],
127500:[1074, 1739, 2272, 2707],
127600:[1074, 1740, 2274, 2709],
127700:[1075, 1741, 2275, 2711],
127800:[1076, 1742, 2277, 2713],
127900:[1077, 1744, 2278, 2715],
128000:[1077, 1745, 2280, 2717],
128100:[1078, 1746, 2282, 2719],
128200:[1079, 1748, 2283, 2721],
128300:[1079, 1749, 2285, 2723],
128400:[1080, 1750, 2286, 2725],
128500:[1081, 1751, 2288, 2727],
128600:[1082, 1753, 2289, 2728],
128700:[1082, 1754, 2291, 2730],
128800:[1083, 1755, 2292, 2732],
128900:[1084, 1756, 2294, 2734],
129000:[1085, 1758, 2295, 2736],
129100:[1086, 1759, 2297, 2738],
129200:[1087, 1760, 2298, 2740],
129300:[1087, 1762, 2300, 2742],
129400:[1088, 1763, 2301, 2743],
129500:[1089, 1764, 2303, 2745],
129600:[1090, 1765, 2304, 2747],
129700:[1090, 1767, 2306, 2749],
129800:[1091, 1768, 2307, 2751],
129900:[1092, 1769, 2309, 2753],
130000:[1093, 1770, 2311, 2754],
130100:[1094, 1771, 2313, 2756],
130200:[1095, 1772, 2314, 2758],
130300:[1095, 1774, 2316, 2760],
130400:[1096, 1775, 2317, 2762],
130500:[1097, 1776, 2319, 2763],
130600:[1098, 1777, 2320, 2765],
130700:[1098, 1779, 2322, 2767],
130800:[1099, 1780, 2324, 2769],
130900:[1100, 1781, 2325, 2771],
131000:[1101, 1782, 2327, 2773],
131100:[1102, 1783, 2329, 2775],
131200:[1103, 1784, 2330, 2777],
131300:[1103, 1786, 2332, 2779],
131400:[1104, 1787, 2333, 2780],
131500:[1105, 1788, 2335, 2782],
131600:[1106, 1789, 2337, 2784],
131700:[1107, 1790, 2338, 2786],
131800:[1107, 1792, 2340, 2788],
131900:[1108, 1793, 2342, 2790],
132000:[1109, 1794, 2343, 2791],
132100:[1110, 1795, 2345, 2793],
132200:[1111, 1796, 2346, 2795],
132300:[1111, 1798, 2348, 2797],
132400:[1112, 1799, 2349, 2799],
132500:[1113, 1800, 2351, 2800],
132600:[1114, 1801, 2352, 2802],
132700:[1115, 1802, 2354, 2804],
132800:[1116, 1803, 2355, 2806],
132900:[1116, 1805, 2357, 2808],
133000:[1117, 1806, 2358, 2810],
133100:[1118, 1807, 2360, 2812],
133200:[1119, 1809, 2361, 2814],
133300:[1119, 1810, 2363, 2815],
133400:[1120, 1811, 2364, 2817],
133500:[1121, 1812, 2366, 2819],
133600:[1122, 1814, 2367, 2821],
133700:[1123, 1815, 2369, 2823],
133800:[1124, 1816, 2371, 2825],
133900:[1124, 1817, 2372, 2826],
134000:[1125, 1819, 2374, 2828],
134100:[1126, 1820, 2376, 2830],
134200:[1126, 1821, 2377, 2832],
134300:[1127, 1823, 2379, 2834],
134400:[1128, 1824, 2380, 2835],
134500:[1129, 1825, 2382, 2837],
134600:[1129, 1826, 2384, 2839],
134700:[1130, 1828, 2385, 2841],
134800:[1131, 1829, 2387, 2843],
134900:[1132, 1830, 2388, 2845],
135000:[1132, 1831, 2390, 2847],
135100:[1133, 1832, 2392, 2849],
135200:[1134, 1833, 2393, 2851],
135300:[1134, 1835, 2395, 2852],
135400:[1135, 1836, 2396, 2854],
135500:[1136, 1837, 2398, 2856],
135600:[1137, 1838, 2399, 2858],
135700:[1137, 1839, 2401, 2860],
135800:[1138, 1841, 2402, 2862],
135900:[1139, 1842, 2404, 2863],
136000:[1140, 1843, 2405, 2865],
136100:[1141, 1844, 2407, 2867],
136200:[1142, 1845, 2408, 2869],
136300:[1142, 1847, 2410, 2871],
136400:[1143, 1848, 2411, 2872],
136500:[1144, 1849, 2413, 2874],
136600:[1145, 1850, 2414, 2876],
136700:[1145, 1851, 2416, 2878],
136800:[1146, 1853, 2418, 2880],
136900:[1147, 1854, 2419, 2882],
137000:[1148, 1855, 2421, 2884],
137100:[1149, 1856, 2423, 2886],
137200:[1150, 1857, 2424, 2888],
137300:[1150, 1859, 2426, 2889],
137400:[1151, 1860, 2427, 2891],
137500:[1152, 1861, 2429, 2893],
137600:[1153, 1862, 2431, 2895],
137700:[1154, 1863, 2432, 2897],
137800:[1154, 1864, 2434, 2898],
137900:[1155, 1866, 2435, 2900],
138000:[1156, 1867, 2437, 2902],
138100:[1157, 1868, 2439, 2904],
138200:[1158, 1870, 2440, 2906],
138300:[1158, 1871, 2442, 2908],
138400:[1159, 1872, 2443, 2909],
138500:[1160, 1873, 2445, 2911],
138600:[1161, 1875, 2446, 2913],
138700:[1162, 1876, 2448, 2915],
138800:[1162, 1877, 2449, 2917],
138900:[1163, 1878, 2451, 2919],
139000:[1164, 1880, 2452, 2921],
139100:[1165, 1881, 2454, 2923],
139200:[1166, 1882, 2455, 2925],
139300:[1166, 1884, 2457, 2927],
139400:[1167, 1885, 2458, 2929],
139500:[1168, 1886, 2460, 2930],
139600:[1169, 1887, 2461, 2932],
139700:[1170, 1889, 2463, 2934],
139800:[1171, 1890, 2464, 2936],
139900:[1171, 1891, 2466, 2938],
140000:[1172, 1892, 2468, 2940],
140100:[1173, 1893, 2470, 2942],
140200:[1173, 1894, 2471, 2944],
140300:[1174, 1896, 2473, 2946],
140400:[1175, 1897, 2474, 2947],
140500:[1176, 1898, 2476, 2949],
140600:[1176, 1899, 2478, 2951],
140700:[1177, 1900, 2479, 2953],
140800:[1178, 1902, 2481, 2955],
140900:[1179, 1903, 2482, 2957],
141000:[1179, 1904, 2484, 2958],
141100:[1180, 1905, 2486, 2960],
141200:[1181, 1906, 2487, 2962],
141300:[1181, 1908, 2489, 2964],
141400:[1182, 1909, 2490, 2966],
141500:[1183, 1910, 2492, 2967],
141600:[1184, 1911, 2494, 2969],
141700:[1184, 1912, 2495, 2971],
141800:[1185, 1914, 2497, 2973],
141900:[1186, 1915, 2499, 2975],
142000:[1187, 1916, 2500, 2977],
142100:[1188, 1917, 2502, 2979],
142200:[1189, 1919, 2503, 2981],
142300:[1189, 1920, 2505, 2983],
142400:[1190, 1921, 2506, 2984],
142500:[1191, 1922, 2508, 2986],
142600:[1192, 1924, 2509, 2988],
142700:[1192, 1925, 2511, 2990],
142800:[1193, 1926, 2512, 2992],
142900:[1194, 1927, 2514, 2994],
143000:[1195, 1929, 2515, 2995],
143100:[1196, 1930, 2517, 2997],
143200:[1197, 1931, 2518, 2999],
143300:[1197, 1933, 2520, 3001],
143400:[1198, 1934, 2521, 3003],
143500:[1199, 1935, 2523, 3004],
143600:[1200, 1936, 2524, 3006],
143700:[1200, 1938, 2526, 3008],
143800:[1201, 1939, 2528, 3010],
143900:[1202, 1940, 2529, 3012],
144000:[1203, 1941, 2531, 3014],
144100:[1204, 1942, 2533, 3016],
144200:[1205, 1943, 2534, 3018],
144300:[1205, 1945, 2536, 3019],
144400:[1206, 1946, 2537, 3021],
144500:[1207, 1947, 2539, 3023],
144600:[1208, 1948, 2541, 3025],
144700:[1209, 1950, 2542, 3027],
144800:[1209, 1951, 2544, 3029],
144900:[1210, 1952, 2545, 3030],
145000:[1211, 1953, 2547, 3032],
145100:[1212, 1954, 2549, 3034],
145200:[1213, 1955, 2550, 3036],
145300:[1213, 1957, 2552, 3038],
145400:[1214, 1958, 2553, 3039],
145500:[1215, 1959, 2555, 3041],
145600:[1216, 1960, 2556, 3043],
145700:[1217, 1961, 2558, 3045],
145800:[1217, 1963, 2559, 3047],
145900:[1218, 1964, 2561, 3049],
146000:[1219, 1965, 2562, 3051],
146100:[1220, 1966, 2564, 3053],
146200:[1221, 1967, 2565, 3055],
146300:[1221, 1969, 2567, 3056],
146400:[1222, 1970, 2568, 3058],
146500:[1223, 1971, 2570, 3060],
146600:[1224, 1972, 2571, 3062],
146700:[1225, 1973, 2573, 3064],
146800:[1226, 1974, 2575, 3066],
146900:[1226, 1976, 2576, 3067],
147000:[1227, 1977, 2578, 3069],
147100:[1228, 1978, 2580, 3071],
147200:[1228, 1980, 2581, 3073],
147300:[1229, 1981, 2583, 3075],
147400:[1230, 1982, 2584, 3076],
147500:[1231, 1983, 2586, 3078],
147600:[1231, 1985, 2588, 3080],
147700:[1232, 1986, 2589, 3082],
147800:[1233, 1987, 2591, 3084],
147900:[1234, 1988, 2592, 3086],
148000:[1234, 1990, 2594, 3088],
148100:[1235, 1991, 2596, 3090],
148200:[1236, 1992, 2597, 3092],
148300:[1236, 1994, 2599, 3093],
148400:[1237, 1995, 2600, 3095],
148500:[1238, 1996, 2602, 3097],
148600:[1239, 1997, 2603, 3099],
148700:[1239, 1999, 2605, 3101],
148800:[1240, 2000, 2606, 3102],
148900:[1241, 2001, 2608, 3104],
149000:[1242, 2002, 2609, 3106],
149100:[1243, 2003, 2611, 3108],
149200:[1244, 2004, 2612, 3110],
149300:[1244, 2006, 2614, 3112],
149400:[1245, 2007, 2615, 3113],
149500:[1246, 2008, 2617, 3115],
149600:[1247, 2009, 2618, 3117],
149700:[1247, 2011, 2620, 3119],
149800:[1248, 2012, 2622, 3121],
149900:[1249, 2013, 2623, 3123],
150000:[1250, 2014, 2625, 3125],
16000:[0, 0, 0, 0],
16100:[8, 9, 10, 10],
16200:[16, 18, 19, 20],
16300:[24, 26, 29, 31],
16400:[32, 35, 38, 41],
16500:[41, 44, 48, 51],
16600:[49, 53, 57, 61],
16700:[57, 62, 67, 71],
16800:[65, 70, 76, 82],
16900:[73, 79, 86, 92],
17000:[81, 88, 95, 102],
17100:[82, 92, 99, 107],
17200:[83, 96, 104, 111],
17300:[84, 100, 108, 116],
17400:[85, 104, 113, 121],
17500:[86, 108, 117, 126],
17600:[87, 112, 121, 130],
17700:[88, 117, 126, 135],
17800:[89, 121, 130, 140],
17900:[90, 125, 135, 145],
18000:[91, 129, 139, 149],
18100:[92, 133, 143, 153],
18200:[93, 136, 147, 157],
18300:[94, 140, 151, 162],
18400:[95, 144, 155, 166],
18500:[96, 148, 159, 170],
18600:[96, 151, 162, 174],
18700:[97, 155, 166, 179],
18800:[98, 159, 170, 183],
18900:[99, 162, 174, 187],
19000:[100, 166, 178, 191],
19100:[101, 170, 182, 195],
19200:[102, 173, 186, 199],
19300:[103, 177, 190, 204],
19400:[104, 181, 194, 208],
19500:[105, 184, 197, 212],
19600:[106, 188, 201, 216],
19700:[107, 192, 205, 220],
19800:[108, 195, 209, 225],
19900:[109, 199, 213, 229],
20000:[110, 202, 217, 233],
20100:[111, 206, 221, 237],
20200:[112, 209, 225, 241],
20300:[113, 213, 229, 245],
20400:[114, 217, 233, 250],
20500:[115, 220, 236, 254],
20600:[115, 224, 240, 258],
20700:[116, 227, 244, 262],
20800:[117, 231, 248, 266],
20900:[118, 235, 252, 270],
21000:[119, 238, 256, 274],
21100:[120, 242, 260, 278],
21200:[121, 246, 264, 283],
21300:[122, 250, 268, 287],
21400:[123, 253, 272, 292],
21500:[124, 257, 277, 296],
21600:[125, 261, 281, 300],
21700:[126, 265, 285, 305],
21800:[127, 269, 289, 309],
21900:[128, 273, 293, 313],
22000:[129, 276, 297, 318],
22100:[130, 280, 301, 322],
22200:[131, 284, 305, 327],
22300:[132, 288, 310, 331],
22400:[133, 292, 314, 336],
22500:[134, 296, 318, 340],
22600:[134, 299, 322, 345],
22700:[135, 303, 326, 349],
22800:[136, 307, 331, 354],
22900:[137, 311, 335, 358],
23000:[138, 315, 339, 363],
23100:[139, 319, 343, 368],
23200:[140, 323, 348, 372],
23300:[141, 327, 352, 377],
23400:[142, 332, 357, 382],
23500:[143, 336, 361, 387],
23600:[144, 340, 366, 391],
23700:[145, 344, 370, 396],
23800:[146, 348, 374, 401],
23900:[147, 352, 379, 405],
24000:[148, 356, 383, 410],
24100:[149, 360, 387, 415],
24200:[150, 364, 392, 420],
24300:[151, 368, 396, 424],
24400:[152, 373, 401, 429],
24500:[153, 377, 405, 434],
24600:[153, 381, 409, 439],
24700:[154, 385, 414, 443],
24800:[155, 389, 418, 448],
24900:[156, 393, 423, 453],
25000:[157, 397, 427, 458],
25100:[158, 400, 431, 462],
25200:[159, 402, 435, 466],
25300:[160, 405, 438, 470],
25400:[161, 408, 442, 474],
25500:[162, 411, 446, 478],
25600:[163, 413, 450, 482],
25700:[164, 416, 453, 486],
25800:[165, 419, 457, 490],
25900:[166, 421, 461, 494],
26000:[167, 424, 465, 498],
26100:[168, 424, 469, 502],
26200:[169, 425, 472, 506],
26300:[170, 425, 476, 509],
26400:[171, 425, 479, 513],
26500:[172, 426, 483, 517],
26600:[173, 426, 486, 521],
26700:[173, 426, 490, 525],
26800:[174, 427, 493, 528],
26900:[175, 427, 497, 532],
27000:[176, 427, 500, 536],
27100:[177, 428, 504, 540],
27200:[178, 428, 507, 544],
27300:[179, 429, 511, 547],
27400:[180, 429, 514, 551],
27500:[181, 430, 518, 555],
27600:[182, 431, 521, 559],
27700:[183, 431, 525, 563],
27800:[184, 432, 529, 566],
27900:[185, 432, 532, 570],
28000:[186, 433, 536, 574],
28100:[187, 434, 540, 578],
28200:[188, 434, 543, 582],
28300:[189, 435, 547, 585],
28400:[190, 436, 550, 589],
28500:[191, 436, 554, 593],
28600:[192, 437, 558, 597],
28700:[192, 438, 561, 600],
28800:[193, 438, 565, 604],
28900:[194, 439, 568, 608],
29000:[195, 440, 572, 612],
29100:[196, 441, 576, 616],
29200:[197, 442, 579, 620],
29300:[198, 443, 583, 623],
29400:[199, 444, 586, 627],
29500:[200, 445, 590, 631],
29600:[201, 446, 593, 635],
29700:[202, 447, 597, 638],
29800:[203, 449, 600, 642],
29900:[204, 450, 604, 646],
30000:[205, 451, 607, 650],
30100:[206, 452, 610, 653],
30200:[207, 452, 612, 656],
30300:[208, 453, 615, 660],
30400:[209, 454, 618, 663],
30500:[210, 455, 620, 666],
30600:[211, 455, 623, 669],
30700:[211, 456, 625, 672],
30800:[212, 457, 628, 676],
30900:[213, 458, 631, 679],
31000:[214, 458, 633, 682],
31100:[215, 459, 634, 685],
31200:[216, 459, 635, 688],
31300:[217, 460, 636, 691],
31400:[218, 461, 637, 695],
31500:[219, 461, 639, 698],
31600:[220, 462, 640, 701],
31700:[221, 463, 641, 704],
31800:[222, 463, 642, 707],
31900:[223, 464, 643, 710],
32000:[224, 465, 644, 713],
32100:[225, 466, 645, 716],
32200:[226, 466, 646, 719],
32300:[227, 467, 647, 722],
32400:[228, 467, 648, 725],
32500:[229, 468, 649, 728],
32600:[230, 469, 650, 731],
32700:[230, 469, 651, 734],
32800:[231, 470, 652, 737],
32900:[232, 470, 654, 740],
33000:[233, 471, 655, 743],
33100:[234, 472, 656, 746],
33200:[234, 472, 657, 749],
33300:[235, 473, 658, 751],
33400:[236, 473, 659, 754],
33500:[236, 474, 660, 757],
33600:[237, 474, 661, 760],
33700:[238, 475, 662, 763],
33800:[238, 475, 662, 766],
33900:[239, 476, 663, 768],
34000:[240, 476, 664, 771],
34100:[240, 477, 665, 774],
34200:[241, 478, 666, 777],
34300:[241, 478, 667, 779],
34400:[242, 479, 669, 782],
34500:[242, 480, 670, 785],
34600:[243, 481, 671, 788],
34700:[243, 482, 672, 791],
34800:[244, 482, 673, 794],
34900:[244, 483, 674, 796],
35000:[245, 484, 676, 799],
35100:[246, 485, 678, 803],
35200:[247, 487, 679, 806],
35300:[248, 488, 681, 810],
35400:[249, 490, 683, 813],
35500:[250, 491, 685, 817],
35600:[250, 492, 686, 821],
35700:[251, 494, 688, 824],
35800:[252, 495, 690, 828],
35900:[253, 496, 692, 831],
36000:[254, 498, 693, 835],
36100:[255, 500, 695, 839],
36200:[257, 501, 697, 843],
36300:[258, 503, 699, 847],
36400:[259, 505, 702, 851],
36500:[260, 507, 704, 855],
36600:[262, 508, 706, 859],
36700:[263, 510, 708, 863],
36800:[264, 512, 710, 867],
36900:[265, 513, 712, 871],
37000:[267, 515, 714, 875],
37100:[268, 517, 716, 877],
37200:[270, 518, 718, 880],
37300:[271, 520, 720, 882],
37400:[272, 522, 723, 885],
37500:[273, 523, 725, 887],
37600:[275, 525, 727, 890],
37700:[276, 527, 729, 892],
37800:[277, 528, 731, 895],
37900:[279, 530, 733, 897],
38000:[280, 532, 735, 900],
38100:[281, 534, 737, 902],
38200:[282, 536, 739, 905],
38300:[284, 537, 741, 907],
38400:[285, 539, 743, 910],
38500:[286, 541, 745, 912],
38600:[287, 543, 747, 914],
38700:[289, 544, 749, 917],
38800:[290, 546, 751, 919],
38900:[291, 548, 753, 922],
39000:[292, 550, 755, 924],
39100:[293, 552, 757, 926],
39200:[295, 553, 759, 929],
39300:[296, 555, 761, 931],
39400:[297, 557, 763, 934],
39500:[298, 559, 765, 936],
39600:[300, 560, 767, 938],
39700:[301, 562, 769, 941],
39800:[302, 564, 771, 943],
39900:[303, 566, 774, 946],
40000:[305, 567, 776, 948],
40100:[306, 569, 778, 950],
40200:[307, 570, 780, 953],
40300:[309, 572, 782, 955],
40400:[310, 573, 784, 957],
40500:[311, 575, 786, 960],
40600:[312, 577, 788, 962],
40700:[313, 578, 790, 964],
40800:[315, 580, 793, 967],
40900:[316, 582, 795, 969],
41000:[317, 583, 797, 971],
41100:[318, 585, 799, 973],
41200:[319, 586, 801, 976],
41300:[321, 588, 803, 978],
41400:[322, 590, 805, 980],
41500:[323, 591, 807, 983],
41600:[324, 593, 809, 985],
41700:[325, 595, 811, 987],
41800:[326, 596, 813, 989],
41900:[328, 598, 815, 992],
42000:[329, 600, 817, 994],
42100:[330, 602, 819, 996],
42200:[332, 603, 821, 999],
42300:[333, 605, 823, 1001],
42400:[334, 607, 825, 1003],
42500:[335, 608, 827, 1006],
42600:[337, 610, 829, 1008],
42700:[338, 612, 831, 1010],
42800:[339, 613, 833, 1012],
42900:[340, 615, 835, 1015],
43000:[342, 617, 837, 1017],
43100:[343, 619, 839, 1019],
43200:[345, 621, 841, 1022],
43300:[346, 622, 843, 1024],
43400:[347, 624, 845, 1026],
43500:[349, 626, 847, 1029],
43600:[350, 628, 849, 1031],
43700:[352, 629, 852, 1034],
43800:[353, 631, 854, 1036],
43900:[354, 633, 856, 1038],
44000:[356, 635, 858, 1041],
44100:[357, 637, 860, 1043],
44200:[359, 639, 862, 1046],
44300:[360, 640, 864, 1048],
44400:[362, 642, 866, 1050],
44500:[363, 644, 868, 1053],
44600:[364, 646, 870, 1055],
44700:[366, 648, 873, 1057],
44800:[367, 649, 875, 1060],
44900:[369, 651, 877, 1062],
45000:[370, 653, 879, 1064],
45100:[371, 655, 881, 1066],
45200:[373, 656, 883, 1069],
45300:[374, 658, 885, 1071],
45400:[375, 660, 887, 1073],
45500:[377, 662, 889, 1076],
45600:[378, 663, 892, 1078],
45700:[379, 665, 894, 1081],
45800:[381, 667, 896, 1083],
45900:[382, 669, 898, 1085],
46000:[383, 670, 900, 1088],
46100:[384, 671, 902, 1090],
46200:[385, 673, 904, 1092],
46300:[386, 674, 905, 1094],
46400:[387, 676, 907, 1096],
46500:[388, 677, 909, 1099],
46600:[389, 679, 911, 1101],
46700:[391, 680, 913, 1103],
46800:[392, 682, 914, 1105],
46900:[393, 683, 916, 1107],
47000:[394, 685, 918, 1109],
47100:[395, 686, 920, 1111],
47200:[396, 688, 921, 1113],
47300:[397, 689, 923, 1115],
47400:[397, 690, 925, 1117],
47500:[398, 691, 926, 1119],
47600:[399, 693, 928, 1121],
47700:[400, 694, 930, 1123],
47800:[401, 695, 931, 1125],
47900:[402, 697, 933, 1127],
48000:[402, 698, 935, 1129],
48100:[403, 699, 937, 1131],
48200:[404, 701, 938, 1133],
48300:[405, 702, 940, 1135],
48400:[406, 703, 942, 1137],
48500:[406, 704, 944, 1139],
48600:[407, 706, 945, 1141],
48700:[408, 707, 947, 1143],
48800:[409, 708, 949, 1145],
48900:[410, 710, 950, 1147],
49000:[411, 711, 952, 1149],
49100:[412, 712, 954, 1151],
49200:[413, 714, 955, 1153],
49300:[414, 715, 957, 1155],
49400:[414, 717, 959, 1157],
49500:[415, 718, 961, 1159],
49600:[416, 719, 962, 1161],
49700:[417, 721, 964, 1163],
49800:[418, 722, 966, 1165],
49900:[419, 723, 968, 1167],
50000:[419, 725, 969, 1169],
50100:[420, 726, 971, 1171],
50200:[421, 728, 972, 1173],
50300:[422, 729, 974, 1175],
50400:[422, 730, 976, 1177],
50500:[423, 732, 978, 1179],
50600:[424, 733, 979, 1181],
50700:[425, 734, 981, 1183],
50800:[426, 736, 983, 1185],
50900:[427, 737, 984, 1187],
51000:[428, 738, 986, 1189],
51100:[429, 739, 988, 1191],
51200:[430, 741, 990, 1193],
51300:[431, 742, 991, 1195],
51400:[432, 743, 993, 1197],
51500:[432, 745, 995, 1199],
51600:[433, 746, 997, 1201],
51700:[434, 748, 998, 1203],
51800:[435, 749, 1000, 1205],
51900:[436, 750, 1002, 1208],
52000:[437, 752, 1004, 1210],
52100:[438, 753, 1006, 1212],
52200:[439, 755, 1008, 1214],
52300:[440, 756, 1009, 1216],
52400:[441, 758, 1011, 1218],
52500:[442, 759, 1013, 1220],
52600:[442, 760, 1015, 1223],
52700:[443, 762, 1017, 1225],
52800:[444, 763, 1019, 1227],
52900:[445, 765, 1020, 1229],
53000:[446, 766, 1022, 1231],
53100:[447, 767, 1024, 1233],
53200:[448, 769, 1026, 1235],
53300:[449, 770, 1028, 1237],
53400:[450, 772, 1029, 1239],
53500:[451, 773, 1031, 1242],
53600:[451, 775, 1033, 1244],
53700:[452, 776, 1035, 1246],
53800:[453, 777, 1037, 1248],
53900:[454, 779, 1039, 1250],
54000:[455, 780, 1040, 1252],
54100:[456, 781, 1042, 1254],
54200:[457, 783, 1043, 1256],
54300:[457, 784, 1045, 1258],
54400:[458, 785, 1047, 1260],
54500:[459, 787, 1048, 1262],
54600:[460, 788, 1050, 1264],
54700:[461, 789, 1052, 1266],
54800:[461, 791, 1053, 1268],
54900:[462, 792, 1055, 1270],
55000:[463, 793, 1056, 1272],
55100:[464, 794, 1058, 1274],
55200:[465, 796, 1059, 1276],
55300:[466, 797, 1061, 1278],
55400:[466, 798, 1063, 1280],
55500:[467, 800, 1064, 1282],
55600:[468, 801, 1066, 1284],
55700:[469, 802, 1068, 1286],
55800:[470, 804, 1069, 1287],
55900:[471, 805, 1071, 1289],
56000:[472, 806, 1073, 1291],
56100:[473, 807, 1075, 1293],
56200:[474, 809, 1076, 1295],
56300:[474, 810, 1078, 1297],
56400:[475, 811, 1079, 1299],
56500:[476, 813, 1081, 1301],
56600:[477, 814, 1083, 1303],
56700:[478, 815, 1084, 1305],
56800:[479, 817, 1086, 1307],
56900:[479, 818, 1088, 1309],
57000:[480, 819, 1089, 1311],
57100:[481, 820, 1091, 1313],
57200:[482, 822, 1092, 1315],
57300:[483, 823, 1094, 1317],
57400:[483, 824, 1096, 1319],
57500:[484, 826, 1097, 1321],
57600:[485, 827, 1099, 1323],
57700:[486, 828, 1101, 1325],
57800:[487, 830, 1102, 1327],
57900:[488, 831, 1104, 1329],
58000:[489, 832, 1106, 1331],
58100:[490, 833, 1108, 1333],
58200:[491, 835, 1109, 1335],
58300:[491, 836, 1111, 1337],
58400:[492, 837, 1113, 1339],
58500:[493, 839, 1114, 1341],
58600:[494, 840, 1116, 1343],
58700:[495, 841, 1118, 1345],
58800:[496, 843, 1120, 1347],
58900:[496, 844, 1121, 1348],
59000:[497, 845, 1123, 1350],
59100:[498, 846, 1125, 1352],
59200:[499, 848, 1126, 1354],
59300:[499, 849, 1128, 1356],
59400:[500, 850, 1130, 1358],
59500:[501, 852, 1131, 1360],
59600:[502, 853, 1133, 1362],
59700:[503, 854, 1134, 1364],
59800:[503, 856, 1136, 1366],
59900:[504, 857, 1138, 1368],
60000:[505, 858, 1139, 1370],
60100:[506, 859, 1141, 1372],
60200:[507, 860, 1142, 1374],
60300:[508, 862, 1144, 1376],
60400:[508, 863, 1145, 1378],
60500:[509, 864, 1147, 1380],
60600:[510, 865, 1148, 1382],
60700:[511, 867, 1150, 1384],
60800:[512, 868, 1152, 1385],
60900:[513, 869, 1153, 1387],
61000:[514, 870, 1155, 1389],
61100:[515, 871, 1157, 1391],
61200:[516, 873, 1158, 1393],
61300:[516, 874, 1160, 1395],
61400:[517, 875, 1162, 1397],
61500:[518, 876, 1163, 1399],
61600:[519, 878, 1165, 1401],
61700:[520, 879, 1167, 1402],
61800:[521, 880, 1168, 1404],
61900:[521, 882, 1170, 1406],
62000:[522, 883, 1172, 1408],
62100:[523, 884, 1174, 1410],
62200:[524, 886, 1175, 1412],
62300:[524, 887, 1177, 1414],
62400:[525, 888, 1179, 1416],
62500:[526, 890, 1180, 1418],
62600:[527, 891, 1182, 1419],
62700:[528, 892, 1183, 1421],
62800:[528, 893, 1185, 1423],
62900:[529, 895, 1187, 1425],
63000:[530, 896, 1188, 1427],
63100:[531, 897, 1190, 1429],
63200:[532, 899, 1191, 1431],
63300:[533, 900, 1193, 1433],
63400:[533, 901, 1195, 1435],
63500:[534, 903, 1196, 1437],
63600:[535, 904, 1198, 1439],
63700:[536, 905, 1200, 1441],
63800:[537, 907, 1201, 1443],
63900:[538, 908, 1203, 1445],
64000:[539, 909, 1205, 1447],
64100:[540, 910, 1207, 1449],
64200:[541, 912, 1208, 1451],
64300:[541, 913, 1210, 1453],
64400:[542, 914, 1212, 1455],
64500:[543, 916, 1213, 1457],
64600:[544, 917, 1215, 1458],
64700:[545, 918, 1216, 1460],
64800:[546, 920, 1218, 1462],
64900:[546, 921, 1220, 1464],
65000:[547, 922, 1221, 1466],
65100:[548, 923, 1223, 1468],
65200:[549, 924, 1224, 1470],
65300:[549, 926, 1226, 1472],
65400:[550, 927, 1228, 1474],
65500:[551, 928, 1229, 1476],
65600:[552, 929, 1231, 1478],
65700:[553, 931, 1233, 1480],
65800:[553, 932, 1234, 1482],
65900:[554, 933, 1236, 1484],
66000:[555, 934, 1238, 1486],
66100:[556, 935, 1240, 1488],
66200:[557, 937, 1241, 1490],
66300:[558, 938, 1243, 1492],
66400:[558, 939, 1245, 1494],
66500:[559, 941, 1247, 1496],
66600:[560, 942, 1248, 1498],
66700:[561, 943, 1250, 1500],
66800:[562, 945, 1252, 1502],
66900:[563, 946, 1254, 1504],
67000:[564, 948, 1255, 1506],
67100:[565, 949, 1257, 1508],
67200:[566, 951, 1258, 1510],
67300:[567, 952, 1260, 1512],
67400:[568, 953, 1262, 1514],
67500:[569, 955, 1264, 1516],
67600:[569, 956, 1265, 1518],
67700:[570, 957, 1267, 1520],
67800:[571, 959, 1269, 1522],
67900:[572, 960, 1271, 1524],
68000:[573, 961, 1272, 1526],
68100:[574, 962, 1274, 1528],
68200:[575, 964, 1276, 1530],
68300:[576, 965, 1277, 1532],
68400:[577, 966, 1279, 1534],
68500:[578, 968, 1281, 1536],
68600:[579, 969, 1283, 1538],
68700:[579, 971, 1285, 1540],
68800:[580, 972, 1286, 1543],
68900:[581, 973, 1288, 1545],
69000:[582, 975, 1290, 1547],
69100:[583, 976, 1292, 1549],
69200:[584, 978, 1293, 1551],
69300:[585, 979, 1295, 1553],
69400:[585, 981, 1297, 1555],
69500:[586, 982, 1299, 1558],
69600:[587, 983, 1300, 1560],
69700:[588, 985, 1302, 1562],
69800:[589, 986, 1304, 1564],
69900:[590, 988, 1306, 1566],
70000:[590, 989, 1307, 1568],
70100:[591, 990, 1309, 1570],
70200:[592, 992, 1310, 1572],
70300:[593, 993, 1312, 1574],
70400:[593, 994, 1314, 1576],
70500:[594, 996, 1316, 1578],
70600:[595, 997, 1317, 1580],
70700:[596, 998, 1319, 1582],
70800:[597, 1000, 1321, 1584],
70900:[598, 1001, 1322, 1586],
71000:[599, 1002, 1324, 1588],
71100:[600, 1003, 1326, 1590],
71200:[601, 1005, 1328, 1592],
71300:[602, 1006, 1329, 1594],
71400:[602, 1008, 1331, 1596],
71500:[603, 1009, 1333, 1598],
71600:[604, 1010, 1335, 1601],
71700:[605, 1012, 1336, 1603],
71800:[606, 1013, 1338, 1605],
71900:[607, 1014, 1340, 1607],
72000:[608, 1016, 1342, 1609],
72100:[609, 1017, 1344, 1611],
72200:[610, 1019, 1345, 1613],
72300:[611, 1020, 1347, 1615],
72400:[612, 1021, 1349, 1617],
72500:[612, 1023, 1351, 1619],
72600:[613, 1024, 1352, 1621],
72700:[614, 1025, 1354, 1623],
72800:[615, 1027, 1356, 1625],
72900:[616, 1028, 1357, 1627],
73000:[617, 1029, 1359, 1629],
73100:[618, 1030, 1361, 1631],
73200:[619, 1032, 1363, 1633],
73300:[620, 1033, 1364, 1635],
73400:[621, 1034, 1366, 1637],
73500:[622, 1036, 1368, 1639],
73600:[622, 1037, 1370, 1641],
73700:[623, 1039, 1371, 1643],
73800:[624, 1040, 1373, 1646],
73900:[625, 1041, 1375, 1648],
74000:[626, 1043, 1377, 1650],
74100:[627, 1044, 1379, 1652],
74200:[628, 1046, 1380, 1654],
74300:[629, 1047, 1382, 1656],
74400:[630, 1049, 1384, 1658],
74500:[631, 1050, 1386, 1660],
74600:[632, 1051, 1387, 1662],
74700:[632, 1053, 1389, 1664],
74800:[633, 1054, 1391, 1666],
74900:[634, 1056, 1392, 1668],
75000:[635, 1057, 1394, 1670],
75100:[636, 1058, 1396, 1672],
75200:[637, 1060, 1398, 1674],
75300:[638, 1061, 1399, 1676],
75400:[638, 1062, 1401, 1678],
75500:[639, 1064, 1403, 1680],
75600:[640, 1065, 1405, 1682],
75700:[641, 1066, 1406, 1684],
75800:[642, 1068, 1408, 1686],
75900:[643, 1069, 1410, 1688],
76000:[643, 1070, 1412, 1691],
76100:[644, 1071, 1414, 1693],
76200:[645, 1073, 1415, 1695],
76300:[646, 1074, 1417, 1697],
76400:[646, 1075, 1419, 1699],
76500:[647, 1077, 1421, 1701],
76600:[648, 1078, 1422, 1704],
76700:[649, 1080, 1424, 1706],
76800:[650, 1081, 1426, 1708],
76900:[651, 1082, 1428, 1710],
77000:[652, 1084, 1429, 1712],
77100:[653, 1085, 1431, 1714],
77200:[654, 1087, 1433, 1716],
77300:[655, 1088, 1434, 1718],
77400:[656, 1089, 1436, 1720],
77500:[656, 1091, 1438, 1722],
77600:[657, 1092, 1440, 1724],
77700:[658, 1093, 1441, 1726],
77800:[659, 1095, 1443, 1728],
77900:[660, 1096, 1445, 1730],
78000:[661, 1097, 1447, 1732],
78100:[662, 1098, 1449, 1734],
78200:[663, 1100, 1450, 1736],
78300:[664, 1101, 1452, 1738],
78400:[665, 1102, 1454, 1740],
78500:[666, 1104, 1456, 1742],
78600:[666, 1105, 1457, 1744],
78700:[667, 1107, 1459, 1746],
78800:[668, 1108, 1461, 1749],
78900:[669, 1109, 1463, 1751],
79000:[670, 1111, 1464, 1753],
79100:[671, 1112, 1466, 1755],
79200:[672, 1114, 1468, 1757],
79300:[673, 1115, 1469, 1759],
79400:[673, 1117, 1471, 1761],
79500:[674, 1118, 1473, 1764],
79600:[675, 1119, 1475, 1766],
79700:[676, 1121, 1477, 1768],
79800:[677, 1122, 1478, 1770],
79900:[678, 1124, 1480, 1772],
80000:[678, 1125, 1482, 1774],
80100:[679, 1126, 1484, 1776],
80200:[680, 1128, 1485, 1778],
80300:[681, 1129, 1487, 1780],
80400:[681, 1130, 1489, 1782],
80500:[682, 1132, 1491, 1784],
80600:[683, 1133, 1492, 1786],
80700:[684, 1134, 1494, 1788],
80800:[685, 1136, 1496, 1790],
80900:[686, 1137, 1498, 1792],
81000:[687, 1138, 1499, 1794],
81100:[688, 1139, 1501, 1796],
81200:[689, 1141, 1502, 1798],
81300:[690, 1142, 1504, 1800],
81400:[691, 1144, 1506, 1802],
81500:[691, 1145, 1508, 1804],
81600:[692, 1146, 1509, 1806],
81700:[693, 1148, 1511, 1809],
81800:[694, 1149, 1513, 1811],
81900:[695, 1150, 1514, 1813],
82000:[696, 1152, 1516, 1815],
82100:[697, 1153, 1518, 1817],
82200:[698, 1155, 1520, 1819],
82300:[699, 1156, 1521, 1821],
82400:[700, 1157, 1523, 1823],
82500:[701, 1159, 1525, 1825],
82600:[702, 1160, 1527, 1827],
82700:[702, 1161, 1528, 1829],
82800:[703, 1163, 1530, 1831],
82900:[704, 1164, 1532, 1833],
83000:[705, 1165, 1534, 1835],
83100:[706, 1166, 1536, 1837],
83200:[707, 1168, 1537, 1839],
83300:[708, 1169, 1539, 1841],
83400:[708, 1170, 1541, 1843],
83500:[709, 1172, 1543, 1845],
83600:[710, 1173, 1544, 1847],
83700:[711, 1175, 1546, 1849],
83800:[712, 1176, 1548, 1851],
83900:[713, 1177, 1549, 1853],
84000:[713, 1179, 1551, 1856],
84100:[714, 1180, 1553, 1858],
84200:[715, 1182, 1555, 1860],
84300:[716, 1183, 1556, 1862],
84400:[716, 1184, 1558, 1864],
84500:[717, 1186, 1560, 1866],
84600:[718, 1187, 1562, 1869],
84700:[719, 1188, 1563, 1871],
84800:[720, 1190, 1565, 1873],
84900:[721, 1191, 1567, 1875],
85000:[722, 1192, 1569, 1877],
85100:[723, 1193, 1571, 1879],
85200:[724, 1195, 1572, 1881],
85300:[725, 1196, 1574, 1883],
85400:[726, 1197, 1576, 1885],
85500:[727, 1199, 1578, 1887],
85600:[727, 1200, 1579, 1889],
85700:[728, 1201, 1581, 1891],
85800:[729, 1203, 1583, 1893],
85900:[730, 1204, 1584, 1895],
86000:[731, 1206, 1586, 1897],
86100:[732, 1207, 1588, 1899],
86200:[733, 1209, 1590, 1901],
86300:[733, 1210, 1591, 1903],
86400:[734, 1212, 1593, 1905],
86500:[735, 1213, 1595, 1907],
86600:[736, 1214, 1597, 1909],
86700:[737, 1216, 1598, 1911],
86800:[738, 1217, 1600, 1914],
86900:[738, 1219, 1602, 1916],
87000:[739, 1220, 1604, 1918],
87100:[740, 1221, 1606, 1920],
87200:[741, 1223, 1607, 1922],
87300:[742, 1224, 1609, 1924],
87400:[742, 1225, 1611, 1926],
87500:[743, 1227, 1613, 1929],
87600:[744, 1228, 1614, 1931],
87700:[745, 1229, 1616, 1933],
87800:[746, 1231, 1618, 1935],
87900:[747, 1232, 1620, 1937],
88000:[748, 1233, 1621, 1939],
88100:[749, 1234, 1623, 1941],
88200:[750, 1236, 1625, 1943],
88300:[751, 1237, 1626, 1945],
88400:[752, 1239, 1628, 1947],
88500:[752, 1240, 1630, 1949],
88600:[753, 1241, 1632, 1951],
88700:[754, 1243, 1633, 1953],
88800:[755, 1244, 1635, 1955],
88900:[756, 1245, 1637, 1957],
89000:[757, 1247, 1639, 1959],
89100:[758, 1248, 1641, 1961],
89200:[759, 1250, 1642, 1963],
89300:[760, 1251, 1644, 1965],
89400:[761, 1252, 1646, 1967],
89500:[762, 1254, 1648, 1969],
89600:[762, 1255, 1649, 1971],
89700:[763, 1256, 1651, 1974],
89800:[764, 1258, 1653, 1976],
89900:[765, 1259, 1655, 1978],
90000:[766, 1260, 1656, 1980],
90100:[767, 1261, 1658, 1982],
90200:[768, 1263, 1660, 1984],
90300:[769, 1264, 1661, 1986],
90400:[769, 1265, 1663, 1988],
90500:[770, 1267, 1665, 1990],
90600:[771, 1268, 1667, 1992],
90700:[772, 1270, 1669, 1994],
90800:[773, 1271, 1670, 1996],
90900:[774, 1272, 1672, 1998],
91000:[774, 1274, 1674, 2000],
91100:[775, 1275, 1676, 2002],
91200:[776, 1277, 1677, 2004],
91300:[777, 1278, 1679, 2006],
91400:[777, 1279, 1681, 2008],
91500:[778, 1281, 1683, 2010],
91600:[779, 1282, 1684, 2012],
91700:[780, 1283, 1686, 2014],
91800:[781, 1284, 1688, 2016],
91900:[782, 1286, 1690, 2018],
92000:[783, 1287, 1691, 2021],
92100:[784, 1288, 1693, 2023],
92200:[785, 1290, 1694, 2025],
92300:[786, 1291, 1696, 2027],
92400:[787, 1292, 1698, 2029],
92500:[787, 1294, 1700, 2031],
92600:[788, 1295, 1701, 2034],
92700:[789, 1296, 1703, 2036],
92800:[790, 1298, 1705, 2038],
92900:[791, 1299, 1706, 2040],
93000:[792, 1301, 1708, 2042],
93100:[793, 1302, 1710, 2044],
93200:[794, 1304, 1712, 2046],
93300:[794, 1305, 1713, 2048],
93400:[795, 1307, 1715, 2050],
93500:[796, 1308, 1717, 2052],
93600:[797, 1309, 1719, 2054],
93700:[798, 1311, 1720, 2056],
93800:[799, 1312, 1722, 2058],
93900:[799, 1314, 1724, 2060],
94000:[800, 1315, 1726, 2062],
94100:[801, 1316, 1728, 2064],
94200:[802, 1318, 1729, 2066],
94300:[803, 1319, 1731, 2068],
94400:[803, 1320, 1733, 2070],
94500:[804, 1322, 1735, 2072],
94600:[805, 1323, 1736, 2074],
94700:[806, 1324, 1738, 2077],
94800:[807, 1326, 1740, 2079],
94900:[808, 1327, 1742, 2081],
95000:[809, 1328, 1743, 2083],
95100:[810, 1329, 1745, 2085],
95200:[811, 1331, 1746, 2087],
95300:[812, 1332, 1748, 2089],
95400:[813, 1333, 1750, 2091],
95500:[813, 1335, 1752, 2093],
95600:[814, 1336, 1753, 2095],
95700:[815, 1337, 1755, 2097],
95800:[816, 1338, 1757, 2099],
95900:[817, 1340, 1758, 2101],
96000:[818, 1341, 1760, 2103],
96100:[819, 1342, 1762, 2105],
96200:[820, 1344, 1763, 2107],
96300:[820, 1345, 1765, 2109],
96400:[821, 1346, 1767, 2111],
96500:[822, 1348, 1768, 2113],
96600:[823, 1349, 1770, 2115],
96700:[824, 1351, 1772, 2117],
96800:[825, 1352, 1773, 2119],
96900:[825, 1353, 1775, 2121],
97000:[826, 1355, 1777, 2123],
97100:[827, 1356, 1779, 2125],
97200:[828, 1358, 1781, 2127],
97300:[829, 1359, 1782, 2129],
97400:[829, 1360, 1784, 2131],
97500:[830, 1362, 1786, 2133],
97600:[831, 1363, 1788, 2135],
97700:[832, 1364, 1789, 2137],
97800:[833, 1366, 1791, 2140],
97900:[834, 1367, 1793, 2142],
98000:[835, 1368, 1795, 2144],
98100:[836, 1369, 1797, 2146],
98200:[837, 1371, 1798, 2148],
98300:[838, 1372, 1800, 2150],
98400:[839, 1374, 1802, 2152],
98500:[840, 1375, 1804, 2154],
98600:[840, 1376, 1805, 2156],
98700:[841, 1378, 1807, 2158],
98800:[842, 1379, 1809, 2160],
98900:[843, 1380, 1811, 2162],
99000:[844, 1382, 1812, 2164],
99100:[845, 1383, 1814, 2166],
99200:[846, 1385, 1815, 2168],
99300:[847, 1386, 1817, 2170],
99400:[847, 1387, 1819, 2172],
99500:[848, 1389, 1821, 2174],
99600:[849, 1390, 1822, 2176],
99700:[850, 1391, 1824, 2178],
99800:[851, 1393, 1826, 2180],
99900:[852, 1394, 1827, 2182],
};
const OR_NS=[0.78, 1.22, 1.56, 1.86];

// Northwest Territories — 2025 Federal Child Support Guidelines Table
const T_NT={
100000:[948, 1550, 2031, 2425],
100100:[949, 1551, 2033, 2427],
100200:[950, 1553, 2035, 2429],
100300:[951, 1554, 2037, 2432],
100400:[952, 1556, 2039, 2434],
100500:[952, 1557, 2041, 2436],
100600:[953, 1559, 2043, 2438],
100700:[954, 1560, 2044, 2441],
100800:[955, 1562, 2046, 2443],
100900:[956, 1563, 2048, 2445],
101000:[957, 1564, 2050, 2447],
101100:[958, 1565, 2052, 2449],
101200:[959, 1567, 2054, 2451],
101300:[960, 1568, 2056, 2454],
101400:[961, 1570, 2057, 2456],
101500:[962, 1571, 2059, 2458],
101600:[963, 1573, 2061, 2460],
101700:[964, 1574, 2063, 2463],
101800:[965, 1576, 2065, 2465],
101900:[966, 1577, 2067, 2467],
102000:[967, 1579, 2068, 2469],
102100:[968, 1580, 2070, 2471],
102200:[969, 1582, 2072, 2473],
102300:[970, 1583, 2074, 2476],
102400:[971, 1585, 2076, 2478],
102500:[972, 1586, 2077, 2480],
102600:[973, 1588, 2079, 2482],
102700:[973, 1589, 2081, 2485],
102800:[974, 1590, 2083, 2487],
102900:[975, 1592, 2085, 2489],
103000:[976, 1593, 2087, 2491],
103100:[977, 1594, 2089, 2493],
103200:[978, 1596, 2091, 2495],
103300:[979, 1597, 2093, 2498],
103400:[980, 1599, 2095, 2500],
103500:[981, 1600, 2097, 2502],
103600:[982, 1602, 2098, 2504],
103700:[983, 1603, 2100, 2507],
103800:[984, 1605, 2102, 2509],
103900:[985, 1606, 2104, 2511],
104000:[986, 1608, 2106, 2513],
104100:[987, 1609, 2108, 2515],
104200:[988, 1611, 2110, 2517],
104300:[989, 1612, 2112, 2520],
104400:[990, 1614, 2113, 2522],
104500:[991, 1615, 2115, 2524],
104600:[992, 1617, 2117, 2526],
104700:[993, 1618, 2119, 2528],
104800:[994, 1619, 2121, 2531],
104900:[995, 1621, 2123, 2533],
105000:[995, 1622, 2124, 2535],
105100:[996, 1623, 2126, 2537],
105200:[997, 1625, 2128, 2539],
105300:[998, 1626, 2130, 2542],
105400:[999, 1628, 2131, 2544],
105500:[1000, 1629, 2133, 2546],
105600:[1000, 1631, 2135, 2548],
105700:[1001, 1632, 2137, 2550],
105800:[1002, 1634, 2139, 2553],
105900:[1003, 1635, 2141, 2555],
106000:[1004, 1637, 2143, 2557],
106100:[1005, 1638, 2145, 2559],
106200:[1006, 1640, 2147, 2561],
106300:[1007, 1641, 2149, 2564],
106400:[1008, 1643, 2151, 2566],
106500:[1009, 1644, 2153, 2568],
106600:[1010, 1645, 2154, 2570],
106700:[1011, 1647, 2156, 2572],
106800:[1012, 1648, 2158, 2575],
106900:[1013, 1650, 2160, 2577],
107000:[1014, 1651, 2162, 2579],
107100:[1015, 1652, 2164, 2581],
107200:[1016, 1654, 2165, 2583],
107300:[1017, 1655, 2167, 2585],
107400:[1017, 1656, 2169, 2587],
107500:[1018, 1658, 2171, 2589],
107600:[1019, 1659, 2172, 2592],
107700:[1020, 1661, 2174, 2594],
107800:[1021, 1662, 2176, 2596],
107900:[1022, 1663, 2178, 2598],
108000:[1022, 1665, 2179, 2600],
108100:[1023, 1666, 2181, 2602],
108200:[1024, 1668, 2183, 2604],
108300:[1025, 1669, 2184, 2606],
108400:[1025, 1671, 2186, 2608],
108500:[1026, 1672, 2188, 2610],
108600:[1027, 1673, 2190, 2612],
108700:[1028, 1675, 2191, 2614],
108800:[1029, 1676, 2193, 2616],
108900:[1030, 1677, 2195, 2618],
109000:[1031, 1679, 2197, 2620],
109100:[1032, 1680, 2199, 2622],
109200:[1033, 1682, 2200, 2624],
109300:[1034, 1683, 2202, 2626],
109400:[1035, 1684, 2204, 2628],
109500:[1036, 1686, 2206, 2630],
109600:[1036, 1687, 2207, 2632],
109700:[1037, 1688, 2209, 2634],
109800:[1038, 1690, 2211, 2637],
109900:[1039, 1691, 2213, 2639],
110000:[1040, 1692, 2214, 2641],
110100:[1041, 1693, 2216, 2643],
110200:[1042, 1695, 2217, 2645],
110300:[1043, 1696, 2219, 2647],
110400:[1043, 1697, 2221, 2649],
110500:[1044, 1699, 2223, 2651],
110600:[1045, 1700, 2224, 2653],
110700:[1046, 1701, 2226, 2655],
110800:[1047, 1703, 2228, 2657],
110900:[1048, 1704, 2230, 2659],
111000:[1048, 1705, 2231, 2661],
111100:[1049, 1706, 2233, 2663],
111200:[1050, 1708, 2234, 2665],
111300:[1051, 1709, 2236, 2667],
111400:[1052, 1711, 2238, 2669],
111500:[1052, 1712, 2240, 2671],
111600:[1053, 1713, 2241, 2673],
111700:[1054, 1715, 2243, 2675],
111800:[1055, 1716, 2245, 2677],
111900:[1056, 1717, 2246, 2679],
112000:[1057, 1719, 2248, 2681],
112100:[1058, 1720, 2250, 2683],
112200:[1059, 1722, 2251, 2685],
112300:[1059, 1723, 2253, 2687],
112400:[1060, 1724, 2255, 2689],
112500:[1061, 1726, 2256, 2691],
112600:[1062, 1727, 2258, 2693],
112700:[1063, 1728, 2260, 2696],
112800:[1064, 1730, 2262, 2698],
112900:[1064, 1731, 2263, 2700],
113000:[1065, 1732, 2265, 2702],
113100:[1066, 1733, 2267, 2704],
113200:[1067, 1735, 2268, 2706],
113300:[1068, 1736, 2270, 2708],
113400:[1068, 1737, 2272, 2710],
113500:[1069, 1739, 2273, 2712],
113600:[1070, 1740, 2275, 2714],
113700:[1071, 1741, 2277, 2716],
113800:[1072, 1742, 2278, 2718],
113900:[1073, 1744, 2280, 2720],
114000:[1074, 1745, 2282, 2722],
114100:[1075, 1746, 2284, 2724],
114200:[1076, 1748, 2286, 2726],
114300:[1076, 1749, 2287, 2728],
114400:[1077, 1750, 2289, 2730],
114500:[1078, 1752, 2291, 2732],
114600:[1079, 1753, 2293, 2734],
114700:[1080, 1755, 2294, 2736],
114800:[1080, 1756, 2296, 2738],
114900:[1081, 1757, 2298, 2740],
115000:[1082, 1759, 2300, 2742],
115100:[1083, 1760, 2302, 2744],
115200:[1084, 1762, 2303, 2746],
115300:[1085, 1763, 2305, 2748],
115400:[1085, 1764, 2307, 2750],
115500:[1086, 1766, 2309, 2752],
115600:[1087, 1767, 2310, 2754],
115700:[1088, 1768, 2312, 2756],
115800:[1089, 1770, 2314, 2758],
115900:[1090, 1771, 2316, 2760],
116000:[1091, 1772, 2317, 2762],
116100:[1092, 1773, 2319, 2764],
116200:[1093, 1775, 2320, 2766],
116300:[1094, 1776, 2322, 2768],
116400:[1095, 1777, 2324, 2770],
116500:[1095, 1779, 2326, 2772],
116600:[1096, 1780, 2327, 2774],
116700:[1097, 1781, 2329, 2776],
116800:[1098, 1782, 2331, 2778],
116900:[1099, 1784, 2333, 2781],
117000:[1100, 1785, 2334, 2783],
117100:[1101, 1786, 2336, 2785],
117200:[1102, 1788, 2337, 2787],
117300:[1103, 1789, 2339, 2789],
117400:[1103, 1790, 2341, 2791],
117500:[1104, 1792, 2343, 2793],
117600:[1105, 1793, 2344, 2795],
117700:[1106, 1795, 2346, 2797],
117800:[1107, 1796, 2348, 2799],
117900:[1108, 1797, 2349, 2801],
118000:[1108, 1799, 2351, 2803],
118100:[1109, 1800, 2353, 2805],
118200:[1110, 1802, 2354, 2807],
118300:[1111, 1803, 2356, 2809],
118400:[1112, 1804, 2358, 2811],
118500:[1112, 1806, 2359, 2813],
118600:[1113, 1807, 2361, 2815],
118700:[1114, 1808, 2363, 2817],
118800:[1115, 1810, 2365, 2819],
118900:[1116, 1811, 2366, 2821],
119000:[1117, 1812, 2368, 2823],
119100:[1118, 1813, 2370, 2825],
119200:[1119, 1815, 2371, 2827],
119300:[1119, 1816, 2373, 2829],
119400:[1120, 1817, 2375, 2831],
119500:[1121, 1818, 2376, 2833],
119600:[1122, 1820, 2378, 2835],
119700:[1123, 1821, 2380, 2838],
119800:[1124, 1822, 2381, 2840],
119900:[1124, 1824, 2383, 2842],
120000:[1125, 1825, 2385, 2844],
120100:[1126, 1826, 2387, 2846],
120200:[1127, 1828, 2389, 2848],
120300:[1128, 1829, 2390, 2850],
120400:[1128, 1830, 2392, 2852],
120500:[1129, 1832, 2394, 2854],
120600:[1130, 1833, 2396, 2856],
120700:[1131, 1835, 2397, 2858],
120800:[1132, 1836, 2399, 2860],
120900:[1133, 1837, 2401, 2862],
121000:[1134, 1839, 2403, 2864],
121100:[1135, 1840, 2405, 2866],
121200:[1136, 1842, 2406, 2868],
121300:[1137, 1843, 2408, 2870],
121400:[1138, 1844, 2410, 2872],
121500:[1139, 1846, 2412, 2874],
121600:[1139, 1847, 2413, 2876],
121700:[1140, 1848, 2415, 2878],
121800:[1141, 1850, 2417, 2880],
121900:[1142, 1851, 2419, 2882],
122000:[1143, 1852, 2420, 2884],
122100:[1144, 1853, 2422, 2886],
122200:[1145, 1855, 2423, 2888],
122300:[1146, 1856, 2425, 2890],
122400:[1146, 1857, 2427, 2892],
122500:[1147, 1858, 2429, 2894],
122600:[1148, 1860, 2430, 2896],
122700:[1149, 1861, 2432, 2898],
122800:[1150, 1862, 2434, 2900],
122900:[1151, 1864, 2436, 2902],
123000:[1151, 1865, 2437, 2904],
123100:[1152, 1866, 2439, 2906],
123200:[1153, 1868, 2440, 2908],
123300:[1154, 1869, 2442, 2910],
123400:[1155, 1870, 2444, 2912],
123500:[1155, 1872, 2446, 2914],
123600:[1156, 1873, 2447, 2916],
123700:[1157, 1874, 2449, 2918],
123800:[1158, 1876, 2451, 2920],
123900:[1159, 1877, 2452, 2923],
124000:[1160, 1879, 2454, 2925],
124100:[1161, 1880, 2456, 2927],
124200:[1162, 1882, 2457, 2929],
124300:[1162, 1883, 2459, 2931],
124400:[1163, 1884, 2461, 2933],
124500:[1164, 1886, 2462, 2935],
124600:[1165, 1887, 2464, 2937],
124700:[1166, 1888, 2466, 2939],
124800:[1167, 1890, 2468, 2941],
124900:[1167, 1891, 2469, 2943],
125000:[1168, 1892, 2471, 2945],
125100:[1169, 1893, 2473, 2947],
125200:[1170, 1895, 2474, 2949],
125300:[1171, 1896, 2476, 2951],
125400:[1171, 1897, 2478, 2953],
125500:[1172, 1898, 2479, 2955],
125600:[1173, 1900, 2481, 2957],
125700:[1174, 1901, 2483, 2959],
125800:[1175, 1902, 2484, 2961],
125900:[1176, 1904, 2486, 2963],
126000:[1177, 1905, 2488, 2965],
126100:[1178, 1906, 2490, 2967],
126200:[1179, 1908, 2492, 2969],
126300:[1179, 1909, 2493, 2971],
126400:[1180, 1910, 2495, 2973],
126500:[1181, 1912, 2497, 2975],
126600:[1182, 1913, 2499, 2977],
126700:[1183, 1914, 2500, 2980],
126800:[1183, 1916, 2502, 2982],
126900:[1184, 1917, 2504, 2984],
127000:[1185, 1919, 2506, 2986],
127100:[1186, 1920, 2508, 2988],
127200:[1187, 1922, 2509, 2990],
127300:[1188, 1923, 2511, 2992],
127400:[1188, 1924, 2513, 2994],
127500:[1189, 1926, 2515, 2996],
127600:[1190, 1927, 2516, 2998],
127700:[1191, 1928, 2518, 3000],
127800:[1192, 1930, 2520, 3002],
127900:[1193, 1931, 2522, 3004],
128000:[1194, 1932, 2523, 3006],
128100:[1195, 1933, 2525, 3008],
128200:[1196, 1935, 2526, 3010],
128300:[1197, 1936, 2528, 3012],
128400:[1198, 1938, 2530, 3014],
128500:[1198, 1939, 2532, 3016],
128600:[1199, 1940, 2533, 3018],
128700:[1200, 1942, 2535, 3020],
128800:[1201, 1943, 2537, 3022],
128900:[1202, 1944, 2539, 3024],
129000:[1203, 1946, 2540, 3026],
129100:[1204, 1947, 2542, 3028],
129200:[1205, 1949, 2543, 3030],
129300:[1206, 1950, 2545, 3032],
129400:[1206, 1951, 2547, 3034],
129500:[1207, 1953, 2549, 3036],
129600:[1208, 1954, 2550, 3038],
129700:[1209, 1955, 2552, 3040],
129800:[1210, 1957, 2554, 3042],
129900:[1211, 1958, 2555, 3044],
130000:[1211, 1959, 2557, 3046],
130100:[1212, 1960, 2559, 3048],
130200:[1213, 1962, 2560, 3050],
130300:[1214, 1963, 2562, 3052],
130400:[1215, 1964, 2564, 3054],
130500:[1215, 1966, 2565, 3056],
130600:[1216, 1967, 2567, 3058],
130700:[1217, 1968, 2569, 3060],
130800:[1218, 1969, 2571, 3062],
130900:[1219, 1971, 2572, 3065],
131000:[1220, 1972, 2574, 3067],
131100:[1221, 1973, 2576, 3069],
131200:[1222, 1975, 2577, 3071],
131300:[1222, 1976, 2579, 3073],
131400:[1223, 1977, 2581, 3075],
131500:[1224, 1979, 2582, 3077],
131600:[1225, 1980, 2584, 3079],
131700:[1226, 1982, 2586, 3081],
131800:[1227, 1983, 2587, 3083],
131900:[1227, 1984, 2589, 3085],
132000:[1228, 1986, 2591, 3087],
132100:[1229, 1987, 2593, 3089],
132200:[1230, 1989, 2595, 3091],
132300:[1231, 1990, 2596, 3093],
132400:[1231, 1991, 2598, 3095],
132500:[1232, 1993, 2600, 3097],
132600:[1233, 1994, 2602, 3099],
132700:[1234, 1995, 2603, 3101],
132800:[1235, 1997, 2605, 3103],
132900:[1236, 1998, 2607, 3105],
133000:[1237, 1999, 2609, 3107],
133100:[1238, 2000, 2611, 3109],
133200:[1239, 2002, 2612, 3111],
133300:[1240, 2003, 2614, 3113],
133400:[1241, 2004, 2616, 3115],
133500:[1242, 2006, 2618, 3117],
133600:[1242, 2007, 2619, 3119],
133700:[1243, 2008, 2621, 3122],
133800:[1244, 2009, 2623, 3124],
133900:[1245, 2011, 2625, 3126],
134000:[1246, 2012, 2626, 3128],
134100:[1247, 2013, 2628, 3130],
134200:[1248, 2015, 2629, 3132],
134300:[1249, 2016, 2631, 3134],
134400:[1249, 2017, 2633, 3136],
134500:[1250, 2019, 2635, 3138],
134600:[1251, 2020, 2636, 3140],
134700:[1252, 2022, 2638, 3142],
134800:[1253, 2023, 2640, 3144],
134900:[1254, 2024, 2642, 3146],
135000:[1254, 2026, 2643, 3148],
135100:[1255, 2027, 2645, 3150],
135200:[1256, 2029, 2646, 3152],
135300:[1257, 2030, 2648, 3154],
135400:[1258, 2031, 2650, 3156],
135500:[1258, 2033, 2652, 3158],
135600:[1259, 2034, 2653, 3160],
135700:[1260, 2035, 2655, 3162],
135800:[1261, 2037, 2657, 3164],
135900:[1262, 2038, 2658, 3166],
136000:[1263, 2039, 2660, 3168],
136100:[1264, 2040, 2662, 3170],
136200:[1265, 2042, 2663, 3172],
136300:[1265, 2043, 2665, 3174],
136400:[1266, 2044, 2667, 3176],
136500:[1267, 2045, 2668, 3178],
136600:[1268, 2047, 2670, 3180],
136700:[1269, 2048, 2672, 3182],
136800:[1270, 2049, 2674, 3184],
136900:[1270, 2051, 2675, 3186],
137000:[1271, 2052, 2677, 3188],
137100:[1272, 2053, 2679, 3190],
137200:[1273, 2055, 2680, 3192],
137300:[1274, 2056, 2682, 3194],
137400:[1274, 2057, 2684, 3196],
137500:[1275, 2059, 2685, 3198],
137600:[1276, 2060, 2687, 3200],
137700:[1277, 2062, 2689, 3202],
137800:[1278, 2063, 2690, 3204],
137900:[1279, 2064, 2692, 3207],
138000:[1280, 2066, 2694, 3209],
138100:[1281, 2067, 2696, 3211],
138200:[1282, 2069, 2698, 3213],
138300:[1282, 2070, 2699, 3215],
138400:[1283, 2071, 2701, 3217],
138500:[1284, 2073, 2703, 3219],
138600:[1285, 2074, 2705, 3221],
138700:[1286, 2075, 2706, 3223],
138800:[1286, 2077, 2708, 3225],
138900:[1287, 2078, 2710, 3227],
139000:[1288, 2079, 2712, 3229],
139100:[1289, 2080, 2714, 3231],
139200:[1290, 2082, 2715, 3233],
139300:[1291, 2083, 2717, 3235],
139400:[1291, 2084, 2719, 3237],
139500:[1292, 2085, 2721, 3239],
139600:[1293, 2087, 2722, 3241],
139700:[1294, 2088, 2724, 3243],
139800:[1295, 2089, 2726, 3245],
139900:[1296, 2091, 2728, 3247],
140000:[1297, 2092, 2729, 3249],
140100:[1298, 2093, 2731, 3251],
140200:[1299, 2095, 2732, 3253],
140300:[1300, 2096, 2734, 3255],
140400:[1301, 2097, 2736, 3257],
140500:[1301, 2099, 2738, 3259],
140600:[1302, 2100, 2739, 3261],
140700:[1303, 2102, 2741, 3263],
140800:[1304, 2103, 2743, 3266],
140900:[1305, 2104, 2745, 3268],
141000:[1306, 2106, 2746, 3270],
141100:[1307, 2107, 2748, 3272],
141200:[1308, 2109, 2749, 3274],
141300:[1309, 2110, 2751, 3276],
141400:[1309, 2111, 2753, 3278],
141500:[1310, 2113, 2755, 3280],
141600:[1311, 2114, 2756, 3282],
141700:[1312, 2115, 2758, 3284],
141800:[1313, 2117, 2760, 3286],
141900:[1314, 2118, 2761, 3288],
142000:[1314, 2119, 2763, 3290],
142100:[1315, 2120, 2765, 3292],
142200:[1316, 2122, 2766, 3294],
142300:[1317, 2123, 2768, 3296],
142400:[1318, 2124, 2770, 3298],
142500:[1318, 2125, 2771, 3300],
142600:[1319, 2127, 2773, 3302],
142700:[1320, 2128, 2775, 3304],
142800:[1321, 2129, 2777, 3306],
142900:[1322, 2131, 2778, 3308],
143000:[1323, 2132, 2780, 3310],
143100:[1324, 2133, 2782, 3312],
143200:[1325, 2135, 2783, 3314],
143300:[1325, 2136, 2785, 3316],
143400:[1326, 2137, 2787, 3318],
143500:[1327, 2139, 2788, 3320],
143600:[1328, 2140, 2790, 3322],
143700:[1329, 2141, 2792, 3324],
143800:[1330, 2143, 2793, 3326],
143900:[1330, 2144, 2795, 3328],
144000:[1331, 2146, 2797, 3330],
144100:[1332, 2147, 2799, 3332],
144200:[1333, 2149, 2801, 3334],
144300:[1334, 2150, 2802, 3336],
144400:[1334, 2151, 2804, 3338],
144500:[1335, 2153, 2806, 3340],
144600:[1336, 2154, 2808, 3342],
144700:[1337, 2155, 2809, 3344],
144800:[1338, 2157, 2811, 3346],
144900:[1339, 2158, 2813, 3349],
145000:[1340, 2159, 2815, 3351],
145100:[1341, 2160, 2817, 3353],
145200:[1342, 2162, 2818, 3355],
145300:[1343, 2163, 2820, 3357],
145400:[1344, 2165, 2822, 3359],
145500:[1345, 2166, 2824, 3361],
145600:[1345, 2167, 2825, 3363],
145700:[1346, 2169, 2827, 3365],
145800:[1347, 2170, 2829, 3367],
145900:[1348, 2171, 2831, 3369],
146000:[1349, 2173, 2832, 3371],
146100:[1350, 2174, 2834, 3373],
146200:[1351, 2176, 2835, 3375],
146300:[1352, 2177, 2837, 3377],
146400:[1352, 2178, 2839, 3379],
146500:[1353, 2180, 2841, 3381],
146600:[1354, 2181, 2842, 3383],
146700:[1355, 2182, 2844, 3385],
146800:[1356, 2184, 2846, 3387],
146900:[1357, 2185, 2848, 3389],
147000:[1357, 2186, 2849, 3391],
147100:[1358, 2187, 2851, 3393],
147200:[1359, 2189, 2852, 3395],
147300:[1360, 2190, 2854, 3397],
147400:[1361, 2191, 2856, 3399],
147500:[1361, 2193, 2858, 3401],
147600:[1362, 2194, 2859, 3403],
147700:[1363, 2195, 2861, 3405],
147800:[1364, 2196, 2863, 3408],
147900:[1365, 2198, 2864, 3410],
148000:[1366, 2199, 2866, 3412],
148100:[1367, 2200, 2868, 3414],
148200:[1368, 2202, 2869, 3416],
148300:[1368, 2203, 2871, 3418],
148400:[1369, 2205, 2873, 3420],
148500:[1370, 2206, 2874, 3422],
148600:[1371, 2207, 2876, 3424],
148700:[1372, 2209, 2878, 3426],
148800:[1373, 2210, 2880, 3428],
148900:[1373, 2211, 2881, 3430],
149000:[1374, 2213, 2883, 3432],
149100:[1375, 2214, 2885, 3434],
149200:[1376, 2216, 2886, 3436],
149300:[1377, 2217, 2888, 3438],
149400:[1377, 2218, 2890, 3440],
149500:[1378, 2220, 2891, 3442],
149600:[1379, 2221, 2893, 3444],
149700:[1380, 2222, 2895, 3446],
149800:[1381, 2224, 2896, 3448],
149900:[1382, 2225, 2898, 3450],
150000:[1383, 2226, 2900, 3452],
16000:[0, 0, 0, 0],
16100:[10, 11, 11, 12],
16200:[19, 21, 23, 24],
16300:[29, 32, 34, 36],
16400:[38, 42, 45, 48],
16500:[48, 53, 57, 61],
16600:[58, 63, 68, 73],
16700:[67, 74, 79, 85],
16800:[77, 84, 90, 97],
16900:[86, 95, 102, 109],
17000:[96, 105, 113, 121],
17100:[97, 110, 118, 127],
17200:[98, 114, 123, 132],
17300:[99, 119, 128, 138],
17400:[100, 124, 134, 143],
17500:[101, 129, 139, 149],
17600:[102, 133, 144, 154],
17700:[103, 138, 149, 160],
17800:[104, 143, 154, 165],
17900:[105, 148, 159, 171],
18000:[107, 152, 164, 176],
18100:[108, 156, 168, 181],
18200:[109, 160, 173, 185],
18300:[110, 165, 177, 190],
18400:[111, 169, 182, 195],
18500:[112, 173, 186, 200],
18600:[113, 177, 190, 204],
18700:[114, 181, 195, 209],
18800:[115, 185, 199, 214],
18900:[116, 190, 204, 219],
19000:[117, 194, 208, 223],
19100:[118, 198, 212, 228],
19200:[119, 202, 217, 233],
19300:[120, 206, 221, 237],
19400:[121, 210, 226, 242],
19500:[122, 214, 230, 247],
19600:[123, 218, 235, 252],
19700:[124, 222, 239, 256],
19800:[125, 226, 244, 261],
19900:[126, 230, 248, 266],
20000:[127, 234, 253, 271],
20100:[128, 238, 257, 276],
20200:[129, 242, 262, 280],
20300:[130, 246, 266, 285],
20400:[131, 250, 270, 290],
20500:[132, 254, 275, 295],
20600:[133, 258, 279, 299],
20700:[134, 262, 283, 304],
20800:[135, 266, 288, 309],
20900:[136, 270, 292, 314],
21000:[137, 275, 296, 318],
21100:[138, 279, 300, 323],
21200:[139, 283, 305, 327],
21300:[140, 287, 309, 332],
21400:[141, 291, 313, 337],
21500:[142, 295, 318, 342],
21600:[143, 299, 322, 346],
21700:[144, 303, 326, 351],
21800:[145, 308, 331, 356],
21900:[146, 312, 335, 361],
22000:[147, 316, 340, 365],
22100:[148, 320, 344, 370],
22200:[149, 324, 349, 374],
22300:[150, 328, 353, 379],
22400:[151, 332, 357, 384],
22500:[152, 336, 362, 389],
22600:[153, 341, 366, 393],
22700:[154, 345, 370, 398],
22800:[155, 349, 375, 403],
22900:[156, 353, 379, 408],
23000:[157, 357, 384, 412],
23100:[158, 361, 389, 417],
23200:[159, 366, 393, 422],
23300:[160, 370, 398, 427],
23400:[161, 374, 403, 432],
23500:[162, 379, 407, 437],
23600:[163, 383, 412, 442],
23700:[164, 387, 417, 447],
23800:[165, 391, 421, 452],
23900:[166, 396, 426, 457],
24000:[168, 400, 431, 462],
24100:[169, 404, 436, 467],
24200:[170, 409, 440, 472],
24300:[171, 413, 445, 477],
24400:[172, 418, 450, 482],
24500:[173, 422, 455, 487],
24600:[174, 426, 459, 492],
24700:[175, 431, 464, 497],
24800:[176, 435, 469, 502],
24900:[177, 440, 473, 507],
25000:[178, 444, 478, 512],
25100:[179, 446, 482, 516],
25200:[180, 448, 486, 520],
25300:[181, 450, 490, 525],
25400:[182, 452, 494, 529],
25500:[183, 454, 498, 533],
25600:[184, 456, 502, 537],
25700:[185, 458, 506, 542],
25800:[186, 460, 509, 546],
25900:[187, 462, 513, 550],
26000:[188, 464, 517, 554],
26100:[189, 464, 521, 558],
26200:[190, 465, 525, 562],
26300:[191, 465, 529, 566],
26400:[192, 466, 532, 570],
26500:[193, 466, 536, 574],
26600:[194, 466, 540, 578],
26700:[195, 467, 544, 582],
26800:[196, 467, 548, 586],
26900:[197, 467, 552, 590],
27000:[198, 468, 556, 595],
27100:[199, 468, 560, 599],
27200:[200, 469, 564, 603],
27300:[201, 469, 568, 607],
27400:[202, 469, 571, 611],
27500:[203, 470, 575, 615],
27600:[204, 470, 579, 619],
27700:[205, 471, 583, 623],
27800:[206, 471, 587, 628],
27900:[207, 471, 591, 632],
28000:[208, 472, 594, 636],
28100:[209, 473, 598, 640],
28200:[210, 473, 602, 644],
28300:[211, 474, 605, 648],
28400:[212, 474, 609, 652],
28500:[213, 475, 613, 656],
28600:[214, 475, 617, 660],
28700:[215, 476, 621, 665],
28800:[216, 476, 625, 669],
28900:[217, 477, 628, 673],
29000:[218, 477, 632, 677],
29100:[219, 478, 635, 681],
29200:[220, 479, 639, 685],
29300:[221, 479, 642, 689],
29400:[222, 480, 645, 693],
29500:[223, 481, 648, 697],
29600:[224, 482, 652, 702],
29700:[225, 483, 655, 706],
29800:[226, 484, 658, 710],
29900:[228, 484, 662, 714],
30000:[229, 485, 665, 718],
30100:[230, 486, 666, 722],
30200:[231, 487, 668, 726],
30300:[232, 487, 669, 730],
30400:[233, 488, 670, 734],
30500:[234, 489, 671, 738],
30600:[235, 490, 673, 743],
30700:[236, 491, 674, 747],
30800:[237, 491, 675, 751],
30900:[238, 492, 676, 755],
31000:[239, 493, 678, 759],
31100:[240, 494, 679, 763],
31200:[241, 495, 681, 767],
31300:[242, 495, 682, 771],
31400:[243, 496, 683, 775],
31500:[244, 497, 684, 780],
31600:[245, 498, 686, 784],
31700:[246, 499, 687, 788],
31800:[247, 499, 688, 792],
31900:[248, 500, 689, 796],
32000:[249, 501, 691, 800],
32100:[250, 502, 692, 804],
32200:[251, 502, 693, 808],
32300:[252, 503, 695, 812],
32400:[253, 504, 696, 816],
32500:[254, 504, 697, 820],
32600:[255, 505, 698, 823],
32700:[256, 506, 699, 827],
32800:[257, 506, 701, 831],
32900:[258, 507, 702, 835],
33000:[259, 508, 703, 839],
33100:[260, 509, 704, 843],
33200:[261, 509, 705, 846],
33300:[261, 510, 706, 850],
33400:[262, 511, 708, 854],
33500:[263, 511, 709, 857],
33600:[264, 512, 710, 861],
33700:[265, 513, 711, 865],
33800:[265, 513, 712, 868],
33900:[266, 514, 713, 872],
34000:[267, 515, 714, 876],
34100:[267, 516, 715, 878],
34200:[268, 517, 717, 880],
34300:[268, 518, 718, 881],
34400:[269, 519, 720, 883],
34500:[269, 520, 721, 885],
34600:[270, 521, 723, 887],
34700:[270, 522, 724, 888],
34800:[271, 523, 725, 890],
34900:[271, 524, 727, 892],
35000:[271, 525, 728, 894],
35100:[272, 527, 730, 896],
35200:[273, 528, 732, 898],
35300:[274, 530, 734, 901],
35400:[275, 531, 736, 903],
35500:[276, 533, 738, 905],
35600:[277, 534, 740, 907],
35700:[278, 536, 742, 910],
35800:[279, 537, 743, 912],
35900:[280, 539, 745, 914],
36000:[281, 540, 747, 916],
36100:[282, 542, 749, 919],
36200:[284, 544, 752, 922],
36300:[285, 546, 754, 924],
36400:[287, 548, 757, 927],
36500:[288, 550, 759, 930],
36600:[289, 552, 761, 933],
36700:[291, 553, 764, 935],
36800:[292, 555, 766, 938],
36900:[294, 557, 769, 941],
37000:[295, 559, 771, 944],
37100:[296, 561, 773, 947],
37200:[298, 563, 776, 949],
37300:[299, 565, 778, 952],
37400:[301, 567, 780, 955],
37500:[302, 568, 783, 958],
37600:[304, 570, 785, 960],
37700:[305, 572, 787, 963],
37800:[306, 574, 790, 966],
37900:[308, 576, 792, 969],
38000:[309, 578, 794, 971],
38100:[310, 580, 796, 974],
38200:[312, 582, 799, 976],
38300:[313, 584, 801, 979],
38400:[315, 586, 803, 982],
38500:[316, 588, 806, 985],
38600:[318, 590, 808, 987],
38700:[319, 592, 811, 990],
38800:[320, 594, 813, 993],
38900:[322, 596, 815, 995],
39000:[323, 598, 818, 998],
39100:[324, 600, 820, 1001],
39200:[326, 602, 823, 1003],
39300:[327, 604, 825, 1006],
39400:[329, 606, 828, 1009],
39500:[330, 608, 830, 1011],
39600:[332, 610, 832, 1014],
39700:[333, 611, 835, 1017],
39800:[334, 613, 837, 1020],
39900:[336, 615, 840, 1022],
40000:[337, 617, 842, 1025],
40100:[338, 619, 844, 1028],
40200:[340, 621, 847, 1030],
40300:[341, 623, 849, 1033],
40400:[342, 625, 851, 1036],
40500:[344, 626, 854, 1038],
40600:[345, 628, 856, 1041],
40700:[346, 630, 858, 1044],
40800:[348, 632, 861, 1046],
40900:[349, 634, 863, 1049],
41000:[350, 636, 865, 1052],
41100:[351, 638, 867, 1055],
41200:[353, 640, 870, 1057],
41300:[354, 642, 872, 1060],
41400:[356, 644, 874, 1063],
41500:[357, 646, 877, 1065],
41600:[358, 647, 879, 1068],
41700:[360, 649, 881, 1070],
41800:[361, 651, 884, 1073],
41900:[363, 653, 886, 1076],
42000:[364, 655, 888, 1078],
42100:[365, 657, 890, 1081],
42200:[367, 659, 893, 1083],
42300:[368, 661, 895, 1086],
42400:[370, 663, 897, 1089],
42500:[371, 665, 900, 1091],
42600:[373, 667, 902, 1094],
42700:[374, 668, 904, 1097],
42800:[375, 670, 907, 1099],
42900:[377, 672, 909, 1102],
43000:[378, 674, 911, 1105],
43100:[380, 676, 913, 1108],
43200:[381, 678, 916, 1110],
43300:[383, 680, 918, 1113],
43400:[384, 682, 921, 1116],
43500:[386, 684, 923, 1119],
43600:[387, 686, 925, 1121],
43700:[389, 688, 928, 1124],
43800:[390, 690, 930, 1127],
43900:[392, 692, 933, 1130],
44000:[393, 694, 935, 1132],
44100:[395, 696, 937, 1135],
44200:[396, 698, 940, 1137],
44300:[398, 700, 942, 1140],
44400:[399, 702, 944, 1143],
44500:[401, 704, 947, 1145],
44600:[402, 706, 949, 1148],
44700:[404, 708, 951, 1150],
44800:[405, 710, 954, 1153],
44900:[407, 712, 956, 1156],
45000:[408, 714, 958, 1158],
45100:[410, 716, 960, 1161],
45200:[411, 718, 963, 1163],
45300:[413, 720, 965, 1166],
45400:[414, 722, 967, 1169],
45500:[416, 724, 970, 1171],
45600:[417, 726, 972, 1174],
45700:[419, 728, 975, 1177],
45800:[420, 730, 977, 1179],
45900:[422, 732, 979, 1182],
46000:[423, 733, 982, 1185],
46100:[424, 735, 984, 1187],
46200:[425, 736, 986, 1190],
46300:[426, 738, 988, 1192],
46400:[428, 740, 990, 1195],
46500:[429, 741, 993, 1197],
46600:[430, 743, 995, 1200],
46700:[431, 745, 997, 1202],
46800:[432, 746, 999, 1205],
46900:[433, 748, 1001, 1207],
47000:[434, 750, 1003, 1210],
47100:[435, 751, 1005, 1212],
47200:[436, 753, 1007, 1215],
47300:[437, 754, 1009, 1217],
47400:[438, 756, 1011, 1219],
47500:[439, 757, 1013, 1222],
47600:[440, 759, 1015, 1224],
47700:[441, 760, 1017, 1226],
47800:[442, 762, 1019, 1229],
47900:[443, 763, 1021, 1231],
48000:[444, 765, 1023, 1233],
48100:[445, 766, 1025, 1235],
48200:[446, 768, 1027, 1238],
48300:[447, 769, 1029, 1240],
48400:[448, 771, 1031, 1242],
48500:[449, 772, 1033, 1245],
48600:[450, 774, 1035, 1247],
48700:[451, 775, 1037, 1249],
48800:[452, 777, 1039, 1251],
48900:[453, 778, 1041, 1254],
49000:[454, 780, 1042, 1256],
49100:[455, 781, 1044, 1258],
49200:[456, 783, 1046, 1260],
49300:[457, 784, 1048, 1263],
49400:[458, 786, 1050, 1265],
49500:[459, 787, 1052, 1267],
49600:[460, 789, 1053, 1269],
49700:[461, 790, 1055, 1272],
49800:[461, 792, 1057, 1274],
49900:[462, 793, 1059, 1276],
50000:[463, 795, 1061, 1278],
50100:[464, 796, 1063, 1280],
50200:[465, 798, 1065, 1283],
50300:[466, 799, 1067, 1285],
50400:[467, 801, 1069, 1287],
50500:[468, 802, 1070, 1289],
50600:[469, 804, 1072, 1292],
50700:[470, 805, 1074, 1294],
50800:[471, 807, 1076, 1296],
50900:[472, 808, 1078, 1298],
51000:[473, 810, 1080, 1301],
51100:[474, 812, 1082, 1303],
51200:[475, 813, 1084, 1306],
51300:[476, 815, 1086, 1308],
51400:[477, 816, 1088, 1310],
51500:[478, 818, 1090, 1312],
51600:[479, 819, 1092, 1315],
51700:[480, 821, 1094, 1317],
51800:[481, 822, 1096, 1319],
51900:[482, 824, 1098, 1321],
52000:[483, 826, 1100, 1324],
52100:[484, 828, 1102, 1326],
52200:[485, 829, 1104, 1329],
52300:[486, 831, 1106, 1331],
52400:[487, 832, 1108, 1333],
52500:[488, 834, 1110, 1336],
52600:[489, 835, 1112, 1338],
52700:[490, 837, 1114, 1341],
52800:[491, 838, 1116, 1343],
52900:[492, 840, 1118, 1345],
53000:[493, 841, 1120, 1348],
53100:[494, 843, 1122, 1350],
53200:[495, 844, 1124, 1353],
53300:[496, 846, 1126, 1355],
53400:[497, 847, 1128, 1357],
53500:[498, 849, 1130, 1360],
53600:[499, 850, 1132, 1362],
53700:[500, 852, 1134, 1364],
53800:[501, 853, 1136, 1367],
53900:[502, 855, 1137, 1369],
54000:[502, 856, 1139, 1371],
54100:[503, 857, 1141, 1373],
54200:[504, 859, 1143, 1375],
54300:[505, 860, 1145, 1378],
54400:[506, 862, 1146, 1380],
54500:[507, 863, 1148, 1382],
54600:[508, 865, 1150, 1384],
54700:[509, 866, 1152, 1386],
54800:[510, 868, 1154, 1389],
54900:[511, 869, 1156, 1391],
55000:[512, 871, 1158, 1393],
55100:[513, 872, 1160, 1395],
55200:[514, 874, 1162, 1397],
55300:[515, 875, 1164, 1400],
55400:[516, 877, 1166, 1402],
55500:[517, 878, 1167, 1404],
55600:[518, 880, 1169, 1406],
55700:[518, 881, 1171, 1408],
55800:[519, 882, 1173, 1411],
55900:[520, 884, 1175, 1413],
56000:[521, 885, 1177, 1415],
56100:[522, 886, 1179, 1417],
56200:[523, 888, 1181, 1419],
56300:[524, 889, 1182, 1422],
56400:[525, 891, 1184, 1424],
56500:[525, 892, 1186, 1426],
56600:[526, 894, 1188, 1428],
56700:[527, 895, 1190, 1430],
56800:[528, 897, 1192, 1433],
56900:[529, 898, 1193, 1435],
57000:[530, 900, 1195, 1437],
57100:[531, 901, 1197, 1439],
57200:[532, 903, 1199, 1441],
57300:[533, 904, 1201, 1444],
57400:[534, 906, 1202, 1446],
57500:[535, 907, 1204, 1448],
57600:[536, 909, 1206, 1450],
57700:[537, 910, 1208, 1452],
57800:[538, 911, 1210, 1455],
57900:[539, 913, 1212, 1457],
58000:[540, 914, 1214, 1459],
58100:[541, 915, 1216, 1461],
58200:[542, 917, 1218, 1463],
58300:[543, 918, 1219, 1466],
58400:[544, 920, 1221, 1468],
58500:[545, 921, 1223, 1470],
58600:[546, 923, 1225, 1472],
58700:[547, 924, 1227, 1474],
58800:[547, 926, 1228, 1477],
58900:[548, 927, 1230, 1479],
59000:[549, 929, 1232, 1481],
59100:[550, 930, 1234, 1483],
59200:[551, 932, 1236, 1485],
59300:[552, 933, 1238, 1488],
59400:[553, 935, 1239, 1490],
59500:[554, 936, 1241, 1492],
59600:[554, 938, 1243, 1494],
59700:[555, 939, 1245, 1496],
59800:[556, 940, 1247, 1499],
59900:[557, 942, 1249, 1501],
60000:[558, 943, 1251, 1503],
60100:[559, 944, 1253, 1505],
60200:[560, 946, 1255, 1507],
60300:[561, 947, 1257, 1510],
60400:[562, 949, 1259, 1512],
60500:[563, 950, 1260, 1514],
60600:[564, 952, 1262, 1516],
60700:[565, 953, 1264, 1518],
60800:[566, 955, 1266, 1521],
60900:[567, 956, 1268, 1523],
61000:[568, 958, 1270, 1525],
61100:[569, 959, 1272, 1527],
61200:[570, 961, 1274, 1529],
61300:[571, 962, 1275, 1532],
61400:[572, 964, 1277, 1534],
61500:[573, 965, 1279, 1536],
61600:[574, 967, 1281, 1538],
61700:[575, 968, 1283, 1540],
61800:[576, 969, 1285, 1543],
61900:[576, 971, 1286, 1545],
62000:[577, 972, 1288, 1547],
62100:[578, 973, 1290, 1549],
62200:[579, 975, 1292, 1552],
62300:[580, 976, 1294, 1554],
62400:[581, 978, 1295, 1556],
62500:[582, 979, 1297, 1558],
62600:[582, 981, 1299, 1561],
62700:[583, 982, 1301, 1563],
62800:[584, 984, 1303, 1565],
62900:[585, 985, 1305, 1567],
63000:[586, 987, 1307, 1570],
63100:[587, 988, 1309, 1572],
63200:[588, 990, 1311, 1574],
63300:[589, 991, 1313, 1577],
63400:[590, 993, 1314, 1579],
63500:[591, 994, 1316, 1581],
63600:[592, 996, 1318, 1583],
63700:[593, 997, 1320, 1586],
63800:[594, 999, 1322, 1588],
63900:[595, 1000, 1324, 1590],
64000:[596, 1002, 1326, 1592],
64100:[597, 1004, 1328, 1594],
64200:[598, 1005, 1330, 1596],
64300:[599, 1007, 1332, 1599],
64400:[600, 1008, 1333, 1601],
64500:[601, 1010, 1335, 1603],
64600:[601, 1011, 1337, 1605],
64700:[602, 1013, 1339, 1607],
64800:[603, 1014, 1341, 1610],
64900:[604, 1016, 1343, 1612],
65000:[605, 1017, 1345, 1614],
65100:[606, 1018, 1347, 1616],
65200:[607, 1020, 1349, 1619],
65300:[608, 1021, 1351, 1621],
65400:[609, 1023, 1352, 1623],
65500:[610, 1024, 1354, 1625],
65600:[611, 1026, 1356, 1628],
65700:[612, 1027, 1358, 1630],
65800:[613, 1029, 1360, 1632],
65900:[614, 1030, 1362, 1634],
66000:[615, 1031, 1364, 1637],
66100:[616, 1032, 1366, 1639],
66200:[617, 1034, 1368, 1642],
66300:[618, 1035, 1370, 1644],
66400:[619, 1037, 1372, 1646],
66500:[620, 1038, 1374, 1649],
66600:[621, 1040, 1376, 1651],
66700:[622, 1041, 1378, 1653],
66800:[623, 1043, 1380, 1656],
66900:[624, 1044, 1382, 1658],
67000:[625, 1046, 1384, 1660],
67100:[626, 1048, 1386, 1662],
67200:[627, 1049, 1388, 1665],
67300:[628, 1051, 1390, 1667],
67400:[629, 1052, 1392, 1669],
67500:[630, 1054, 1394, 1672],
67600:[631, 1055, 1396, 1674],
67700:[632, 1057, 1398, 1676],
67800:[633, 1059, 1400, 1679],
67900:[634, 1060, 1401, 1681],
68000:[634, 1062, 1403, 1683],
68100:[635, 1064, 1405, 1685],
68200:[636, 1065, 1407, 1688],
68300:[637, 1067, 1409, 1690],
68400:[638, 1068, 1411, 1692],
68500:[639, 1070, 1413, 1695],
68600:[640, 1071, 1415, 1697],
68700:[641, 1073, 1417, 1699],
68800:[642, 1074, 1419, 1701],
68900:[643, 1076, 1421, 1704],
69000:[644, 1077, 1423, 1706],
69100:[645, 1079, 1425, 1708],
69200:[646, 1080, 1427, 1711],
69300:[647, 1082, 1429, 1713],
69400:[648, 1083, 1431, 1715],
69500:[649, 1085, 1433, 1717],
69600:[650, 1086, 1435, 1720],
69700:[651, 1088, 1437, 1722],
69800:[652, 1089, 1439, 1724],
69900:[653, 1091, 1441, 1727],
70000:[654, 1092, 1443, 1729],
70100:[655, 1094, 1445, 1731],
70200:[656, 1095, 1447, 1734],
70300:[657, 1097, 1449, 1736],
70400:[658, 1098, 1451, 1738],
70500:[659, 1100, 1453, 1741],
70600:[660, 1101, 1455, 1743],
70700:[661, 1103, 1457, 1745],
70800:[662, 1105, 1458, 1748],
70900:[663, 1106, 1460, 1750],
71000:[664, 1108, 1462, 1753],
71100:[665, 1110, 1464, 1755],
71200:[666, 1111, 1466, 1758],
71300:[667, 1113, 1468, 1760],
71400:[668, 1114, 1470, 1762],
71500:[669, 1116, 1472, 1765],
71600:[670, 1117, 1474, 1767],
71700:[671, 1119, 1476, 1769],
71800:[672, 1120, 1478, 1772],
71900:[673, 1122, 1480, 1774],
72000:[674, 1123, 1482, 1776],
72100:[675, 1125, 1484, 1778],
72200:[676, 1126, 1486, 1781],
72300:[677, 1128, 1488, 1783],
72400:[678, 1129, 1490, 1785],
72500:[679, 1131, 1492, 1787],
72600:[680, 1132, 1494, 1790],
72700:[681, 1134, 1496, 1792],
72800:[682, 1135, 1498, 1794],
72900:[683, 1137, 1500, 1797],
73000:[684, 1138, 1502, 1799],
73100:[685, 1139, 1504, 1801],
73200:[686, 1141, 1506, 1804],
73300:[687, 1142, 1508, 1806],
73400:[688, 1144, 1510, 1808],
73500:[689, 1145, 1512, 1811],
73600:[690, 1147, 1514, 1813],
73700:[691, 1148, 1515, 1816],
73800:[692, 1150, 1517, 1818],
73900:[692, 1151, 1519, 1820],
74000:[693, 1153, 1521, 1823],
74100:[694, 1155, 1523, 1825],
74200:[695, 1156, 1525, 1828],
74300:[696, 1158, 1527, 1830],
74400:[697, 1159, 1529, 1832],
74500:[698, 1161, 1531, 1835],
74600:[699, 1162, 1533, 1837],
74700:[700, 1164, 1535, 1839],
74800:[701, 1165, 1537, 1842],
74900:[702, 1167, 1539, 1844],
75000:[703, 1169, 1541, 1846],
75100:[704, 1171, 1543, 1848],
75200:[705, 1172, 1545, 1851],
75300:[706, 1174, 1547, 1853],
75400:[707, 1175, 1549, 1855],
75500:[708, 1177, 1551, 1858],
75600:[709, 1178, 1553, 1860],
75700:[710, 1180, 1555, 1862],
75800:[711, 1181, 1557, 1865],
75900:[712, 1183, 1559, 1867],
76000:[713, 1184, 1561, 1869],
76100:[714, 1185, 1563, 1871],
76200:[715, 1187, 1565, 1874],
76300:[716, 1188, 1567, 1876],
76400:[717, 1190, 1569, 1878],
76500:[718, 1191, 1571, 1880],
76600:[719, 1193, 1573, 1883],
76700:[720, 1194, 1575, 1885],
76800:[721, 1196, 1577, 1887],
76900:[722, 1197, 1579, 1890],
77000:[723, 1199, 1581, 1892],
77100:[724, 1201, 1583, 1894],
77200:[725, 1202, 1585, 1897],
77300:[726, 1204, 1587, 1899],
77400:[727, 1205, 1589, 1901],
77500:[728, 1207, 1591, 1904],
77600:[729, 1208, 1593, 1906],
77700:[730, 1210, 1595, 1909],
77800:[731, 1211, 1597, 1911],
77900:[732, 1213, 1599, 1913],
78000:[733, 1215, 1600, 1916],
78100:[734, 1217, 1602, 1918],
78200:[735, 1218, 1604, 1921],
78300:[736, 1220, 1606, 1923],
78400:[737, 1221, 1608, 1925],
78500:[738, 1223, 1610, 1928],
78600:[739, 1224, 1612, 1930],
78700:[740, 1226, 1614, 1932],
78800:[741, 1227, 1616, 1935],
78900:[742, 1229, 1618, 1937],
79000:[743, 1230, 1620, 1939],
79100:[744, 1231, 1622, 1941],
79200:[745, 1233, 1624, 1944],
79300:[746, 1234, 1626, 1946],
79400:[747, 1236, 1628, 1948],
79500:[748, 1237, 1630, 1951],
79600:[749, 1239, 1632, 1953],
79700:[750, 1240, 1634, 1955],
79800:[751, 1242, 1636, 1957],
79900:[752, 1243, 1638, 1960],
80000:[753, 1245, 1640, 1962],
80100:[754, 1247, 1642, 1964],
80200:[755, 1248, 1644, 1967],
80300:[756, 1250, 1646, 1969],
80400:[757, 1251, 1648, 1971],
80500:[758, 1253, 1650, 1973],
80600:[759, 1254, 1652, 1976],
80700:[760, 1256, 1654, 1978],
80800:[761, 1258, 1655, 1980],
80900:[762, 1259, 1657, 1983],
81000:[762, 1261, 1659, 1985],
81100:[763, 1263, 1661, 1987],
81200:[764, 1264, 1663, 1990],
81300:[765, 1266, 1665, 1992],
81400:[766, 1267, 1667, 1994],
81500:[767, 1269, 1669, 1997],
81600:[768, 1270, 1671, 1999],
81700:[769, 1272, 1673, 2001],
81800:[770, 1273, 1675, 2004],
81900:[771, 1275, 1677, 2006],
82000:[772, 1276, 1679, 2009],
82100:[773, 1277, 1681, 2011],
82200:[774, 1279, 1683, 2014],
82300:[775, 1280, 1685, 2016],
82400:[776, 1282, 1687, 2018],
82500:[777, 1283, 1689, 2021],
82600:[778, 1285, 1691, 2023],
82700:[779, 1286, 1693, 2025],
82800:[780, 1288, 1695, 2028],
82900:[781, 1289, 1697, 2030],
83000:[782, 1291, 1699, 2032],
83100:[783, 1293, 1701, 2034],
83200:[784, 1294, 1703, 2037],
83300:[785, 1296, 1705, 2039],
83400:[786, 1297, 1707, 2041],
83500:[787, 1299, 1709, 2043],
83600:[788, 1300, 1711, 2046],
83700:[789, 1302, 1712, 2048],
83800:[790, 1304, 1714, 2050],
83900:[791, 1305, 1716, 2053],
84000:[792, 1307, 1718, 2055],
84100:[793, 1309, 1720, 2057],
84200:[794, 1310, 1722, 2060],
84300:[795, 1312, 1724, 2062],
84400:[796, 1313, 1726, 2064],
84500:[797, 1315, 1728, 2067],
84600:[798, 1316, 1730, 2069],
84700:[799, 1318, 1732, 2072],
84800:[800, 1319, 1734, 2074],
84900:[801, 1321, 1736, 2076],
85000:[802, 1322, 1738, 2079],
85100:[803, 1324, 1740, 2081],
85200:[804, 1325, 1742, 2084],
85300:[805, 1327, 1744, 2086],
85400:[806, 1328, 1746, 2088],
85500:[807, 1330, 1748, 2091],
85600:[808, 1331, 1750, 2093],
85700:[809, 1333, 1752, 2095],
85800:[810, 1334, 1754, 2098],
85900:[811, 1336, 1756, 2100],
86000:[812, 1337, 1758, 2102],
86100:[813, 1339, 1760, 2104],
86200:[814, 1340, 1762, 2107],
86300:[815, 1342, 1764, 2109],
86400:[816, 1343, 1766, 2111],
86500:[817, 1345, 1768, 2114],
86600:[818, 1346, 1770, 2116],
86700:[819, 1348, 1771, 2118],
86800:[819, 1350, 1773, 2121],
86900:[820, 1351, 1775, 2123],
87000:[821, 1353, 1777, 2125],
87100:[822, 1355, 1779, 2127],
87200:[823, 1356, 1781, 2130],
87300:[824, 1358, 1783, 2132],
87400:[825, 1359, 1785, 2134],
87500:[826, 1361, 1787, 2136],
87600:[827, 1362, 1789, 2139],
87700:[828, 1364, 1791, 2141],
87800:[829, 1365, 1793, 2143],
87900:[830, 1367, 1795, 2146],
88000:[831, 1368, 1797, 2148],
88100:[832, 1370, 1799, 2150],
88200:[833, 1371, 1801, 2153],
88300:[834, 1373, 1803, 2155],
88400:[835, 1374, 1805, 2157],
88500:[836, 1376, 1807, 2160],
88600:[837, 1377, 1809, 2162],
88700:[838, 1379, 1811, 2165],
88800:[839, 1380, 1813, 2167],
88900:[840, 1382, 1815, 2169],
89000:[841, 1383, 1817, 2172],
89100:[842, 1385, 1819, 2174],
89200:[843, 1386, 1821, 2177],
89300:[844, 1388, 1823, 2179],
89400:[845, 1389, 1825, 2181],
89500:[846, 1391, 1827, 2184],
89600:[847, 1392, 1829, 2186],
89700:[848, 1394, 1831, 2188],
89800:[849, 1396, 1833, 2191],
89900:[850, 1397, 1835, 2193],
90000:[851, 1399, 1837, 2195],
90100:[852, 1401, 1839, 2197],
90200:[853, 1402, 1841, 2200],
90300:[854, 1404, 1843, 2202],
90400:[855, 1405, 1845, 2204],
90500:[856, 1407, 1847, 2207],
90600:[857, 1408, 1849, 2209],
90700:[858, 1410, 1851, 2211],
90800:[859, 1411, 1853, 2213],
90900:[860, 1413, 1854, 2216],
91000:[861, 1414, 1856, 2218],
91100:[862, 1416, 1858, 2220],
91200:[863, 1417, 1860, 2223],
91300:[864, 1419, 1862, 2225],
91400:[865, 1420, 1864, 2228],
91500:[866, 1422, 1866, 2230],
91600:[867, 1423, 1868, 2232],
91700:[868, 1425, 1870, 2235],
91800:[869, 1426, 1872, 2237],
91900:[870, 1428, 1874, 2239],
92000:[871, 1429, 1876, 2242],
92100:[872, 1431, 1878, 2244],
92200:[873, 1432, 1880, 2247],
92300:[874, 1434, 1882, 2249],
92400:[875, 1435, 1884, 2251],
92500:[876, 1437, 1886, 2254],
92600:[877, 1438, 1888, 2256],
92700:[878, 1440, 1890, 2258],
92800:[879, 1442, 1892, 2261],
92900:[880, 1443, 1894, 2263],
93000:[881, 1445, 1896, 2265],
93100:[882, 1447, 1898, 2267],
93200:[883, 1448, 1900, 2270],
93300:[884, 1450, 1902, 2272],
93400:[885, 1451, 1904, 2274],
93500:[886, 1453, 1906, 2277],
93600:[887, 1454, 1908, 2279],
93700:[888, 1456, 1910, 2281],
93800:[889, 1457, 1911, 2284],
93900:[889, 1459, 1913, 2286],
94000:[890, 1460, 1915, 2288],
94100:[891, 1462, 1917, 2290],
94200:[892, 1463, 1919, 2293],
94300:[893, 1465, 1921, 2295],
94400:[894, 1466, 1923, 2297],
94500:[895, 1468, 1925, 2299],
94600:[896, 1469, 1927, 2302],
94700:[897, 1471, 1929, 2304],
94800:[898, 1472, 1931, 2306],
94900:[899, 1474, 1933, 2309],
95000:[900, 1475, 1935, 2311],
95100:[901, 1476, 1937, 2313],
95200:[902, 1478, 1939, 2316],
95300:[903, 1479, 1941, 2318],
95400:[904, 1481, 1943, 2320],
95500:[905, 1482, 1945, 2323],
95600:[906, 1484, 1947, 2325],
95700:[907, 1485, 1949, 2328],
95800:[908, 1487, 1951, 2330],
95900:[909, 1488, 1953, 2332],
96000:[910, 1490, 1955, 2335],
96100:[911, 1492, 1957, 2337],
96200:[912, 1493, 1959, 2340],
96300:[913, 1495, 1961, 2342],
96400:[914, 1496, 1963, 2344],
96500:[915, 1498, 1965, 2347],
96600:[916, 1499, 1967, 2349],
96700:[917, 1501, 1968, 2351],
96800:[918, 1502, 1970, 2354],
96900:[919, 1504, 1972, 2356],
97000:[920, 1506, 1974, 2358],
97100:[921, 1508, 1976, 2360],
97200:[922, 1509, 1978, 2362],
97300:[923, 1511, 1980, 2365],
97400:[924, 1512, 1981, 2367],
97500:[925, 1514, 1983, 2369],
97600:[925, 1515, 1985, 2371],
97700:[926, 1517, 1987, 2373],
97800:[927, 1518, 1989, 2376],
97900:[928, 1520, 1991, 2378],
98000:[929, 1521, 1993, 2380],
98100:[930, 1522, 1995, 2382],
98200:[931, 1524, 1997, 2384],
98300:[932, 1525, 1999, 2387],
98400:[933, 1527, 2000, 2389],
98500:[934, 1528, 2002, 2391],
98600:[935, 1530, 2004, 2393],
98700:[936, 1531, 2006, 2395],
98800:[937, 1533, 2008, 2397],
98900:[938, 1534, 2010, 2400],
99000:[939, 1535, 2012, 2402],
99100:[940, 1536, 2014, 2404],
99200:[941, 1538, 2016, 2407],
99300:[942, 1539, 2018, 2409],
99400:[943, 1541, 2020, 2411],
99500:[944, 1542, 2021, 2413],
99600:[945, 1544, 2023, 2416],
99700:[945, 1545, 2025, 2418],
99800:[946, 1547, 2027, 2420],
99900:[947, 1548, 2029, 2422],
};
const OR_NT=[0.86, 1.34, 1.68, 2.02];

// Nunavut — 2025 Federal Child Support Guidelines Table
const T_NU={
100000:[978, 1596, 2090, 2494],
100100:[979, 1598, 2092, 2496],
100200:[980, 1599, 2094, 2499],
100300:[981, 1601, 2096, 2501],
100400:[982, 1602, 2098, 2503],
100500:[983, 1604, 2100, 2506],
100600:[984, 1605, 2102, 2508],
100700:[985, 1607, 2104, 2510],
100800:[986, 1608, 2106, 2513],
100900:[987, 1610, 2108, 2515],
101000:[988, 1611, 2110, 2518],
101100:[989, 1613, 2112, 2520],
101200:[990, 1614, 2114, 2523],
101300:[991, 1616, 2116, 2525],
101400:[992, 1617, 2118, 2527],
101500:[993, 1619, 2120, 2530],
101600:[994, 1620, 2122, 2532],
101700:[995, 1622, 2124, 2535],
101800:[996, 1623, 2126, 2537],
101900:[997, 1625, 2128, 2539],
102000:[998, 1627, 2130, 2542],
102100:[999, 1629, 2132, 2544],
102200:[1000, 1630, 2134, 2547],
102300:[1001, 1632, 2136, 2549],
102400:[1002, 1633, 2138, 2551],
102500:[1003, 1635, 2140, 2553],
102600:[1004, 1637, 2142, 2556],
102700:[1005, 1638, 2144, 2558],
102800:[1006, 1640, 2146, 2560],
102900:[1007, 1641, 2148, 2563],
103000:[1008, 1643, 2150, 2565],
103100:[1009, 1645, 2152, 2567],
103200:[1010, 1646, 2154, 2570],
103300:[1011, 1648, 2156, 2572],
103400:[1012, 1649, 2158, 2574],
103500:[1013, 1651, 2160, 2577],
103600:[1014, 1652, 2162, 2579],
103700:[1015, 1654, 2164, 2581],
103800:[1016, 1655, 2166, 2584],
103900:[1017, 1657, 2168, 2586],
104000:[1018, 1658, 2170, 2589],
104100:[1019, 1660, 2172, 2591],
104200:[1020, 1661, 2174, 2594],
104300:[1021, 1663, 2176, 2596],
104400:[1022, 1664, 2178, 2598],
104500:[1023, 1666, 2180, 2601],
104600:[1024, 1667, 2182, 2603],
104700:[1025, 1669, 2183, 2605],
104800:[1026, 1670, 2185, 2608],
104900:[1027, 1672, 2187, 2610],
105000:[1028, 1673, 2189, 2612],
105100:[1029, 1675, 2191, 2614],
105200:[1030, 1676, 2193, 2617],
105300:[1031, 1678, 2195, 2619],
105400:[1032, 1679, 2197, 2621],
105500:[1033, 1681, 2199, 2624],
105600:[1034, 1682, 2201, 2626],
105700:[1035, 1684, 2203, 2628],
105800:[1036, 1685, 2205, 2631],
105900:[1037, 1687, 2207, 2633],
106000:[1037, 1688, 2209, 2635],
106100:[1038, 1689, 2211, 2637],
106200:[1039, 1691, 2213, 2640],
106300:[1040, 1692, 2215, 2642],
106400:[1041, 1694, 2217, 2644],
106500:[1042, 1695, 2219, 2647],
106600:[1043, 1697, 2220, 2649],
106700:[1044, 1698, 2222, 2651],
106800:[1045, 1700, 2224, 2653],
106900:[1046, 1701, 2226, 2656],
107000:[1047, 1703, 2228, 2658],
107100:[1048, 1704, 2230, 2660],
107200:[1049, 1706, 2232, 2662],
107300:[1050, 1707, 2234, 2665],
107400:[1051, 1709, 2235, 2667],
107500:[1051, 1710, 2237, 2669],
107600:[1052, 1712, 2239, 2671],
107700:[1053, 1713, 2241, 2673],
107800:[1054, 1715, 2243, 2676],
107900:[1055, 1716, 2245, 2678],
108000:[1056, 1718, 2247, 2680],
108100:[1057, 1719, 2249, 2682],
108200:[1058, 1721, 2251, 2684],
108300:[1059, 1722, 2252, 2686],
108400:[1059, 1724, 2254, 2688],
108500:[1060, 1725, 2256, 2690],
108600:[1061, 1726, 2258, 2693],
108700:[1062, 1728, 2260, 2695],
108800:[1063, 1729, 2261, 2697],
108900:[1064, 1731, 2263, 2699],
109000:[1065, 1732, 2265, 2701],
109100:[1066, 1733, 2267, 2703],
109200:[1067, 1735, 2269, 2705],
109300:[1068, 1736, 2270, 2707],
109400:[1068, 1738, 2272, 2710],
109500:[1069, 1739, 2274, 2712],
109600:[1070, 1740, 2276, 2714],
109700:[1071, 1742, 2278, 2716],
109800:[1072, 1743, 2279, 2718],
109900:[1073, 1745, 2281, 2720],
110000:[1074, 1746, 2283, 2723],
110100:[1075, 1747, 2285, 2725],
110200:[1076, 1749, 2287, 2727],
110300:[1077, 1750, 2288, 2729],
110400:[1077, 1752, 2290, 2732],
110500:[1078, 1753, 2292, 2734],
110600:[1079, 1754, 2294, 2736],
110700:[1080, 1756, 2295, 2738],
110800:[1081, 1757, 2297, 2740],
110900:[1082, 1759, 2299, 2742],
111000:[1083, 1760, 2301, 2744],
111100:[1084, 1761, 2303, 2746],
111200:[1085, 1763, 2305, 2748],
111300:[1086, 1764, 2306, 2750],
111400:[1087, 1766, 2308, 2752],
111500:[1088, 1767, 2310, 2754],
111600:[1089, 1768, 2312, 2757],
111700:[1090, 1770, 2313, 2759],
111800:[1091, 1771, 2315, 2761],
111900:[1092, 1773, 2317, 2763],
112000:[1093, 1774, 2319, 2765],
112100:[1094, 1775, 2321, 2767],
112200:[1095, 1777, 2323, 2769],
112300:[1096, 1778, 2324, 2771],
112400:[1097, 1780, 2326, 2774],
112500:[1098, 1781, 2328, 2776],
112600:[1099, 1782, 2330, 2778],
112700:[1100, 1784, 2331, 2780],
112800:[1101, 1785, 2333, 2782],
112900:[1102, 1787, 2335, 2784],
113000:[1102, 1788, 2337, 2787],
113100:[1103, 1789, 2339, 2789],
113200:[1104, 1791, 2341, 2791],
113300:[1105, 1792, 2342, 2793],
113400:[1106, 1794, 2344, 2796],
113500:[1107, 1795, 2346, 2798],
113600:[1108, 1796, 2348, 2800],
113700:[1109, 1798, 2349, 2802],
113800:[1110, 1799, 2351, 2804],
113900:[1111, 1801, 2353, 2806],
114000:[1111, 1802, 2355, 2808],
114100:[1112, 1803, 2357, 2810],
114200:[1113, 1805, 2359, 2812],
114300:[1114, 1806, 2360, 2814],
114400:[1115, 1808, 2362, 2816],
114500:[1116, 1809, 2364, 2818],
114600:[1117, 1810, 2366, 2821],
114700:[1118, 1812, 2367, 2823],
114800:[1119, 1813, 2369, 2825],
114900:[1119, 1814, 2371, 2827],
115000:[1120, 1816, 2373, 2829],
115100:[1121, 1817, 2375, 2831],
115200:[1122, 1819, 2377, 2833],
115300:[1123, 1820, 2379, 2835],
115400:[1124, 1822, 2380, 2838],
115500:[1125, 1823, 2382, 2840],
115600:[1126, 1824, 2384, 2842],
115700:[1127, 1826, 2386, 2844],
115800:[1128, 1827, 2388, 2846],
115900:[1128, 1828, 2390, 2848],
116000:[1129, 1830, 2392, 2851],
116100:[1130, 1831, 2394, 2853],
116200:[1131, 1833, 2396, 2855],
116300:[1132, 1834, 2398, 2857],
116400:[1133, 1836, 2399, 2860],
116500:[1134, 1837, 2401, 2862],
116600:[1135, 1838, 2403, 2864],
116700:[1136, 1840, 2405, 2866],
116800:[1136, 1841, 2407, 2868],
116900:[1137, 1842, 2409, 2870],
117000:[1138, 1844, 2410, 2872],
117100:[1139, 1845, 2412, 2874],
117200:[1140, 1847, 2414, 2876],
117300:[1141, 1848, 2416, 2878],
117400:[1142, 1849, 2417, 2880],
117500:[1143, 1851, 2419, 2882],
117600:[1144, 1852, 2421, 2885],
117700:[1145, 1854, 2423, 2887],
117800:[1145, 1855, 2425, 2889],
117900:[1146, 1856, 2427, 2891],
118000:[1147, 1858, 2428, 2893],
118100:[1148, 1859, 2430, 2895],
118200:[1149, 1861, 2432, 2897],
118300:[1150, 1862, 2434, 2899],
118400:[1151, 1863, 2435, 2902],
118500:[1152, 1865, 2437, 2904],
118600:[1153, 1866, 2439, 2906],
118700:[1154, 1868, 2441, 2908],
118800:[1154, 1869, 2443, 2910],
118900:[1155, 1870, 2445, 2912],
119000:[1156, 1872, 2446, 2915],
119100:[1157, 1873, 2448, 2917],
119200:[1158, 1875, 2450, 2919],
119300:[1159, 1876, 2451, 2921],
119400:[1160, 1877, 2453, 2923],
119500:[1161, 1879, 2455, 2926],
119600:[1162, 1880, 2457, 2928],
119700:[1163, 1882, 2459, 2930],
119800:[1163, 1883, 2461, 2932],
119900:[1164, 1884, 2462, 2934],
120000:[1165, 1886, 2464, 2936],
120100:[1166, 1887, 2466, 2938],
120200:[1167, 1889, 2468, 2940],
120300:[1168, 1890, 2469, 2942],
120400:[1169, 1891, 2471, 2944],
120500:[1170, 1893, 2473, 2946],
120600:[1171, 1894, 2475, 2949],
120700:[1171, 1896, 2477, 2951],
120800:[1172, 1897, 2479, 2953],
120900:[1173, 1898, 2480, 2955],
121000:[1174, 1900, 2482, 2957],
121100:[1175, 1901, 2484, 2959],
121200:[1176, 1903, 2486, 2961],
121300:[1177, 1904, 2487, 2963],
121400:[1178, 1905, 2489, 2966],
121500:[1179, 1907, 2491, 2968],
121600:[1180, 1908, 2493, 2970],
121700:[1180, 1909, 2495, 2972],
121800:[1181, 1911, 2497, 2974],
121900:[1182, 1912, 2498, 2976],
122000:[1183, 1914, 2500, 2979],
122100:[1184, 1915, 2502, 2981],
122200:[1185, 1917, 2504, 2983],
122300:[1186, 1918, 2505, 2985],
122400:[1187, 1920, 2507, 2987],
122500:[1188, 1921, 2509, 2990],
122600:[1189, 1923, 2511, 2992],
122700:[1189, 1924, 2513, 2994],
122800:[1190, 1926, 2515, 2996],
122900:[1191, 1927, 2516, 2998],
123000:[1192, 1929, 2518, 3000],
123100:[1193, 1930, 2520, 3002],
123200:[1194, 1932, 2522, 3004],
123300:[1195, 1933, 2523, 3006],
123400:[1196, 1935, 2525, 3008],
123500:[1197, 1936, 2527, 3010],
123600:[1198, 1938, 2529, 3013],
123700:[1198, 1939, 2531, 3015],
123800:[1199, 1941, 2532, 3017],
123900:[1200, 1942, 2534, 3019],
124000:[1201, 1943, 2536, 3021],
124100:[1202, 1944, 2538, 3023],
124200:[1203, 1946, 2540, 3025],
124300:[1204, 1947, 2541, 3027],
124400:[1205, 1949, 2543, 3030],
124500:[1206, 1950, 2545, 3032],
124600:[1206, 1952, 2547, 3034],
124700:[1207, 1953, 2549, 3036],
124800:[1208, 1955, 2550, 3038],
124900:[1209, 1956, 2552, 3040],
125000:[1210, 1957, 2554, 3043],
125100:[1211, 1958, 2556, 3045],
125200:[1212, 1960, 2558, 3047],
125300:[1213, 1961, 2559, 3049],
125400:[1214, 1963, 2561, 3051],
125500:[1215, 1964, 2563, 3054],
125600:[1215, 1966, 2565, 3056],
125700:[1216, 1967, 2567, 3058],
125800:[1217, 1969, 2568, 3060],
125900:[1218, 1970, 2570, 3062],
126000:[1219, 1971, 2572, 3064],
126100:[1220, 1972, 2574, 3066],
126200:[1221, 1974, 2576, 3068],
126300:[1222, 1975, 2577, 3070],
126400:[1223, 1977, 2579, 3072],
126500:[1224, 1978, 2581, 3074],
126600:[1224, 1980, 2583, 3077],
126700:[1225, 1981, 2585, 3079],
126800:[1226, 1982, 2586, 3081],
126900:[1227, 1984, 2588, 3083],
127000:[1228, 1985, 2590, 3085],
127100:[1229, 1986, 2592, 3087],
127200:[1230, 1988, 2594, 3089],
127300:[1231, 1989, 2595, 3091],
127400:[1232, 1991, 2597, 3094],
127500:[1233, 1992, 2599, 3096],
127600:[1233, 1994, 2601, 3098],
127700:[1234, 1995, 2603, 3100],
127800:[1235, 1996, 2604, 3102],
127900:[1236, 1998, 2606, 3104],
128000:[1237, 1999, 2608, 3107],
128100:[1238, 2000, 2610, 3109],
128200:[1239, 2002, 2612, 3111],
128300:[1240, 2003, 2613, 3113],
128400:[1241, 2005, 2615, 3115],
128500:[1242, 2006, 2617, 3118],
128600:[1242, 2008, 2619, 3120],
128700:[1243, 2009, 2620, 3122],
128800:[1244, 2010, 2622, 3124],
128900:[1245, 2012, 2624, 3126],
129000:[1246, 2013, 2626, 3128],
129100:[1247, 2014, 2628, 3130],
129200:[1248, 2016, 2630, 3132],
129300:[1249, 2017, 2631, 3134],
129400:[1250, 2019, 2633, 3136],
129500:[1251, 2020, 2635, 3138],
129600:[1251, 2022, 2637, 3141],
129700:[1252, 2023, 2638, 3143],
129800:[1253, 2024, 2640, 3145],
129900:[1254, 2026, 2642, 3147],
130000:[1255, 2027, 2644, 3149],
130100:[1256, 2028, 2646, 3151],
130200:[1257, 2030, 2648, 3153],
130300:[1258, 2031, 2649, 3155],
130400:[1259, 2033, 2651, 3158],
130500:[1259, 2034, 2653, 3160],
130600:[1260, 2035, 2655, 3162],
130700:[1261, 2037, 2656, 3164],
130800:[1262, 2038, 2658, 3166],
130900:[1263, 2040, 2660, 3168],
131000:[1264, 2041, 2662, 3171],
131100:[1265, 2042, 2664, 3173],
131200:[1266, 2044, 2666, 3175],
131300:[1267, 2045, 2667, 3177],
131400:[1268, 2047, 2669, 3179],
131500:[1268, 2048, 2671, 3182],
131600:[1269, 2049, 2673, 3184],
131700:[1270, 2051, 2674, 3186],
131800:[1271, 2052, 2676, 3188],
131900:[1272, 2054, 2678, 3190],
132000:[1273, 2055, 2680, 3192],
132100:[1274, 2056, 2682, 3194],
132200:[1275, 2058, 2684, 3196],
132300:[1276, 2059, 2685, 3198],
132400:[1277, 2061, 2687, 3200],
132500:[1277, 2062, 2689, 3202],
132600:[1278, 2063, 2691, 3205],
132700:[1279, 2065, 2692, 3207],
132800:[1280, 2066, 2694, 3209],
132900:[1281, 2068, 2696, 3211],
133000:[1282, 2069, 2698, 3213],
133100:[1283, 2070, 2700, 3215],
133200:[1284, 2072, 2702, 3217],
133300:[1285, 2073, 2704, 3219],
133400:[1286, 2075, 2705, 3222],
133500:[1286, 2076, 2707, 3224],
133600:[1287, 2077, 2709, 3226],
133700:[1288, 2079, 2711, 3228],
133800:[1289, 2080, 2713, 3230],
133900:[1290, 2082, 2715, 3232],
134000:[1291, 2083, 2717, 3235],
134100:[1292, 2084, 2719, 3237],
134200:[1293, 2086, 2721, 3239],
134300:[1294, 2087, 2723, 3241],
134400:[1295, 2089, 2724, 3243],
134500:[1295, 2090, 2726, 3246],
134600:[1296, 2091, 2728, 3248],
134700:[1297, 2093, 2730, 3250],
134800:[1298, 2094, 2732, 3252],
134900:[1299, 2096, 2734, 3254],
135000:[1300, 2097, 2735, 3256],
135100:[1301, 2098, 2737, 3258],
135200:[1302, 2100, 2739, 3260],
135300:[1303, 2101, 2741, 3263],
135400:[1304, 2103, 2742, 3265],
135500:[1304, 2104, 2744, 3267],
135600:[1305, 2105, 2746, 3269],
135700:[1306, 2107, 2748, 3271],
135800:[1307, 2108, 2750, 3273],
135900:[1308, 2110, 2752, 3276],
136000:[1309, 2111, 2753, 3278],
136100:[1310, 2112, 2755, 3280],
136200:[1311, 2114, 2757, 3282],
136300:[1312, 2115, 2759, 3284],
136400:[1313, 2117, 2760, 3287],
136500:[1313, 2118, 2762, 3289],
136600:[1314, 2119, 2764, 3291],
136700:[1315, 2121, 2766, 3293],
136800:[1316, 2122, 2768, 3295],
136900:[1317, 2124, 2770, 3297],
137000:[1318, 2125, 2771, 3299],
137100:[1319, 2126, 2773, 3301],
137200:[1320, 2128, 2775, 3303],
137300:[1321, 2129, 2776, 3305],
137400:[1322, 2131, 2778, 3307],
137500:[1322, 2132, 2780, 3310],
137600:[1323, 2133, 2782, 3312],
137700:[1324, 2135, 2784, 3314],
137800:[1325, 2136, 2786, 3316],
137900:[1326, 2137, 2787, 3318],
138000:[1327, 2139, 2789, 3320],
138100:[1328, 2140, 2791, 3322],
138200:[1329, 2142, 2793, 3324],
138300:[1330, 2143, 2794, 3327],
138400:[1331, 2145, 2796, 3329],
138500:[1331, 2146, 2798, 3331],
138600:[1332, 2147, 2800, 3333],
138700:[1333, 2149, 2802, 3335],
138800:[1334, 2150, 2804, 3337],
138900:[1335, 2151, 2805, 3340],
139000:[1336, 2153, 2807, 3342],
139100:[1337, 2154, 2809, 3344],
139200:[1338, 2156, 2811, 3346],
139300:[1339, 2157, 2812, 3348],
139400:[1339, 2159, 2814, 3351],
139500:[1340, 2160, 2816, 3353],
139600:[1341, 2161, 2818, 3355],
139700:[1342, 2163, 2820, 3357],
139800:[1343, 2164, 2822, 3359],
139900:[1344, 2165, 2823, 3361],
140000:[1345, 2167, 2825, 3363],
140100:[1346, 2168, 2827, 3365],
140200:[1347, 2170, 2829, 3367],
140300:[1348, 2171, 2830, 3369],
140400:[1348, 2172, 2832, 3371],
140500:[1349, 2174, 2834, 3374],
140600:[1350, 2175, 2836, 3376],
140700:[1351, 2177, 2838, 3378],
140800:[1352, 2178, 2840, 3380],
140900:[1353, 2179, 2841, 3382],
141000:[1354, 2181, 2843, 3384],
141100:[1355, 2182, 2845, 3386],
141200:[1356, 2184, 2847, 3388],
141300:[1357, 2185, 2848, 3391],
141400:[1357, 2186, 2850, 3393],
141500:[1358, 2188, 2852, 3395],
141600:[1359, 2189, 2854, 3397],
141700:[1360, 2191, 2856, 3399],
141800:[1361, 2192, 2857, 3401],
141900:[1362, 2193, 2859, 3404],
142000:[1363, 2195, 2861, 3406],
142100:[1364, 2196, 2863, 3408],
142200:[1365, 2198, 2865, 3410],
142300:[1366, 2199, 2866, 3412],
142400:[1366, 2200, 2868, 3415],
142500:[1367, 2202, 2870, 3417],
142600:[1368, 2203, 2872, 3419],
142700:[1369, 2205, 2874, 3421],
142800:[1370, 2206, 2875, 3423],
142900:[1371, 2207, 2877, 3425],
143000:[1372, 2209, 2879, 3427],
143100:[1373, 2210, 2881, 3429],
143200:[1374, 2212, 2883, 3431],
143300:[1375, 2213, 2884, 3433],
143400:[1375, 2214, 2886, 3435],
143500:[1376, 2216, 2888, 3438],
143600:[1377, 2217, 2890, 3440],
143700:[1378, 2219, 2892, 3442],
143800:[1379, 2220, 2893, 3444],
143900:[1380, 2221, 2895, 3446],
144000:[1381, 2223, 2897, 3448],
144100:[1382, 2224, 2899, 3450],
144200:[1383, 2226, 2901, 3452],
144300:[1384, 2227, 2902, 3455],
144400:[1384, 2228, 2904, 3457],
144500:[1385, 2230, 2906, 3459],
144600:[1386, 2231, 2908, 3461],
144700:[1387, 2232, 2910, 3463],
144800:[1388, 2234, 2911, 3465],
144900:[1389, 2235, 2913, 3468],
145000:[1390, 2237, 2915, 3470],
145100:[1391, 2238, 2917, 3472],
145200:[1392, 2240, 2919, 3474],
145300:[1393, 2241, 2920, 3476],
145400:[1393, 2243, 2922, 3479],
145500:[1394, 2244, 2924, 3481],
145600:[1395, 2246, 2926, 3483],
145700:[1396, 2247, 2928, 3485],
145800:[1397, 2249, 2929, 3487],
145900:[1398, 2250, 2931, 3489],
146000:[1399, 2252, 2933, 3491],
146100:[1400, 2253, 2935, 3493],
146200:[1401, 2255, 2937, 3495],
146300:[1402, 2256, 2938, 3497],
146400:[1402, 2258, 2940, 3499],
146500:[1403, 2259, 2942, 3502],
146600:[1404, 2261, 2944, 3504],
146700:[1405, 2262, 2945, 3506],
146800:[1406, 2264, 2947, 3508],
146900:[1407, 2265, 2949, 3510],
147000:[1408, 2266, 2951, 3512],
147100:[1409, 2267, 2953, 3514],
147200:[1410, 2269, 2955, 3516],
147300:[1411, 2270, 2956, 3519],
147400:[1412, 2272, 2958, 3521],
147500:[1413, 2273, 2960, 3523],
147600:[1414, 2275, 2962, 3525],
147700:[1415, 2276, 2963, 3527],
147800:[1416, 2278, 2965, 3529],
147900:[1417, 2279, 2967, 3532],
148000:[1418, 2280, 2969, 3534],
148100:[1419, 2281, 2971, 3536],
148200:[1420, 2283, 2973, 3538],
148300:[1421, 2284, 2974, 3540],
148400:[1422, 2286, 2976, 3543],
148500:[1423, 2287, 2978, 3545],
148600:[1424, 2289, 2980, 3547],
148700:[1425, 2290, 2981, 3549],
148800:[1426, 2292, 2983, 3551],
148900:[1427, 2293, 2985, 3553],
149000:[1427, 2294, 2987, 3555],
149100:[1428, 2295, 2989, 3557],
149200:[1429, 2297, 2991, 3559],
149300:[1430, 2298, 2992, 3561],
149400:[1431, 2300, 2994, 3563],
149500:[1432, 2301, 2996, 3566],
149600:[1433, 2303, 2998, 3568],
149700:[1434, 2304, 2999, 3570],
149800:[1435, 2305, 3001, 3572],
149900:[1436, 2307, 3003, 3574],
150000:[1436, 2308, 3005, 3576],
16000:[0, 0, 0, 0],
16100:[9, 10, 11, 12],
16200:[19, 20, 22, 24],
16300:[28, 31, 33, 35],
16400:[38, 41, 44, 47],
16500:[47, 51, 55, 59],
16600:[56, 61, 66, 71],
16700:[66, 71, 77, 83],
16800:[75, 82, 88, 94],
16900:[85, 92, 99, 106],
17000:[94, 102, 110, 118],
17100:[98, 107, 115, 124],
17200:[103, 112, 121, 129],
17300:[107, 117, 126, 135],
17400:[112, 122, 131, 140],
17500:[116, 126, 136, 146],
17600:[121, 131, 142, 152],
17700:[125, 136, 147, 157],
17800:[130, 141, 152, 163],
17900:[134, 146, 158, 168],
18000:[139, 151, 163, 174],
18100:[143, 155, 168, 179],
18200:[147, 160, 173, 184],
18300:[151, 164, 177, 189],
18400:[156, 169, 182, 195],
18500:[160, 173, 187, 200],
18600:[164, 178, 192, 205],
18700:[168, 182, 197, 210],
18800:[172, 187, 202, 215],
18900:[176, 191, 206, 220],
19000:[181, 196, 211, 226],
19100:[185, 200, 216, 231],
19200:[189, 204, 220, 236],
19300:[193, 209, 225, 241],
19400:[197, 213, 229, 246],
19500:[201, 217, 234, 251],
19600:[205, 221, 239, 255],
19700:[208, 226, 243, 260],
19800:[212, 230, 248, 265],
19900:[216, 234, 252, 270],
20000:[220, 238, 257, 275],
20100:[224, 242, 262, 280],
20200:[228, 247, 266, 285],
20300:[232, 251, 271, 290],
20400:[236, 255, 275, 295],
20500:[239, 259, 280, 299],
20600:[243, 264, 284, 304],
20700:[247, 268, 289, 309],
20800:[251, 272, 293, 314],
20900:[255, 276, 298, 319],
21000:[259, 281, 302, 324],
21100:[259, 285, 307, 329],
21200:[260, 289, 311, 334],
21300:[260, 294, 316, 338],
21400:[260, 298, 320, 343],
21500:[260, 302, 325, 348],
21600:[261, 306, 329, 353],
21700:[261, 311, 334, 358],
21800:[261, 315, 339, 363],
21900:[262, 319, 343, 367],
22000:[262, 323, 348, 372],
22100:[262, 327, 353, 377],
22200:[263, 331, 357, 382],
22300:[263, 336, 362, 387],
22400:[263, 340, 366, 391],
22500:[264, 344, 371, 396],
22600:[264, 348, 375, 401],
22700:[265, 353, 380, 406],
22800:[265, 357, 384, 411],
22900:[265, 361, 389, 416],
23000:[266, 365, 393, 421],
23100:[266, 369, 398, 426],
23200:[267, 374, 402, 431],
23300:[267, 378, 407, 436],
23400:[268, 382, 411, 441],
23500:[268, 387, 416, 445],
23600:[269, 391, 421, 450],
23700:[269, 395, 425, 455],
23800:[270, 399, 430, 460],
23900:[270, 404, 434, 465],
24000:[271, 408, 439, 470],
24100:[272, 412, 444, 475],
24200:[272, 417, 448, 480],
24300:[273, 421, 453, 485],
24400:[273, 425, 457, 490],
24500:[274, 430, 462, 495],
24600:[274, 434, 467, 500],
24700:[275, 438, 471, 505],
24800:[275, 443, 476, 510],
24900:[276, 447, 480, 515],
25000:[277, 451, 485, 520],
25100:[277, 454, 489, 525],
25200:[278, 457, 494, 529],
25300:[278, 460, 498, 534],
25400:[279, 464, 503, 539],
25500:[279, 467, 507, 544],
25600:[280, 470, 512, 548],
25700:[280, 473, 516, 553],
25800:[280, 476, 521, 558],
25900:[281, 479, 525, 562],
26000:[281, 482, 530, 567],
26100:[281, 483, 534, 572],
26200:[282, 484, 539, 576],
26300:[282, 485, 543, 581],
26400:[282, 486, 547, 586],
26500:[283, 487, 552, 590],
26600:[283, 488, 556, 595],
26700:[283, 489, 560, 600],
26800:[284, 490, 565, 604],
26900:[284, 491, 569, 609],
27000:[284, 492, 573, 614],
27100:[284, 493, 577, 619],
27200:[285, 494, 582, 623],
27300:[285, 495, 586, 628],
27400:[285, 496, 590, 633],
27500:[286, 497, 595, 637],
27600:[286, 498, 599, 642],
27700:[286, 499, 604, 647],
27800:[286, 500, 608, 651],
27900:[287, 501, 612, 656],
28000:[287, 502, 617, 661],
28100:[287, 503, 621, 666],
28200:[288, 504, 626, 670],
28300:[288, 505, 630, 675],
28400:[288, 506, 634, 680],
28500:[289, 507, 639, 684],
28600:[289, 508, 643, 689],
28700:[290, 509, 648, 694],
28800:[290, 510, 652, 698],
28900:[290, 511, 656, 703],
29000:[291, 512, 661, 708],
29100:[291, 513, 665, 713],
29200:[292, 514, 669, 717],
29300:[292, 515, 674, 722],
29400:[292, 516, 678, 727],
29500:[293, 517, 682, 731],
29600:[293, 518, 686, 736],
29700:[293, 519, 690, 741],
29800:[294, 520, 694, 745],
29900:[294, 521, 699, 750],
30000:[294, 522, 703, 755],
30100:[294, 523, 705, 760],
30200:[295, 524, 706, 764],
30300:[295, 525, 708, 769],
30400:[296, 526, 709, 774],
30500:[296, 527, 711, 778],
30600:[296, 528, 712, 783],
30700:[297, 529, 714, 788],
30800:[297, 530, 715, 792],
30900:[297, 531, 717, 797],
31000:[298, 532, 719, 802],
31100:[298, 533, 721, 807],
31200:[299, 534, 722, 811],
31300:[299, 535, 724, 816],
31400:[299, 536, 725, 821],
31500:[300, 537, 727, 825],
31600:[300, 538, 728, 830],
31700:[300, 539, 730, 835],
31800:[301, 540, 731, 839],
31900:[301, 540, 733, 844],
32000:[301, 541, 734, 849],
32100:[301, 542, 735, 854],
32200:[301, 543, 737, 858],
32300:[302, 544, 738, 863],
32400:[302, 545, 740, 868],
32500:[302, 546, 741, 872],
32600:[302, 547, 742, 877],
32700:[302, 548, 744, 882],
32800:[303, 549, 745, 886],
32900:[303, 550, 747, 891],
33000:[303, 551, 748, 896],
33100:[303, 552, 750, 899],
33200:[304, 553, 751, 903],
33300:[304, 554, 753, 906],
33400:[304, 555, 754, 909],
33500:[305, 556, 756, 913],
33600:[305, 557, 757, 916],
33700:[306, 558, 759, 920],
33800:[306, 559, 760, 923],
33900:[306, 560, 762, 926],
34000:[307, 561, 764, 930],
34100:[308, 562, 766, 932],
34200:[309, 564, 768, 935],
34300:[310, 565, 770, 937],
34400:[310, 567, 772, 939],
34500:[311, 568, 773, 941],
34600:[312, 569, 775, 944],
34700:[313, 571, 777, 946],
34800:[314, 572, 779, 948],
34900:[315, 574, 781, 951],
35000:[316, 575, 783, 953],
35100:[317, 577, 785, 955],
35200:[318, 578, 787, 958],
35300:[319, 580, 789, 960],
35400:[320, 581, 791, 963],
35500:[321, 583, 793, 965],
35600:[322, 584, 795, 968],
35700:[323, 586, 798, 970],
35800:[324, 587, 800, 973],
35900:[325, 589, 802, 975],
36000:[326, 591, 804, 978],
36100:[327, 593, 806, 980],
36200:[328, 594, 808, 983],
36300:[329, 596, 810, 985],
36400:[330, 597, 812, 988],
36500:[331, 599, 814, 990],
36600:[332, 600, 816, 993],
36700:[333, 602, 818, 995],
36800:[334, 604, 820, 997],
36900:[335, 605, 822, 1000],
37000:[336, 607, 824, 1002],
37100:[337, 609, 826, 1004],
37200:[338, 610, 828, 1007],
37300:[339, 612, 830, 1009],
37400:[340, 613, 832, 1012],
37500:[341, 615, 834, 1014],
37600:[342, 616, 836, 1017],
37700:[343, 618, 838, 1019],
37800:[344, 620, 840, 1022],
37900:[345, 621, 843, 1024],
38000:[346, 623, 845, 1027],
38100:[347, 625, 847, 1029],
38200:[348, 626, 849, 1032],
38300:[349, 628, 851, 1034],
38400:[350, 630, 853, 1037],
38500:[351, 631, 855, 1039],
38600:[352, 633, 858, 1042],
38700:[353, 635, 860, 1044],
38800:[354, 636, 862, 1047],
38900:[355, 638, 864, 1049],
39000:[356, 640, 866, 1051],
39100:[357, 642, 868, 1054],
39200:[358, 643, 870, 1056],
39300:[359, 645, 873, 1059],
39400:[361, 647, 875, 1061],
39500:[362, 649, 877, 1064],
39600:[363, 650, 879, 1066],
39700:[364, 652, 881, 1069],
39800:[365, 654, 884, 1071],
39900:[366, 656, 886, 1074],
40000:[368, 657, 888, 1077],
40100:[369, 659, 890, 1079],
40200:[370, 660, 892, 1082],
40300:[371, 662, 894, 1084],
40400:[372, 664, 897, 1087],
40500:[374, 665, 899, 1089],
40600:[375, 667, 901, 1092],
40700:[376, 668, 903, 1094],
40800:[377, 670, 905, 1096],
40900:[378, 672, 907, 1099],
41000:[379, 673, 909, 1101],
41100:[380, 675, 911, 1103],
41200:[381, 676, 913, 1106],
41300:[382, 678, 915, 1108],
41400:[383, 680, 918, 1111],
41500:[385, 681, 920, 1113],
41600:[386, 683, 922, 1116],
41700:[387, 685, 924, 1118],
41800:[388, 686, 926, 1121],
41900:[389, 688, 928, 1123],
42000:[390, 690, 930, 1126],
42100:[391, 692, 932, 1128],
42200:[392, 693, 934, 1131],
42300:[393, 695, 936, 1133],
42400:[394, 697, 938, 1136],
42500:[396, 698, 940, 1138],
42600:[397, 700, 942, 1141],
42700:[398, 701, 944, 1143],
42800:[399, 703, 946, 1145],
42900:[400, 705, 948, 1148],
43000:[401, 706, 950, 1150],
43100:[402, 708, 952, 1152],
43200:[403, 709, 954, 1155],
43300:[404, 711, 956, 1157],
43400:[405, 712, 958, 1160],
43500:[406, 714, 960, 1162],
43600:[407, 716, 962, 1164],
43700:[408, 717, 964, 1167],
43800:[409, 719, 966, 1169],
43900:[410, 720, 968, 1172],
44000:[411, 722, 970, 1174],
44100:[412, 724, 972, 1176],
44200:[413, 725, 974, 1179],
44300:[414, 727, 976, 1181],
44400:[415, 728, 978, 1183],
44500:[416, 730, 980, 1186],
44600:[417, 732, 982, 1188],
44700:[418, 733, 984, 1190],
44800:[419, 735, 986, 1193],
44900:[421, 736, 988, 1195],
45000:[422, 738, 991, 1197],
45100:[423, 740, 993, 1199],
45200:[424, 741, 995, 1202],
45300:[425, 743, 997, 1204],
45400:[426, 744, 999, 1206],
45500:[427, 746, 1001, 1209],
45600:[429, 748, 1003, 1211],
45700:[430, 749, 1005, 1213],
45800:[431, 751, 1007, 1216],
45900:[432, 752, 1009, 1218],
46000:[433, 754, 1011, 1221],
46100:[434, 756, 1013, 1223],
46200:[435, 757, 1015, 1226],
46300:[436, 759, 1017, 1228],
46400:[437, 760, 1019, 1231],
46500:[438, 762, 1021, 1233],
46600:[439, 764, 1023, 1235],
46700:[440, 765, 1025, 1238],
46800:[441, 767, 1027, 1240],
46900:[442, 768, 1029, 1242],
47000:[443, 770, 1031, 1245],
47100:[444, 772, 1033, 1247],
47200:[445, 773, 1035, 1250],
47300:[446, 775, 1037, 1252],
47400:[447, 776, 1039, 1255],
47500:[448, 778, 1041, 1257],
47600:[449, 780, 1043, 1259],
47700:[450, 781, 1045, 1262],
47800:[451, 783, 1047, 1264],
47900:[453, 784, 1049, 1267],
48000:[454, 786, 1051, 1269],
48100:[455, 788, 1053, 1271],
48200:[456, 789, 1055, 1274],
48300:[457, 791, 1057, 1276],
48400:[458, 792, 1059, 1278],
48500:[459, 794, 1061, 1281],
48600:[461, 796, 1063, 1283],
48700:[462, 797, 1065, 1285],
48800:[463, 799, 1067, 1288],
48900:[464, 800, 1070, 1290],
49000:[465, 802, 1072, 1292],
49100:[466, 804, 1074, 1294],
49200:[467, 805, 1076, 1297],
49300:[468, 807, 1078, 1299],
49400:[469, 808, 1080, 1302],
49500:[471, 810, 1082, 1304],
49600:[472, 812, 1084, 1307],
49700:[473, 813, 1086, 1309],
49800:[474, 815, 1088, 1312],
49900:[475, 816, 1090, 1314],
50000:[476, 818, 1092, 1317],
50100:[477, 820, 1094, 1319],
50200:[478, 821, 1096, 1322],
50300:[479, 823, 1098, 1324],
50400:[481, 825, 1100, 1327],
50500:[482, 826, 1102, 1329],
50600:[483, 828, 1104, 1332],
50700:[484, 830, 1106, 1334],
50800:[485, 831, 1109, 1337],
50900:[486, 833, 1111, 1339],
51000:[487, 835, 1113, 1341],
51100:[488, 837, 1115, 1343],
51200:[489, 838, 1117, 1346],
51300:[490, 840, 1119, 1348],
51400:[491, 841, 1121, 1351],
51500:[492, 843, 1123, 1353],
51600:[493, 845, 1125, 1355],
51700:[494, 846, 1128, 1358],
51800:[495, 848, 1130, 1360],
51900:[496, 850, 1132, 1362],
52000:[497, 851, 1134, 1365],
52100:[498, 853, 1136, 1367],
52200:[499, 854, 1138, 1370],
52300:[500, 856, 1140, 1372],
52400:[501, 857, 1142, 1375],
52500:[502, 859, 1144, 1377],
52600:[503, 861, 1146, 1379],
52700:[504, 862, 1148, 1382],
52800:[505, 864, 1150, 1384],
52900:[507, 865, 1152, 1387],
53000:[508, 867, 1154, 1389],
53100:[509, 869, 1156, 1391],
53200:[510, 870, 1158, 1394],
53300:[511, 872, 1160, 1396],
53400:[512, 873, 1162, 1399],
53500:[513, 875, 1164, 1401],
53600:[515, 877, 1167, 1403],
53700:[516, 878, 1169, 1406],
53800:[517, 880, 1171, 1408],
53900:[518, 881, 1173, 1411],
54000:[519, 883, 1175, 1413],
54100:[520, 884, 1177, 1415],
54200:[521, 886, 1179, 1418],
54300:[522, 887, 1181, 1420],
54400:[523, 889, 1183, 1422],
54500:[524, 890, 1185, 1424],
54600:[525, 892, 1187, 1427],
54700:[526, 893, 1189, 1429],
54800:[527, 895, 1190, 1431],
54900:[528, 896, 1192, 1434],
55000:[529, 898, 1194, 1436],
55100:[530, 900, 1196, 1438],
55200:[531, 901, 1198, 1440],
55300:[532, 903, 1200, 1443],
55400:[533, 904, 1202, 1445],
55500:[534, 906, 1204, 1447],
55600:[535, 907, 1205, 1449],
55700:[536, 909, 1207, 1452],
55800:[537, 910, 1209, 1454],
55900:[538, 912, 1211, 1456],
56000:[539, 914, 1213, 1458],
56100:[540, 916, 1215, 1460],
56200:[541, 917, 1217, 1463],
56300:[542, 919, 1219, 1465],
56400:[543, 920, 1221, 1467],
56500:[544, 922, 1222, 1469],
56600:[545, 923, 1224, 1472],
56700:[546, 925, 1226, 1474],
56800:[548, 926, 1228, 1476],
56900:[549, 928, 1230, 1478],
57000:[550, 929, 1232, 1481],
57100:[551, 931, 1234, 1483],
57200:[552, 932, 1236, 1485],
57300:[553, 934, 1238, 1488],
57400:[554, 935, 1240, 1490],
57500:[555, 937, 1242, 1492],
57600:[556, 938, 1244, 1494],
57700:[557, 940, 1246, 1497],
57800:[558, 941, 1248, 1499],
57900:[559, 943, 1250, 1501],
58000:[560, 944, 1252, 1503],
58100:[561, 946, 1254, 1505],
58200:[562, 947, 1256, 1508],
58300:[563, 949, 1258, 1510],
58400:[564, 950, 1260, 1512],
58500:[565, 952, 1262, 1514],
58600:[566, 953, 1264, 1517],
58700:[567, 955, 1265, 1519],
58800:[568, 957, 1267, 1521],
58900:[569, 958, 1269, 1523],
59000:[570, 960, 1271, 1526],
59100:[571, 962, 1273, 1528],
59200:[572, 963, 1275, 1530],
59300:[573, 965, 1277, 1533],
59400:[574, 966, 1279, 1535],
59500:[575, 968, 1280, 1537],
59600:[576, 969, 1282, 1539],
59700:[578, 971, 1284, 1541],
59800:[579, 972, 1286, 1544],
59900:[580, 974, 1288, 1546],
60000:[581, 975, 1290, 1548],
60100:[582, 977, 1292, 1550],
60200:[583, 978, 1294, 1553],
60300:[584, 980, 1296, 1555],
60400:[585, 981, 1297, 1557],
60500:[586, 983, 1299, 1559],
60600:[587, 984, 1301, 1562],
60700:[588, 986, 1303, 1564],
60800:[589, 987, 1305, 1566],
60900:[590, 989, 1307, 1568],
61000:[591, 990, 1309, 1571],
61100:[592, 991, 1311, 1573],
61200:[593, 993, 1313, 1575],
61300:[594, 994, 1315, 1578],
61400:[595, 996, 1316, 1580],
61500:[596, 997, 1318, 1582],
61600:[597, 999, 1320, 1584],
61700:[598, 1000, 1322, 1587],
61800:[599, 1002, 1324, 1589],
61900:[600, 1003, 1326, 1591],
62000:[601, 1005, 1328, 1593],
62100:[602, 1007, 1330, 1595],
62200:[603, 1008, 1332, 1597],
62300:[604, 1010, 1334, 1600],
62400:[605, 1011, 1335, 1602],
62500:[606, 1013, 1337, 1604],
62600:[607, 1014, 1339, 1606],
62700:[608, 1016, 1341, 1608],
62800:[609, 1017, 1343, 1611],
62900:[610, 1019, 1345, 1613],
63000:[611, 1020, 1347, 1615],
63100:[612, 1021, 1349, 1617],
63200:[613, 1023, 1351, 1620],
63300:[614, 1024, 1353, 1622],
63400:[615, 1026, 1355, 1624],
63500:[616, 1027, 1357, 1626],
63600:[617, 1029, 1359, 1629],
63700:[617, 1030, 1361, 1631],
63800:[618, 1032, 1363, 1633],
63900:[619, 1033, 1365, 1635],
64000:[620, 1035, 1367, 1638],
64100:[621, 1036, 1369, 1640],
64200:[622, 1038, 1371, 1643],
64300:[623, 1039, 1373, 1645],
64400:[624, 1041, 1375, 1647],
64500:[624, 1042, 1377, 1650],
64600:[625, 1044, 1379, 1652],
64700:[626, 1045, 1381, 1654],
64800:[627, 1046, 1383, 1656],
64900:[628, 1048, 1385, 1659],
65000:[629, 1049, 1386, 1661],
65100:[630, 1050, 1388, 1663],
65200:[631, 1052, 1390, 1665],
65300:[632, 1053, 1392, 1668],
65400:[633, 1055, 1394, 1670],
65500:[633, 1056, 1396, 1672],
65600:[634, 1058, 1398, 1674],
65700:[635, 1059, 1400, 1677],
65800:[636, 1061, 1401, 1679],
65900:[637, 1062, 1403, 1681],
66000:[638, 1064, 1405, 1683],
66100:[639, 1065, 1407, 1685],
66200:[640, 1067, 1409, 1688],
66300:[641, 1068, 1411, 1690],
66400:[642, 1070, 1413, 1692],
66500:[643, 1071, 1415, 1695],
66600:[644, 1073, 1417, 1697],
66700:[645, 1074, 1418, 1700],
66800:[646, 1076, 1420, 1702],
66900:[647, 1077, 1422, 1704],
67000:[648, 1079, 1424, 1707],
67100:[649, 1081, 1426, 1709],
67200:[650, 1082, 1428, 1712],
67300:[651, 1084, 1430, 1714],
67400:[652, 1085, 1432, 1717],
67500:[653, 1087, 1434, 1719],
67600:[654, 1089, 1436, 1722],
67700:[655, 1090, 1438, 1724],
67800:[655, 1092, 1440, 1726],
67900:[656, 1093, 1442, 1729],
68000:[657, 1095, 1444, 1731],
68100:[658, 1097, 1446, 1733],
68200:[659, 1098, 1448, 1736],
68300:[660, 1100, 1450, 1738],
68400:[661, 1101, 1452, 1741],
68500:[662, 1103, 1454, 1743],
68600:[663, 1104, 1456, 1746],
68700:[664, 1106, 1458, 1748],
68800:[665, 1107, 1460, 1751],
68900:[666, 1109, 1463, 1753],
69000:[667, 1110, 1465, 1755],
69100:[668, 1112, 1467, 1757],
69200:[669, 1113, 1469, 1760],
69300:[670, 1115, 1471, 1762],
69400:[671, 1116, 1473, 1764],
69500:[672, 1118, 1475, 1767],
69600:[673, 1120, 1477, 1769],
69700:[674, 1121, 1479, 1771],
69800:[675, 1123, 1481, 1774],
69900:[676, 1124, 1483, 1776],
70000:[677, 1126, 1485, 1778],
70100:[678, 1128, 1487, 1780],
70200:[679, 1129, 1489, 1783],
70300:[680, 1131, 1491, 1785],
70400:[681, 1132, 1493, 1787],
70500:[682, 1134, 1495, 1790],
70600:[683, 1135, 1497, 1792],
70700:[684, 1137, 1499, 1794],
70800:[685, 1138, 1501, 1797],
70900:[685, 1140, 1503, 1799],
71000:[686, 1141, 1505, 1802],
71100:[687, 1142, 1507, 1804],
71200:[688, 1144, 1509, 1807],
71300:[689, 1145, 1511, 1809],
71400:[690, 1147, 1513, 1811],
71500:[691, 1148, 1515, 1814],
71600:[692, 1150, 1517, 1816],
71700:[693, 1151, 1519, 1818],
71800:[694, 1153, 1521, 1821],
71900:[695, 1154, 1523, 1823],
72000:[696, 1156, 1525, 1826],
72100:[697, 1158, 1527, 1828],
72200:[698, 1159, 1529, 1831],
72300:[699, 1161, 1531, 1833],
72400:[700, 1162, 1533, 1835],
72500:[701, 1164, 1535, 1838],
72600:[702, 1165, 1537, 1840],
72700:[703, 1167, 1539, 1843],
72800:[704, 1168, 1541, 1845],
72900:[705, 1170, 1543, 1847],
73000:[706, 1172, 1545, 1850],
73100:[707, 1174, 1547, 1852],
73200:[708, 1175, 1549, 1855],
73300:[709, 1177, 1551, 1857],
73400:[710, 1178, 1553, 1860],
73500:[711, 1180, 1555, 1862],
73600:[712, 1182, 1558, 1865],
73700:[713, 1183, 1560, 1867],
73800:[714, 1185, 1562, 1870],
73900:[715, 1186, 1564, 1872],
74000:[716, 1188, 1566, 1875],
74100:[717, 1190, 1568, 1877],
74200:[718, 1191, 1570, 1880],
74300:[719, 1193, 1572, 1882],
74400:[720, 1194, 1574, 1885],
74500:[721, 1196, 1576, 1887],
74600:[722, 1198, 1578, 1890],
74700:[723, 1199, 1580, 1892],
74800:[724, 1201, 1582, 1895],
74900:[725, 1203, 1584, 1897],
75000:[726, 1204, 1586, 1899],
75100:[727, 1206, 1588, 1901],
75200:[728, 1207, 1590, 1904],
75300:[729, 1209, 1592, 1906],
75400:[730, 1210, 1594, 1909],
75500:[731, 1212, 1596, 1911],
75600:[732, 1214, 1598, 1913],
75700:[733, 1215, 1601, 1916],
75800:[734, 1217, 1603, 1918],
75900:[735, 1218, 1605, 1921],
76000:[736, 1220, 1607, 1923],
76100:[737, 1222, 1609, 1925],
76200:[738, 1223, 1611, 1928],
76300:[739, 1225, 1613, 1930],
76400:[740, 1226, 1615, 1932],
76500:[741, 1228, 1617, 1935],
76600:[742, 1230, 1619, 1937],
76700:[743, 1231, 1621, 1940],
76800:[744, 1233, 1623, 1942],
76900:[745, 1235, 1625, 1944],
77000:[746, 1236, 1627, 1947],
77100:[747, 1238, 1629, 1949],
77200:[748, 1239, 1631, 1952],
77300:[749, 1241, 1633, 1954],
77400:[750, 1242, 1635, 1957],
77500:[751, 1244, 1637, 1959],
77600:[752, 1245, 1639, 1961],
77700:[753, 1247, 1641, 1964],
77800:[754, 1248, 1643, 1966],
77900:[755, 1250, 1645, 1969],
78000:[756, 1251, 1647, 1971],
78100:[757, 1253, 1649, 1973],
78200:[758, 1254, 1651, 1976],
78300:[759, 1256, 1653, 1978],
78400:[760, 1257, 1655, 1981],
78500:[761, 1259, 1657, 1983],
78600:[762, 1260, 1659, 1985],
78700:[763, 1262, 1661, 1988],
78800:[764, 1264, 1663, 1990],
78900:[765, 1265, 1665, 1993],
79000:[766, 1267, 1667, 1995],
79100:[767, 1269, 1669, 1997],
79200:[768, 1270, 1671, 2000],
79300:[769, 1272, 1673, 2002],
79400:[770, 1273, 1675, 2004],
79500:[771, 1275, 1677, 2007],
79600:[772, 1277, 1679, 2009],
79700:[773, 1278, 1681, 2011],
79800:[774, 1280, 1683, 2014],
79900:[775, 1282, 1685, 2016],
80000:[777, 1283, 1687, 2018],
80100:[778, 1285, 1689, 2020],
80200:[779, 1286, 1691, 2023],
80300:[780, 1288, 1693, 2025],
80400:[781, 1289, 1695, 2027],
80500:[782, 1291, 1697, 2030],
80600:[783, 1292, 1699, 2032],
80700:[784, 1294, 1701, 2034],
80800:[785, 1295, 1703, 2037],
80900:[786, 1297, 1705, 2039],
81000:[787, 1298, 1707, 2042],
81100:[788, 1300, 1709, 2044],
81200:[789, 1301, 1711, 2047],
81300:[790, 1303, 1713, 2049],
81400:[791, 1304, 1715, 2051],
81500:[792, 1306, 1717, 2054],
81600:[793, 1307, 1719, 2056],
81700:[794, 1309, 1721, 2059],
81800:[795, 1311, 1723, 2061],
81900:[796, 1312, 1726, 2063],
82000:[797, 1314, 1728, 2066],
82100:[798, 1316, 1730, 2068],
82200:[799, 1317, 1732, 2071],
82300:[800, 1319, 1734, 2073],
82400:[801, 1320, 1736, 2076],
82500:[802, 1322, 1738, 2078],
82600:[803, 1323, 1740, 2080],
82700:[804, 1325, 1742, 2083],
82800:[805, 1326, 1744, 2085],
82900:[806, 1328, 1746, 2088],
83000:[807, 1329, 1748, 2090],
83100:[808, 1331, 1750, 2092],
83200:[809, 1332, 1752, 2095],
83300:[810, 1334, 1754, 2097],
83400:[811, 1335, 1756, 2100],
83500:[812, 1337, 1758, 2102],
83600:[813, 1338, 1760, 2104],
83700:[814, 1340, 1762, 2107],
83800:[815, 1341, 1764, 2109],
83900:[816, 1343, 1766, 2112],
84000:[817, 1345, 1768, 2114],
84100:[818, 1347, 1770, 2116],
84200:[819, 1348, 1772, 2119],
84300:[820, 1350, 1774, 2121],
84400:[821, 1351, 1776, 2123],
84500:[822, 1353, 1778, 2126],
84600:[823, 1355, 1780, 2128],
84700:[824, 1356, 1782, 2130],
84800:[825, 1358, 1784, 2133],
84900:[826, 1359, 1786, 2135],
85000:[827, 1361, 1788, 2137],
85100:[828, 1363, 1790, 2139],
85200:[829, 1364, 1792, 2142],
85300:[830, 1366, 1794, 2144],
85400:[831, 1367, 1796, 2146],
85500:[832, 1369, 1798, 2149],
85600:[833, 1370, 1800, 2151],
85700:[834, 1372, 1802, 2153],
85800:[835, 1373, 1804, 2156],
85900:[836, 1375, 1806, 2158],
86000:[837, 1376, 1808, 2161],
86100:[838, 1378, 1810, 2163],
86200:[839, 1379, 1812, 2166],
86300:[840, 1381, 1814, 2168],
86400:[841, 1382, 1816, 2170],
86500:[842, 1384, 1818, 2173],
86600:[843, 1385, 1820, 2175],
86700:[844, 1387, 1822, 2178],
86800:[845, 1388, 1824, 2180],
86900:[846, 1390, 1826, 2182],
87000:[847, 1392, 1828, 2185],
87100:[848, 1394, 1830, 2187],
87200:[849, 1395, 1832, 2190],
87300:[850, 1397, 1834, 2192],
87400:[851, 1398, 1836, 2195],
87500:[852, 1400, 1838, 2197],
87600:[853, 1402, 1840, 2199],
87700:[854, 1403, 1842, 2202],
87800:[855, 1405, 1844, 2204],
87900:[856, 1406, 1846, 2207],
88000:[857, 1408, 1848, 2209],
88100:[858, 1410, 1850, 2211],
88200:[859, 1411, 1852, 2214],
88300:[860, 1413, 1854, 2216],
88400:[861, 1414, 1856, 2219],
88500:[862, 1416, 1858, 2221],
88600:[863, 1417, 1860, 2223],
88700:[864, 1419, 1862, 2226],
88800:[865, 1420, 1864, 2228],
88900:[866, 1422, 1867, 2231],
89000:[867, 1423, 1869, 2233],
89100:[868, 1425, 1871, 2235],
89200:[869, 1426, 1873, 2238],
89300:[870, 1428, 1875, 2240],
89400:[871, 1429, 1877, 2242],
89500:[872, 1431, 1879, 2245],
89600:[873, 1432, 1881, 2247],
89700:[874, 1434, 1883, 2249],
89800:[875, 1435, 1885, 2252],
89900:[876, 1437, 1887, 2254],
90000:[877, 1439, 1889, 2256],
90100:[878, 1441, 1891, 2258],
90200:[879, 1442, 1893, 2261],
90300:[880, 1444, 1895, 2263],
90400:[881, 1445, 1897, 2265],
90500:[882, 1447, 1899, 2268],
90600:[883, 1449, 1901, 2270],
90700:[884, 1450, 1903, 2272],
90800:[885, 1452, 1905, 2275],
90900:[886, 1453, 1907, 2277],
91000:[887, 1455, 1909, 2280],
91100:[888, 1457, 1911, 2282],
91200:[889, 1458, 1913, 2285],
91300:[890, 1460, 1915, 2287],
91400:[891, 1461, 1917, 2289],
91500:[892, 1463, 1919, 2292],
91600:[893, 1464, 1921, 2294],
91700:[894, 1466, 1923, 2297],
91800:[895, 1467, 1925, 2299],
91900:[896, 1469, 1927, 2301],
92000:[897, 1470, 1929, 2304],
92100:[898, 1472, 1931, 2306],
92200:[899, 1473, 1933, 2309],
92300:[900, 1475, 1935, 2311],
92400:[901, 1476, 1937, 2314],
92500:[902, 1478, 1939, 2316],
92600:[903, 1479, 1941, 2318],
92700:[904, 1481, 1943, 2321],
92800:[905, 1482, 1945, 2323],
92900:[906, 1484, 1947, 2326],
93000:[907, 1486, 1949, 2328],
93100:[908, 1488, 1951, 2330],
93200:[909, 1489, 1953, 2333],
93300:[910, 1491, 1955, 2335],
93400:[911, 1492, 1957, 2338],
93500:[912, 1494, 1959, 2340],
93600:[913, 1496, 1961, 2342],
93700:[914, 1497, 1963, 2345],
93800:[915, 1499, 1965, 2347],
93900:[916, 1500, 1967, 2350],
94000:[917, 1502, 1969, 2352],
94100:[918, 1504, 1971, 2354],
94200:[919, 1505, 1973, 2357],
94300:[920, 1507, 1975, 2359],
94400:[921, 1508, 1977, 2361],
94500:[922, 1510, 1979, 2364],
94600:[923, 1511, 1981, 2366],
94700:[924, 1513, 1983, 2368],
94800:[925, 1514, 1985, 2371],
94900:[926, 1516, 1987, 2373],
95000:[928, 1517, 1989, 2375],
95100:[929, 1519, 1991, 2377],
95200:[930, 1520, 1993, 2380],
95300:[931, 1522, 1995, 2382],
95400:[932, 1523, 1997, 2384],
95500:[933, 1525, 1999, 2387],
95600:[934, 1526, 2001, 2389],
95700:[935, 1528, 2003, 2391],
95800:[936, 1529, 2005, 2394],
95900:[937, 1531, 2008, 2396],
96000:[938, 1533, 2010, 2399],
96100:[939, 1535, 2012, 2401],
96200:[940, 1536, 2014, 2404],
96300:[941, 1538, 2016, 2406],
96400:[942, 1539, 2018, 2408],
96500:[943, 1541, 2020, 2411],
96600:[944, 1543, 2022, 2413],
96700:[945, 1544, 2024, 2416],
96800:[946, 1546, 2026, 2418],
96900:[947, 1547, 2028, 2420],
97000:[948, 1549, 2030, 2423],
97100:[949, 1551, 2032, 2425],
97200:[950, 1552, 2034, 2428],
97300:[951, 1554, 2036, 2430],
97400:[952, 1555, 2038, 2433],
97500:[953, 1557, 2040, 2435],
97600:[954, 1558, 2042, 2437],
97700:[955, 1560, 2044, 2440],
97800:[956, 1561, 2046, 2442],
97900:[957, 1563, 2048, 2445],
98000:[958, 1564, 2050, 2447],
98100:[959, 1566, 2052, 2449],
98200:[960, 1567, 2054, 2452],
98300:[961, 1569, 2056, 2454],
98400:[962, 1570, 2058, 2457],
98500:[963, 1572, 2060, 2459],
98600:[964, 1573, 2062, 2461],
98700:[965, 1575, 2064, 2464],
98800:[966, 1576, 2066, 2466],
98900:[967, 1578, 2068, 2469],
99000:[968, 1580, 2070, 2471],
99100:[969, 1582, 2072, 2473],
99200:[970, 1583, 2074, 2476],
99300:[971, 1585, 2076, 2478],
99400:[972, 1586, 2078, 2480],
99500:[973, 1588, 2080, 2483],
99600:[974, 1590, 2082, 2485],
99700:[975, 1591, 2084, 2487],
99800:[976, 1593, 2086, 2490],
99900:[977, 1594, 2088, 2492],
};
const OR_NU=[0.94, 1.44, 1.76, 2.1];

// Ontario — 2025 Federal Child Support Guidelines Table
const T_ON={
100000:[932, 1517, 1984, 2366],
100100:[933, 1518, 1986, 2368],
100200:[934, 1520, 1988, 2370],
100300:[935, 1521, 1989, 2372],
100400:[936, 1523, 1991, 2375],
100500:[937, 1524, 1993, 2377],
100600:[938, 1526, 1995, 2379],
100700:[939, 1527, 1997, 2381],
100800:[940, 1529, 1998, 2383],
100900:[941, 1530, 2000, 2385],
101000:[942, 1531, 2002, 2388],
101100:[943, 1532, 2004, 2390],
101200:[944, 1534, 2006, 2392],
101300:[945, 1535, 2008, 2395],
101400:[946, 1537, 2009, 2397],
101500:[947, 1538, 2011, 2399],
101600:[948, 1539, 2013, 2401],
101700:[949, 1541, 2015, 2403],
101800:[950, 1542, 2017, 2406],
101900:[950, 1544, 2019, 2408],
102000:[951, 1545, 2021, 2410],
102100:[952, 1546, 2023, 2412],
102200:[953, 1548, 2025, 2414],
102300:[954, 1549, 2026, 2416],
102400:[955, 1551, 2028, 2418],
102500:[956, 1552, 2030, 2421],
102600:[957, 1553, 2032, 2423],
102700:[957, 1555, 2034, 2425],
102800:[958, 1556, 2036, 2427],
102900:[959, 1557, 2037, 2429],
103000:[960, 1559, 2039, 2431],
103100:[961, 1560, 2041, 2433],
103200:[962, 1562, 2043, 2435],
103300:[963, 1563, 2044, 2437],
103400:[964, 1565, 2046, 2440],
103500:[965, 1566, 2048, 2442],
103600:[965, 1568, 2050, 2444],
103700:[966, 1569, 2052, 2446],
103800:[967, 1571, 2053, 2448],
103900:[968, 1572, 2055, 2450],
104000:[969, 1574, 2057, 2453],
104100:[970, 1575, 2059, 2455],
104200:[971, 1577, 2061, 2457],
104300:[972, 1578, 2062, 2459],
104400:[973, 1579, 2064, 2461],
104500:[973, 1581, 2066, 2463],
104600:[974, 1582, 2068, 2465],
104700:[975, 1583, 2069, 2468],
104800:[976, 1585, 2071, 2470],
104900:[977, 1586, 2073, 2472],
105000:[978, 1587, 2075, 2474],
105100:[979, 1588, 2077, 2476],
105200:[979, 1589, 2078, 2478],
105300:[980, 1591, 2080, 2480],
105400:[981, 1592, 2081, 2482],
105500:[982, 1593, 2083, 2483],
105600:[982, 1594, 2085, 2485],
105700:[983, 1595, 2086, 2487],
105800:[984, 1596, 2088, 2489],
105900:[985, 1598, 2089, 2491],
106000:[985, 1599, 2091, 2493],
106100:[986, 1600, 2093, 2495],
106200:[986, 1602, 2094, 2497],
106300:[987, 1603, 2096, 2499],
106400:[988, 1604, 2097, 2501],
106500:[989, 1605, 2099, 2503],
106600:[989, 1607, 2101, 2505],
106700:[990, 1608, 2102, 2507],
106800:[991, 1609, 2104, 2509],
106900:[991, 1610, 2105, 2511],
107000:[992, 1612, 2107, 2513],
107100:[993, 1613, 2108, 2515],
107200:[993, 1614, 2110, 2517],
107300:[994, 1615, 2111, 2518],
107400:[995, 1617, 2113, 2520],
107500:[995, 1618, 2114, 2522],
107600:[996, 1619, 2116, 2524],
107700:[997, 1620, 2117, 2526],
107800:[998, 1621, 2119, 2528],
107900:[998, 1622, 2120, 2529],
108000:[999, 1623, 2122, 2531],
108100:[1000, 1624, 2123, 2533],
108200:[1000, 1625, 2125, 2535],
108300:[1001, 1626, 2126, 2536],
108400:[1001, 1627, 2128, 2538],
108500:[1002, 1628, 2129, 2540],
108600:[1003, 1630, 2131, 2542],
108700:[1003, 1631, 2132, 2544],
108800:[1004, 1632, 2134, 2545],
108900:[1005, 1633, 2135, 2547],
109000:[1005, 1634, 2137, 2549],
109100:[1006, 1635, 2139, 2551],
109200:[1007, 1636, 2140, 2553],
109300:[1007, 1638, 2142, 2555],
109400:[1008, 1639, 2143, 2556],
109500:[1009, 1640, 2145, 2558],
109600:[1010, 1641, 2146, 2560],
109700:[1010, 1642, 2148, 2562],
109800:[1011, 1644, 2149, 2564],
109900:[1012, 1645, 2151, 2566],
110000:[1013, 1646, 2152, 2567],
110100:[1014, 1647, 2154, 2569],
110200:[1015, 1648, 2155, 2571],
110300:[1015, 1650, 2157, 2572],
110400:[1016, 1651, 2158, 2574],
110500:[1017, 1652, 2160, 2576],
110600:[1018, 1653, 2161, 2578],
110700:[1019, 1654, 2163, 2580],
110800:[1020, 1656, 2164, 2581],
110900:[1020, 1657, 2166, 2583],
111000:[1021, 1658, 2168, 2585],
111100:[1022, 1659, 2170, 2587],
111200:[1023, 1660, 2171, 2589],
111300:[1023, 1662, 2173, 2591],
111400:[1024, 1663, 2174, 2592],
111500:[1025, 1664, 2176, 2594],
111600:[1026, 1665, 2177, 2596],
111700:[1027, 1666, 2179, 2598],
111800:[1028, 1667, 2181, 2600],
111900:[1028, 1669, 2182, 2602],
112000:[1029, 1670, 2184, 2604],
112100:[1030, 1671, 2186, 2606],
112200:[1030, 1673, 2187, 2608],
112300:[1031, 1674, 2189, 2610],
112400:[1032, 1675, 2190, 2612],
112500:[1033, 1676, 2192, 2613],
112600:[1033, 1678, 2194, 2615],
112700:[1034, 1679, 2195, 2617],
112800:[1035, 1680, 2197, 2619],
112900:[1036, 1681, 2198, 2621],
113000:[1036, 1683, 2200, 2623],
113100:[1037, 1684, 2202, 2625],
113200:[1038, 1685, 2203, 2627],
113300:[1038, 1687, 2205, 2629],
113400:[1039, 1688, 2206, 2630],
113500:[1040, 1689, 2208, 2632],
113600:[1041, 1690, 2209, 2634],
113700:[1041, 1692, 2211, 2636],
113800:[1042, 1693, 2212, 2638],
113900:[1043, 1694, 2214, 2640],
114000:[1044, 1695, 2215, 2641],
114100:[1045, 1696, 2217, 2643],
114200:[1046, 1697, 2218, 2645],
114300:[1046, 1699, 2220, 2647],
114400:[1047, 1700, 2221, 2649],
114500:[1048, 1701, 2223, 2650],
114600:[1049, 1702, 2224, 2652],
114700:[1049, 1703, 2226, 2654],
114800:[1050, 1705, 2228, 2656],
114900:[1051, 1706, 2229, 2658],
115000:[1052, 1707, 2231, 2660],
115100:[1053, 1708, 2233, 2662],
115200:[1054, 1709, 2234, 2664],
115300:[1054, 1711, 2236, 2665],
115400:[1055, 1712, 2237, 2667],
115500:[1056, 1713, 2239, 2669],
115600:[1057, 1714, 2241, 2671],
115700:[1058, 1715, 2242, 2673],
115800:[1058, 1717, 2244, 2675],
115900:[1059, 1718, 2245, 2676],
116000:[1060, 1719, 2247, 2678],
116100:[1061, 1720, 2249, 2680],
116200:[1062, 1722, 2250, 2682],
116300:[1062, 1723, 2252, 2684],
116400:[1063, 1724, 2253, 2685],
116500:[1064, 1725, 2255, 2687],
116600:[1065, 1727, 2257, 2689],
116700:[1066, 1728, 2258, 2691],
116800:[1066, 1729, 2260, 2693],
116900:[1067, 1730, 2262, 2695],
117000:[1068, 1732, 2263, 2697],
117100:[1069, 1733, 2265, 2699],
117200:[1070, 1734, 2266, 2701],
117300:[1070, 1736, 2268, 2703],
117400:[1071, 1737, 2269, 2705],
117500:[1072, 1738, 2271, 2707],
117600:[1073, 1739, 2272, 2708],
117700:[1074, 1741, 2274, 2710],
117800:[1075, 1742, 2275, 2712],
117900:[1075, 1743, 2277, 2714],
118000:[1076, 1744, 2278, 2716],
118100:[1077, 1745, 2280, 2718],
118200:[1078, 1746, 2281, 2720],
118300:[1078, 1748, 2283, 2722],
118400:[1079, 1749, 2284, 2723],
118500:[1080, 1750, 2286, 2725],
118600:[1081, 1751, 2287, 2727],
118700:[1082, 1753, 2289, 2729],
118800:[1083, 1754, 2291, 2731],
118900:[1083, 1755, 2292, 2733],
119000:[1084, 1756, 2294, 2734],
119100:[1085, 1757, 2296, 2736],
119200:[1085, 1758, 2297, 2738],
119300:[1086, 1760, 2299, 2740],
119400:[1087, 1761, 2300, 2742],
119500:[1088, 1762, 2302, 2743],
119600:[1088, 1763, 2304, 2745],
119700:[1089, 1764, 2305, 2747],
119800:[1090, 1766, 2307, 2749],
119900:[1091, 1767, 2308, 2751],
120000:[1091, 1768, 2310, 2753],
120100:[1092, 1769, 2312, 2755],
120200:[1093, 1770, 2313, 2757],
120300:[1093, 1772, 2315, 2758],
120400:[1094, 1773, 2316, 2760],
120500:[1095, 1774, 2318, 2762],
120600:[1096, 1775, 2319, 2764],
120700:[1096, 1776, 2321, 2766],
120800:[1097, 1777, 2322, 2768],
120900:[1098, 1779, 2324, 2769],
121000:[1099, 1780, 2325, 2771],
121100:[1100, 1781, 2327, 2773],
121200:[1101, 1783, 2328, 2775],
121300:[1101, 1784, 2330, 2777],
121400:[1102, 1785, 2331, 2778],
121500:[1103, 1786, 2333, 2780],
121600:[1104, 1788, 2334, 2782],
121700:[1104, 1789, 2336, 2784],
121800:[1105, 1790, 2337, 2786],
121900:[1106, 1791, 2339, 2788],
122000:[1107, 1793, 2341, 2790],
122100:[1108, 1794, 2343, 2792],
122200:[1109, 1795, 2344, 2794],
122300:[1109, 1797, 2346, 2795],
122400:[1110, 1798, 2347, 2797],
122500:[1111, 1799, 2349, 2799],
122600:[1112, 1800, 2351, 2801],
122700:[1112, 1802, 2352, 2803],
122800:[1113, 1803, 2354, 2805],
122900:[1114, 1804, 2355, 2806],
123000:[1115, 1805, 2357, 2808],
123100:[1116, 1806, 2359, 2810],
123200:[1117, 1807, 2360, 2812],
123300:[1117, 1809, 2362, 2814],
123400:[1118, 1810, 2363, 2815],
123500:[1119, 1811, 2365, 2817],
123600:[1120, 1812, 2367, 2819],
123700:[1121, 1813, 2368, 2821],
123800:[1121, 1815, 2370, 2823],
123900:[1122, 1816, 2372, 2825],
124000:[1123, 1817, 2373, 2827],
124100:[1124, 1818, 2375, 2829],
124200:[1125, 1819, 2376, 2831],
124300:[1125, 1821, 2378, 2833],
124400:[1126, 1822, 2379, 2835],
124500:[1127, 1823, 2381, 2837],
124600:[1128, 1824, 2382, 2838],
124700:[1129, 1825, 2384, 2840],
124800:[1130, 1826, 2385, 2842],
124900:[1130, 1828, 2387, 2844],
125000:[1131, 1829, 2388, 2846],
125100:[1132, 1830, 2390, 2848],
125200:[1133, 1832, 2391, 2850],
125300:[1133, 1833, 2393, 2852],
125400:[1134, 1834, 2394, 2853],
125500:[1135, 1835, 2396, 2855],
125600:[1136, 1837, 2397, 2857],
125700:[1137, 1838, 2399, 2859],
125800:[1138, 1839, 2401, 2861],
125900:[1138, 1840, 2402, 2863],
126000:[1139, 1842, 2404, 2864],
126100:[1140, 1843, 2406, 2866],
126200:[1140, 1844, 2407, 2868],
126300:[1141, 1846, 2409, 2870],
126400:[1142, 1847, 2410, 2872],
126500:[1143, 1848, 2412, 2873],
126600:[1143, 1849, 2414, 2875],
126700:[1144, 1851, 2415, 2877],
126800:[1145, 1852, 2417, 2879],
126900:[1146, 1853, 2418, 2881],
127000:[1146, 1854, 2420, 2883],
127100:[1147, 1855, 2422, 2885],
127200:[1148, 1856, 2423, 2887],
127300:[1148, 1858, 2425, 2888],
127400:[1149, 1859, 2426, 2890],
127500:[1150, 1860, 2428, 2892],
127600:[1151, 1861, 2429, 2894],
127700:[1151, 1863, 2431, 2896],
127800:[1152, 1864, 2432, 2898],
127900:[1153, 1865, 2434, 2899],
128000:[1154, 1866, 2435, 2901],
128100:[1155, 1867, 2437, 2903],
128200:[1156, 1868, 2438, 2905],
128300:[1156, 1870, 2440, 2907],
128400:[1157, 1871, 2441, 2908],
128500:[1158, 1872, 2443, 2910],
128600:[1159, 1873, 2444, 2912],
128700:[1159, 1874, 2446, 2914],
128800:[1160, 1876, 2447, 2916],
128900:[1161, 1877, 2449, 2918],
129000:[1162, 1878, 2451, 2920],
129100:[1163, 1879, 2453, 2922],
129200:[1164, 1881, 2454, 2924],
129300:[1164, 1882, 2456, 2925],
129400:[1165, 1883, 2457, 2927],
129500:[1166, 1884, 2459, 2929],
129600:[1167, 1886, 2461, 2931],
129700:[1167, 1887, 2462, 2933],
129800:[1168, 1888, 2464, 2934],
129900:[1169, 1889, 2465, 2936],
130000:[1170, 1891, 2467, 2938],
130100:[1171, 1892, 2469, 2940],
130200:[1172, 1893, 2470, 2942],
130300:[1172, 1895, 2472, 2944],
130400:[1173, 1896, 2473, 2945],
130500:[1174, 1897, 2475, 2947],
130600:[1175, 1898, 2477, 2949],
130700:[1176, 1900, 2478, 2951],
130800:[1176, 1901, 2480, 2953],
130900:[1177, 1902, 2482, 2955],
131000:[1178, 1903, 2483, 2957],
131100:[1179, 1904, 2485, 2959],
131200:[1180, 1905, 2486, 2961],
131300:[1180, 1907, 2488, 2963],
131400:[1181, 1908, 2489, 2965],
131500:[1182, 1909, 2491, 2966],
131600:[1183, 1910, 2492, 2968],
131700:[1184, 1912, 2494, 2970],
131800:[1184, 1913, 2495, 2972],
131900:[1185, 1914, 2497, 2974],
132000:[1186, 1915, 2498, 2976],
132100:[1187, 1916, 2500, 2978],
132200:[1188, 1917, 2501, 2980],
132300:[1188, 1919, 2503, 2982],
132400:[1189, 1920, 2504, 2983],
132500:[1190, 1921, 2506, 2985],
132600:[1191, 1922, 2507, 2987],
132700:[1192, 1923, 2509, 2989],
132800:[1193, 1925, 2511, 2991],
132900:[1193, 1926, 2512, 2993],
133000:[1194, 1927, 2514, 2994],
133100:[1195, 1928, 2516, 2996],
133200:[1195, 1929, 2517, 2998],
133300:[1196, 1931, 2519, 3000],
133400:[1197, 1932, 2520, 3002],
133500:[1198, 1933, 2522, 3003],
133600:[1198, 1934, 2524, 3005],
133700:[1199, 1935, 2525, 3007],
133800:[1200, 1936, 2527, 3009],
133900:[1201, 1938, 2528, 3011],
134000:[1201, 1939, 2530, 3013],
134100:[1202, 1940, 2532, 3015],
134200:[1203, 1942, 2533, 3017],
134300:[1203, 1943, 2535, 3018],
134400:[1204, 1944, 2536, 3020],
134500:[1205, 1945, 2538, 3022],
134600:[1206, 1947, 2539, 3024],
134700:[1206, 1948, 2541, 3026],
134800:[1207, 1949, 2542, 3028],
134900:[1208, 1950, 2544, 3029],
135000:[1209, 1952, 2545, 3031],
135100:[1210, 1953, 2547, 3033],
135200:[1211, 1954, 2548, 3035],
135300:[1211, 1956, 2550, 3037],
135400:[1212, 1957, 2551, 3038],
135500:[1213, 1958, 2553, 3040],
135600:[1214, 1959, 2554, 3042],
135700:[1214, 1961, 2556, 3044],
135800:[1215, 1962, 2557, 3046],
135900:[1216, 1963, 2559, 3048],
136000:[1217, 1964, 2561, 3050],
136100:[1218, 1965, 2563, 3052],
136200:[1219, 1966, 2564, 3054],
136300:[1219, 1968, 2566, 3056],
136400:[1220, 1969, 2567, 3058],
136500:[1221, 1970, 2569, 3060],
136600:[1222, 1971, 2570, 3061],
136700:[1222, 1972, 2572, 3063],
136800:[1223, 1974, 2574, 3065],
136900:[1224, 1975, 2575, 3067],
137000:[1225, 1976, 2577, 3069],
137100:[1226, 1977, 2579, 3071],
137200:[1227, 1978, 2580, 3073],
137300:[1227, 1980, 2582, 3075],
137400:[1228, 1981, 2583, 3076],
137500:[1229, 1982, 2585, 3078],
137600:[1230, 1983, 2587, 3080],
137700:[1231, 1984, 2588, 3082],
137800:[1231, 1986, 2590, 3084],
137900:[1232, 1987, 2591, 3086],
138000:[1233, 1988, 2593, 3087],
138100:[1234, 1989, 2595, 3089],
138200:[1235, 1991, 2596, 3091],
138300:[1235, 1992, 2598, 3093],
138400:[1236, 1993, 2599, 3095],
138500:[1237, 1994, 2601, 3096],
138600:[1238, 1996, 2602, 3098],
138700:[1239, 1997, 2604, 3100],
138800:[1239, 1998, 2605, 3102],
138900:[1240, 1999, 2607, 3104],
139000:[1241, 2001, 2608, 3106],
139100:[1242, 2002, 2610, 3108],
139200:[1243, 2003, 2611, 3110],
139300:[1243, 2005, 2613, 3112],
139400:[1244, 2006, 2614, 3113],
139500:[1245, 2007, 2616, 3115],
139600:[1246, 2008, 2617, 3117],
139700:[1247, 2010, 2619, 3119],
139800:[1248, 2011, 2621, 3121],
139900:[1248, 2012, 2622, 3123],
140000:[1249, 2013, 2624, 3124],
140100:[1250, 2014, 2626, 3126],
140200:[1250, 2015, 2627, 3128],
140300:[1251, 2017, 2629, 3130],
140400:[1252, 2018, 2630, 3132],
140500:[1253, 2019, 2632, 3133],
140600:[1253, 2020, 2634, 3135],
140700:[1254, 2022, 2635, 3137],
140800:[1255, 2023, 2637, 3139],
140900:[1256, 2024, 2638, 3141],
141000:[1256, 2025, 2640, 3143],
141100:[1257, 2026, 2642, 3145],
141200:[1258, 2027, 2643, 3147],
141300:[1258, 2029, 2645, 3148],
141400:[1259, 2030, 2646, 3150],
141500:[1260, 2031, 2648, 3152],
141600:[1261, 2032, 2650, 3154],
141700:[1261, 2033, 2651, 3156],
141800:[1262, 2035, 2653, 3158],
141900:[1263, 2036, 2655, 3159],
142000:[1264, 2037, 2656, 3161],
142100:[1265, 2038, 2658, 3163],
142200:[1266, 2039, 2659, 3165],
142300:[1266, 2041, 2661, 3167],
142400:[1267, 2042, 2662, 3168],
142500:[1268, 2043, 2664, 3170],
142600:[1269, 2044, 2665, 3172],
142700:[1269, 2045, 2667, 3174],
142800:[1270, 2046, 2668, 3176],
142900:[1271, 2048, 2670, 3178],
143000:[1272, 2049, 2671, 3180],
143100:[1273, 2050, 2673, 3182],
143200:[1274, 2052, 2674, 3184],
143300:[1274, 2053, 2676, 3186],
143400:[1275, 2054, 2677, 3188],
143500:[1276, 2055, 2679, 3190],
143600:[1277, 2057, 2680, 3191],
143700:[1277, 2058, 2682, 3193],
143800:[1278, 2059, 2684, 3195],
143900:[1279, 2060, 2685, 3197],
144000:[1280, 2062, 2687, 3199],
144100:[1281, 2063, 2689, 3201],
144200:[1282, 2064, 2690, 3203],
144300:[1282, 2066, 2692, 3205],
144400:[1283, 2067, 2693, 3206],
144500:[1284, 2068, 2695, 3208],
144600:[1285, 2069, 2697, 3210],
144700:[1286, 2071, 2698, 3212],
144800:[1286, 2072, 2700, 3214],
144900:[1287, 2073, 2701, 3216],
145000:[1288, 2074, 2703, 3217],
145100:[1289, 2075, 2705, 3219],
145200:[1290, 2076, 2706, 3221],
145300:[1290, 2078, 2708, 3223],
145400:[1291, 2079, 2709, 3225],
145500:[1292, 2080, 2711, 3226],
145600:[1293, 2081, 2712, 3228],
145700:[1294, 2082, 2714, 3230],
145800:[1294, 2084, 2715, 3232],
145900:[1295, 2085, 2717, 3234],
146000:[1296, 2086, 2718, 3236],
146100:[1297, 2087, 2720, 3238],
146200:[1298, 2088, 2721, 3240],
146300:[1298, 2090, 2723, 3241],
146400:[1299, 2091, 2724, 3243],
146500:[1300, 2092, 2726, 3245],
146600:[1301, 2093, 2727, 3247],
146700:[1302, 2094, 2729, 3249],
146800:[1303, 2095, 2730, 3251],
146900:[1303, 2097, 2732, 3252],
147000:[1304, 2098, 2734, 3254],
147100:[1305, 2099, 2736, 3256],
147200:[1306, 2101, 2737, 3258],
147300:[1307, 2102, 2739, 3260],
147400:[1307, 2103, 2740, 3261],
147500:[1308, 2104, 2742, 3263],
147600:[1309, 2106, 2744, 3265],
147700:[1310, 2107, 2745, 3267],
147800:[1311, 2108, 2747, 3269],
147900:[1312, 2109, 2748, 3271],
148000:[1312, 2111, 2750, 3273],
148100:[1313, 2112, 2752, 3275],
148200:[1313, 2113, 2753, 3277],
148300:[1314, 2115, 2755, 3278],
148400:[1315, 2116, 2756, 3280],
148500:[1316, 2117, 2758, 3282],
148600:[1316, 2118, 2760, 3284],
148700:[1317, 2120, 2761, 3286],
148800:[1318, 2121, 2763, 3288],
148900:[1319, 2122, 2765, 3289],
149000:[1319, 2123, 2766, 3291],
149100:[1320, 2124, 2768, 3293],
149200:[1321, 2125, 2769, 3295],
149300:[1321, 2127, 2771, 3297],
149400:[1322, 2128, 2772, 3298],
149500:[1323, 2129, 2774, 3300],
149600:[1324, 2130, 2775, 3302],
149700:[1324, 2132, 2777, 3304],
149800:[1325, 2133, 2778, 3306],
149900:[1326, 2134, 2780, 3308],
150000:[1327, 2135, 2781, 3310],
16000:[0, 0, 0, 0],
16100:[10, 10, 11, 12],
16200:[19, 20, 22, 24],
16300:[29, 31, 33, 35],
16400:[38, 41, 44, 47],
16500:[48, 51, 55, 59],
16600:[57, 61, 66, 71],
16700:[67, 71, 77, 83],
16800:[76, 82, 88, 94],
16900:[86, 92, 99, 106],
17000:[95, 102, 110, 118],
17100:[96, 107, 115, 123],
17200:[97, 112, 120, 129],
17300:[98, 116, 126, 134],
17400:[100, 121, 131, 140],
17500:[101, 126, 136, 145],
17600:[102, 131, 141, 151],
17700:[103, 135, 146, 156],
17800:[104, 140, 151, 162],
17900:[105, 145, 157, 167],
18000:[106, 150, 162, 173],
18100:[107, 154, 167, 178],
18200:[108, 159, 171, 183],
18300:[109, 163, 176, 188],
18400:[111, 167, 181, 193],
18500:[112, 172, 186, 198],
18600:[113, 176, 190, 203],
18700:[114, 181, 195, 208],
18800:[115, 185, 200, 213],
18900:[116, 189, 204, 219],
19000:[117, 194, 209, 224],
19100:[118, 198, 214, 229],
19200:[119, 203, 218, 234],
19300:[120, 207, 223, 239],
19400:[121, 211, 227, 244],
19500:[123, 216, 232, 249],
19600:[124, 220, 237, 254],
19700:[125, 224, 241, 259],
19800:[126, 228, 246, 264],
19900:[127, 233, 251, 269],
20000:[128, 237, 255, 274],
20100:[129, 241, 259, 279],
20200:[130, 245, 264, 283],
20300:[131, 249, 268, 288],
20400:[132, 253, 272, 293],
20500:[133, 257, 277, 297],
20600:[135, 262, 281, 302],
20700:[136, 266, 286, 306],
20800:[137, 270, 290, 311],
20900:[138, 274, 294, 316],
21000:[139, 278, 299, 320],
21100:[140, 282, 303, 325],
21200:[141, 286, 308, 329],
21300:[142, 290, 312, 334],
21400:[143, 294, 316, 338],
21500:[144, 298, 321, 343],
21600:[145, 302, 325, 347],
21700:[147, 306, 329, 352],
21800:[148, 310, 333, 357],
21900:[149, 314, 338, 361],
22000:[150, 317, 342, 366],
22100:[151, 321, 346, 371],
22200:[152, 325, 351, 375],
22300:[153, 329, 355, 380],
22400:[155, 333, 359, 384],
22500:[156, 337, 364, 389],
22600:[157, 341, 368, 393],
22700:[158, 345, 372, 398],
22800:[159, 349, 377, 403],
22900:[160, 353, 381, 407],
23000:[162, 357, 385, 412],
23100:[163, 361, 390, 417],
23200:[164, 365, 394, 422],
23300:[165, 370, 399, 427],
23400:[167, 374, 403, 431],
23500:[168, 378, 408, 436],
23600:[169, 382, 412, 441],
23700:[170, 386, 417, 446],
23800:[171, 390, 421, 451],
23900:[172, 395, 426, 456],
24000:[173, 399, 430, 461],
24100:[174, 403, 435, 466],
24200:[175, 408, 439, 471],
24300:[176, 412, 444, 476],
24400:[178, 416, 448, 481],
24500:[179, 420, 453, 486],
24600:[180, 425, 457, 490],
24700:[181, 429, 462, 495],
24800:[182, 433, 467, 500],
24900:[183, 437, 471, 505],
25000:[184, 442, 476, 510],
25100:[185, 445, 480, 514],
25200:[186, 449, 484, 519],
25300:[187, 452, 488, 523],
25400:[188, 456, 492, 527],
25500:[190, 459, 496, 531],
25600:[191, 463, 500, 536],
25700:[192, 466, 504, 540],
25800:[193, 470, 508, 544],
25900:[194, 473, 512, 549],
26000:[195, 477, 516, 553],
26100:[196, 478, 520, 557],
26200:[197, 478, 524, 561],
26300:[198, 479, 528, 566],
26400:[199, 479, 532, 570],
26500:[200, 480, 536, 574],
26600:[202, 481, 540, 578],
26700:[203, 481, 544, 582],
26800:[204, 482, 548, 586],
26900:[205, 482, 552, 591],
27000:[206, 483, 556, 595],
27100:[207, 483, 560, 599],
27200:[208, 484, 564, 603],
27300:[209, 484, 568, 607],
27400:[210, 485, 571, 611],
27500:[211, 485, 575, 615],
27600:[212, 486, 579, 619],
27700:[214, 486, 583, 624],
27800:[215, 487, 587, 628],
27900:[216, 487, 591, 632],
28000:[217, 487, 594, 636],
28100:[218, 488, 598, 640],
28200:[219, 488, 602, 644],
28300:[220, 489, 605, 648],
28400:[222, 489, 609, 652],
28500:[223, 490, 613, 656],
28600:[224, 490, 617, 660],
28700:[225, 491, 621, 664],
28800:[226, 491, 624, 669],
28900:[227, 492, 628, 673],
29000:[229, 492, 632, 677],
29100:[230, 493, 636, 681],
29200:[231, 494, 640, 685],
29300:[232, 495, 644, 689],
29400:[234, 496, 648, 693],
29500:[235, 497, 651, 697],
29600:[236, 497, 655, 701],
29700:[237, 498, 659, 705],
29800:[238, 499, 663, 710],
29900:[239, 500, 667, 714],
30000:[240, 501, 671, 718],
30100:[241, 502, 673, 722],
30200:[242, 503, 675, 726],
30300:[243, 504, 678, 730],
30400:[245, 504, 680, 734],
30500:[246, 505, 682, 738],
30600:[247, 506, 684, 742],
30700:[248, 507, 687, 746],
30800:[249, 508, 689, 750],
30900:[250, 509, 691, 755],
31000:[251, 509, 693, 759],
31100:[252, 510, 694, 763],
31200:[253, 511, 695, 767],
31300:[254, 511, 697, 771],
31400:[255, 512, 698, 775],
31500:[257, 513, 699, 779],
31600:[258, 514, 700, 783],
31700:[259, 514, 701, 787],
31800:[260, 515, 703, 791],
31900:[261, 516, 704, 795],
32000:[262, 517, 705, 799],
32100:[263, 518, 706, 803],
32200:[264, 518, 707, 806],
32300:[265, 519, 708, 810],
32400:[266, 519, 709, 814],
32500:[267, 520, 710, 817],
32600:[269, 520, 710, 821],
32700:[270, 521, 711, 824],
32800:[271, 521, 712, 828],
32900:[272, 522, 713, 832],
33000:[273, 522, 714, 835],
33100:[274, 522, 715, 838],
33200:[275, 523, 716, 842],
33300:[275, 523, 716, 845],
33400:[276, 524, 717, 848],
33500:[277, 524, 718, 852],
33600:[278, 524, 719, 855],
33700:[278, 525, 719, 858],
33800:[279, 525, 720, 862],
33900:[280, 526, 721, 865],
34000:[281, 526, 722, 868],
34100:[281, 527, 723, 871],
34200:[282, 528, 724, 874],
34300:[282, 528, 725, 877],
34400:[282, 529, 727, 880],
34500:[283, 530, 728, 883],
34600:[283, 531, 729, 886],
34700:[283, 532, 730, 889],
34800:[284, 532, 731, 891],
34900:[284, 533, 732, 894],
35000:[284, 534, 734, 897],
35100:[285, 535, 736, 899],
35200:[285, 536, 737, 901],
35300:[286, 538, 739, 903],
35400:[287, 539, 741, 905],
35500:[288, 540, 742, 907],
35600:[288, 541, 744, 909],
35700:[289, 543, 745, 911],
35800:[290, 544, 747, 913],
35900:[291, 545, 749, 915],
36000:[291, 546, 750, 917],
36100:[292, 548, 752, 919],
36200:[293, 549, 754, 922],
36300:[294, 551, 756, 924],
36400:[295, 552, 758, 926],
36500:[296, 554, 760, 928],
36600:[297, 555, 762, 931],
36700:[298, 557, 764, 933],
36800:[300, 558, 766, 935],
36900:[301, 560, 768, 937],
37000:[302, 562, 770, 940],
37100:[303, 564, 772, 942],
37200:[304, 565, 774, 944],
37300:[305, 567, 776, 947],
37400:[306, 568, 778, 949],
37500:[307, 570, 780, 951],
37600:[308, 571, 781, 953],
37700:[309, 573, 783, 955],
37800:[310, 574, 785, 957],
37900:[311, 576, 787, 960],
38000:[312, 577, 789, 962],
38100:[313, 578, 791, 964],
38200:[314, 580, 793, 967],
38300:[315, 581, 795, 969],
38400:[316, 583, 797, 971],
38500:[317, 584, 799, 973],
38600:[318, 586, 800, 976],
38700:[319, 587, 802, 978],
38800:[321, 589, 804, 980],
38900:[322, 590, 806, 982],
39000:[323, 592, 808, 985],
39100:[324, 594, 810, 987],
39200:[325, 595, 812, 990],
39300:[326, 597, 814, 992],
39400:[327, 599, 816, 994],
39500:[329, 600, 818, 997],
39600:[330, 602, 820, 999],
39700:[331, 604, 822, 1001],
39800:[332, 605, 824, 1004],
39900:[333, 607, 826, 1006],
40000:[334, 609, 828, 1008],
40100:[335, 611, 830, 1010],
40200:[336, 612, 832, 1013],
40300:[337, 614, 834, 1015],
40400:[338, 615, 836, 1017],
40500:[339, 617, 838, 1019],
40600:[340, 618, 840, 1022],
40700:[341, 620, 842, 1024],
40800:[342, 621, 844, 1026],
40900:[343, 623, 846, 1028],
41000:[344, 624, 848, 1031],
41100:[345, 626, 850, 1033],
41200:[346, 627, 852, 1036],
41300:[347, 629, 854, 1038],
41400:[348, 630, 856, 1040],
41500:[349, 632, 858, 1042],
41600:[350, 633, 860, 1045],
41700:[351, 635, 861, 1047],
41800:[352, 636, 863, 1049],
41900:[353, 638, 865, 1052],
42000:[354, 639, 867, 1054],
42100:[355, 640, 869, 1056],
42200:[356, 642, 871, 1058],
42300:[357, 643, 873, 1061],
42400:[358, 645, 875, 1063],
42500:[359, 646, 876, 1065],
42600:[360, 648, 878, 1067],
42700:[361, 649, 880, 1070],
42800:[362, 651, 882, 1072],
42900:[363, 652, 884, 1074],
43000:[364, 654, 886, 1076],
43100:[365, 656, 888, 1078],
43200:[366, 657, 890, 1081],
43300:[368, 659, 892, 1083],
43400:[369, 660, 894, 1085],
43500:[370, 662, 896, 1087],
43600:[371, 663, 898, 1090],
43700:[372, 665, 900, 1092],
43800:[374, 667, 902, 1094],
43900:[375, 668, 904, 1096],
44000:[376, 670, 906, 1099],
44100:[378, 672, 908, 1101],
44200:[379, 673, 910, 1104],
44300:[381, 675, 912, 1106],
44400:[382, 676, 914, 1108],
44500:[384, 678, 916, 1111],
44600:[386, 680, 917, 1113],
44700:[387, 681, 919, 1115],
44800:[389, 683, 921, 1117],
44900:[390, 685, 923, 1120],
45000:[392, 686, 925, 1122],
45100:[394, 688, 927, 1124],
45200:[395, 689, 929, 1126],
45300:[397, 691, 931, 1129],
45400:[398, 692, 933, 1131],
45500:[400, 694, 935, 1133],
45600:[402, 695, 937, 1135],
45700:[403, 697, 939, 1138],
45800:[405, 698, 941, 1140],
45900:[407, 700, 943, 1142],
46000:[408, 701, 945, 1144],
46100:[409, 702, 947, 1146],
46200:[410, 704, 948, 1148],
46300:[412, 705, 950, 1150],
46400:[413, 706, 952, 1152],
46500:[414, 707, 954, 1154],
46600:[415, 709, 955, 1156],
46700:[417, 710, 957, 1158],
46800:[418, 711, 959, 1160],
46900:[419, 713, 960, 1162],
47000:[420, 714, 962, 1164],
47100:[421, 715, 964, 1166],
47200:[422, 716, 965, 1168],
47300:[423, 717, 967, 1170],
47400:[424, 718, 968, 1171],
47500:[425, 720, 970, 1173],
47600:[427, 721, 971, 1175],
47700:[428, 722, 973, 1177],
47800:[429, 723, 974, 1179],
47900:[430, 724, 976, 1181],
48000:[431, 725, 977, 1183],
48100:[432, 726, 978, 1184],
48200:[433, 727, 979, 1186],
48300:[434, 727, 981, 1187],
48400:[435, 728, 982, 1189],
48500:[436, 729, 983, 1190],
48600:[437, 730, 984, 1192],
48700:[437, 731, 985, 1193],
48800:[438, 731, 987, 1195],
48900:[439, 732, 988, 1196],
49000:[440, 733, 989, 1198],
49100:[441, 734, 990, 1200],
49200:[442, 735, 992, 1202],
49300:[443, 736, 993, 1203],
49400:[444, 737, 995, 1205],
49500:[445, 738, 996, 1207],
49600:[446, 740, 998, 1209],
49700:[447, 741, 999, 1211],
49800:[448, 742, 1000, 1213],
49900:[449, 743, 1002, 1214],
50000:[450, 744, 1003, 1216],
50100:[451, 745, 1005, 1218],
50200:[453, 747, 1006, 1220],
50300:[454, 748, 1008, 1222],
50400:[455, 749, 1009, 1224],
50500:[456, 751, 1011, 1225],
50600:[458, 752, 1012, 1227],
50700:[459, 753, 1014, 1229],
50800:[460, 755, 1015, 1231],
50900:[461, 756, 1017, 1233],
51000:[463, 757, 1019, 1235],
51100:[464, 759, 1021, 1237],
51200:[465, 761, 1022, 1239],
51300:[467, 762, 1024, 1241],
51400:[468, 764, 1026, 1243],
51500:[469, 766, 1027, 1245],
51600:[470, 768, 1029, 1247],
51700:[472, 769, 1030, 1249],
51800:[473, 771, 1032, 1251],
51900:[474, 773, 1034, 1253],
52000:[475, 775, 1035, 1255],
52100:[476, 777, 1037, 1257],
52200:[478, 779, 1038, 1259],
52300:[479, 780, 1040, 1261],
52400:[480, 782, 1042, 1263],
52500:[481, 784, 1043, 1265],
52600:[483, 786, 1045, 1268],
52700:[484, 788, 1047, 1270],
52800:[485, 789, 1048, 1272],
52900:[487, 791, 1050, 1274],
53000:[488, 793, 1052, 1276],
53100:[489, 795, 1054, 1278],
53200:[490, 796, 1055, 1280],
53300:[491, 798, 1057, 1282],
53400:[492, 800, 1059, 1284],
53500:[494, 802, 1060, 1286],
53600:[495, 803, 1062, 1288],
53700:[496, 805, 1064, 1290],
53800:[497, 807, 1066, 1292],
53900:[498, 809, 1067, 1294],
54000:[499, 810, 1069, 1296],
54100:[500, 812, 1071, 1298],
54200:[501, 813, 1072, 1300],
54300:[502, 815, 1074, 1302],
54400:[502, 817, 1075, 1304],
54500:[503, 818, 1077, 1306],
54600:[504, 820, 1079, 1308],
54700:[505, 822, 1080, 1310],
54800:[506, 823, 1082, 1312],
54900:[507, 825, 1083, 1314],
55000:[508, 827, 1085, 1316],
55100:[509, 829, 1087, 1318],
55200:[510, 830, 1088, 1320],
55300:[511, 832, 1090, 1322],
55400:[511, 834, 1091, 1324],
55500:[512, 835, 1093, 1326],
55600:[513, 837, 1095, 1328],
55700:[514, 839, 1096, 1329],
55800:[515, 840, 1098, 1331],
55900:[516, 842, 1100, 1333],
56000:[517, 844, 1101, 1335],
56100:[518, 846, 1103, 1337],
56200:[519, 847, 1105, 1339],
56300:[520, 849, 1107, 1341],
56400:[521, 851, 1109, 1343],
56500:[522, 852, 1111, 1344],
56600:[523, 854, 1113, 1346],
56700:[524, 856, 1115, 1348],
56800:[525, 858, 1117, 1350],
56900:[526, 859, 1118, 1352],
57000:[527, 861, 1120, 1354],
57100:[528, 863, 1122, 1356],
57200:[529, 864, 1124, 1358],
57300:[530, 866, 1126, 1360],
57400:[531, 868, 1128, 1362],
57500:[532, 870, 1130, 1364],
57600:[533, 871, 1133, 1366],
57700:[534, 873, 1135, 1368],
57800:[535, 875, 1137, 1370],
57900:[536, 876, 1139, 1372],
58000:[536, 878, 1141, 1374],
58100:[537, 880, 1143, 1376],
58200:[538, 881, 1145, 1378],
58300:[539, 883, 1147, 1380],
58400:[540, 885, 1149, 1382],
58500:[541, 887, 1151, 1384],
58600:[542, 888, 1153, 1386],
58700:[543, 890, 1155, 1388],
58800:[544, 892, 1157, 1390],
58900:[544, 894, 1159, 1392],
59000:[545, 895, 1161, 1393],
59100:[546, 897, 1163, 1395],
59200:[547, 898, 1165, 1397],
59300:[548, 900, 1167, 1399],
59400:[549, 902, 1169, 1401],
59500:[550, 903, 1171, 1403],
59600:[551, 905, 1173, 1405],
59700:[552, 907, 1176, 1406],
59800:[552, 908, 1178, 1408],
59900:[553, 910, 1180, 1410],
60000:[554, 911, 1182, 1412],
60100:[555, 913, 1184, 1414],
60200:[556, 914, 1186, 1416],
60300:[557, 916, 1188, 1418],
60400:[558, 918, 1190, 1420],
60500:[559, 919, 1192, 1421],
60600:[560, 921, 1194, 1423],
60700:[560, 923, 1196, 1425],
60800:[561, 924, 1198, 1427],
60900:[562, 926, 1200, 1429],
61000:[563, 928, 1202, 1431],
61100:[564, 930, 1204, 1433],
61200:[565, 931, 1206, 1435],
61300:[566, 933, 1208, 1437],
61400:[567, 935, 1210, 1439],
61500:[568, 936, 1212, 1441],
61600:[568, 938, 1214, 1443],
61700:[569, 940, 1216, 1445],
61800:[570, 941, 1218, 1447],
61900:[571, 943, 1221, 1449],
62000:[572, 945, 1223, 1451],
62100:[573, 947, 1225, 1453],
62200:[574, 948, 1227, 1456],
62300:[575, 950, 1229, 1458],
62400:[576, 952, 1231, 1461],
62500:[576, 953, 1233, 1463],
62600:[577, 955, 1235, 1466],
62700:[578, 957, 1238, 1468],
62800:[579, 958, 1240, 1470],
62900:[580, 960, 1242, 1473],
63000:[581, 962, 1244, 1475],
63100:[582, 964, 1246, 1477],
63200:[583, 965, 1248, 1480],
63300:[584, 967, 1250, 1482],
63400:[585, 969, 1252, 1485],
63500:[586, 970, 1254, 1487],
63600:[587, 972, 1257, 1490],
63700:[588, 974, 1259, 1492],
63800:[589, 975, 1261, 1494],
63900:[590, 977, 1263, 1497],
64000:[591, 979, 1265, 1499],
64100:[592, 981, 1267, 1501],
64200:[593, 983, 1269, 1504],
64300:[594, 984, 1271, 1506],
64400:[595, 986, 1273, 1509],
64500:[596, 988, 1275, 1511],
64600:[597, 990, 1278, 1513],
64700:[598, 991, 1280, 1516],
64800:[599, 993, 1282, 1518],
64900:[600, 995, 1284, 1521],
65000:[600, 997, 1286, 1523],
65100:[601, 998, 1288, 1525],
65200:[602, 1000, 1290, 1528],
65300:[603, 1001, 1292, 1530],
65400:[604, 1003, 1294, 1533],
65500:[605, 1004, 1296, 1535],
65600:[606, 1006, 1299, 1537],
65700:[606, 1007, 1301, 1540],
65800:[607, 1009, 1303, 1542],
65900:[608, 1010, 1305, 1545],
66000:[609, 1011, 1307, 1547],
66100:[610, 1012, 1309, 1549],
66200:[611, 1014, 1311, 1552],
66300:[612, 1015, 1313, 1554],
66400:[613, 1017, 1315, 1557],
66500:[614, 1018, 1317, 1559],
66600:[615, 1020, 1320, 1562],
66700:[616, 1021, 1322, 1564],
66800:[617, 1023, 1324, 1567],
66900:[618, 1024, 1326, 1569],
67000:[619, 1026, 1328, 1572],
67100:[620, 1027, 1330, 1575],
67200:[621, 1029, 1333, 1577],
67300:[622, 1030, 1335, 1580],
67400:[623, 1032, 1337, 1582],
67500:[624, 1033, 1339, 1585],
67600:[625, 1035, 1342, 1587],
67700:[626, 1036, 1344, 1590],
67800:[627, 1038, 1346, 1592],
67900:[628, 1039, 1348, 1595],
68000:[628, 1041, 1351, 1597],
68100:[629, 1042, 1353, 1600],
68200:[630, 1044, 1355, 1602],
68300:[631, 1045, 1358, 1605],
68400:[632, 1047, 1360, 1607],
68500:[633, 1048, 1362, 1610],
68600:[634, 1050, 1364, 1612],
68700:[635, 1051, 1367, 1615],
68800:[636, 1053, 1369, 1618],
68900:[637, 1054, 1371, 1620],
69000:[638, 1056, 1373, 1623],
69100:[639, 1058, 1375, 1626],
69200:[640, 1059, 1377, 1628],
69300:[641, 1061, 1380, 1631],
69400:[642, 1062, 1382, 1633],
69500:[643, 1064, 1384, 1636],
69600:[644, 1065, 1386, 1638],
69700:[645, 1067, 1389, 1641],
69800:[646, 1068, 1391, 1643],
69900:[647, 1070, 1393, 1646],
70000:[648, 1072, 1395, 1648],
70100:[649, 1074, 1397, 1650],
70200:[650, 1075, 1399, 1653],
70300:[651, 1077, 1402, 1655],
70400:[652, 1078, 1404, 1658],
70500:[653, 1080, 1406, 1660],
70600:[654, 1081, 1408, 1663],
70700:[655, 1083, 1411, 1665],
70800:[656, 1084, 1413, 1668],
70900:[657, 1086, 1415, 1670],
71000:[658, 1087, 1417, 1673],
71100:[659, 1089, 1419, 1676],
71200:[660, 1090, 1421, 1678],
71300:[661, 1092, 1424, 1681],
71400:[662, 1093, 1426, 1683],
71500:[663, 1095, 1428, 1686],
71600:[664, 1096, 1430, 1688],
71700:[665, 1098, 1433, 1691],
71800:[666, 1099, 1435, 1693],
71900:[666, 1101, 1437, 1696],
72000:[667, 1102, 1439, 1699],
72100:[668, 1103, 1441, 1701],
72200:[669, 1105, 1443, 1703],
72300:[670, 1106, 1445, 1706],
72400:[670, 1107, 1447, 1708],
72500:[671, 1108, 1449, 1710],
72600:[672, 1110, 1450, 1712],
72700:[673, 1111, 1452, 1715],
72800:[674, 1112, 1454, 1717],
72900:[675, 1114, 1456, 1719],
73000:[676, 1115, 1458, 1721],
73100:[677, 1116, 1460, 1723],
73200:[678, 1118, 1462, 1726],
73300:[679, 1119, 1464, 1728],
73400:[680, 1121, 1466, 1731],
73500:[681, 1122, 1468, 1733],
73600:[681, 1123, 1470, 1735],
73700:[682, 1125, 1472, 1738],
73800:[683, 1126, 1474, 1740],
73900:[684, 1127, 1477, 1742],
74000:[685, 1129, 1479, 1745],
74100:[686, 1130, 1481, 1748],
74200:[687, 1132, 1483, 1750],
74300:[688, 1133, 1486, 1753],
74400:[689, 1135, 1488, 1755],
74500:[690, 1136, 1490, 1758],
74600:[691, 1138, 1492, 1760],
74700:[692, 1139, 1494, 1763],
74800:[693, 1141, 1497, 1765],
74900:[694, 1142, 1499, 1768],
75000:[695, 1144, 1501, 1770],
75100:[696, 1146, 1503, 1773],
75200:[697, 1147, 1505, 1775],
75300:[698, 1149, 1508, 1778],
75400:[699, 1150, 1510, 1780],
75500:[700, 1152, 1512, 1783],
75600:[701, 1153, 1514, 1786],
75700:[702, 1155, 1516, 1788],
75800:[703, 1157, 1519, 1791],
75900:[703, 1158, 1521, 1793],
76000:[704, 1160, 1523, 1796],
76100:[705, 1162, 1525, 1799],
76200:[706, 1163, 1527, 1801],
76300:[707, 1165, 1529, 1804],
76400:[708, 1166, 1531, 1806],
76500:[709, 1168, 1533, 1809],
76600:[710, 1169, 1535, 1811],
76700:[711, 1171, 1537, 1814],
76800:[712, 1172, 1539, 1816],
76900:[713, 1174, 1541, 1819],
77000:[714, 1175, 1543, 1821],
77100:[715, 1177, 1545, 1824],
77200:[716, 1178, 1547, 1826],
77300:[717, 1180, 1549, 1829],
77400:[718, 1181, 1551, 1831],
77500:[719, 1183, 1553, 1834],
77600:[720, 1184, 1555, 1836],
77700:[721, 1186, 1557, 1839],
77800:[722, 1187, 1559, 1841],
77900:[723, 1189, 1561, 1844],
78000:[724, 1190, 1563, 1846],
78100:[725, 1192, 1565, 1849],
78200:[726, 1193, 1567, 1851],
78300:[727, 1195, 1569, 1854],
78400:[728, 1196, 1571, 1856],
78500:[729, 1198, 1573, 1859],
78600:[730, 1199, 1575, 1861],
78700:[731, 1201, 1576, 1864],
78800:[732, 1202, 1578, 1867],
78900:[733, 1204, 1580, 1869],
79000:[734, 1205, 1582, 1872],
79100:[735, 1206, 1584, 1875],
79200:[736, 1208, 1586, 1877],
79300:[737, 1209, 1588, 1880],
79400:[738, 1211, 1590, 1882],
79500:[739, 1212, 1592, 1885],
79600:[740, 1214, 1594, 1887],
79700:[741, 1215, 1596, 1890],
79800:[741, 1217, 1598, 1892],
79900:[742, 1218, 1600, 1895],
80000:[743, 1220, 1602, 1897],
80100:[744, 1222, 1604, 1900],
80200:[745, 1223, 1606, 1902],
80300:[746, 1225, 1608, 1905],
80400:[747, 1226, 1610, 1907],
80500:[748, 1228, 1612, 1910],
80600:[749, 1229, 1613, 1913],
80700:[750, 1231, 1615, 1915],
80800:[751, 1233, 1617, 1918],
80900:[752, 1234, 1619, 1920],
81000:[753, 1236, 1621, 1923],
81100:[754, 1238, 1623, 1926],
81200:[755, 1239, 1625, 1928],
81300:[756, 1241, 1627, 1931],
81400:[757, 1242, 1629, 1933],
81500:[758, 1244, 1631, 1936],
81600:[759, 1245, 1633, 1938],
81700:[760, 1247, 1635, 1941],
81800:[761, 1248, 1637, 1943],
81900:[762, 1250, 1639, 1946],
82000:[763, 1251, 1641, 1948],
82100:[764, 1253, 1643, 1951],
82200:[765, 1254, 1645, 1953],
82300:[766, 1256, 1647, 1956],
82400:[767, 1257, 1649, 1958],
82500:[768, 1259, 1651, 1961],
82600:[769, 1260, 1652, 1963],
82700:[770, 1262, 1654, 1966],
82800:[771, 1263, 1656, 1968],
82900:[772, 1265, 1658, 1971],
83000:[773, 1266, 1660, 1973],
83100:[774, 1268, 1662, 1976],
83200:[775, 1269, 1664, 1978],
83300:[776, 1271, 1666, 1981],
83400:[777, 1272, 1668, 1983],
83500:[778, 1274, 1670, 1986],
83600:[779, 1275, 1672, 1988],
83700:[780, 1277, 1674, 1991],
83800:[781, 1278, 1676, 1994],
83900:[782, 1280, 1678, 1996],
84000:[783, 1281, 1680, 1999],
84100:[784, 1282, 1682, 2002],
84200:[785, 1284, 1684, 2004],
84300:[786, 1285, 1686, 2007],
84400:[787, 1287, 1688, 2009],
84500:[788, 1288, 1690, 2012],
84600:[789, 1290, 1692, 2014],
84700:[790, 1291, 1694, 2017],
84800:[791, 1293, 1696, 2019],
84900:[792, 1294, 1698, 2022],
85000:[792, 1296, 1700, 2024],
85100:[793, 1298, 1702, 2027],
85200:[794, 1299, 1704, 2029],
85300:[795, 1301, 1706, 2032],
85400:[796, 1302, 1708, 2034],
85500:[797, 1304, 1710, 2037],
85600:[798, 1305, 1712, 2040],
85700:[799, 1307, 1714, 2042],
85800:[800, 1309, 1716, 2045],
85900:[801, 1310, 1717, 2047],
86000:[802, 1312, 1719, 2050],
86100:[803, 1314, 1721, 2053],
86200:[804, 1315, 1723, 2055],
86300:[805, 1317, 1725, 2058],
86400:[806, 1318, 1727, 2060],
86500:[807, 1320, 1729, 2063],
86600:[808, 1321, 1731, 2065],
86700:[809, 1323, 1733, 2068],
86800:[810, 1324, 1735, 2070],
86900:[811, 1326, 1737, 2073],
87000:[812, 1327, 1739, 2075],
87100:[813, 1329, 1741, 2077],
87200:[814, 1330, 1743, 2080],
87300:[815, 1332, 1745, 2082],
87400:[816, 1333, 1747, 2085],
87500:[817, 1335, 1749, 2087],
87600:[818, 1336, 1751, 2089],
87700:[819, 1338, 1753, 2092],
87800:[820, 1339, 1754, 2094],
87900:[821, 1341, 1756, 2097],
88000:[822, 1342, 1758, 2099],
88100:[823, 1344, 1760, 2101],
88200:[824, 1345, 1762, 2104],
88300:[825, 1347, 1764, 2106],
88400:[826, 1348, 1766, 2108],
88500:[827, 1350, 1768, 2111],
88600:[828, 1351, 1770, 2113],
88700:[829, 1353, 1772, 2115],
88800:[829, 1354, 1774, 2118],
88900:[830, 1356, 1776, 2120],
89000:[831, 1357, 1778, 2122],
89100:[832, 1358, 1780, 2124],
89200:[833, 1360, 1782, 2127],
89300:[834, 1361, 1784, 2129],
89400:[835, 1363, 1786, 2131],
89500:[836, 1364, 1788, 2134],
89600:[837, 1366, 1790, 2136],
89700:[838, 1367, 1791, 2138],
89800:[839, 1369, 1793, 2141],
89900:[840, 1370, 1795, 2143],
90000:[841, 1372, 1797, 2145],
90100:[842, 1373, 1799, 2147],
90200:[843, 1375, 1801, 2149],
90300:[844, 1376, 1802, 2152],
90400:[845, 1378, 1804, 2154],
90500:[846, 1379, 1806, 2156],
90600:[847, 1380, 1808, 2158],
90700:[847, 1382, 1810, 2161],
90800:[848, 1383, 1811, 2163],
90900:[849, 1385, 1813, 2165],
91000:[850, 1386, 1815, 2167],
91100:[851, 1387, 1817, 2169],
91200:[852, 1389, 1819, 2171],
91300:[853, 1390, 1821, 2174],
91400:[854, 1392, 1822, 2176],
91500:[855, 1393, 1824, 2178],
91600:[856, 1394, 1826, 2180],
91700:[857, 1396, 1828, 2183],
91800:[857, 1397, 1830, 2185],
91900:[858, 1398, 1832, 2187],
92000:[859, 1400, 1834, 2189],
92100:[860, 1401, 1836, 2191],
92200:[861, 1403, 1838, 2193],
92300:[862, 1404, 1839, 2196],
92400:[862, 1406, 1841, 2198],
92500:[863, 1407, 1843, 2200],
92600:[864, 1409, 1845, 2202],
92700:[865, 1410, 1847, 2205],
92800:[866, 1412, 1848, 2207],
92900:[867, 1413, 1850, 2209],
93000:[867, 1415, 1852, 2211],
93100:[868, 1416, 1854, 2213],
93200:[869, 1418, 1856, 2215],
93300:[870, 1419, 1858, 2218],
93400:[870, 1421, 1859, 2220],
93500:[871, 1422, 1861, 2222],
93600:[872, 1424, 1863, 2224],
93700:[873, 1425, 1865, 2227],
93800:[874, 1426, 1867, 2229],
93900:[875, 1428, 1869, 2231],
94000:[876, 1429, 1871, 2233],
94100:[877, 1430, 1873, 2235],
94200:[878, 1432, 1875, 2237],
94300:[879, 1433, 1877, 2240],
94400:[879, 1435, 1879, 2242],
94500:[880, 1436, 1881, 2244],
94600:[881, 1437, 1882, 2246],
94700:[882, 1439, 1884, 2249],
94800:[883, 1440, 1886, 2251],
94900:[884, 1442, 1888, 2253],
95000:[885, 1443, 1890, 2255],
95100:[886, 1444, 1892, 2257],
95200:[887, 1446, 1894, 2259],
95300:[888, 1447, 1896, 2262],
95400:[889, 1449, 1897, 2264],
95500:[890, 1450, 1899, 2266],
95600:[891, 1452, 1901, 2268],
95700:[892, 1453, 1903, 2271],
95800:[893, 1455, 1905, 2273],
95900:[894, 1456, 1907, 2275],
96000:[895, 1458, 1908, 2277],
96100:[896, 1460, 1910, 2279],
96200:[897, 1461, 1912, 2282],
96300:[898, 1463, 1914, 2284],
96400:[899, 1464, 1915, 2286],
96500:[900, 1466, 1917, 2288],
96600:[901, 1467, 1919, 2291],
96700:[902, 1469, 1921, 2293],
96800:[902, 1470, 1923, 2295],
96900:[903, 1472, 1925, 2298],
97000:[904, 1473, 1927, 2300],
97100:[905, 1474, 1929, 2302],
97200:[906, 1476, 1931, 2304],
97300:[907, 1477, 1933, 2307],
97400:[908, 1479, 1935, 2309],
97500:[909, 1480, 1937, 2311],
97600:[910, 1482, 1939, 2313],
97700:[911, 1483, 1941, 2316],
97800:[912, 1484, 1943, 2318],
97900:[913, 1486, 1945, 2320],
98000:[914, 1487, 1947, 2322],
98100:[915, 1488, 1949, 2324],
98200:[916, 1490, 1951, 2327],
98300:[917, 1491, 1953, 2329],
98400:[918, 1493, 1955, 2331],
98500:[919, 1494, 1957, 2333],
98600:[920, 1496, 1959, 2336],
98700:[921, 1497, 1961, 2338],
98800:[921, 1499, 1963, 2340],
98900:[922, 1500, 1965, 2343],
99000:[923, 1502, 1966, 2345],
99100:[924, 1503, 1968, 2347],
99200:[925, 1505, 1970, 2349],
99300:[926, 1506, 1972, 2351],
99400:[927, 1508, 1973, 2354],
99500:[927, 1509, 1975, 2356],
99600:[928, 1511, 1977, 2358],
99700:[929, 1512, 1979, 2360],
99800:[930, 1514, 1981, 2362],
99900:[931, 1515, 1983, 2364],
};
const OR_ON=[0.76, 1.22, 1.54, 1.86];

// Prince Edward Island — 2025 Federal Child Support Guidelines Table
const T_PE={
100000:[853, 1404, 1844, 2205],
100100:[854, 1405, 1846, 2207],
100200:[855, 1407, 1848, 2209],
100300:[856, 1408, 1849, 2211],
100400:[857, 1409, 1851, 2213],
100500:[857, 1411, 1853, 2215],
100600:[858, 1412, 1855, 2217],
100700:[859, 1413, 1856, 2219],
100800:[860, 1415, 1858, 2221],
100900:[861, 1416, 1860, 2223],
101000:[862, 1417, 1862, 2225],
101100:[863, 1418, 1864, 2227],
101200:[864, 1420, 1865, 2229],
101300:[865, 1421, 1867, 2231],
101400:[866, 1422, 1869, 2233],
101500:[867, 1424, 1871, 2235],
101600:[867, 1425, 1872, 2237],
101700:[868, 1427, 1874, 2239],
101800:[869, 1428, 1876, 2242],
101900:[870, 1429, 1878, 2244],
102000:[871, 1431, 1879, 2246],
102100:[872, 1432, 1881, 2248],
102200:[873, 1434, 1883, 2250],
102300:[874, 1435, 1884, 2252],
102400:[874, 1436, 1886, 2254],
102500:[875, 1438, 1888, 2257],
102600:[876, 1439, 1890, 2259],
102700:[877, 1440, 1891, 2261],
102800:[878, 1441, 1893, 2263],
102900:[879, 1443, 1895, 2265],
103000:[879, 1444, 1897, 2267],
103100:[880, 1445, 1899, 2269],
103200:[881, 1447, 1900, 2271],
103300:[882, 1448, 1902, 2273],
103400:[882, 1449, 1904, 2275],
103500:[883, 1451, 1906, 2277],
103600:[884, 1452, 1907, 2279],
103700:[885, 1453, 1909, 2281],
103800:[886, 1455, 1911, 2283],
103900:[887, 1456, 1913, 2285],
104000:[888, 1458, 1914, 2287],
104100:[889, 1459, 1916, 2289],
104200:[890, 1461, 1917, 2291],
104300:[890, 1462, 1919, 2293],
104400:[891, 1463, 1921, 2295],
104500:[892, 1464, 1922, 2297],
104600:[893, 1466, 1924, 2299],
104700:[894, 1467, 1926, 2301],
104800:[894, 1468, 1928, 2303],
104900:[895, 1470, 1929, 2305],
105000:[896, 1471, 1931, 2307],
105100:[897, 1472, 1933, 2309],
105200:[898, 1474, 1934, 2311],
105300:[898, 1475, 1936, 2313],
105400:[899, 1476, 1938, 2315],
105500:[900, 1478, 1939, 2317],
105600:[901, 1479, 1941, 2319],
105700:[902, 1480, 1942, 2321],
105800:[902, 1481, 1944, 2323],
105900:[903, 1483, 1946, 2325],
106000:[904, 1484, 1947, 2327],
106100:[905, 1485, 1949, 2329],
106200:[906, 1486, 1950, 2331],
106300:[906, 1488, 1952, 2333],
106400:[907, 1489, 1954, 2335],
106500:[908, 1490, 1955, 2337],
106600:[909, 1491, 1957, 2339],
106700:[910, 1493, 1959, 2341],
106800:[910, 1494, 1960, 2343],
106900:[911, 1495, 1962, 2344],
107000:[912, 1496, 1964, 2346],
107100:[913, 1497, 1966, 2348],
107200:[913, 1498, 1967, 2350],
107300:[914, 1500, 1969, 2352],
107400:[915, 1501, 1970, 2353],
107500:[916, 1502, 1972, 2355],
107600:[916, 1503, 1973, 2357],
107700:[917, 1504, 1975, 2359],
107800:[918, 1505, 1976, 2361],
107900:[918, 1507, 1978, 2363],
108000:[919, 1508, 1979, 2365],
108100:[920, 1509, 1980, 2367],
108200:[920, 1510, 1982, 2369],
108300:[921, 1512, 1983, 2370],
108400:[922, 1513, 1985, 2372],
108500:[922, 1514, 1986, 2374],
108600:[923, 1515, 1988, 2376],
108700:[924, 1516, 1989, 2378],
108800:[924, 1517, 1991, 2380],
108900:[925, 1519, 1992, 2381],
109000:[926, 1520, 1994, 2383],
109100:[927, 1521, 1995, 2385],
109200:[928, 1522, 1997, 2386],
109300:[928, 1523, 1998, 2388],
109400:[929, 1525, 2000, 2390],
109500:[930, 1526, 2001, 2392],
109600:[931, 1527, 2003, 2393],
109700:[931, 1528, 2004, 2395],
109800:[932, 1529, 2006, 2397],
109900:[933, 1530, 2007, 2399],
110000:[934, 1531, 2009, 2400],
110100:[935, 1532, 2010, 2402],
110200:[935, 1533, 2012, 2404],
110300:[936, 1535, 2013, 2405],
110400:[937, 1536, 2015, 2407],
110500:[938, 1537, 2016, 2409],
110600:[938, 1538, 2018, 2411],
110700:[939, 1539, 2019, 2412],
110800:[940, 1540, 2021, 2414],
110900:[941, 1542, 2022, 2416],
111000:[941, 1543, 2024, 2418],
111100:[942, 1544, 2026, 2420],
111200:[943, 1545, 2027, 2422],
111300:[943, 1547, 2029, 2424],
111400:[944, 1548, 2030, 2425],
111500:[945, 1549, 2032, 2427],
111600:[946, 1550, 2033, 2429],
111700:[947, 1551, 2035, 2431],
111800:[947, 1553, 2036, 2433],
111900:[948, 1554, 2038, 2435],
112000:[949, 1555, 2040, 2437],
112100:[950, 1556, 2042, 2439],
112200:[950, 1557, 2043, 2441],
112300:[951, 1559, 2045, 2442],
112400:[952, 1560, 2046, 2444],
112500:[953, 1561, 2048, 2446],
112600:[953, 1562, 2049, 2448],
112700:[954, 1563, 2051, 2450],
112800:[955, 1565, 2052, 2452],
112900:[956, 1566, 2054, 2453],
113000:[956, 1567, 2055, 2455],
113100:[957, 1568, 2057, 2457],
113200:[958, 1569, 2058, 2459],
113300:[958, 1571, 2060, 2460],
113400:[959, 1572, 2061, 2462],
113500:[960, 1573, 2063, 2464],
113600:[961, 1574, 2064, 2466],
113700:[961, 1575, 2066, 2468],
113800:[962, 1577, 2067, 2469],
113900:[963, 1578, 2069, 2471],
114000:[964, 1579, 2071, 2473],
114100:[965, 1580, 2073, 2475],
114200:[966, 1581, 2074, 2477],
114300:[966, 1583, 2076, 2479],
114400:[967, 1584, 2077, 2481],
114500:[968, 1585, 2079, 2482],
114600:[969, 1586, 2080, 2484],
114700:[969, 1587, 2082, 2486],
114800:[970, 1589, 2083, 2488],
114900:[971, 1590, 2085, 2490],
115000:[972, 1591, 2086, 2492],
115100:[973, 1592, 2088, 2494],
115200:[974, 1593, 2089, 2496],
115300:[974, 1595, 2091, 2498],
115400:[975, 1596, 2092, 2499],
115500:[976, 1597, 2094, 2501],
115600:[977, 1598, 2095, 2503],
115700:[978, 1599, 2097, 2505],
115800:[978, 1601, 2099, 2507],
115900:[979, 1602, 2100, 2509],
116000:[980, 1603, 2102, 2510],
116100:[981, 1604, 2104, 2512],
116200:[981, 1605, 2105, 2514],
116300:[982, 1607, 2107, 2515],
116400:[983, 1608, 2108, 2517],
116500:[984, 1609, 2110, 2519],
116600:[984, 1610, 2111, 2521],
116700:[985, 1611, 2113, 2523],
116800:[986, 1613, 2114, 2525],
116900:[987, 1614, 2116, 2526],
117000:[987, 1615, 2117, 2528],
117100:[988, 1616, 2119, 2530],
117200:[989, 1617, 2120, 2532],
117300:[989, 1619, 2122, 2533],
117400:[990, 1620, 2123, 2535],
117500:[991, 1621, 2125, 2537],
117600:[992, 1622, 2126, 2539],
117700:[992, 1623, 2128, 2541],
117800:[993, 1625, 2130, 2542],
117900:[994, 1626, 2131, 2544],
118000:[995, 1627, 2133, 2546],
118100:[996, 1628, 2135, 2548],
118200:[997, 1629, 2136, 2550],
118300:[997, 1631, 2138, 2552],
118400:[998, 1632, 2139, 2553],
118500:[999, 1633, 2141, 2555],
118600:[1000, 1634, 2142, 2557],
118700:[1001, 1635, 2144, 2559],
118800:[1001, 1637, 2145, 2561],
118900:[1002, 1638, 2147, 2563],
119000:[1003, 1639, 2148, 2565],
119100:[1004, 1640, 2150, 2567],
119200:[1005, 1641, 2151, 2569],
119300:[1005, 1643, 2153, 2571],
119400:[1006, 1644, 2154, 2572],
119500:[1007, 1645, 2156, 2574],
119600:[1008, 1646, 2158, 2576],
119700:[1009, 1647, 2159, 2578],
119800:[1010, 1649, 2161, 2580],
119900:[1010, 1650, 2162, 2582],
120000:[1011, 1651, 2164, 2583],
120100:[1012, 1652, 2166, 2585],
120200:[1012, 1653, 2167, 2587],
120300:[1013, 1655, 2169, 2588],
120400:[1014, 1656, 2170, 2590],
120500:[1015, 1657, 2172, 2592],
120600:[1015, 1658, 2173, 2594],
120700:[1016, 1659, 2175, 2596],
120800:[1017, 1661, 2176, 2598],
120900:[1018, 1662, 2178, 2599],
121000:[1018, 1663, 2179, 2601],
121100:[1019, 1664, 2180, 2603],
121200:[1020, 1665, 2182, 2605],
121300:[1020, 1667, 2183, 2606],
121400:[1021, 1668, 2185, 2608],
121500:[1022, 1669, 2186, 2610],
121600:[1023, 1670, 2188, 2612],
121700:[1023, 1671, 2189, 2614],
121800:[1024, 1672, 2191, 2615],
121900:[1025, 1674, 2192, 2617],
122000:[1026, 1675, 2194, 2619],
122100:[1027, 1676, 2196, 2621],
122200:[1028, 1677, 2197, 2623],
122300:[1028, 1679, 2199, 2625],
122400:[1029, 1680, 2200, 2626],
122500:[1030, 1681, 2202, 2628],
122600:[1031, 1682, 2203, 2630],
122700:[1032, 1683, 2205, 2632],
122800:[1032, 1684, 2206, 2634],
122900:[1033, 1686, 2208, 2636],
123000:[1034, 1687, 2210, 2638],
123100:[1035, 1688, 2212, 2640],
123200:[1035, 1689, 2213, 2642],
123300:[1036, 1691, 2215, 2644],
123400:[1037, 1692, 2216, 2645],
123500:[1038, 1693, 2218, 2647],
123600:[1038, 1694, 2219, 2649],
123700:[1039, 1695, 2221, 2651],
123800:[1040, 1696, 2222, 2653],
123900:[1041, 1698, 2224, 2655],
124000:[1041, 1699, 2225, 2656],
124100:[1042, 1700, 2227, 2658],
124200:[1043, 1701, 2228, 2660],
124300:[1043, 1703, 2230, 2661],
124400:[1044, 1704, 2231, 2663],
124500:[1045, 1705, 2233, 2665],
124600:[1046, 1706, 2234, 2667],
124700:[1046, 1707, 2236, 2669],
124800:[1047, 1708, 2238, 2671],
124900:[1048, 1710, 2239, 2672],
125000:[1049, 1711, 2241, 2674],
125100:[1050, 1712, 2243, 2676],
125200:[1051, 1713, 2244, 2678],
125300:[1051, 1715, 2246, 2679],
125400:[1052, 1716, 2247, 2681],
125500:[1053, 1717, 2249, 2683],
125600:[1054, 1718, 2250, 2685],
125700:[1054, 1719, 2252, 2687],
125800:[1055, 1720, 2253, 2688],
125900:[1056, 1722, 2255, 2690],
126000:[1057, 1723, 2256, 2692],
126100:[1058, 1724, 2258, 2694],
126200:[1059, 1725, 2259, 2696],
126300:[1059, 1727, 2261, 2698],
126400:[1060, 1728, 2262, 2699],
126500:[1061, 1729, 2264, 2701],
126600:[1062, 1730, 2265, 2703],
126700:[1063, 1731, 2267, 2705],
126800:[1063, 1732, 2269, 2707],
126900:[1064, 1734, 2270, 2709],
127000:[1065, 1735, 2272, 2711],
127100:[1066, 1736, 2274, 2713],
127200:[1066, 1737, 2275, 2715],
127300:[1067, 1739, 2277, 2717],
127400:[1068, 1740, 2278, 2718],
127500:[1069, 1741, 2280, 2720],
127600:[1069, 1742, 2281, 2722],
127700:[1070, 1743, 2283, 2724],
127800:[1071, 1744, 2284, 2726],
127900:[1072, 1746, 2286, 2728],
128000:[1072, 1747, 2287, 2729],
128100:[1073, 1748, 2289, 2731],
128200:[1074, 1749, 2290, 2733],
128300:[1074, 1751, 2292, 2734],
128400:[1075, 1752, 2293, 2736],
128500:[1076, 1753, 2295, 2738],
128600:[1077, 1754, 2296, 2740],
128700:[1077, 1755, 2298, 2742],
128800:[1078, 1756, 2300, 2743],
128900:[1079, 1758, 2301, 2745],
129000:[1080, 1759, 2303, 2747],
129100:[1081, 1760, 2305, 2749],
129200:[1082, 1761, 2306, 2751],
129300:[1082, 1763, 2308, 2752],
129400:[1083, 1764, 2309, 2754],
129500:[1084, 1765, 2311, 2756],
129600:[1085, 1766, 2312, 2758],
129700:[1086, 1767, 2314, 2759],
129800:[1086, 1768, 2315, 2761],
129900:[1087, 1770, 2317, 2763],
130000:[1088, 1771, 2318, 2765],
130100:[1089, 1772, 2320, 2767],
130200:[1090, 1773, 2321, 2769],
130300:[1090, 1775, 2323, 2771],
130400:[1091, 1776, 2324, 2772],
130500:[1092, 1777, 2326, 2774],
130600:[1093, 1778, 2328, 2776],
130700:[1094, 1779, 2329, 2778],
130800:[1095, 1780, 2331, 2780],
130900:[1095, 1782, 2332, 2782],
131000:[1096, 1783, 2334, 2784],
131100:[1097, 1784, 2336, 2786],
131200:[1097, 1785, 2337, 2788],
131300:[1098, 1787, 2339, 2789],
131400:[1099, 1788, 2340, 2791],
131500:[1100, 1789, 2342, 2793],
131600:[1100, 1790, 2343, 2795],
131700:[1101, 1791, 2345, 2797],
131800:[1102, 1792, 2346, 2799],
131900:[1103, 1794, 2348, 2800],
132000:[1103, 1795, 2349, 2802],
132100:[1104, 1796, 2351, 2804],
132200:[1105, 1797, 2352, 2806],
132300:[1105, 1798, 2354, 2807],
132400:[1106, 1800, 2355, 2809],
132500:[1107, 1801, 2357, 2811],
132600:[1108, 1802, 2358, 2813],
132700:[1108, 1803, 2360, 2815],
132800:[1109, 1804, 2361, 2816],
132900:[1110, 1805, 2363, 2818],
133000:[1111, 1807, 2364, 2820],
133100:[1112, 1808, 2366, 2822],
133200:[1113, 1809, 2367, 2824],
133300:[1113, 1810, 2369, 2825],
133400:[1114, 1812, 2370, 2827],
133500:[1115, 1813, 2372, 2829],
133600:[1116, 1814, 2373, 2831],
133700:[1117, 1815, 2375, 2832],
133800:[1117, 1816, 2376, 2834],
133900:[1118, 1817, 2378, 2836],
134000:[1119, 1819, 2380, 2838],
134100:[1120, 1820, 2382, 2840],
134200:[1120, 1821, 2383, 2842],
134300:[1121, 1822, 2385, 2844],
134400:[1122, 1824, 2386, 2845],
134500:[1123, 1825, 2388, 2847],
134600:[1123, 1826, 2389, 2849],
134700:[1124, 1827, 2391, 2851],
134800:[1125, 1828, 2392, 2853],
134900:[1126, 1829, 2394, 2855],
135000:[1126, 1831, 2395, 2857],
135100:[1127, 1832, 2397, 2859],
135200:[1128, 1833, 2398, 2861],
135300:[1128, 1834, 2400, 2862],
135400:[1129, 1836, 2401, 2864],
135500:[1130, 1837, 2403, 2866],
135600:[1131, 1838, 2404, 2868],
135700:[1131, 1839, 2406, 2870],
135800:[1132, 1840, 2408, 2872],
135900:[1133, 1841, 2409, 2873],
136000:[1134, 1843, 2411, 2875],
136100:[1135, 1844, 2413, 2877],
136200:[1136, 1845, 2414, 2879],
136300:[1136, 1846, 2416, 2880],
136400:[1137, 1848, 2417, 2882],
136500:[1138, 1849, 2419, 2884],
136600:[1139, 1850, 2420, 2886],
136700:[1139, 1851, 2422, 2888],
136800:[1140, 1852, 2423, 2889],
136900:[1141, 1853, 2425, 2891],
137000:[1142, 1855, 2426, 2893],
137100:[1143, 1856, 2428, 2895],
137200:[1144, 1857, 2429, 2897],
137300:[1144, 1858, 2431, 2899],
137400:[1145, 1860, 2432, 2900],
137500:[1146, 1861, 2434, 2902],
137600:[1147, 1862, 2435, 2904],
137700:[1148, 1863, 2437, 2906],
137800:[1148, 1864, 2439, 2908],
137900:[1149, 1865, 2440, 2910],
138000:[1150, 1867, 2442, 2912],
138100:[1151, 1868, 2444, 2914],
138200:[1151, 1869, 2445, 2916],
138300:[1152, 1870, 2447, 2918],
138400:[1153, 1872, 2448, 2919],
138500:[1154, 1873, 2450, 2921],
138600:[1154, 1874, 2451, 2923],
138700:[1155, 1875, 2453, 2925],
138800:[1156, 1876, 2454, 2927],
138900:[1157, 1877, 2456, 2929],
139000:[1157, 1879, 2457, 2930],
139100:[1158, 1880, 2459, 2932],
139200:[1159, 1882, 2460, 2934],
139300:[1159, 1883, 2462, 2935],
139400:[1160, 1884, 2463, 2937],
139500:[1161, 1885, 2465, 2939],
139600:[1162, 1887, 2467, 2941],
139700:[1162, 1888, 2468, 2943],
139800:[1163, 1889, 2470, 2945],
139900:[1164, 1890, 2471, 2946],
140000:[1165, 1892, 2473, 2948],
140100:[1166, 1893, 2475, 2950],
140200:[1167, 1894, 2476, 2952],
140300:[1167, 1896, 2478, 2953],
140400:[1168, 1897, 2479, 2955],
140500:[1169, 1898, 2481, 2957],
140600:[1170, 1899, 2482, 2959],
140700:[1171, 1901, 2484, 2961],
140800:[1171, 1902, 2485, 2962],
140900:[1172, 1903, 2487, 2964],
141000:[1173, 1904, 2488, 2966],
141100:[1174, 1905, 2490, 2968],
141200:[1175, 1906, 2491, 2970],
141300:[1175, 1908, 2493, 2972],
141400:[1176, 1909, 2494, 2973],
141500:[1177, 1910, 2496, 2975],
141600:[1178, 1911, 2498, 2977],
141700:[1179, 1913, 2499, 2979],
141800:[1180, 1914, 2501, 2981],
141900:[1180, 1915, 2502, 2983],
142000:[1181, 1916, 2504, 2985],
142100:[1182, 1917, 2506, 2987],
142200:[1182, 1918, 2507, 2989],
142300:[1183, 1920, 2509, 2991],
142400:[1184, 1921, 2510, 2992],
142500:[1185, 1922, 2512, 2994],
142600:[1185, 1923, 2513, 2996],
142700:[1186, 1925, 2515, 2998],
142800:[1187, 1926, 2516, 3000],
142900:[1188, 1927, 2518, 3002],
143000:[1188, 1928, 2519, 3003],
143100:[1189, 1929, 2521, 3005],
143200:[1190, 1930, 2522, 3007],
143300:[1190, 1932, 2524, 3008],
143400:[1191, 1933, 2525, 3010],
143500:[1192, 1934, 2527, 3012],
143600:[1193, 1935, 2528, 3014],
143700:[1193, 1937, 2530, 3016],
143800:[1194, 1938, 2531, 3018],
143900:[1195, 1939, 2533, 3019],
144000:[1196, 1940, 2534, 3021],
144100:[1197, 1941, 2536, 3023],
144200:[1198, 1942, 2537, 3025],
144300:[1198, 1944, 2539, 3026],
144400:[1199, 1945, 2540, 3028],
144500:[1200, 1946, 2542, 3030],
144600:[1201, 1947, 2543, 3032],
144700:[1202, 1949, 2545, 3034],
144800:[1202, 1950, 2546, 3035],
144900:[1203, 1951, 2548, 3037],
145000:[1204, 1952, 2550, 3039],
145100:[1205, 1953, 2552, 3041],
145200:[1205, 1954, 2553, 3043],
145300:[1206, 1956, 2555, 3045],
145400:[1207, 1957, 2556, 3046],
145500:[1208, 1958, 2558, 3048],
145600:[1208, 1959, 2559, 3050],
145700:[1209, 1961, 2561, 3052],
145800:[1210, 1962, 2562, 3054],
145900:[1211, 1963, 2564, 3056],
146000:[1211, 1964, 2565, 3058],
146100:[1212, 1965, 2567, 3060],
146200:[1213, 1966, 2568, 3062],
146300:[1213, 1968, 2570, 3064],
146400:[1214, 1969, 2571, 3065],
146500:[1215, 1970, 2573, 3067],
146600:[1216, 1971, 2574, 3069],
146700:[1216, 1973, 2576, 3071],
146800:[1217, 1974, 2578, 3073],
146900:[1218, 1975, 2579, 3075],
147000:[1219, 1976, 2581, 3076],
147100:[1220, 1977, 2583, 3078],
147200:[1221, 1978, 2584, 3080],
147300:[1221, 1980, 2586, 3081],
147400:[1222, 1981, 2587, 3083],
147500:[1223, 1982, 2589, 3085],
147600:[1224, 1983, 2590, 3087],
147700:[1224, 1985, 2592, 3089],
147800:[1225, 1986, 2593, 3090],
147900:[1226, 1987, 2595, 3092],
148000:[1227, 1988, 2596, 3094],
148100:[1228, 1989, 2598, 3096],
148200:[1229, 1990, 2599, 3098],
148300:[1229, 1992, 2601, 3099],
148400:[1230, 1993, 2602, 3101],
148500:[1231, 1994, 2604, 3103],
148600:[1232, 1995, 2605, 3105],
148700:[1233, 1997, 2607, 3106],
148800:[1233, 1998, 2609, 3108],
148900:[1234, 1999, 2610, 3110],
149000:[1235, 2000, 2612, 3112],
149100:[1236, 2001, 2614, 3114],
149200:[1236, 2002, 2615, 3116],
149300:[1237, 2004, 2617, 3118],
149400:[1238, 2005, 2618, 3119],
149500:[1239, 2006, 2620, 3121],
149600:[1239, 2007, 2621, 3123],
149700:[1240, 2009, 2623, 3125],
149800:[1241, 2010, 2624, 3127],
149900:[1242, 2011, 2626, 3129],
150000:[1242, 2012, 2627, 3131],
16000:[0, 0, 0, 0],
16100:[8, 9, 10, 10],
16200:[17, 18, 19, 21],
16300:[25, 27, 29, 31],
16400:[33, 36, 39, 42],
16500:[42, 45, 49, 52],
16600:[50, 54, 58, 62],
16700:[58, 63, 68, 73],
16800:[66, 72, 78, 83],
16900:[75, 81, 87, 94],
17000:[83, 90, 97, 104],
17100:[84, 94, 102, 109],
17200:[85, 99, 107, 114],
17300:[86, 103, 112, 120],
17400:[88, 108, 117, 125],
17500:[89, 112, 121, 130],
17600:[90, 117, 126, 135],
17700:[91, 121, 131, 140],
17800:[92, 126, 136, 145],
17900:[93, 130, 141, 151],
18000:[95, 135, 146, 156],
18100:[96, 139, 150, 160],
18200:[97, 143, 154, 165],
18300:[98, 147, 158, 169],
18400:[100, 150, 163, 174],
18500:[101, 154, 167, 178],
18600:[102, 158, 171, 183],
18700:[103, 162, 175, 187],
18800:[104, 166, 179, 192],
18900:[105, 170, 183, 196],
19000:[106, 174, 187, 201],
19100:[107, 178, 191, 205],
19200:[108, 182, 195, 210],
19300:[109, 185, 199, 214],
19400:[110, 189, 204, 219],
19500:[112, 193, 208, 223],
19600:[113, 197, 212, 227],
19700:[114, 201, 216, 232],
19800:[115, 204, 220, 236],
19900:[116, 208, 224, 241],
20000:[117, 212, 229, 245],
20100:[118, 216, 233, 249],
20200:[119, 220, 237, 254],
20300:[120, 223, 241, 258],
20400:[121, 227, 246, 263],
20500:[122, 231, 250, 267],
20600:[124, 235, 254, 271],
20700:[125, 238, 258, 276],
20800:[126, 242, 262, 280],
20900:[127, 246, 266, 285],
21000:[128, 250, 270, 289],
21100:[129, 254, 274, 293],
21200:[130, 257, 278, 297],
21300:[131, 261, 282, 301],
21400:[132, 264, 285, 305],
21500:[133, 268, 289, 310],
21600:[134, 271, 293, 314],
21700:[136, 275, 297, 318],
21800:[137, 279, 301, 322],
21900:[138, 282, 305, 326],
22000:[139, 286, 308, 330],
22100:[140, 290, 312, 334],
22200:[141, 293, 316, 338],
22300:[142, 297, 319, 342],
22400:[144, 300, 323, 346],
22500:[145, 304, 327, 351],
22600:[146, 307, 331, 355],
22700:[147, 311, 335, 359],
22800:[148, 314, 339, 363],
22900:[149, 318, 342, 367],
23000:[151, 321, 346, 371],
23100:[152, 325, 350, 375],
23200:[153, 329, 354, 380],
23300:[154, 332, 358, 384],
23400:[156, 336, 362, 388],
23500:[157, 340, 366, 393],
23600:[158, 344, 371, 397],
23700:[159, 347, 375, 401],
23800:[160, 351, 379, 406],
23900:[161, 355, 383, 410],
24000:[162, 359, 387, 414],
24100:[163, 363, 391, 418],
24200:[164, 367, 395, 423],
24300:[165, 370, 399, 427],
24400:[166, 374, 403, 432],
24500:[168, 378, 408, 436],
24600:[169, 382, 412, 441],
24700:[170, 385, 416, 445],
24800:[171, 389, 420, 450],
24900:[172, 393, 424, 454],
25000:[173, 397, 428, 459],
25100:[174, 400, 431, 463],
25200:[175, 403, 435, 466],
25300:[176, 406, 438, 470],
25400:[177, 408, 442, 474],
25500:[178, 411, 445, 477],
25600:[180, 414, 448, 481],
25700:[181, 417, 452, 485],
25800:[182, 420, 455, 488],
25900:[183, 423, 459, 492],
26000:[184, 426, 462, 495],
26100:[185, 426, 465, 498],
26200:[186, 426, 469, 502],
26300:[187, 426, 472, 505],
26400:[189, 426, 475, 509],
26500:[190, 427, 478, 512],
26600:[191, 427, 482, 516],
26700:[192, 427, 485, 519],
26800:[193, 427, 488, 523],
26900:[194, 427, 492, 526],
27000:[196, 427, 495, 530],
27100:[197, 427, 498, 534],
27200:[198, 427, 501, 537],
27300:[199, 427, 505, 541],
27400:[201, 427, 508, 544],
27500:[202, 427, 511, 548],
27600:[203, 427, 514, 551],
27700:[204, 427, 518, 555],
27800:[205, 427, 521, 558],
27900:[206, 427, 524, 562],
28000:[207, 427, 527, 565],
28100:[208, 427, 530, 569],
28200:[208, 427, 534, 573],
28300:[209, 427, 537, 577],
28400:[210, 427, 541, 580],
28500:[211, 427, 544, 584],
28600:[211, 427, 548, 588],
28700:[212, 427, 551, 592],
28800:[213, 427, 555, 596],
28900:[213, 428, 558, 600],
29000:[214, 428, 562, 603],
29100:[215, 428, 566, 607],
29200:[215, 429, 569, 610],
29300:[216, 429, 573, 614],
29400:[216, 430, 576, 618],
29500:[217, 430, 580, 622],
29600:[217, 431, 583, 625],
29700:[218, 431, 587, 629],
29800:[219, 432, 591, 633],
29900:[219, 432, 594, 637],
30000:[220, 433, 598, 640],
30100:[221, 434, 600, 644],
30200:[221, 434, 602, 648],
30300:[222, 435, 604, 652],
30400:[222, 435, 607, 655],
30500:[223, 436, 609, 659],
30600:[223, 437, 611, 663],
30700:[224, 437, 613, 667],
30800:[224, 438, 615, 671],
30900:[225, 439, 617, 675],
31000:[225, 439, 619, 679],
31100:[226, 440, 620, 683],
31200:[226, 441, 621, 687],
31300:[227, 442, 622, 691],
31400:[227, 443, 623, 694],
31500:[228, 444, 624, 698],
31600:[228, 445, 625, 702],
31700:[229, 446, 626, 706],
31800:[229, 448, 627, 710],
31900:[230, 449, 628, 714],
32000:[230, 450, 629, 717],
32100:[230, 451, 630, 721],
32200:[231, 452, 631, 724],
32300:[231, 452, 632, 728],
32400:[231, 453, 632, 731],
32500:[232, 454, 633, 735],
32600:[232, 455, 634, 738],
32700:[233, 456, 635, 742],
32800:[233, 457, 636, 745],
32900:[233, 457, 637, 749],
33000:[234, 458, 638, 752],
33100:[234, 459, 639, 755],
33200:[235, 460, 640, 758],
33300:[235, 461, 642, 762],
33400:[236, 461, 643, 765],
33500:[236, 462, 644, 768],
33600:[236, 463, 645, 771],
33700:[237, 464, 647, 775],
33800:[237, 465, 648, 778],
33900:[237, 466, 649, 781],
34000:[238, 467, 650, 784],
34100:[239, 468, 651, 787],
34200:[239, 469, 653, 790],
34300:[240, 470, 654, 794],
34400:[241, 472, 656, 797],
34500:[241, 473, 657, 800],
34600:[242, 474, 659, 803],
34700:[243, 475, 660, 806],
34800:[244, 476, 662, 809],
34900:[244, 477, 663, 813],
35000:[245, 478, 664, 816],
35100:[246, 480, 666, 818],
35200:[247, 481, 668, 821],
35300:[248, 483, 670, 823],
35400:[249, 484, 672, 825],
35500:[250, 486, 673, 827],
35600:[251, 488, 675, 830],
35700:[252, 489, 677, 832],
35800:[253, 491, 679, 834],
35900:[254, 492, 681, 836],
36000:[255, 494, 683, 839],
36100:[256, 496, 685, 842],
36200:[258, 498, 688, 844],
36300:[259, 500, 690, 847],
36400:[260, 502, 692, 849],
36500:[261, 504, 694, 852],
36600:[263, 506, 697, 854],
36700:[264, 507, 699, 857],
36800:[265, 509, 701, 859],
36900:[267, 511, 703, 862],
37000:[268, 513, 706, 864],
37100:[269, 515, 708, 867],
37200:[271, 517, 711, 869],
37300:[272, 519, 713, 872],
37400:[273, 521, 715, 874],
37500:[275, 523, 717, 877],
37600:[276, 525, 720, 879],
37700:[277, 526, 722, 882],
37800:[279, 528, 724, 885],
37900:[280, 530, 727, 887],
38000:[281, 532, 729, 890],
38100:[282, 534, 731, 893],
38200:[283, 536, 734, 895],
38300:[285, 538, 736, 898],
38400:[286, 540, 738, 900],
38500:[287, 542, 741, 903],
38600:[288, 543, 743, 906],
38700:[290, 545, 745, 908],
38800:[291, 547, 748, 911],
38900:[292, 549, 750, 913],
39000:[293, 551, 752, 916],
39100:[294, 553, 754, 919],
39200:[296, 555, 756, 921],
39300:[297, 557, 759, 924],
39400:[298, 559, 761, 926],
39500:[299, 561, 763, 929],
39600:[301, 562, 765, 932],
39700:[302, 564, 768, 934],
39800:[303, 566, 770, 937],
39900:[304, 568, 772, 940],
40000:[306, 570, 774, 942],
40100:[307, 572, 776, 944],
40200:[309, 574, 778, 947],
40300:[310, 576, 780, 949],
40400:[311, 578, 783, 952],
40500:[312, 579, 785, 954],
40600:[314, 581, 787, 957],
40700:[315, 583, 789, 959],
40800:[316, 585, 791, 962],
40900:[318, 587, 793, 964],
41000:[319, 589, 796, 966],
41100:[320, 591, 798, 968],
41200:[321, 592, 800, 971],
41300:[323, 594, 802, 973],
41400:[324, 596, 805, 976],
41500:[325, 598, 807, 978],
41600:[326, 599, 809, 981],
41700:[328, 601, 811, 983],
41800:[329, 603, 813, 986],
41900:[330, 605, 815, 988],
42000:[331, 606, 818, 991],
42100:[332, 608, 820, 993],
42200:[334, 609, 823, 996],
42300:[335, 611, 825, 998],
42400:[336, 613, 827, 1001],
42500:[338, 615, 829, 1003],
42600:[339, 616, 832, 1006],
42700:[340, 618, 834, 1008],
42800:[342, 620, 836, 1011],
42900:[343, 622, 838, 1013],
43000:[344, 623, 841, 1016],
43100:[345, 625, 843, 1019],
43200:[347, 627, 845, 1021],
43300:[348, 628, 848, 1024],
43400:[349, 630, 850, 1026],
43500:[351, 632, 852, 1029],
43600:[352, 634, 854, 1031],
43700:[353, 636, 857, 1034],
43800:[355, 637, 859, 1037],
43900:[356, 639, 861, 1039],
44000:[357, 641, 863, 1042],
44100:[358, 643, 865, 1045],
44200:[360, 645, 868, 1047],
44300:[361, 646, 870, 1050],
44400:[362, 648, 872, 1052],
44500:[364, 650, 874, 1055],
44600:[365, 652, 877, 1057],
44700:[366, 654, 879, 1060],
44800:[368, 655, 881, 1062],
44900:[369, 657, 884, 1065],
45000:[371, 659, 886, 1067],
45100:[372, 661, 888, 1070],
45200:[374, 663, 890, 1072],
45300:[375, 664, 893, 1075],
45400:[377, 666, 895, 1077],
45500:[378, 668, 897, 1080],
45600:[379, 670, 899, 1082],
45700:[381, 672, 902, 1085],
45800:[382, 674, 904, 1087],
45900:[383, 675, 906, 1090],
46000:[385, 677, 908, 1092],
46100:[386, 679, 910, 1094],
46200:[387, 680, 912, 1097],
46300:[388, 682, 914, 1099],
46400:[389, 683, 916, 1101],
46500:[390, 685, 918, 1104],
46600:[391, 686, 920, 1106],
46700:[392, 688, 922, 1108],
46800:[393, 689, 924, 1110],
46900:[394, 691, 926, 1113],
47000:[395, 692, 928, 1115],
47100:[396, 693, 930, 1117],
47200:[397, 695, 932, 1119],
47300:[398, 696, 933, 1121],
47400:[398, 697, 935, 1123],
47500:[399, 699, 937, 1126],
47600:[400, 700, 939, 1128],
47700:[401, 701, 940, 1130],
47800:[402, 703, 942, 1132],
47900:[403, 704, 944, 1134],
48000:[404, 705, 946, 1136],
48100:[405, 706, 948, 1138],
48200:[406, 708, 949, 1140],
48300:[406, 709, 951, 1143],
48400:[407, 710, 953, 1145],
48500:[408, 712, 955, 1147],
48600:[409, 713, 956, 1149],
48700:[410, 714, 958, 1151],
48800:[410, 715, 960, 1153],
48900:[411, 717, 962, 1156],
49000:[412, 718, 963, 1158],
49100:[413, 719, 965, 1160],
49200:[414, 721, 966, 1162],
49300:[415, 722, 968, 1165],
49400:[415, 724, 970, 1167],
49500:[416, 725, 972, 1169],
49600:[417, 726, 973, 1171],
49700:[418, 728, 975, 1174],
49800:[419, 729, 977, 1176],
49900:[420, 730, 978, 1178],
50000:[421, 732, 980, 1180],
50100:[422, 733, 982, 1182],
50200:[423, 735, 984, 1184],
50300:[424, 736, 985, 1186],
50400:[425, 737, 987, 1189],
50500:[425, 739, 989, 1191],
50600:[426, 740, 991, 1193],
50700:[427, 741, 992, 1195],
50800:[428, 743, 994, 1197],
50900:[429, 744, 996, 1199],
51000:[430, 745, 998, 1201],
51100:[431, 746, 1000, 1203],
51200:[432, 748, 1001, 1205],
51300:[433, 749, 1003, 1207],
51400:[434, 750, 1005, 1210],
51500:[435, 752, 1007, 1212],
51600:[435, 753, 1008, 1214],
51700:[436, 755, 1010, 1216],
51800:[437, 756, 1012, 1218],
51900:[438, 757, 1014, 1220],
52000:[439, 759, 1015, 1223],
52100:[440, 760, 1017, 1225],
52200:[441, 762, 1019, 1227],
52300:[442, 763, 1020, 1230],
52400:[442, 764, 1022, 1232],
52500:[443, 766, 1024, 1234],
52600:[444, 767, 1026, 1236],
52700:[445, 768, 1028, 1238],
52800:[446, 770, 1029, 1241],
52900:[447, 771, 1031, 1243],
53000:[447, 772, 1033, 1245],
53100:[448, 773, 1035, 1247],
53200:[449, 775, 1036, 1249],
53300:[450, 776, 1038, 1251],
53400:[450, 777, 1040, 1253],
53500:[451, 779, 1042, 1255],
53600:[452, 780, 1043, 1258],
53700:[453, 782, 1045, 1260],
53800:[454, 783, 1047, 1262],
53900:[455, 784, 1049, 1264],
54000:[456, 786, 1050, 1266],
54100:[457, 787, 1052, 1268],
54200:[458, 789, 1053, 1270],
54300:[458, 790, 1055, 1272],
54400:[459, 791, 1057, 1274],
54500:[460, 792, 1058, 1276],
54600:[461, 794, 1060, 1278],
54700:[462, 795, 1062, 1280],
54800:[462, 796, 1063, 1282],
54900:[463, 798, 1065, 1284],
55000:[464, 799, 1067, 1286],
55100:[465, 800, 1069, 1288],
55200:[466, 802, 1070, 1290],
55300:[467, 803, 1072, 1292],
55400:[467, 804, 1074, 1294],
55500:[468, 806, 1075, 1296],
55600:[469, 807, 1077, 1298],
55700:[470, 808, 1078, 1300],
55800:[471, 809, 1080, 1301],
55900:[472, 811, 1082, 1303],
56000:[473, 812, 1083, 1305],
56100:[474, 813, 1085, 1307],
56200:[475, 814, 1086, 1309],
56300:[476, 816, 1088, 1311],
56400:[476, 817, 1089, 1313],
56500:[477, 818, 1091, 1314],
56600:[478, 819, 1093, 1316],
56700:[479, 821, 1094, 1318],
56800:[480, 822, 1096, 1320],
56900:[481, 823, 1097, 1322],
57000:[481, 824, 1099, 1324],
57100:[482, 825, 1101, 1326],
57200:[483, 827, 1102, 1328],
57300:[483, 828, 1104, 1330],
57400:[484, 829, 1106, 1332],
57500:[485, 830, 1107, 1334],
57600:[486, 832, 1109, 1336],
57700:[487, 833, 1111, 1338],
57800:[488, 834, 1112, 1340],
57900:[488, 835, 1114, 1342],
58000:[489, 837, 1116, 1344],
58100:[490, 838, 1118, 1346],
58200:[491, 840, 1119, 1348],
58300:[491, 841, 1121, 1350],
58400:[492, 842, 1123, 1352],
58500:[493, 843, 1125, 1354],
58600:[494, 845, 1126, 1356],
58700:[495, 846, 1128, 1358],
58800:[495, 847, 1130, 1360],
58900:[496, 848, 1131, 1362],
59000:[497, 850, 1133, 1364],
59100:[498, 851, 1135, 1366],
59200:[499, 853, 1136, 1368],
59300:[500, 854, 1138, 1370],
59400:[500, 855, 1140, 1372],
59500:[501, 856, 1142, 1374],
59600:[502, 858, 1143, 1376],
59700:[503, 859, 1145, 1378],
59800:[504, 860, 1147, 1380],
59900:[505, 862, 1149, 1382],
60000:[506, 863, 1150, 1384],
60100:[507, 864, 1152, 1386],
60200:[508, 866, 1153, 1388],
60300:[508, 867, 1155, 1390],
60400:[509, 868, 1157, 1392],
60500:[510, 870, 1158, 1394],
60600:[511, 871, 1160, 1396],
60700:[512, 873, 1162, 1398],
60800:[513, 874, 1163, 1400],
60900:[513, 875, 1165, 1402],
61000:[514, 877, 1166, 1404],
61100:[515, 878, 1168, 1406],
61200:[516, 880, 1170, 1408],
61300:[517, 881, 1171, 1410],
61400:[517, 882, 1173, 1412],
61500:[518, 884, 1175, 1414],
61600:[519, 885, 1177, 1416],
61700:[520, 886, 1178, 1418],
61800:[521, 888, 1180, 1420],
61900:[522, 889, 1182, 1422],
62000:[523, 890, 1184, 1424],
62100:[524, 891, 1186, 1426],
62200:[525, 893, 1187, 1428],
62300:[525, 894, 1189, 1430],
62400:[526, 895, 1191, 1432],
62500:[527, 897, 1193, 1434],
62600:[528, 898, 1194, 1436],
62700:[529, 899, 1196, 1438],
62800:[530, 900, 1198, 1440],
62900:[530, 902, 1200, 1442],
63000:[531, 903, 1201, 1444],
63100:[532, 904, 1203, 1446],
63200:[533, 906, 1204, 1448],
63300:[534, 907, 1206, 1450],
63400:[534, 908, 1208, 1452],
63500:[535, 910, 1210, 1454],
63600:[536, 911, 1211, 1456],
63700:[537, 913, 1213, 1458],
63800:[538, 914, 1215, 1460],
63900:[539, 915, 1216, 1463],
64000:[540, 917, 1218, 1465],
64100:[541, 918, 1220, 1467],
64200:[542, 920, 1221, 1469],
64300:[543, 921, 1223, 1471],
64400:[544, 922, 1225, 1473],
64500:[544, 924, 1226, 1475],
64600:[545, 925, 1228, 1477],
64700:[546, 926, 1230, 1479],
64800:[547, 928, 1231, 1481],
64900:[548, 929, 1233, 1483],
65000:[549, 930, 1235, 1485],
65100:[550, 931, 1237, 1487],
65200:[551, 933, 1238, 1489],
65300:[552, 934, 1240, 1491],
65400:[552, 935, 1242, 1493],
65500:[553, 936, 1243, 1495],
65600:[554, 938, 1245, 1496],
65700:[555, 939, 1247, 1498],
65800:[556, 940, 1248, 1500],
65900:[557, 942, 1250, 1502],
66000:[557, 943, 1252, 1504],
66100:[558, 944, 1254, 1506],
66200:[559, 946, 1255, 1508],
66300:[559, 947, 1257, 1510],
66400:[560, 948, 1259, 1512],
66500:[561, 950, 1261, 1514],
66600:[562, 951, 1262, 1516],
66700:[563, 952, 1264, 1518],
66800:[563, 953, 1266, 1520],
66900:[564, 955, 1268, 1522],
67000:[565, 956, 1269, 1524],
67100:[566, 957, 1271, 1526],
67200:[567, 959, 1272, 1528],
67300:[568, 960, 1274, 1530],
67400:[568, 962, 1276, 1532],
67500:[569, 963, 1278, 1534],
67600:[570, 964, 1279, 1536],
67700:[571, 966, 1281, 1538],
67800:[572, 967, 1283, 1540],
67900:[573, 969, 1285, 1543],
68000:[574, 970, 1286, 1545],
68100:[575, 971, 1288, 1547],
68200:[576, 973, 1290, 1549],
68300:[577, 974, 1291, 1551],
68400:[578, 975, 1293, 1553],
68500:[578, 977, 1295, 1556],
68600:[579, 978, 1297, 1558],
68700:[580, 979, 1299, 1560],
68800:[581, 981, 1300, 1562],
68900:[582, 982, 1302, 1564],
69000:[583, 983, 1304, 1566],
69100:[584, 984, 1306, 1568],
69200:[585, 986, 1307, 1570],
69300:[585, 987, 1309, 1572],
69400:[586, 989, 1311, 1574],
69500:[587, 990, 1313, 1576],
69600:[588, 991, 1314, 1578],
69700:[589, 993, 1316, 1580],
69800:[590, 994, 1318, 1582],
69900:[590, 995, 1320, 1584],
70000:[591, 997, 1321, 1586],
70100:[592, 998, 1323, 1588],
70200:[593, 1000, 1324, 1590],
70300:[594, 1001, 1326, 1592],
70400:[594, 1002, 1328, 1594],
70500:[595, 1004, 1330, 1596],
70600:[596, 1005, 1331, 1598],
70700:[597, 1006, 1333, 1601],
70800:[598, 1008, 1335, 1603],
70900:[599, 1009, 1336, 1605],
71000:[600, 1010, 1338, 1607],
71100:[601, 1011, 1340, 1609],
71200:[602, 1013, 1342, 1611],
71300:[603, 1014, 1343, 1613],
71400:[604, 1015, 1345, 1615],
71500:[604, 1017, 1347, 1617],
71600:[605, 1018, 1349, 1619],
71700:[606, 1020, 1350, 1621],
71800:[607, 1021, 1352, 1623],
71900:[608, 1022, 1354, 1625],
72000:[609, 1024, 1356, 1627],
72100:[610, 1025, 1358, 1629],
72200:[611, 1027, 1359, 1631],
72300:[612, 1028, 1361, 1633],
72400:[613, 1029, 1363, 1635],
72500:[614, 1031, 1365, 1637],
72600:[614, 1032, 1366, 1639],
72700:[615, 1033, 1368, 1641],
72800:[616, 1034, 1370, 1643],
72900:[617, 1036, 1371, 1645],
73000:[618, 1037, 1373, 1648],
73100:[619, 1038, 1375, 1650],
73200:[620, 1040, 1377, 1652],
73300:[621, 1041, 1378, 1654],
73400:[621, 1042, 1380, 1656],
73500:[622, 1044, 1382, 1658],
73600:[623, 1045, 1384, 1661],
73700:[624, 1046, 1385, 1663],
73800:[625, 1048, 1387, 1665],
73900:[626, 1049, 1389, 1667],
74000:[626, 1051, 1391, 1669],
74100:[627, 1052, 1393, 1671],
74200:[628, 1054, 1394, 1673],
74300:[629, 1055, 1396, 1675],
74400:[629, 1057, 1398, 1677],
74500:[630, 1058, 1400, 1679],
74600:[631, 1059, 1401, 1681],
74700:[632, 1061, 1403, 1683],
74800:[633, 1062, 1405, 1685],
74900:[634, 1064, 1407, 1687],
75000:[635, 1065, 1408, 1689],
75100:[636, 1066, 1410, 1691],
75200:[637, 1068, 1412, 1693],
75300:[638, 1069, 1413, 1695],
75400:[639, 1070, 1415, 1697],
75500:[639, 1072, 1417, 1699],
75600:[640, 1073, 1419, 1701],
75700:[641, 1074, 1420, 1703],
75800:[642, 1076, 1422, 1706],
75900:[643, 1077, 1424, 1708],
76000:[644, 1078, 1426, 1710],
76100:[645, 1079, 1428, 1712],
76200:[646, 1081, 1429, 1714],
76300:[647, 1082, 1431, 1716],
76400:[648, 1084, 1433, 1718],
76500:[649, 1085, 1435, 1721],
76600:[650, 1086, 1436, 1723],
76700:[650, 1088, 1438, 1725],
76800:[651, 1089, 1440, 1727],
76900:[652, 1090, 1442, 1729],
77000:[653, 1092, 1443, 1731],
77100:[654, 1093, 1445, 1733],
77200:[655, 1095, 1447, 1735],
77300:[656, 1096, 1448, 1737],
77400:[656, 1097, 1450, 1739],
77500:[657, 1099, 1452, 1741],
77600:[658, 1100, 1454, 1743],
77700:[659, 1101, 1456, 1745],
77800:[660, 1103, 1457, 1747],
77900:[661, 1104, 1459, 1749],
78000:[661, 1105, 1461, 1751],
78100:[662, 1106, 1463, 1753],
78200:[663, 1108, 1464, 1755],
78300:[664, 1109, 1466, 1757],
78400:[664, 1110, 1468, 1759],
78500:[665, 1112, 1470, 1761],
78600:[666, 1113, 1471, 1764],
78700:[667, 1115, 1473, 1766],
78800:[668, 1116, 1475, 1768],
78900:[669, 1117, 1477, 1770],
79000:[670, 1119, 1478, 1772],
79100:[671, 1120, 1480, 1774],
79200:[672, 1122, 1481, 1776],
79300:[673, 1123, 1483, 1778],
79400:[674, 1124, 1485, 1780],
79500:[675, 1126, 1487, 1782],
79600:[675, 1127, 1488, 1784],
79700:[676, 1128, 1490, 1786],
79800:[677, 1130, 1492, 1788],
79900:[678, 1131, 1493, 1790],
80000:[679, 1132, 1495, 1792],
80100:[680, 1133, 1497, 1794],
80200:[681, 1135, 1499, 1796],
80300:[681, 1136, 1500, 1798],
80400:[682, 1137, 1502, 1800],
80500:[683, 1139, 1504, 1802],
80600:[684, 1140, 1506, 1804],
80700:[685, 1141, 1507, 1806],
80800:[686, 1143, 1509, 1808],
80900:[686, 1144, 1511, 1811],
81000:[687, 1146, 1513, 1813],
81100:[688, 1147, 1515, 1815],
81200:[689, 1149, 1516, 1817],
81300:[690, 1150, 1518, 1819],
81400:[690, 1152, 1520, 1821],
81500:[691, 1153, 1522, 1823],
81600:[692, 1154, 1523, 1826],
81700:[693, 1156, 1525, 1828],
81800:[694, 1157, 1527, 1830],
81900:[695, 1159, 1528, 1832],
82000:[696, 1160, 1530, 1834],
82100:[697, 1161, 1532, 1836],
82200:[698, 1163, 1534, 1838],
82300:[699, 1164, 1535, 1840],
82400:[700, 1165, 1537, 1842],
82500:[700, 1167, 1539, 1844],
82600:[701, 1168, 1541, 1846],
82700:[702, 1169, 1542, 1848],
82800:[703, 1171, 1544, 1850],
82900:[704, 1172, 1546, 1852],
83000:[705, 1173, 1548, 1854],
83100:[706, 1174, 1550, 1856],
83200:[707, 1176, 1551, 1858],
83300:[708, 1177, 1553, 1860],
83400:[709, 1179, 1555, 1862],
83500:[710, 1180, 1557, 1864],
83600:[710, 1181, 1558, 1866],
83700:[711, 1183, 1560, 1869],
83800:[712, 1184, 1562, 1871],
83900:[713, 1185, 1564, 1873],
84000:[714, 1187, 1565, 1875],
84100:[715, 1188, 1567, 1877],
84200:[716, 1190, 1569, 1879],
84300:[717, 1191, 1570, 1881],
84400:[717, 1192, 1572, 1883],
84500:[718, 1194, 1574, 1885],
84600:[719, 1195, 1576, 1887],
84700:[720, 1196, 1577, 1889],
84800:[721, 1198, 1579, 1891],
84900:[722, 1199, 1581, 1893],
85000:[722, 1200, 1583, 1895],
85100:[723, 1201, 1585, 1897],
85200:[724, 1203, 1586, 1899],
85300:[725, 1204, 1588, 1901],
85400:[725, 1205, 1590, 1903],
85500:[726, 1207, 1592, 1905],
85600:[727, 1208, 1593, 1907],
85700:[728, 1210, 1595, 1909],
85800:[729, 1211, 1597, 1911],
85900:[730, 1212, 1599, 1913],
86000:[731, 1214, 1600, 1916],
86100:[732, 1215, 1602, 1918],
86200:[733, 1217, 1604, 1920],
86300:[734, 1218, 1605, 1922],
86400:[735, 1219, 1607, 1924],
86500:[735, 1221, 1609, 1926],
86600:[736, 1222, 1611, 1929],
86700:[737, 1223, 1613, 1931],
86800:[738, 1225, 1614, 1933],
86900:[739, 1226, 1616, 1935],
87000:[740, 1227, 1618, 1937],
87100:[741, 1228, 1620, 1939],
87200:[742, 1230, 1621, 1941],
87300:[742, 1231, 1623, 1943],
87400:[743, 1232, 1625, 1945],
87500:[744, 1234, 1627, 1947],
87600:[745, 1235, 1628, 1949],
87700:[746, 1237, 1630, 1951],
87800:[747, 1238, 1632, 1953],
87900:[747, 1239, 1634, 1955],
88000:[748, 1241, 1635, 1957],
88100:[749, 1242, 1637, 1959],
88200:[750, 1244, 1638, 1961],
88300:[751, 1245, 1640, 1963],
88400:[751, 1247, 1642, 1965],
88500:[752, 1248, 1644, 1967],
88600:[753, 1249, 1645, 1969],
88700:[754, 1251, 1647, 1971],
88800:[755, 1252, 1649, 1974],
88900:[756, 1254, 1650, 1976],
89000:[757, 1255, 1652, 1978],
89100:[758, 1256, 1654, 1980],
89200:[759, 1258, 1656, 1982],
89300:[760, 1259, 1657, 1984],
89400:[761, 1260, 1659, 1986],
89500:[761, 1262, 1661, 1989],
89600:[762, 1263, 1663, 1991],
89700:[763, 1264, 1664, 1993],
89800:[764, 1266, 1666, 1995],
89900:[765, 1267, 1668, 1997],
90000:[766, 1268, 1670, 1999],
90100:[767, 1269, 1672, 2001],
90200:[768, 1271, 1673, 2003],
90300:[769, 1272, 1675, 2005],
90400:[770, 1274, 1677, 2007],
90500:[771, 1275, 1679, 2009],
90600:[771, 1276, 1680, 2011],
90700:[772, 1278, 1682, 2013],
90800:[773, 1279, 1684, 2015],
90900:[774, 1280, 1685, 2017],
91000:[775, 1282, 1687, 2019],
91100:[776, 1283, 1689, 2021],
91200:[777, 1285, 1691, 2023],
91300:[778, 1286, 1692, 2025],
91400:[778, 1287, 1694, 2027],
91500:[779, 1289, 1696, 2029],
91600:[780, 1290, 1698, 2032],
91700:[781, 1291, 1699, 2034],
91800:[782, 1293, 1701, 2036],
91900:[783, 1294, 1703, 2038],
92000:[783, 1295, 1705, 2040],
92100:[784, 1296, 1707, 2042],
92200:[785, 1298, 1708, 2044],
92300:[786, 1299, 1710, 2046],
92400:[786, 1300, 1712, 2048],
92500:[787, 1302, 1714, 2050],
92600:[788, 1303, 1715, 2052],
92700:[789, 1305, 1717, 2054],
92800:[790, 1306, 1719, 2056],
92900:[791, 1307, 1721, 2058],
93000:[792, 1309, 1722, 2060],
93100:[793, 1310, 1724, 2062],
93200:[794, 1312, 1726, 2064],
93300:[795, 1313, 1727, 2066],
93400:[796, 1314, 1729, 2068],
93500:[796, 1316, 1731, 2070],
93600:[797, 1317, 1733, 2072],
93700:[798, 1318, 1734, 2074],
93800:[799, 1320, 1736, 2076],
93900:[800, 1321, 1738, 2079],
94000:[801, 1322, 1740, 2081],
94100:[802, 1323, 1742, 2083],
94200:[803, 1325, 1743, 2085],
94300:[804, 1326, 1745, 2087],
94400:[805, 1327, 1747, 2089],
94500:[806, 1329, 1749, 2091],
94600:[807, 1330, 1750, 2094],
94700:[807, 1332, 1752, 2096],
94800:[808, 1333, 1754, 2098],
94900:[809, 1334, 1756, 2100],
95000:[810, 1336, 1757, 2102],
95100:[811, 1337, 1759, 2104],
95200:[812, 1339, 1761, 2106],
95300:[813, 1340, 1762, 2108],
95400:[813, 1342, 1764, 2110],
95500:[814, 1343, 1766, 2112],
95600:[815, 1344, 1768, 2114],
95700:[816, 1346, 1770, 2116],
95800:[817, 1347, 1771, 2118],
95900:[818, 1349, 1773, 2120],
96000:[818, 1350, 1775, 2122],
96100:[819, 1351, 1777, 2124],
96200:[820, 1353, 1778, 2126],
96300:[821, 1354, 1780, 2128],
96400:[821, 1355, 1782, 2130],
96500:[822, 1357, 1784, 2132],
96600:[823, 1358, 1785, 2134],
96700:[824, 1359, 1787, 2137],
96800:[825, 1361, 1789, 2139],
96900:[826, 1362, 1791, 2141],
97000:[827, 1363, 1792, 2143],
97100:[828, 1364, 1794, 2145],
97200:[829, 1366, 1795, 2147],
97300:[830, 1367, 1797, 2149],
97400:[831, 1369, 1799, 2151],
97500:[832, 1370, 1801, 2153],
97600:[832, 1371, 1802, 2155],
97700:[833, 1373, 1804, 2157],
97800:[834, 1374, 1806, 2159],
97900:[835, 1376, 1807, 2161],
98000:[836, 1377, 1809, 2163],
98100:[837, 1378, 1811, 2165],
98200:[838, 1380, 1813, 2167],
98300:[838, 1381, 1814, 2169],
98400:[839, 1382, 1816, 2171],
98500:[840, 1384, 1818, 2173],
98600:[841, 1385, 1820, 2175],
98700:[842, 1386, 1821, 2177],
98800:[843, 1388, 1823, 2179],
98900:[843, 1389, 1825, 2181],
99000:[844, 1390, 1827, 2184],
99100:[845, 1391, 1829, 2186],
99200:[846, 1393, 1830, 2188],
99300:[847, 1394, 1832, 2190],
99400:[847, 1396, 1834, 2192],
99500:[848, 1397, 1836, 2194],
99600:[849, 1398, 1837, 2197],
99700:[850, 1400, 1839, 2199],
99800:[851, 1401, 1841, 2201],
99900:[852, 1402, 1842, 2203],
};
const OR_PE=[0.74, 1.24, 1.54, 1.86];

// Saskatchewan — 2025 Federal Child Support Guidelines Table
const T_SK={
100000:[863, 1415, 1857, 2219],
100100:[864, 1416, 1859, 2221],
100200:[865, 1418, 1861, 2223],
100300:[866, 1419, 1863, 2226],
100400:[867, 1421, 1864, 2228],
100500:[868, 1422, 1866, 2230],
100600:[869, 1424, 1868, 2232],
100700:[870, 1425, 1870, 2234],
100800:[870, 1427, 1872, 2237],
100900:[871, 1428, 1874, 2239],
101000:[872, 1430, 1876, 2241],
101100:[873, 1431, 1878, 2243],
101200:[874, 1433, 1880, 2245],
101300:[875, 1434, 1881, 2248],
101400:[876, 1436, 1883, 2250],
101500:[877, 1437, 1885, 2252],
101600:[877, 1439, 1887, 2254],
101700:[878, 1440, 1889, 2256],
101800:[879, 1441, 1890, 2259],
101900:[880, 1443, 1892, 2261],
102000:[881, 1444, 1894, 2263],
102100:[882, 1445, 1896, 2265],
102200:[883, 1447, 1898, 2267],
102300:[884, 1448, 1900, 2270],
102400:[885, 1450, 1901, 2272],
102500:[886, 1451, 1903, 2274],
102600:[887, 1453, 1905, 2276],
102700:[888, 1454, 1907, 2278],
102800:[889, 1456, 1909, 2281],
102900:[890, 1457, 1911, 2283],
103000:[891, 1459, 1913, 2285],
103100:[892, 1460, 1915, 2287],
103200:[893, 1462, 1917, 2289],
103300:[894, 1463, 1919, 2292],
103400:[895, 1465, 1921, 2294],
103500:[896, 1466, 1922, 2296],
103600:[897, 1468, 1924, 2298],
103700:[898, 1469, 1926, 2300],
103800:[899, 1470, 1928, 2303],
103900:[899, 1472, 1930, 2305],
104000:[900, 1473, 1932, 2307],
104100:[901, 1474, 1934, 2309],
104200:[902, 1476, 1936, 2311],
104300:[903, 1477, 1937, 2314],
104400:[904, 1479, 1939, 2316],
104500:[905, 1480, 1941, 2318],
104600:[905, 1482, 1943, 2320],
104700:[906, 1483, 1945, 2322],
104800:[907, 1485, 1947, 2325],
104900:[908, 1486, 1948, 2327],
105000:[909, 1488, 1950, 2329],
105100:[910, 1489, 1952, 2331],
105200:[911, 1491, 1954, 2333],
105300:[912, 1492, 1956, 2336],
105400:[913, 1494, 1957, 2338],
105500:[914, 1495, 1959, 2340],
105600:[915, 1497, 1961, 2342],
105700:[916, 1498, 1963, 2344],
105800:[917, 1500, 1965, 2347],
105900:[918, 1501, 1967, 2349],
106000:[919, 1502, 1969, 2351],
106100:[920, 1503, 1971, 2353],
106200:[921, 1505, 1973, 2355],
106300:[922, 1506, 1975, 2358],
106400:[923, 1508, 1977, 2360],
106500:[924, 1509, 1979, 2362],
106600:[925, 1511, 1980, 2364],
106700:[926, 1512, 1982, 2366],
106800:[927, 1514, 1984, 2369],
106900:[928, 1515, 1986, 2371],
107000:[928, 1517, 1988, 2373],
107100:[929, 1518, 1990, 2375],
107200:[930, 1520, 1991, 2377],
107300:[931, 1521, 1993, 2379],
107400:[932, 1522, 1995, 2381],
107500:[933, 1524, 1997, 2384],
107600:[934, 1525, 1998, 2386],
107700:[934, 1526, 2000, 2388],
107800:[935, 1528, 2002, 2390],
107900:[936, 1529, 2004, 2392],
108000:[937, 1530, 2005, 2394],
108100:[938, 1531, 2007, 2396],
108200:[939, 1533, 2008, 2398],
108300:[940, 1534, 2010, 2400],
108400:[940, 1535, 2012, 2402],
108500:[941, 1537, 2013, 2404],
108600:[942, 1538, 2015, 2406],
108700:[943, 1540, 2017, 2408],
108800:[944, 1541, 2018, 2410],
108900:[945, 1542, 2020, 2412],
109000:[945, 1544, 2022, 2414],
109100:[946, 1545, 2024, 2416],
109200:[947, 1547, 2025, 2418],
109300:[948, 1548, 2027, 2420],
109400:[949, 1549, 2029, 2422],
109500:[949, 1551, 2030, 2424],
109600:[950, 1552, 2032, 2426],
109700:[951, 1553, 2034, 2428],
109800:[952, 1555, 2035, 2430],
109900:[953, 1556, 2037, 2432],
110000:[954, 1557, 2039, 2434],
110100:[955, 1558, 2041, 2436],
110200:[956, 1560, 2042, 2438],
110300:[956, 1561, 2044, 2440],
110400:[957, 1562, 2046, 2442],
110500:[958, 1564, 2047, 2444],
110600:[959, 1565, 2049, 2446],
110700:[960, 1566, 2051, 2448],
110800:[961, 1568, 2052, 2450],
110900:[961, 1569, 2054, 2452],
111000:[962, 1570, 2056, 2454],
111100:[963, 1571, 2058, 2456],
111200:[964, 1573, 2059, 2458],
111300:[965, 1574, 2061, 2460],
111400:[966, 1575, 2063, 2462],
111500:[966, 1576, 2064, 2464],
111600:[967, 1578, 2066, 2466],
111700:[968, 1579, 2068, 2468],
111800:[969, 1580, 2069, 2470],
111900:[970, 1582, 2071, 2472],
112000:[971, 1583, 2073, 2474],
112100:[972, 1584, 2075, 2476],
112200:[973, 1586, 2077, 2478],
112300:[973, 1587, 2078, 2480],
112400:[974, 1588, 2080, 2482],
112500:[975, 1590, 2082, 2484],
112600:[976, 1591, 2084, 2486],
112700:[977, 1593, 2085, 2488],
112800:[978, 1594, 2087, 2490],
112900:[978, 1595, 2089, 2492],
113000:[979, 1597, 2091, 2495],
113100:[980, 1598, 2093, 2497],
113200:[981, 1600, 2094, 2499],
113300:[982, 1601, 2096, 2501],
113400:[982, 1602, 2098, 2503],
113500:[983, 1604, 2100, 2505],
113600:[984, 1605, 2101, 2507],
113700:[985, 1606, 2103, 2509],
113800:[986, 1608, 2105, 2511],
113900:[987, 1609, 2107, 2513],
114000:[988, 1610, 2108, 2515],
114100:[989, 1611, 2110, 2517],
114200:[990, 1613, 2111, 2519],
114300:[990, 1614, 2113, 2521],
114400:[991, 1615, 2115, 2523],
114500:[992, 1617, 2117, 2525],
114600:[993, 1618, 2118, 2527],
114700:[994, 1619, 2120, 2529],
114800:[995, 1620, 2122, 2531],
114900:[995, 1622, 2124, 2533],
115000:[996, 1623, 2125, 2535],
115100:[997, 1624, 2127, 2537],
115200:[998, 1626, 2128, 2539],
115300:[999, 1627, 2130, 2541],
115400:[999, 1628, 2132, 2543],
115500:[1000, 1630, 2134, 2545],
115600:[1001, 1631, 2135, 2547],
115700:[1002, 1633, 2137, 2549],
115800:[1003, 1634, 2139, 2551],
115900:[1004, 1635, 2141, 2553],
116000:[1005, 1637, 2142, 2555],
116100:[1006, 1638, 2144, 2557],
116200:[1007, 1640, 2145, 2559],
116300:[1007, 1641, 2147, 2561],
116400:[1008, 1642, 2149, 2563],
116500:[1009, 1644, 2151, 2565],
116600:[1010, 1645, 2152, 2567],
116700:[1011, 1646, 2154, 2569],
116800:[1011, 1648, 2156, 2571],
116900:[1012, 1649, 2157, 2573],
117000:[1013, 1650, 2159, 2575],
117100:[1014, 1651, 2161, 2577],
117200:[1015, 1653, 2162, 2579],
117300:[1016, 1654, 2164, 2581],
117400:[1016, 1655, 2166, 2583],
117500:[1017, 1657, 2168, 2585],
117600:[1018, 1658, 2169, 2587],
117700:[1019, 1659, 2171, 2589],
117800:[1020, 1661, 2173, 2591],
117900:[1021, 1662, 2174, 2594],
118000:[1022, 1663, 2176, 2596],
118100:[1023, 1664, 2178, 2598],
118200:[1024, 1666, 2179, 2600],
118300:[1025, 1667, 2181, 2602],
118400:[1026, 1668, 2183, 2604],
118500:[1026, 1669, 2185, 2606],
118600:[1027, 1671, 2186, 2608],
118700:[1028, 1672, 2188, 2610],
118800:[1029, 1673, 2190, 2612],
118900:[1030, 1675, 2191, 2614],
119000:[1031, 1676, 2193, 2616],
119100:[1032, 1677, 2195, 2618],
119200:[1033, 1679, 2196, 2620],
119300:[1034, 1680, 2198, 2622],
119400:[1034, 1681, 2200, 2624],
119500:[1035, 1683, 2201, 2626],
119600:[1036, 1684, 2203, 2628],
119700:[1037, 1686, 2205, 2630],
119800:[1038, 1687, 2207, 2632],
119900:[1039, 1688, 2208, 2634],
120000:[1039, 1690, 2210, 2636],
120100:[1040, 1691, 2212, 2638],
120200:[1041, 1693, 2213, 2640],
120300:[1042, 1694, 2215, 2642],
120400:[1043, 1695, 2217, 2644],
120500:[1043, 1697, 2218, 2646],
120600:[1044, 1698, 2220, 2648],
120700:[1045, 1699, 2222, 2650],
120800:[1046, 1701, 2223, 2652],
120900:[1047, 1702, 2225, 2654],
121000:[1048, 1703, 2227, 2656],
121100:[1049, 1704, 2229, 2658],
121200:[1050, 1706, 2230, 2660],
121300:[1051, 1707, 2232, 2662],
121400:[1051, 1708, 2234, 2664],
121500:[1052, 1710, 2235, 2666],
121600:[1053, 1711, 2237, 2668],
121700:[1054, 1712, 2239, 2670],
121800:[1055, 1713, 2240, 2672],
121900:[1056, 1715, 2242, 2674],
122000:[1056, 1716, 2244, 2676],
122100:[1057, 1717, 2246, 2678],
122200:[1058, 1719, 2247, 2680],
122300:[1059, 1720, 2249, 2682],
122400:[1060, 1721, 2251, 2684],
122500:[1060, 1723, 2252, 2686],
122600:[1061, 1724, 2254, 2688],
122700:[1062, 1726, 2256, 2690],
122800:[1063, 1727, 2257, 2692],
122900:[1064, 1728, 2259, 2695],
123000:[1065, 1730, 2261, 2697],
123100:[1066, 1731, 2263, 2699],
123200:[1067, 1733, 2264, 2701],
123300:[1067, 1734, 2266, 2703],
123400:[1068, 1735, 2268, 2705],
123500:[1069, 1737, 2269, 2707],
123600:[1070, 1738, 2271, 2709],
123700:[1071, 1739, 2273, 2711],
123800:[1072, 1741, 2274, 2713],
123900:[1072, 1742, 2276, 2715],
124000:[1073, 1743, 2278, 2717],
124100:[1074, 1744, 2280, 2719],
124200:[1075, 1746, 2282, 2721],
124300:[1076, 1747, 2283, 2723],
124400:[1076, 1748, 2285, 2725],
124500:[1077, 1750, 2287, 2727],
124600:[1078, 1751, 2289, 2729],
124700:[1079, 1752, 2290, 2731],
124800:[1080, 1754, 2292, 2733],
124900:[1081, 1755, 2294, 2735],
125000:[1082, 1756, 2296, 2737],
125100:[1083, 1757, 2298, 2739],
125200:[1084, 1759, 2299, 2741],
125300:[1084, 1760, 2301, 2743],
125400:[1085, 1761, 2303, 2745],
125500:[1086, 1762, 2305, 2747],
125600:[1087, 1764, 2306, 2749],
125700:[1088, 1765, 2308, 2751],
125800:[1089, 1766, 2310, 2753],
125900:[1089, 1768, 2312, 2755],
126000:[1090, 1769, 2313, 2757],
126100:[1091, 1770, 2315, 2759],
126200:[1092, 1772, 2316, 2761],
126300:[1093, 1773, 2318, 2763],
126400:[1093, 1774, 2320, 2765],
126500:[1094, 1776, 2322, 2767],
126600:[1095, 1777, 2323, 2769],
126700:[1096, 1779, 2325, 2771],
126800:[1097, 1780, 2327, 2773],
126900:[1098, 1781, 2329, 2775],
127000:[1099, 1783, 2330, 2777],
127100:[1100, 1784, 2332, 2779],
127200:[1101, 1786, 2333, 2781],
127300:[1101, 1787, 2335, 2783],
127400:[1102, 1788, 2337, 2785],
127500:[1103, 1790, 2339, 2787],
127600:[1104, 1791, 2340, 2789],
127700:[1105, 1792, 2342, 2791],
127800:[1105, 1794, 2344, 2794],
127900:[1106, 1795, 2346, 2796],
128000:[1107, 1796, 2347, 2798],
128100:[1108, 1797, 2349, 2800],
128200:[1109, 1799, 2350, 2802],
128300:[1110, 1800, 2352, 2804],
128400:[1110, 1801, 2354, 2806],
128500:[1111, 1803, 2356, 2808],
128600:[1112, 1804, 2357, 2810],
128700:[1113, 1805, 2359, 2812],
128800:[1114, 1806, 2361, 2814],
128900:[1115, 1808, 2362, 2816],
129000:[1116, 1809, 2364, 2818],
129100:[1117, 1810, 2366, 2820],
129200:[1118, 1812, 2367, 2822],
129300:[1119, 1813, 2369, 2824],
129400:[1120, 1814, 2371, 2826],
129500:[1121, 1816, 2373, 2828],
129600:[1121, 1817, 2374, 2830],
129700:[1122, 1819, 2376, 2832],
129800:[1123, 1820, 2378, 2834],
129900:[1124, 1821, 2379, 2836],
130000:[1125, 1823, 2381, 2838],
130100:[1126, 1824, 2383, 2840],
130200:[1127, 1826, 2384, 2842],
130300:[1128, 1827, 2386, 2844],
130400:[1128, 1828, 2388, 2846],
130500:[1129, 1830, 2390, 2848],
130600:[1130, 1831, 2391, 2850],
130700:[1131, 1832, 2393, 2852],
130800:[1132, 1834, 2395, 2854],
130900:[1133, 1835, 2396, 2856],
131000:[1133, 1836, 2398, 2858],
131100:[1134, 1837, 2400, 2860],
131200:[1135, 1839, 2401, 2862],
131300:[1136, 1840, 2403, 2864],
131400:[1137, 1841, 2405, 2866],
131500:[1137, 1843, 2406, 2868],
131600:[1138, 1844, 2408, 2870],
131700:[1139, 1845, 2410, 2872],
131800:[1140, 1847, 2412, 2874],
131900:[1141, 1848, 2413, 2876],
132000:[1142, 1849, 2415, 2878],
132100:[1143, 1850, 2417, 2880],
132200:[1144, 1852, 2418, 2882],
132300:[1145, 1853, 2420, 2884],
132400:[1145, 1854, 2422, 2886],
132500:[1146, 1855, 2423, 2888],
132600:[1147, 1857, 2425, 2890],
132700:[1148, 1858, 2427, 2892],
132800:[1149, 1859, 2428, 2894],
132900:[1150, 1861, 2430, 2896],
133000:[1150, 1862, 2432, 2898],
133100:[1151, 1863, 2434, 2900],
133200:[1152, 1865, 2435, 2902],
133300:[1153, 1866, 2437, 2904],
133400:[1154, 1867, 2439, 2906],
133500:[1154, 1869, 2440, 2908],
133600:[1155, 1870, 2442, 2910],
133700:[1156, 1871, 2444, 2912],
133800:[1157, 1873, 2445, 2914],
133900:[1158, 1874, 2447, 2916],
134000:[1159, 1876, 2449, 2919],
134100:[1160, 1877, 2451, 2921],
134200:[1161, 1879, 2452, 2923],
134300:[1161, 1880, 2454, 2925],
134400:[1162, 1881, 2456, 2927],
134500:[1163, 1883, 2457, 2929],
134600:[1164, 1884, 2459, 2931],
134700:[1165, 1885, 2461, 2933],
134800:[1166, 1887, 2462, 2935],
134900:[1166, 1888, 2464, 2937],
135000:[1167, 1889, 2466, 2939],
135100:[1168, 1890, 2468, 2941],
135200:[1169, 1892, 2469, 2943],
135300:[1170, 1893, 2471, 2945],
135400:[1171, 1894, 2473, 2947],
135500:[1171, 1895, 2474, 2949],
135600:[1172, 1897, 2476, 2951],
135700:[1173, 1898, 2478, 2953],
135800:[1174, 1899, 2479, 2955],
135900:[1175, 1901, 2481, 2957],
136000:[1176, 1902, 2483, 2959],
136100:[1177, 1903, 2485, 2961],
136200:[1178, 1905, 2487, 2963],
136300:[1178, 1906, 2488, 2965],
136400:[1179, 1907, 2490, 2967],
136500:[1180, 1909, 2492, 2969],
136600:[1181, 1910, 2494, 2971],
136700:[1182, 1912, 2495, 2973],
136800:[1183, 1913, 2497, 2975],
136900:[1183, 1914, 2499, 2977],
137000:[1184, 1916, 2501, 2979],
137100:[1185, 1917, 2503, 2981],
137200:[1186, 1919, 2504, 2983],
137300:[1187, 1920, 2506, 2985],
137400:[1187, 1921, 2508, 2987],
137500:[1188, 1923, 2510, 2989],
137600:[1189, 1924, 2511, 2991],
137700:[1190, 1925, 2513, 2993],
137800:[1191, 1927, 2515, 2995],
137900:[1192, 1928, 2517, 2997],
138000:[1193, 1929, 2518, 2999],
138100:[1194, 1930, 2520, 3001],
138200:[1195, 1932, 2521, 3003],
138300:[1195, 1933, 2523, 3005],
138400:[1196, 1934, 2525, 3007],
138500:[1197, 1936, 2527, 3009],
138600:[1198, 1937, 2528, 3011],
138700:[1199, 1938, 2530, 3013],
138800:[1200, 1940, 2532, 3015],
138900:[1200, 1941, 2534, 3018],
139000:[1201, 1942, 2535, 3020],
139100:[1202, 1943, 2537, 3022],
139200:[1203, 1945, 2538, 3024],
139300:[1204, 1946, 2540, 3026],
139400:[1204, 1947, 2542, 3028],
139500:[1205, 1948, 2544, 3030],
139600:[1206, 1950, 2545, 3032],
139700:[1207, 1951, 2547, 3034],
139800:[1208, 1952, 2549, 3036],
139900:[1209, 1954, 2551, 3038],
140000:[1210, 1955, 2552, 3040],
140100:[1211, 1956, 2554, 3042],
140200:[1212, 1958, 2555, 3044],
140300:[1212, 1959, 2557, 3046],
140400:[1213, 1960, 2559, 3048],
140500:[1214, 1962, 2561, 3050],
140600:[1215, 1963, 2562, 3052],
140700:[1216, 1964, 2564, 3054],
140800:[1216, 1966, 2566, 3056],
140900:[1217, 1967, 2567, 3058],
141000:[1218, 1969, 2569, 3060],
141100:[1219, 1970, 2571, 3062],
141200:[1220, 1972, 2572, 3064],
141300:[1221, 1973, 2574, 3066],
141400:[1221, 1974, 2576, 3068],
141500:[1222, 1976, 2578, 3070],
141600:[1223, 1977, 2579, 3072],
141700:[1224, 1978, 2581, 3074],
141800:[1225, 1980, 2583, 3076],
141900:[1226, 1981, 2584, 3078],
142000:[1227, 1982, 2586, 3080],
142100:[1228, 1983, 2588, 3082],
142200:[1229, 1985, 2589, 3084],
142300:[1229, 1986, 2591, 3086],
142400:[1230, 1987, 2593, 3088],
142500:[1231, 1988, 2595, 3090],
142600:[1232, 1990, 2596, 3092],
142700:[1233, 1991, 2598, 3094],
142800:[1233, 1992, 2600, 3096],
142900:[1234, 1994, 2601, 3098],
143000:[1235, 1995, 2603, 3100],
143100:[1236, 1996, 2605, 3102],
143200:[1237, 1998, 2606, 3104],
143300:[1238, 1999, 2608, 3106],
143400:[1238, 2000, 2609, 3108],
143500:[1239, 2001, 2611, 3110],
143600:[1240, 2003, 2613, 3112],
143700:[1241, 2004, 2614, 3114],
143800:[1242, 2005, 2616, 3116],
143900:[1243, 2007, 2617, 3118],
144000:[1244, 2008, 2619, 3120],
144100:[1245, 2009, 2621, 3122],
144200:[1246, 2011, 2622, 3124],
144300:[1246, 2012, 2624, 3126],
144400:[1247, 2013, 2626, 3128],
144500:[1248, 2014, 2627, 3130],
144600:[1249, 2016, 2629, 3132],
144700:[1250, 2017, 2631, 3134],
144800:[1251, 2018, 2632, 3135],
144900:[1251, 2020, 2634, 3137],
145000:[1252, 2021, 2636, 3139],
145100:[1253, 2022, 2638, 3141],
145200:[1254, 2024, 2639, 3143],
145300:[1254, 2025, 2641, 3145],
145400:[1255, 2026, 2642, 3147],
145500:[1256, 2028, 2644, 3149],
145600:[1257, 2029, 2646, 3151],
145700:[1258, 2030, 2647, 3153],
145800:[1258, 2031, 2649, 3155],
145900:[1259, 2033, 2650, 3157],
146000:[1260, 2034, 2652, 3159],
146100:[1261, 2035, 2654, 3161],
146200:[1262, 2037, 2655, 3163],
146300:[1263, 2038, 2657, 3165],
146400:[1263, 2039, 2659, 3167],
146500:[1264, 2041, 2660, 3169],
146600:[1265, 2042, 2662, 3171],
146700:[1266, 2043, 2664, 3172],
146800:[1267, 2045, 2665, 3174],
146900:[1268, 2046, 2667, 3176],
147000:[1269, 2047, 2669, 3178],
147100:[1270, 2048, 2671, 3180],
147200:[1271, 2049, 2672, 3182],
147300:[1272, 2051, 2674, 3184],
147400:[1272, 2052, 2676, 3186],
147500:[1273, 2053, 2677, 3188],
147600:[1274, 2054, 2679, 3190],
147700:[1275, 2056, 2681, 3192],
147800:[1276, 2057, 2683, 3194],
147900:[1277, 2058, 2684, 3196],
148000:[1277, 2059, 2686, 3198],
148100:[1278, 2060, 2688, 3200],
148200:[1279, 2062, 2689, 3202],
148300:[1279, 2063, 2691, 3204],
148400:[1280, 2064, 2693, 3206],
148500:[1281, 2065, 2694, 3208],
148600:[1282, 2067, 2696, 3210],
148700:[1283, 2068, 2698, 3211],
148800:[1284, 2069, 2699, 3213],
148900:[1284, 2070, 2701, 3215],
149000:[1285, 2072, 2702, 3217],
149100:[1286, 2073, 2704, 3219],
149200:[1287, 2075, 2705, 3221],
149300:[1287, 2076, 2707, 3223],
149400:[1288, 2077, 2709, 3225],
149500:[1289, 2078, 2710, 3227],
149600:[1290, 2080, 2712, 3229],
149700:[1291, 2081, 2714, 3231],
149800:[1291, 2082, 2716, 3233],
149900:[1292, 2083, 2717, 3235],
150000:[1293, 2085, 2719, 3237],
16000:[0, 0, 0, 0],
16100:[10, 10, 11, 12],
16200:[19, 21, 22, 24],
16300:[29, 31, 34, 36],
16400:[38, 42, 45, 48],
16500:[48, 52, 56, 60],
16600:[58, 62, 67, 72],
16700:[67, 73, 78, 84],
16800:[77, 83, 90, 96],
16900:[86, 94, 101, 108],
17000:[96, 104, 112, 120],
17100:[97, 109, 117, 126],
17200:[98, 114, 122, 131],
17300:[99, 118, 127, 137],
17400:[99, 123, 133, 142],
17500:[100, 128, 138, 148],
17600:[101, 133, 143, 153],
17700:[102, 137, 148, 159],
17800:[103, 142, 153, 165],
17900:[104, 147, 158, 170],
18000:[105, 152, 164, 176],
18100:[106, 156, 169, 181],
18200:[107, 161, 173, 186],
18300:[108, 165, 178, 191],
18400:[108, 169, 182, 196],
18500:[109, 173, 187, 201],
18600:[110, 178, 192, 206],
18700:[111, 182, 196, 211],
18800:[112, 186, 201, 216],
18900:[113, 191, 206, 221],
19000:[113, 195, 210, 225],
19100:[114, 199, 214, 229],
19200:[115, 203, 218, 234],
19300:[115, 206, 222, 238],
19400:[116, 210, 226, 243],
19500:[117, 214, 230, 247],
19600:[118, 218, 234, 251],
19700:[119, 221, 239, 256],
19800:[119, 225, 243, 260],
19900:[120, 229, 247, 264],
20000:[121, 233, 251, 269],
20100:[122, 237, 255, 273],
20200:[123, 241, 259, 278],
20300:[124, 244, 263, 282],
20400:[124, 248, 267, 287],
20500:[125, 252, 271, 291],
20600:[126, 256, 276, 295],
20700:[127, 260, 280, 300],
20800:[128, 263, 284, 304],
20900:[129, 267, 288, 309],
21000:[130, 271, 292, 313],
21100:[131, 275, 296, 317],
21200:[132, 279, 300, 322],
21300:[132, 282, 304, 326],
21400:[133, 286, 308, 330],
21500:[134, 290, 313, 335],
21600:[135, 294, 317, 339],
21700:[136, 298, 321, 343],
21800:[137, 301, 325, 348],
21900:[137, 305, 329, 352],
22000:[138, 309, 333, 356],
22100:[139, 313, 337, 360],
22200:[140, 317, 341, 365],
22300:[140, 320, 345, 369],
22400:[141, 324, 349, 373],
22500:[142, 328, 353, 378],
22600:[143, 332, 357, 382],
22700:[144, 336, 361, 387],
22800:[144, 340, 365, 391],
22900:[145, 343, 369, 395],
23000:[146, 347, 373, 400],
23100:[147, 351, 377, 405],
23200:[148, 355, 382, 409],
23300:[149, 359, 386, 414],
23400:[149, 363, 390, 418],
23500:[150, 367, 395, 423],
23600:[151, 371, 399, 428],
23700:[152, 375, 404, 432],
23800:[153, 379, 408, 437],
23900:[154, 383, 412, 441],
24000:[155, 387, 417, 446],
24100:[156, 391, 421, 451],
24200:[157, 395, 426, 455],
24300:[157, 399, 430, 460],
24400:[158, 403, 434, 465],
24500:[159, 407, 439, 469],
24600:[160, 411, 443, 474],
24700:[161, 415, 447, 479],
24800:[162, 419, 452, 483],
24900:[162, 423, 456, 488],
25000:[163, 427, 460, 493],
25100:[164, 429, 464, 497],
25200:[165, 431, 467, 501],
25300:[165, 434, 471, 505],
25400:[166, 436, 475, 509],
25500:[167, 438, 478, 512],
25600:[168, 440, 482, 516],
25700:[169, 442, 486, 520],
25800:[169, 444, 489, 524],
25900:[170, 447, 493, 528],
26000:[171, 449, 497, 532],
26100:[172, 449, 501, 536],
26200:[173, 449, 504, 540],
26300:[174, 450, 508, 543],
26400:[174, 450, 511, 547],
26500:[175, 450, 515, 551],
26600:[176, 450, 518, 555],
26700:[177, 450, 522, 558],
26800:[178, 451, 525, 562],
26900:[179, 451, 529, 566],
27000:[180, 451, 532, 570],
27100:[181, 451, 536, 574],
27200:[182, 451, 539, 577],
27300:[182, 451, 543, 581],
27400:[183, 451, 546, 585],
27500:[184, 452, 550, 589],
27600:[185, 452, 553, 592],
27700:[186, 452, 557, 596],
27800:[187, 452, 560, 600],
27900:[187, 452, 564, 604],
28000:[188, 452, 567, 607],
28100:[189, 452, 571, 611],
28200:[190, 452, 574, 615],
28300:[190, 453, 578, 618],
28400:[191, 453, 581, 622],
28500:[192, 453, 585, 626],
28600:[193, 453, 588, 630],
28700:[194, 453, 592, 633],
28800:[194, 454, 595, 637],
28900:[195, 454, 599, 641],
29000:[196, 454, 602, 645],
29100:[197, 455, 606, 649],
29200:[198, 455, 609, 652],
29300:[199, 456, 613, 656],
29400:[199, 456, 616, 660],
29500:[200, 457, 620, 664],
29600:[201, 458, 623, 667],
29700:[202, 458, 627, 671],
29800:[203, 459, 630, 675],
29900:[204, 459, 634, 679],
30000:[205, 460, 637, 682],
30100:[206, 461, 638, 686],
30200:[207, 461, 639, 690],
30300:[207, 462, 640, 693],
30400:[208, 462, 642, 697],
30500:[209, 463, 643, 701],
30600:[210, 464, 644, 705],
30700:[211, 464, 645, 708],
30800:[212, 465, 646, 712],
30900:[212, 466, 647, 716],
31000:[213, 466, 648, 720],
31100:[214, 467, 649, 724],
31200:[215, 467, 650, 727],
31300:[216, 468, 651, 731],
31400:[217, 468, 652, 735],
31500:[217, 469, 653, 739],
31600:[218, 469, 654, 742],
31700:[219, 470, 655, 746],
31800:[220, 470, 656, 750],
31900:[221, 471, 657, 754],
32000:[222, 471, 658, 757],
32100:[223, 471, 659, 761],
32200:[224, 472, 660, 764],
32300:[225, 472, 661, 768],
32400:[225, 473, 661, 771],
32500:[226, 473, 662, 775],
32600:[227, 474, 663, 779],
32700:[228, 474, 664, 782],
32800:[229, 475, 665, 786],
32900:[230, 475, 666, 789],
33000:[230, 476, 667, 793],
33100:[231, 476, 668, 796],
33200:[231, 477, 669, 800],
33300:[232, 477, 670, 803],
33400:[232, 478, 671, 807],
33500:[233, 478, 671, 810],
33600:[233, 479, 672, 813],
33700:[234, 479, 673, 817],
33800:[234, 479, 674, 820],
33900:[235, 480, 675, 823],
34000:[235, 480, 676, 827],
34100:[235, 481, 677, 829],
34200:[236, 481, 678, 832],
34300:[236, 482, 679, 834],
34400:[236, 483, 680, 836],
34500:[236, 484, 681, 838],
34600:[237, 484, 682, 841],
34700:[237, 485, 683, 843],
34800:[237, 486, 684, 845],
34900:[237, 486, 685, 847],
35000:[238, 487, 686, 850],
35100:[239, 488, 688, 852],
35200:[239, 489, 689, 854],
35300:[240, 491, 691, 856],
35400:[241, 492, 692, 858],
35500:[241, 493, 694, 860],
35600:[242, 494, 695, 862],
35700:[242, 495, 697, 864],
35800:[243, 497, 698, 866],
35900:[244, 498, 700, 867],
36000:[244, 499, 702, 869],
36100:[245, 500, 704, 871],
36200:[246, 502, 706, 873],
36300:[247, 503, 708, 876],
36400:[248, 505, 710, 878],
36500:[249, 506, 711, 880],
36600:[250, 508, 713, 882],
36700:[251, 509, 715, 885],
36800:[252, 511, 717, 887],
36900:[253, 512, 719, 889],
37000:[254, 513, 721, 891],
37100:[255, 514, 723, 893],
37200:[256, 516, 725, 895],
37300:[257, 517, 727, 898],
37400:[258, 519, 729, 900],
37500:[259, 520, 731, 902],
37600:[260, 522, 732, 904],
37700:[260, 523, 734, 907],
37800:[261, 525, 736, 909],
37900:[262, 526, 738, 911],
38000:[263, 528, 740, 913],
38100:[264, 529, 742, 915],
38200:[266, 531, 744, 917],
38300:[267, 532, 746, 920],
38400:[268, 534, 747, 922],
38500:[269, 535, 749, 924],
38600:[271, 537, 751, 926],
38700:[272, 538, 753, 929],
38800:[273, 539, 755, 931],
38900:[275, 541, 757, 933],
39000:[276, 542, 758, 935],
39100:[277, 543, 760, 937],
39200:[279, 545, 762, 939],
39300:[280, 546, 764, 942],
39400:[281, 548, 766, 944],
39500:[283, 549, 767, 946],
39600:[284, 551, 769, 948],
39700:[285, 552, 771, 950],
39800:[286, 554, 773, 953],
39900:[288, 555, 775, 955],
40000:[289, 557, 777, 957],
40100:[290, 558, 779, 959],
40200:[291, 560, 781, 961],
40300:[293, 561, 782, 963],
40400:[294, 563, 784, 965],
40500:[295, 564, 786, 968],
40600:[296, 565, 788, 970],
40700:[298, 567, 790, 972],
40800:[299, 568, 791, 974],
40900:[300, 570, 793, 976],
41000:[301, 571, 795, 978],
41100:[302, 572, 797, 980],
41200:[303, 574, 799, 982],
41300:[305, 575, 800, 984],
41400:[306, 577, 802, 986],
41500:[307, 578, 804, 988],
41600:[308, 579, 806, 990],
41700:[309, 581, 808, 993],
41800:[311, 582, 809, 995],
41900:[312, 584, 811, 997],
42000:[313, 585, 813, 999],
42100:[314, 586, 815, 1001],
42200:[316, 588, 817, 1003],
42300:[317, 589, 818, 1005],
42400:[318, 591, 820, 1008],
42500:[319, 592, 822, 1010],
42600:[321, 593, 824, 1012],
42700:[322, 595, 826, 1014],
42800:[323, 596, 827, 1016],
42900:[324, 598, 829, 1018],
43000:[326, 599, 831, 1021],
43100:[327, 600, 833, 1023],
43200:[329, 602, 835, 1025],
43300:[330, 603, 837, 1028],
43400:[331, 605, 838, 1030],
43500:[333, 606, 840, 1032],
43600:[334, 608, 842, 1034],
43700:[335, 609, 844, 1036],
43800:[337, 611, 846, 1039],
43900:[338, 612, 848, 1041],
44000:[340, 614, 850, 1043],
44100:[341, 615, 852, 1045],
44200:[343, 617, 854, 1047],
44300:[344, 618, 856, 1049],
44400:[345, 620, 858, 1052],
44500:[347, 621, 860, 1054],
44600:[348, 623, 861, 1056],
44700:[350, 624, 863, 1058],
44800:[351, 626, 865, 1060],
44900:[352, 627, 867, 1062],
45000:[354, 629, 869, 1064],
45100:[355, 631, 871, 1066],
45200:[357, 633, 873, 1068],
45300:[358, 634, 875, 1070],
45400:[360, 636, 876, 1073],
45500:[361, 638, 878, 1075],
45600:[362, 640, 880, 1077],
45700:[364, 641, 882, 1079],
45800:[365, 643, 884, 1081],
45900:[367, 645, 886, 1083],
46000:[368, 647, 887, 1086],
46100:[369, 649, 889, 1088],
46200:[370, 650, 890, 1090],
46300:[371, 652, 892, 1092],
46400:[372, 653, 893, 1094],
46500:[373, 655, 895, 1095],
46600:[374, 656, 896, 1097],
46700:[375, 658, 898, 1099],
46800:[376, 659, 900, 1101],
46900:[377, 661, 901, 1103],
47000:[378, 662, 903, 1105],
47100:[379, 663, 904, 1107],
47200:[380, 665, 906, 1109],
47300:[381, 666, 907, 1111],
47400:[381, 668, 909, 1112],
47500:[382, 669, 910, 1114],
47600:[383, 671, 912, 1116],
47700:[384, 672, 913, 1118],
47800:[385, 673, 915, 1120],
47900:[386, 675, 916, 1122],
48000:[387, 676, 918, 1124],
48100:[388, 677, 919, 1126],
48200:[389, 679, 921, 1128],
48300:[390, 680, 922, 1129],
48400:[391, 681, 924, 1131],
48500:[391, 683, 925, 1133],
48600:[392, 684, 927, 1135],
48700:[393, 685, 928, 1137],
48800:[394, 687, 930, 1139],
48900:[395, 688, 931, 1140],
49000:[396, 689, 933, 1142],
49100:[397, 690, 935, 1144],
49200:[398, 692, 936, 1146],
49300:[399, 693, 938, 1148],
49400:[400, 694, 939, 1150],
49500:[401, 696, 941, 1151],
49600:[401, 697, 942, 1153],
49700:[402, 699, 944, 1155],
49800:[403, 700, 946, 1157],
49900:[404, 701, 947, 1159],
50000:[405, 703, 949, 1161],
50100:[406, 704, 951, 1163],
50200:[407, 706, 952, 1165],
50300:[408, 707, 954, 1167],
50400:[409, 709, 955, 1169],
50500:[409, 710, 957, 1170],
50600:[410, 712, 958, 1172],
50700:[411, 713, 960, 1174],
50800:[412, 715, 961, 1176],
50900:[413, 716, 963, 1178],
51000:[414, 718, 964, 1180],
51100:[415, 719, 966, 1182],
51200:[416, 721, 967, 1184],
51300:[417, 722, 969, 1185],
51400:[418, 724, 970, 1187],
51500:[418, 725, 972, 1189],
51600:[419, 727, 973, 1191],
51700:[420, 728, 975, 1193],
51800:[421, 730, 976, 1195],
51900:[422, 731, 978, 1196],
52000:[423, 732, 979, 1198],
52100:[424, 733, 981, 1200],
52200:[425, 735, 983, 1202],
52300:[426, 736, 984, 1204],
52400:[427, 738, 986, 1205],
52500:[427, 739, 988, 1207],
52600:[428, 741, 990, 1209],
52700:[429, 742, 992, 1211],
52800:[430, 743, 994, 1213],
52900:[431, 745, 995, 1215],
53000:[432, 746, 997, 1217],
53100:[433, 747, 999, 1219],
53200:[434, 749, 1001, 1221],
53300:[435, 750, 1002, 1223],
53400:[436, 752, 1004, 1225],
53500:[437, 753, 1006, 1226],
53600:[438, 754, 1008, 1228],
53700:[439, 756, 1010, 1230],
53800:[440, 757, 1012, 1232],
53900:[441, 759, 1013, 1234],
54000:[442, 760, 1015, 1236],
54100:[443, 761, 1017, 1238],
54200:[444, 763, 1019, 1240],
54300:[444, 764, 1020, 1241],
54400:[445, 765, 1022, 1243],
54500:[446, 767, 1024, 1245],
54600:[447, 768, 1026, 1247],
54700:[448, 769, 1027, 1248],
54800:[449, 771, 1029, 1250],
54900:[449, 772, 1031, 1252],
55000:[450, 774, 1033, 1254],
55100:[451, 775, 1035, 1256],
55200:[452, 777, 1036, 1257],
55300:[453, 778, 1038, 1259],
55400:[453, 779, 1040, 1261],
55500:[454, 781, 1042, 1263],
55600:[455, 782, 1043, 1264],
55700:[456, 783, 1045, 1266],
55800:[457, 784, 1047, 1268],
55900:[458, 786, 1048, 1270],
56000:[459, 787, 1050, 1271],
56100:[460, 788, 1052, 1273],
56200:[461, 790, 1053, 1275],
56300:[462, 791, 1055, 1276],
56400:[463, 792, 1057, 1278],
56500:[463, 794, 1058, 1280],
56600:[464, 795, 1060, 1282],
56700:[465, 796, 1062, 1283],
56800:[466, 798, 1064, 1285],
56900:[467, 799, 1065, 1287],
57000:[468, 801, 1067, 1289],
57100:[469, 802, 1069, 1291],
57200:[470, 804, 1071, 1292],
57300:[470, 805, 1072, 1294],
57400:[471, 806, 1074, 1296],
57500:[472, 808, 1076, 1298],
57600:[473, 809, 1078, 1299],
57700:[474, 810, 1079, 1301],
57800:[475, 811, 1081, 1303],
57900:[475, 813, 1083, 1304],
58000:[476, 814, 1085, 1306],
58100:[477, 815, 1087, 1308],
58200:[478, 817, 1088, 1310],
58300:[479, 818, 1090, 1312],
58400:[479, 819, 1092, 1314],
58500:[480, 821, 1094, 1316],
58600:[481, 822, 1095, 1318],
58700:[482, 824, 1097, 1320],
58800:[483, 825, 1099, 1322],
58900:[484, 826, 1100, 1325],
59000:[485, 828, 1102, 1327],
59100:[486, 829, 1104, 1329],
59200:[487, 831, 1105, 1331],
59300:[488, 832, 1107, 1333],
59400:[489, 833, 1109, 1335],
59500:[489, 835, 1110, 1337],
59600:[490, 836, 1112, 1339],
59700:[491, 837, 1114, 1341],
59800:[492, 838, 1115, 1343],
59900:[493, 840, 1117, 1345],
60000:[494, 841, 1119, 1347],
60100:[495, 842, 1121, 1349],
60200:[496, 844, 1123, 1351],
60300:[496, 845, 1124, 1353],
60400:[497, 846, 1126, 1355],
60500:[498, 848, 1128, 1357],
60600:[499, 849, 1130, 1360],
60700:[500, 851, 1131, 1362],
60800:[501, 852, 1133, 1364],
60900:[501, 853, 1135, 1366],
61000:[502, 855, 1137, 1368],
61100:[503, 856, 1139, 1370],
61200:[504, 858, 1140, 1372],
61300:[505, 859, 1142, 1374],
61400:[505, 861, 1144, 1376],
61500:[506, 862, 1146, 1378],
61600:[507, 863, 1147, 1380],
61700:[508, 865, 1149, 1382],
61800:[509, 866, 1151, 1384],
61900:[510, 868, 1152, 1386],
62000:[511, 869, 1154, 1388],
62100:[512, 870, 1156, 1390],
62200:[513, 872, 1158, 1392],
62300:[514, 873, 1159, 1394],
62400:[515, 874, 1161, 1396],
62500:[515, 876, 1163, 1398],
62600:[516, 877, 1165, 1400],
62700:[517, 878, 1166, 1403],
62800:[518, 880, 1168, 1405],
62900:[519, 881, 1170, 1407],
63000:[520, 882, 1172, 1409],
63100:[521, 883, 1174, 1411],
63200:[522, 885, 1176, 1413],
63300:[523, 886, 1177, 1415],
63400:[524, 887, 1179, 1417],
63500:[524, 889, 1181, 1419],
63600:[525, 890, 1183, 1422],
63700:[526, 892, 1185, 1424],
63800:[527, 893, 1186, 1426],
63900:[528, 894, 1188, 1428],
64000:[529, 896, 1190, 1430],
64100:[530, 897, 1192, 1432],
64200:[531, 899, 1193, 1434],
64300:[532, 900, 1195, 1436],
64400:[533, 902, 1197, 1438],
64500:[534, 903, 1199, 1441],
64600:[534, 904, 1200, 1443],
64700:[535, 906, 1202, 1445],
64800:[536, 907, 1204, 1447],
64900:[537, 909, 1206, 1449],
65000:[538, 910, 1207, 1451],
65100:[539, 911, 1209, 1453],
65200:[540, 913, 1211, 1455],
65300:[541, 914, 1212, 1457],
65400:[542, 916, 1214, 1459],
65500:[543, 917, 1216, 1462],
65600:[544, 919, 1218, 1464],
65700:[544, 920, 1219, 1466],
65800:[545, 921, 1221, 1468],
65900:[546, 923, 1223, 1470],
66000:[547, 924, 1225, 1472],
66100:[548, 925, 1227, 1474],
66200:[549, 927, 1229, 1476],
66300:[550, 928, 1230, 1478],
66400:[551, 930, 1232, 1480],
66500:[552, 931, 1234, 1483],
66600:[553, 933, 1236, 1485],
66700:[554, 934, 1238, 1487],
66800:[555, 936, 1239, 1489],
66900:[555, 937, 1241, 1491],
67000:[556, 938, 1243, 1493],
67100:[557, 939, 1245, 1495],
67200:[558, 941, 1247, 1497],
67300:[559, 942, 1249, 1500],
67400:[560, 944, 1251, 1502],
67500:[561, 945, 1252, 1504],
67600:[562, 947, 1254, 1506],
67700:[563, 948, 1256, 1508],
67800:[564, 950, 1258, 1511],
67900:[564, 951, 1260, 1513],
68000:[565, 952, 1262, 1515],
68100:[566, 953, 1264, 1517],
68200:[567, 955, 1266, 1519],
68300:[568, 956, 1267, 1522],
68400:[569, 958, 1269, 1524],
68500:[570, 959, 1271, 1526],
68600:[570, 960, 1273, 1528],
68700:[571, 962, 1275, 1530],
68800:[572, 963, 1277, 1533],
68900:[573, 965, 1278, 1535],
69000:[574, 966, 1280, 1537],
69100:[575, 967, 1282, 1539],
69200:[576, 969, 1284, 1541],
69300:[577, 970, 1286, 1544],
69400:[578, 972, 1287, 1546],
69500:[579, 973, 1289, 1548],
69600:[580, 975, 1291, 1550],
69700:[581, 976, 1293, 1552],
69800:[582, 978, 1295, 1555],
69900:[583, 979, 1297, 1557],
70000:[584, 981, 1299, 1559],
70100:[585, 982, 1301, 1561],
70200:[586, 984, 1303, 1563],
70300:[587, 985, 1305, 1566],
70400:[588, 987, 1307, 1568],
70500:[589, 988, 1309, 1570],
70600:[590, 989, 1310, 1572],
70700:[591, 991, 1312, 1574],
70800:[592, 992, 1314, 1577],
70900:[593, 994, 1316, 1579],
71000:[593, 995, 1318, 1581],
71100:[594, 996, 1320, 1583],
71200:[595, 998, 1322, 1585],
71300:[596, 999, 1324, 1588],
71400:[597, 1001, 1325, 1590],
71500:[598, 1002, 1327, 1592],
71600:[599, 1004, 1329, 1594],
71700:[599, 1005, 1331, 1596],
71800:[600, 1007, 1333, 1599],
71900:[601, 1008, 1335, 1601],
72000:[602, 1010, 1336, 1603],
72100:[603, 1011, 1338, 1605],
72200:[604, 1013, 1340, 1607],
72300:[605, 1014, 1342, 1610],
72400:[606, 1016, 1344, 1612],
72500:[606, 1017, 1345, 1614],
72600:[607, 1018, 1347, 1616],
72700:[608, 1020, 1349, 1618],
72800:[609, 1021, 1351, 1621],
72900:[610, 1023, 1353, 1623],
73000:[611, 1024, 1355, 1625],
73100:[612, 1025, 1357, 1627],
73200:[613, 1027, 1359, 1629],
73300:[614, 1028, 1360, 1632],
73400:[615, 1030, 1362, 1634],
73500:[616, 1031, 1364, 1636],
73600:[617, 1033, 1366, 1638],
73700:[618, 1034, 1368, 1640],
73800:[619, 1036, 1370, 1643],
73900:[620, 1037, 1371, 1645],
74000:[621, 1039, 1373, 1647],
74100:[622, 1040, 1375, 1649],
74200:[623, 1042, 1377, 1651],
74300:[624, 1043, 1379, 1654],
74400:[625, 1045, 1380, 1656],
74500:[626, 1046, 1382, 1658],
74600:[627, 1047, 1384, 1660],
74700:[627, 1049, 1386, 1662],
74800:[628, 1050, 1388, 1665],
74900:[629, 1052, 1390, 1667],
75000:[630, 1053, 1392, 1669],
75100:[631, 1054, 1394, 1671],
75200:[632, 1056, 1396, 1673],
75300:[633, 1057, 1398, 1676],
75400:[634, 1059, 1400, 1678],
75500:[634, 1060, 1402, 1680],
75600:[635, 1062, 1403, 1682],
75700:[636, 1063, 1405, 1684],
75800:[637, 1065, 1407, 1687],
75900:[638, 1066, 1409, 1689],
76000:[639, 1068, 1411, 1691],
76100:[640, 1069, 1413, 1693],
76200:[641, 1071, 1415, 1695],
76300:[642, 1072, 1417, 1698],
76400:[643, 1074, 1418, 1700],
76500:[644, 1075, 1420, 1702],
76600:[645, 1077, 1422, 1704],
76700:[646, 1078, 1424, 1706],
76800:[647, 1079, 1426, 1709],
76900:[648, 1081, 1428, 1711],
77000:[649, 1082, 1429, 1713],
77100:[650, 1083, 1431, 1715],
77200:[651, 1085, 1433, 1717],
77300:[652, 1086, 1435, 1720],
77400:[653, 1088, 1437, 1722],
77500:[654, 1089, 1438, 1724],
77600:[655, 1091, 1440, 1726],
77700:[656, 1092, 1442, 1728],
77800:[656, 1094, 1444, 1731],
77900:[657, 1095, 1446, 1733],
78000:[658, 1097, 1448, 1735],
78100:[659, 1098, 1450, 1737],
78200:[660, 1100, 1452, 1739],
78300:[661, 1101, 1453, 1742],
78400:[662, 1103, 1455, 1744],
78500:[663, 1104, 1457, 1746],
78600:[663, 1106, 1459, 1748],
78700:[664, 1107, 1461, 1750],
78800:[665, 1108, 1463, 1753],
78900:[666, 1110, 1464, 1755],
79000:[667, 1111, 1466, 1757],
79100:[668, 1112, 1468, 1759],
79200:[669, 1114, 1470, 1761],
79300:[670, 1115, 1472, 1764],
79400:[671, 1117, 1473, 1766],
79500:[672, 1118, 1475, 1768],
79600:[673, 1120, 1477, 1770],
79700:[674, 1121, 1479, 1772],
79800:[675, 1123, 1481, 1775],
79900:[676, 1124, 1483, 1777],
80000:[677, 1126, 1485, 1779],
80100:[678, 1127, 1487, 1781],
80200:[679, 1129, 1489, 1783],
80300:[680, 1130, 1491, 1786],
80400:[681, 1132, 1493, 1788],
80500:[682, 1133, 1494, 1790],
80600:[683, 1135, 1496, 1792],
80700:[684, 1136, 1498, 1794],
80800:[685, 1137, 1500, 1797],
80900:[685, 1139, 1502, 1799],
81000:[686, 1140, 1504, 1801],
81100:[687, 1141, 1506, 1803],
81200:[688, 1143, 1508, 1805],
81300:[689, 1144, 1510, 1808],
81400:[690, 1146, 1511, 1810],
81500:[691, 1147, 1513, 1812],
81600:[691, 1149, 1515, 1814],
81700:[692, 1150, 1517, 1816],
81800:[693, 1152, 1519, 1819],
81900:[694, 1153, 1521, 1821],
82000:[695, 1155, 1522, 1823],
82100:[696, 1156, 1524, 1825],
82200:[697, 1158, 1526, 1827],
82300:[698, 1159, 1528, 1830],
82400:[699, 1161, 1529, 1832],
82500:[699, 1162, 1531, 1834],
82600:[700, 1164, 1533, 1836],
82700:[701, 1165, 1535, 1838],
82800:[702, 1166, 1537, 1841],
82900:[703, 1168, 1539, 1843],
83000:[704, 1169, 1541, 1845],
83100:[705, 1170, 1543, 1847],
83200:[706, 1172, 1545, 1849],
83300:[707, 1173, 1546, 1852],
83400:[708, 1175, 1548, 1854],
83500:[709, 1176, 1550, 1856],
83600:[710, 1178, 1552, 1858],
83700:[711, 1179, 1554, 1860],
83800:[712, 1181, 1555, 1863],
83900:[713, 1182, 1557, 1865],
84000:[714, 1184, 1559, 1867],
84100:[715, 1185, 1561, 1869],
84200:[716, 1187, 1563, 1871],
84300:[717, 1188, 1565, 1874],
84400:[718, 1190, 1566, 1876],
84500:[719, 1191, 1568, 1878],
84600:[720, 1193, 1570, 1880],
84700:[720, 1194, 1572, 1882],
84800:[721, 1196, 1574, 1885],
84900:[722, 1197, 1576, 1887],
85000:[723, 1198, 1578, 1889],
85100:[724, 1199, 1580, 1891],
85200:[725, 1201, 1582, 1893],
85300:[726, 1202, 1584, 1896],
85400:[727, 1204, 1586, 1898],
85500:[727, 1205, 1587, 1900],
85600:[728, 1207, 1589, 1902],
85700:[729, 1208, 1591, 1904],
85800:[730, 1210, 1593, 1907],
85900:[731, 1211, 1595, 1909],
86000:[732, 1213, 1597, 1911],
86100:[733, 1214, 1599, 1913],
86200:[734, 1216, 1601, 1915],
86300:[735, 1217, 1602, 1918],
86400:[736, 1219, 1604, 1920],
86500:[737, 1220, 1606, 1922],
86600:[738, 1222, 1608, 1924],
86700:[739, 1223, 1610, 1926],
86800:[740, 1225, 1612, 1929],
86900:[741, 1226, 1613, 1931],
87000:[742, 1227, 1615, 1933],
87100:[743, 1228, 1617, 1935],
87200:[744, 1230, 1619, 1937],
87300:[745, 1231, 1621, 1940],
87400:[746, 1233, 1622, 1942],
87500:[747, 1234, 1624, 1944],
87600:[748, 1236, 1626, 1946],
87700:[749, 1237, 1628, 1948],
87800:[749, 1239, 1630, 1951],
87900:[750, 1240, 1632, 1953],
88000:[751, 1242, 1634, 1955],
88100:[752, 1243, 1636, 1957],
88200:[753, 1245, 1638, 1959],
88300:[754, 1246, 1640, 1962],
88400:[755, 1248, 1642, 1964],
88500:[755, 1249, 1644, 1966],
88600:[756, 1251, 1645, 1968],
88700:[757, 1252, 1647, 1970],
88800:[758, 1254, 1649, 1973],
88900:[759, 1255, 1651, 1975],
89000:[760, 1256, 1653, 1977],
89100:[761, 1257, 1655, 1979],
89200:[762, 1259, 1657, 1981],
89300:[763, 1260, 1659, 1984],
89400:[764, 1262, 1660, 1986],
89500:[765, 1263, 1662, 1988],
89600:[766, 1264, 1664, 1990],
89700:[767, 1266, 1666, 1992],
89800:[768, 1267, 1668, 1995],
89900:[769, 1269, 1670, 1997],
90000:[770, 1270, 1671, 1999],
90100:[771, 1271, 1673, 2001],
90200:[772, 1273, 1675, 2003],
90300:[773, 1274, 1677, 2006],
90400:[774, 1276, 1679, 2008],
90500:[775, 1277, 1680, 2010],
90600:[776, 1279, 1682, 2012],
90700:[777, 1280, 1684, 2014],
90800:[778, 1282, 1686, 2017],
90900:[778, 1283, 1688, 2019],
91000:[779, 1285, 1690, 2021],
91100:[780, 1286, 1692, 2023],
91200:[781, 1288, 1694, 2025],
91300:[782, 1289, 1695, 2028],
91400:[783, 1291, 1697, 2030],
91500:[784, 1292, 1699, 2032],
91600:[784, 1293, 1701, 2034],
91700:[785, 1295, 1703, 2036],
91800:[786, 1296, 1705, 2039],
91900:[787, 1298, 1706, 2041],
92000:[788, 1299, 1708, 2043],
92100:[789, 1300, 1710, 2045],
92200:[790, 1302, 1712, 2047],
92300:[791, 1303, 1714, 2050],
92400:[792, 1305, 1715, 2052],
92500:[793, 1306, 1717, 2054],
92600:[794, 1308, 1719, 2056],
92700:[795, 1309, 1721, 2058],
92800:[796, 1311, 1723, 2061],
92900:[797, 1312, 1725, 2063],
93000:[798, 1314, 1727, 2065],
93100:[799, 1315, 1729, 2067],
93200:[800, 1317, 1731, 2069],
93300:[801, 1318, 1733, 2072],
93400:[802, 1320, 1735, 2074],
93500:[803, 1321, 1737, 2076],
93600:[804, 1322, 1738, 2078],
93700:[805, 1324, 1740, 2080],
93800:[806, 1325, 1742, 2083],
93900:[807, 1327, 1744, 2085],
94000:[807, 1328, 1746, 2087],
94100:[808, 1329, 1748, 2089],
94200:[809, 1331, 1750, 2091],
94300:[810, 1332, 1752, 2094],
94400:[811, 1334, 1753, 2096],
94500:[812, 1335, 1755, 2098],
94600:[812, 1337, 1757, 2100],
94700:[813, 1338, 1759, 2102],
94800:[814, 1340, 1761, 2105],
94900:[815, 1341, 1763, 2107],
95000:[816, 1343, 1764, 2109],
95100:[817, 1344, 1766, 2111],
95200:[818, 1346, 1768, 2113],
95300:[819, 1347, 1770, 2116],
95400:[820, 1349, 1772, 2118],
95500:[820, 1350, 1773, 2120],
95600:[821, 1351, 1775, 2122],
95700:[822, 1353, 1777, 2124],
95800:[823, 1354, 1779, 2127],
95900:[824, 1356, 1781, 2129],
96000:[825, 1357, 1783, 2131],
96100:[826, 1358, 1785, 2133],
96200:[827, 1360, 1787, 2135],
96300:[828, 1361, 1788, 2138],
96400:[829, 1363, 1790, 2140],
96500:[830, 1364, 1792, 2142],
96600:[831, 1366, 1794, 2144],
96700:[832, 1367, 1796, 2146],
96800:[833, 1369, 1798, 2149],
96900:[834, 1370, 1799, 2151],
97000:[835, 1372, 1801, 2153],
97100:[836, 1373, 1803, 2155],
97200:[837, 1375, 1805, 2157],
97300:[838, 1376, 1807, 2160],
97400:[839, 1378, 1808, 2162],
97500:[840, 1379, 1810, 2164],
97600:[841, 1381, 1812, 2166],
97700:[841, 1382, 1814, 2168],
97800:[842, 1383, 1816, 2171],
97900:[843, 1385, 1818, 2173],
98000:[844, 1386, 1820, 2175],
98100:[845, 1387, 1822, 2177],
98200:[846, 1389, 1824, 2179],
98300:[847, 1390, 1826, 2182],
98400:[848, 1392, 1828, 2184],
98500:[848, 1393, 1829, 2186],
98600:[849, 1395, 1831, 2188],
98700:[850, 1396, 1833, 2190],
98800:[851, 1398, 1835, 2193],
98900:[852, 1399, 1837, 2195],
99000:[853, 1401, 1839, 2197],
99100:[854, 1402, 1841, 2199],
99200:[855, 1404, 1843, 2201],
99300:[856, 1405, 1845, 2204],
99400:[857, 1407, 1846, 2206],
99500:[858, 1408, 1848, 2208],
99600:[859, 1410, 1850, 2210],
99700:[860, 1411, 1852, 2212],
99800:[861, 1412, 1854, 2215],
99900:[862, 1414, 1856, 2217],
};
const OR_SK=[0.8, 1.28, 1.7, 1.96];

// Yukon — 2025 Federal Child Support Guidelines Table
const T_YT={
100000:[934, 1527, 2002, 2390],
100100:[935, 1528, 2004, 2392],
100200:[936, 1530, 2006, 2395],
100300:[937, 1531, 2008, 2397],
100400:[938, 1533, 2010, 2399],
100500:[939, 1534, 2012, 2402],
100600:[940, 1536, 2014, 2404],
100700:[941, 1537, 2016, 2406],
100800:[942, 1539, 2018, 2409],
100900:[943, 1540, 2019, 2411],
101000:[944, 1542, 2021, 2413],
101100:[945, 1544, 2023, 2415],
101200:[946, 1545, 2025, 2418],
101300:[947, 1547, 2027, 2420],
101400:[948, 1548, 2029, 2422],
101500:[949, 1550, 2031, 2424],
101600:[950, 1551, 2033, 2427],
101700:[951, 1553, 2035, 2429],
101800:[952, 1555, 2037, 2431],
101900:[953, 1556, 2039, 2434],
102000:[954, 1558, 2041, 2436],
102100:[955, 1560, 2043, 2438],
102200:[956, 1561, 2045, 2441],
102300:[957, 1563, 2047, 2443],
102400:[958, 1564, 2049, 2445],
102500:[959, 1566, 2051, 2447],
102600:[960, 1567, 2053, 2450],
102700:[961, 1569, 2054, 2452],
102800:[962, 1570, 2056, 2454],
102900:[963, 1572, 2058, 2457],
103000:[963, 1573, 2060, 2459],
103100:[964, 1575, 2062, 2461],
103200:[965, 1576, 2064, 2464],
103300:[966, 1578, 2066, 2466],
103400:[967, 1579, 2068, 2468],
103500:[968, 1581, 2070, 2470],
103600:[969, 1582, 2072, 2473],
103700:[970, 1584, 2074, 2475],
103800:[971, 1585, 2076, 2477],
103900:[972, 1587, 2078, 2479],
104000:[973, 1588, 2080, 2482],
104100:[974, 1589, 2082, 2484],
104200:[975, 1591, 2084, 2487],
104300:[976, 1592, 2086, 2489],
104400:[977, 1594, 2088, 2491],
104500:[978, 1595, 2090, 2494],
104600:[979, 1597, 2092, 2496],
104700:[980, 1598, 2094, 2498],
104800:[981, 1600, 2096, 2501],
104900:[982, 1601, 2098, 2503],
105000:[983, 1603, 2100, 2506],
105100:[984, 1604, 2102, 2508],
105200:[985, 1606, 2104, 2511],
105300:[986, 1607, 2106, 2513],
105400:[987, 1609, 2108, 2515],
105500:[988, 1610, 2110, 2518],
105600:[989, 1612, 2112, 2520],
105700:[990, 1613, 2114, 2522],
105800:[991, 1615, 2116, 2525],
105900:[992, 1616, 2118, 2527],
106000:[993, 1618, 2119, 2529],
106100:[994, 1620, 2121, 2531],
106200:[995, 1621, 2123, 2534],
106300:[996, 1623, 2125, 2536],
106400:[997, 1624, 2127, 2538],
106500:[998, 1626, 2129, 2541],
106600:[999, 1627, 2131, 2543],
106700:[1000, 1629, 2133, 2545],
106800:[1000, 1630, 2135, 2548],
106900:[1001, 1632, 2137, 2550],
107000:[1002, 1634, 2139, 2552],
107100:[1003, 1635, 2141, 2554],
107200:[1004, 1637, 2143, 2556],
107300:[1005, 1638, 2144, 2558],
107400:[1006, 1640, 2146, 2560],
107500:[1007, 1641, 2148, 2563],
107600:[1008, 1643, 2150, 2565],
107700:[1009, 1644, 2152, 2567],
107800:[1010, 1645, 2154, 2569],
107900:[1011, 1647, 2155, 2571],
108000:[1012, 1648, 2157, 2573],
108100:[1013, 1649, 2159, 2575],
108200:[1014, 1651, 2160, 2577],
108300:[1015, 1652, 2162, 2579],
108400:[1015, 1654, 2164, 2581],
108500:[1016, 1655, 2166, 2583],
108600:[1017, 1656, 2167, 2585],
108700:[1018, 1658, 2169, 2587],
108800:[1019, 1659, 2171, 2589],
108900:[1020, 1661, 2172, 2592],
109000:[1020, 1662, 2174, 2594],
109100:[1021, 1663, 2176, 2596],
109200:[1022, 1665, 2178, 2598],
109300:[1023, 1666, 2179, 2600],
109400:[1023, 1667, 2181, 2602],
109500:[1024, 1669, 2183, 2604],
109600:[1025, 1670, 2185, 2607],
109700:[1026, 1671, 2186, 2609],
109800:[1027, 1673, 2188, 2611],
109900:[1028, 1674, 2190, 2613],
110000:[1029, 1675, 2192, 2615],
110100:[1030, 1676, 2194, 2617],
110200:[1031, 1678, 2196, 2619],
110300:[1032, 1679, 2197, 2621],
110400:[1033, 1681, 2199, 2623],
110500:[1033, 1682, 2201, 2626],
110600:[1034, 1683, 2203, 2628],
110700:[1035, 1685, 2205, 2630],
110800:[1036, 1686, 2206, 2632],
110900:[1037, 1687, 2208, 2634],
111000:[1038, 1689, 2210, 2636],
111100:[1039, 1690, 2212, 2638],
111200:[1040, 1692, 2213, 2640],
111300:[1041, 1693, 2215, 2642],
111400:[1042, 1694, 2217, 2644],
111500:[1043, 1696, 2219, 2646],
111600:[1043, 1697, 2220, 2648],
111700:[1044, 1698, 2222, 2650],
111800:[1045, 1700, 2224, 2652],
111900:[1046, 1701, 2226, 2654],
112000:[1047, 1702, 2227, 2656],
112100:[1048, 1703, 2229, 2658],
112200:[1049, 1705, 2231, 2660],
112300:[1050, 1706, 2232, 2662],
112400:[1050, 1707, 2234, 2664],
112500:[1051, 1709, 2236, 2666],
112600:[1052, 1710, 2238, 2668],
112700:[1053, 1712, 2240, 2671],
112800:[1054, 1713, 2241, 2673],
112900:[1055, 1714, 2243, 2675],
113000:[1055, 1716, 2245, 2677],
113100:[1056, 1717, 2247, 2679],
113200:[1057, 1719, 2248, 2681],
113300:[1058, 1720, 2250, 2683],
113400:[1058, 1722, 2252, 2685],
113500:[1059, 1723, 2254, 2688],
113600:[1060, 1724, 2255, 2690],
113700:[1061, 1726, 2257, 2692],
113800:[1062, 1727, 2259, 2694],
113900:[1063, 1729, 2261, 2696],
114000:[1064, 1730, 2262, 2698],
114100:[1065, 1731, 2264, 2700],
114200:[1066, 1733, 2266, 2702],
114300:[1067, 1734, 2267, 2704],
114400:[1068, 1735, 2269, 2706],
114500:[1068, 1737, 2271, 2708],
114600:[1069, 1738, 2273, 2710],
114700:[1070, 1739, 2275, 2712],
114800:[1071, 1741, 2276, 2714],
114900:[1072, 1742, 2278, 2716],
115000:[1073, 1743, 2280, 2718],
115100:[1074, 1744, 2282, 2720],
115200:[1075, 1746, 2283, 2722],
115300:[1076, 1747, 2285, 2724],
115400:[1077, 1748, 2287, 2726],
115500:[1078, 1750, 2289, 2728],
115600:[1078, 1751, 2290, 2730],
115700:[1079, 1753, 2292, 2732],
115800:[1080, 1754, 2294, 2734],
115900:[1081, 1755, 2296, 2737],
116000:[1082, 1757, 2297, 2739],
116100:[1083, 1758, 2299, 2741],
116200:[1084, 1760, 2301, 2743],
116300:[1084, 1761, 2302, 2745],
116400:[1085, 1763, 2304, 2747],
116500:[1086, 1764, 2306, 2749],
116600:[1087, 1765, 2308, 2752],
116700:[1088, 1767, 2309, 2754],
116800:[1089, 1768, 2311, 2756],
116900:[1089, 1770, 2313, 2758],
117000:[1090, 1771, 2315, 2760],
117100:[1091, 1772, 2317, 2762],
117200:[1092, 1774, 2318, 2764],
117300:[1093, 1775, 2320, 2766],
117400:[1093, 1776, 2322, 2768],
117500:[1094, 1778, 2324, 2771],
117600:[1095, 1779, 2325, 2773],
117700:[1096, 1780, 2327, 2775],
117800:[1097, 1782, 2329, 2777],
117900:[1098, 1783, 2331, 2779],
118000:[1099, 1784, 2332, 2781],
118100:[1100, 1785, 2334, 2783],
118200:[1101, 1787, 2336, 2785],
118300:[1102, 1788, 2337, 2787],
118400:[1103, 1790, 2339, 2789],
118500:[1103, 1791, 2341, 2791],
118600:[1104, 1792, 2343, 2793],
118700:[1105, 1794, 2344, 2795],
118800:[1106, 1795, 2346, 2797],
118900:[1107, 1796, 2348, 2799],
119000:[1108, 1798, 2350, 2801],
119100:[1109, 1799, 2352, 2803],
119200:[1110, 1801, 2353, 2805],
119300:[1111, 1802, 2355, 2807],
119400:[1112, 1803, 2357, 2809],
119500:[1113, 1805, 2359, 2811],
119600:[1113, 1806, 2360, 2813],
119700:[1114, 1807, 2362, 2815],
119800:[1115, 1809, 2364, 2818],
119900:[1116, 1810, 2366, 2820],
120000:[1117, 1811, 2367, 2822],
120100:[1118, 1812, 2369, 2824],
120200:[1119, 1814, 2371, 2826],
120300:[1120, 1815, 2372, 2828],
120400:[1121, 1816, 2374, 2830],
120500:[1122, 1818, 2376, 2832],
120600:[1123, 1819, 2378, 2835],
120700:[1123, 1820, 2379, 2837],
120800:[1124, 1822, 2381, 2839],
120900:[1125, 1823, 2383, 2841],
121000:[1126, 1825, 2385, 2843],
121100:[1127, 1826, 2387, 2845],
121200:[1128, 1828, 2388, 2847],
121300:[1129, 1829, 2390, 2849],
121400:[1129, 1831, 2392, 2851],
121500:[1130, 1832, 2394, 2853],
121600:[1131, 1833, 2395, 2855],
121700:[1132, 1835, 2397, 2857],
121800:[1133, 1836, 2399, 2859],
121900:[1134, 1837, 2400, 2861],
122000:[1134, 1839, 2402, 2863],
122100:[1135, 1840, 2404, 2865],
122200:[1136, 1842, 2406, 2867],
122300:[1137, 1843, 2407, 2869],
122400:[1137, 1844, 2409, 2871],
122500:[1138, 1846, 2411, 2873],
122600:[1139, 1847, 2413, 2875],
122700:[1140, 1848, 2414, 2877],
122800:[1141, 1850, 2416, 2879],
122900:[1142, 1851, 2418, 2882],
123000:[1143, 1852, 2420, 2884],
123100:[1144, 1853, 2422, 2886],
123200:[1145, 1855, 2423, 2888],
123300:[1146, 1856, 2425, 2890],
123400:[1147, 1857, 2427, 2892],
123500:[1147, 1859, 2429, 2894],
123600:[1148, 1860, 2430, 2897],
123700:[1149, 1862, 2432, 2899],
123800:[1150, 1863, 2434, 2901],
123900:[1151, 1864, 2435, 2903],
124000:[1152, 1866, 2437, 2905],
124100:[1153, 1867, 2439, 2907],
124200:[1154, 1869, 2441, 2909],
124300:[1155, 1870, 2442, 2911],
124400:[1156, 1872, 2444, 2913],
124500:[1157, 1873, 2446, 2916],
124600:[1158, 1874, 2448, 2918],
124700:[1158, 1876, 2449, 2920],
124800:[1159, 1877, 2451, 2922],
124900:[1160, 1879, 2453, 2924],
125000:[1161, 1880, 2455, 2926],
125100:[1162, 1881, 2457, 2928],
125200:[1163, 1883, 2458, 2930],
125300:[1164, 1884, 2460, 2932],
125400:[1164, 1885, 2462, 2934],
125500:[1165, 1887, 2464, 2936],
125600:[1166, 1888, 2465, 2938],
125700:[1167, 1889, 2467, 2940],
125800:[1168, 1891, 2469, 2942],
125900:[1169, 1892, 2470, 2944],
126000:[1169, 1893, 2472, 2946],
126100:[1170, 1894, 2474, 2948],
126200:[1171, 1896, 2476, 2950],
126300:[1172, 1897, 2477, 2952],
126400:[1172, 1898, 2479, 2954],
126500:[1173, 1900, 2481, 2956],
126600:[1174, 1901, 2483, 2958],
126700:[1175, 1903, 2484, 2960],
126800:[1176, 1904, 2486, 2963],
126900:[1177, 1905, 2488, 2965],
127000:[1178, 1907, 2490, 2967],
127100:[1179, 1908, 2492, 2969],
127200:[1180, 1910, 2493, 2971],
127300:[1181, 1911, 2495, 2973],
127400:[1182, 1913, 2497, 2975],
127500:[1182, 1914, 2499, 2977],
127600:[1183, 1915, 2500, 2980],
127700:[1184, 1917, 2502, 2982],
127800:[1185, 1918, 2504, 2984],
127900:[1186, 1920, 2505, 2986],
128000:[1187, 1921, 2507, 2988],
128100:[1188, 1922, 2509, 2990],
128200:[1189, 1924, 2511, 2992],
128300:[1190, 1925, 2512, 2994],
128400:[1191, 1926, 2514, 2996],
128500:[1192, 1928, 2516, 2998],
128600:[1192, 1929, 2518, 3000],
128700:[1193, 1930, 2519, 3002],
128800:[1194, 1932, 2521, 3004],
128900:[1195, 1933, 2523, 3006],
129000:[1196, 1934, 2525, 3008],
129100:[1197, 1935, 2527, 3010],
129200:[1198, 1937, 2529, 3012],
129300:[1199, 1938, 2530, 3014],
129400:[1199, 1940, 2532, 3016],
129500:[1200, 1941, 2534, 3018],
129600:[1201, 1942, 2536, 3020],
129700:[1202, 1944, 2538, 3022],
129800:[1203, 1945, 2539, 3024],
129900:[1204, 1946, 2541, 3027],
130000:[1204, 1948, 2543, 3029],
130100:[1205, 1949, 2545, 3031],
130200:[1206, 1951, 2546, 3033],
130300:[1207, 1952, 2548, 3035],
130400:[1207, 1953, 2550, 3037],
130500:[1208, 1955, 2552, 3039],
130600:[1209, 1956, 2553, 3042],
130700:[1210, 1957, 2555, 3044],
130800:[1211, 1959, 2557, 3046],
130900:[1212, 1960, 2559, 3048],
131000:[1213, 1961, 2560, 3050],
131100:[1214, 1962, 2562, 3052],
131200:[1215, 1964, 2564, 3054],
131300:[1216, 1965, 2565, 3056],
131400:[1217, 1966, 2567, 3058],
131500:[1217, 1968, 2569, 3061],
131600:[1218, 1969, 2571, 3063],
131700:[1219, 1970, 2573, 3065],
131800:[1220, 1972, 2574, 3067],
131900:[1221, 1973, 2576, 3069],
132000:[1222, 1975, 2578, 3071],
132100:[1223, 1976, 2580, 3073],
132200:[1224, 1978, 2581, 3075],
132300:[1225, 1979, 2583, 3077],
132400:[1226, 1981, 2585, 3079],
132500:[1227, 1982, 2587, 3081],
132600:[1227, 1983, 2588, 3083],
132700:[1228, 1985, 2590, 3085],
132800:[1229, 1986, 2592, 3087],
132900:[1230, 1988, 2594, 3089],
133000:[1231, 1989, 2595, 3091],
133100:[1232, 1990, 2597, 3093],
133200:[1233, 1992, 2599, 3095],
133300:[1233, 1993, 2600, 3097],
133400:[1234, 1994, 2602, 3099],
133500:[1235, 1996, 2604, 3101],
133600:[1236, 1997, 2606, 3103],
133700:[1237, 1998, 2608, 3105],
133800:[1238, 2000, 2609, 3108],
133900:[1238, 2001, 2611, 3110],
134000:[1239, 2002, 2613, 3112],
134100:[1240, 2003, 2615, 3114],
134200:[1241, 2005, 2616, 3116],
134300:[1242, 2006, 2618, 3118],
134400:[1242, 2007, 2620, 3120],
134500:[1243, 2009, 2622, 3122],
134600:[1244, 2010, 2623, 3125],
134700:[1245, 2012, 2625, 3127],
134800:[1246, 2013, 2627, 3129],
134900:[1247, 2014, 2629, 3131],
135000:[1248, 2016, 2630, 3133],
135100:[1249, 2017, 2632, 3135],
135200:[1250, 2019, 2634, 3137],
135300:[1251, 2020, 2635, 3139],
135400:[1252, 2022, 2637, 3141],
135500:[1252, 2023, 2639, 3143],
135600:[1253, 2024, 2641, 3145],
135700:[1254, 2026, 2642, 3147],
135800:[1255, 2027, 2644, 3149],
135900:[1256, 2029, 2646, 3151],
136000:[1257, 2030, 2648, 3153],
136100:[1258, 2031, 2650, 3155],
136200:[1259, 2033, 2651, 3157],
136300:[1260, 2034, 2653, 3159],
136400:[1261, 2035, 2655, 3161],
136500:[1262, 2037, 2657, 3163],
136600:[1262, 2038, 2658, 3165],
136700:[1263, 2039, 2660, 3167],
136800:[1264, 2041, 2662, 3169],
136900:[1265, 2042, 2664, 3172],
137000:[1266, 2043, 2665, 3174],
137100:[1267, 2044, 2667, 3176],
137200:[1268, 2046, 2669, 3178],
137300:[1269, 2047, 2670, 3180],
137400:[1270, 2049, 2672, 3182],
137500:[1271, 2050, 2674, 3184],
137600:[1272, 2051, 2676, 3187],
137700:[1272, 2053, 2677, 3189],
137800:[1273, 2054, 2679, 3191],
137900:[1274, 2055, 2681, 3193],
138000:[1275, 2057, 2683, 3195],
138100:[1276, 2058, 2685, 3197],
138200:[1277, 2060, 2686, 3199],
138300:[1278, 2061, 2688, 3201],
138400:[1278, 2063, 2690, 3203],
138500:[1279, 2064, 2692, 3206],
138600:[1280, 2065, 2693, 3208],
138700:[1281, 2067, 2695, 3210],
138800:[1282, 2068, 2697, 3212],
138900:[1283, 2070, 2699, 3214],
139000:[1283, 2071, 2700, 3216],
139100:[1284, 2072, 2702, 3218],
139200:[1285, 2074, 2704, 3220],
139300:[1286, 2075, 2705, 3222],
139400:[1286, 2076, 2707, 3224],
139500:[1287, 2078, 2709, 3226],
139600:[1288, 2079, 2711, 3228],
139700:[1289, 2080, 2712, 3230],
139800:[1290, 2082, 2714, 3232],
139900:[1291, 2083, 2716, 3234],
140000:[1292, 2084, 2718, 3236],
140100:[1293, 2085, 2720, 3238],
140200:[1294, 2087, 2721, 3240],
140300:[1295, 2088, 2723, 3242],
140400:[1296, 2090, 2725, 3244],
140500:[1296, 2091, 2727, 3246],
140600:[1297, 2092, 2728, 3248],
140700:[1298, 2094, 2730, 3250],
140800:[1299, 2095, 2732, 3253],
140900:[1300, 2096, 2733, 3255],
141000:[1301, 2098, 2735, 3257],
141100:[1302, 2099, 2737, 3259],
141200:[1303, 2101, 2739, 3261],
141300:[1304, 2102, 2740, 3263],
141400:[1305, 2103, 2742, 3265],
141500:[1306, 2105, 2744, 3267],
141600:[1307, 2106, 2746, 3270],
141700:[1307, 2107, 2747, 3272],
141800:[1308, 2109, 2749, 3274],
141900:[1309, 2110, 2751, 3276],
142000:[1310, 2111, 2753, 3278],
142100:[1311, 2112, 2755, 3280],
142200:[1312, 2114, 2756, 3282],
142300:[1313, 2115, 2758, 3284],
142400:[1313, 2116, 2760, 3286],
142500:[1314, 2118, 2762, 3288],
142600:[1315, 2119, 2763, 3290],
142700:[1316, 2121, 2765, 3292],
142800:[1317, 2122, 2767, 3294],
142900:[1318, 2123, 2768, 3296],
143000:[1318, 2125, 2770, 3298],
143100:[1319, 2126, 2772, 3300],
143200:[1320, 2128, 2774, 3302],
143300:[1321, 2129, 2775, 3304],
143400:[1321, 2131, 2777, 3306],
143500:[1322, 2132, 2779, 3308],
143600:[1323, 2133, 2781, 3310],
143700:[1324, 2135, 2782, 3312],
143800:[1325, 2136, 2784, 3314],
143900:[1326, 2138, 2786, 3317],
144000:[1327, 2139, 2788, 3319],
144100:[1328, 2140, 2790, 3321],
144200:[1329, 2142, 2791, 3323],
144300:[1330, 2143, 2793, 3325],
144400:[1331, 2144, 2795, 3327],
144500:[1331, 2146, 2797, 3329],
144600:[1332, 2147, 2798, 3332],
144700:[1333, 2148, 2800, 3334],
144800:[1334, 2150, 2802, 3336],
144900:[1335, 2151, 2803, 3338],
145000:[1336, 2152, 2805, 3340],
145100:[1337, 2153, 2807, 3342],
145200:[1338, 2155, 2809, 3344],
145300:[1339, 2156, 2810, 3346],
145400:[1340, 2157, 2812, 3348],
145500:[1341, 2159, 2814, 3351],
145600:[1341, 2160, 2816, 3353],
145700:[1342, 2162, 2817, 3355],
145800:[1343, 2163, 2819, 3357],
145900:[1344, 2164, 2821, 3359],
146000:[1345, 2166, 2823, 3361],
146100:[1346, 2167, 2825, 3363],
146200:[1347, 2169, 2827, 3365],
146300:[1348, 2170, 2828, 3367],
146400:[1348, 2172, 2830, 3369],
146500:[1349, 2173, 2832, 3371],
146600:[1350, 2174, 2834, 3373],
146700:[1351, 2176, 2836, 3375],
146800:[1352, 2177, 2837, 3377],
146900:[1353, 2179, 2839, 3379],
147000:[1353, 2180, 2841, 3381],
147100:[1354, 2181, 2843, 3383],
147200:[1355, 2183, 2844, 3385],
147300:[1356, 2184, 2846, 3387],
147400:[1356, 2185, 2848, 3389],
147500:[1357, 2187, 2850, 3391],
147600:[1358, 2188, 2851, 3393],
147700:[1359, 2189, 2853, 3395],
147800:[1360, 2191, 2855, 3398],
147900:[1361, 2192, 2857, 3400],
148000:[1362, 2193, 2858, 3402],
148100:[1363, 2194, 2860, 3404],
148200:[1364, 2196, 2862, 3406],
148300:[1365, 2197, 2863, 3408],
148400:[1366, 2199, 2865, 3410],
148500:[1366, 2200, 2867, 3412],
148600:[1367, 2201, 2869, 3415],
148700:[1368, 2203, 2871, 3417],
148800:[1369, 2204, 2872, 3419],
148900:[1370, 2205, 2874, 3421],
149000:[1371, 2207, 2876, 3423],
149100:[1372, 2208, 2878, 3425],
149200:[1373, 2210, 2879, 3427],
149300:[1374, 2211, 2881, 3429],
149400:[1375, 2212, 2883, 3431],
149500:[1376, 2214, 2885, 3433],
149600:[1376, 2215, 2886, 3435],
149700:[1377, 2216, 2888, 3437],
149800:[1378, 2218, 2890, 3439],
149900:[1379, 2219, 2892, 3441],
150000:[1380, 2220, 2893, 3443],
16000:[0, 0, 0, 0],
16100:[8, 8, 9, 10],
16200:[16, 17, 18, 19],
16300:[23, 25, 27, 29],
16400:[31, 34, 36, 39],
16500:[39, 42, 46, 49],
16600:[47, 50, 55, 58],
16700:[55, 59, 64, 68],
16800:[62, 67, 73, 78],
16900:[70, 76, 82, 87],
17000:[78, 84, 91, 97],
17100:[79, 89, 96, 102],
17200:[80, 93, 101, 108],
17300:[81, 98, 106, 113],
17400:[82, 102, 111, 118],
17500:[83, 107, 116, 124],
17600:[84, 111, 121, 129],
17700:[85, 116, 126, 135],
17800:[86, 121, 131, 140],
17900:[87, 125, 136, 145],
18000:[88, 130, 141, 151],
18100:[89, 134, 145, 156],
18200:[90, 138, 150, 160],
18300:[91, 142, 154, 165],
18400:[92, 146, 158, 170],
18500:[93, 150, 163, 174],
18600:[94, 154, 167, 179],
18700:[95, 158, 171, 184],
18800:[96, 162, 176, 188],
18900:[98, 166, 180, 193],
19000:[99, 171, 184, 197],
19100:[100, 175, 188, 202],
19200:[101, 179, 193, 206],
19300:[102, 183, 197, 211],
19400:[103, 187, 201, 215],
19500:[104, 191, 205, 220],
19600:[105, 195, 210, 224],
19700:[106, 199, 214, 229],
19800:[107, 203, 218, 234],
19900:[108, 207, 223, 238],
20000:[109, 211, 227, 243],
20100:[110, 215, 231, 248],
20200:[111, 219, 236, 252],
20300:[112, 223, 240, 257],
20400:[113, 227, 244, 261],
20500:[114, 231, 248, 266],
20600:[115, 235, 253, 270],
20700:[116, 239, 257, 275],
20800:[117, 243, 261, 279],
20900:[118, 247, 266, 284],
21000:[120, 251, 270, 289],
21100:[121, 255, 274, 294],
21200:[122, 259, 279, 298],
21300:[123, 263, 283, 303],
21400:[124, 267, 287, 307],
21500:[125, 271, 291, 312],
21600:[127, 275, 296, 316],
21700:[128, 279, 300, 321],
21800:[129, 283, 304, 325],
21900:[130, 287, 309, 330],
22000:[131, 291, 313, 335],
22100:[132, 295, 317, 340],
22200:[133, 299, 322, 344],
22300:[134, 303, 326, 349],
22400:[135, 307, 330, 353],
22500:[136, 311, 334, 358],
22600:[137, 315, 339, 362],
22700:[138, 319, 343, 367],
22800:[139, 323, 347, 371],
22900:[140, 327, 352, 376],
23000:[141, 331, 356, 381],
23100:[142, 335, 360, 386],
23200:[143, 339, 365, 391],
23300:[144, 344, 369, 396],
23400:[145, 348, 374, 400],
23500:[146, 352, 378, 405],
23600:[148, 356, 383, 410],
23700:[149, 361, 387, 415],
23800:[150, 365, 392, 420],
23900:[151, 369, 396, 425],
24000:[152, 373, 401, 430],
24100:[153, 377, 406, 435],
24200:[154, 381, 410, 440],
24300:[155, 386, 415, 445],
24400:[156, 390, 419, 450],
24500:[157, 394, 424, 454],
24600:[158, 398, 428, 459],
24700:[159, 403, 433, 464],
24800:[160, 407, 437, 469],
24900:[161, 411, 442, 474],
25000:[162, 415, 447, 479],
25100:[163, 419, 451, 483],
25200:[164, 422, 455, 487],
25300:[165, 426, 459, 492],
25400:[166, 429, 462, 496],
25500:[167, 433, 466, 500],
25600:[168, 436, 470, 504],
25700:[170, 440, 474, 508],
25800:[171, 443, 478, 512],
25900:[172, 447, 482, 517],
26000:[173, 451, 486, 521],
26100:[174, 451, 490, 525],
26200:[175, 452, 493, 529],
26300:[176, 452, 497, 533],
26400:[177, 453, 501, 537],
26500:[178, 453, 504, 541],
26600:[179, 453, 508, 545],
26700:[180, 454, 512, 549],
26800:[181, 454, 515, 553],
26900:[182, 455, 519, 557],
27000:[183, 455, 523, 561],
27100:[184, 455, 527, 565],
27200:[185, 456, 531, 569],
27300:[186, 456, 534, 573],
27400:[187, 456, 538, 577],
27500:[188, 457, 542, 581],
27600:[189, 457, 546, 585],
27700:[191, 457, 549, 589],
27800:[192, 458, 553, 593],
27900:[193, 458, 557, 597],
28000:[194, 458, 561, 601],
28100:[195, 458, 565, 605],
28200:[196, 459, 568, 609],
28300:[197, 459, 572, 613],
28400:[198, 460, 576, 617],
28500:[199, 460, 580, 621],
28600:[200, 461, 583, 625],
28700:[201, 461, 587, 629],
28800:[202, 461, 591, 633],
28900:[203, 462, 595, 636],
29000:[204, 462, 598, 640],
29100:[205, 463, 602, 644],
29200:[206, 464, 605, 648],
29300:[207, 464, 609, 652],
29400:[208, 465, 613, 656],
29500:[209, 466, 617, 660],
29600:[210, 467, 620, 664],
29700:[211, 468, 624, 668],
29800:[213, 468, 628, 672],
29900:[214, 469, 632, 676],
30000:[215, 470, 635, 680],
30100:[216, 471, 637, 684],
30200:[217, 471, 640, 688],
30300:[218, 472, 642, 692],
30400:[219, 473, 645, 696],
30500:[220, 474, 647, 700],
30600:[221, 474, 649, 704],
30700:[222, 475, 652, 708],
30800:[223, 476, 654, 712],
30900:[224, 477, 657, 716],
31000:[225, 477, 659, 720],
31100:[226, 478, 660, 724],
31200:[227, 479, 661, 728],
31300:[228, 479, 663, 732],
31400:[229, 480, 664, 736],
31500:[230, 481, 665, 740],
31600:[231, 482, 666, 744],
31700:[232, 482, 667, 748],
31800:[233, 483, 669, 752],
31900:[234, 484, 670, 756],
32000:[236, 485, 671, 760],
32100:[237, 486, 672, 764],
32200:[238, 486, 673, 768],
32300:[239, 487, 674, 771],
32400:[240, 487, 675, 775],
32500:[242, 488, 676, 779],
32600:[243, 489, 678, 783],
32700:[244, 489, 679, 787],
32800:[245, 490, 680, 790],
32900:[246, 490, 681, 794],
33000:[247, 491, 682, 798],
33100:[248, 492, 683, 802],
33200:[249, 492, 684, 805],
33300:[250, 493, 685, 809],
33400:[250, 494, 686, 813],
33500:[251, 494, 687, 816],
33600:[252, 495, 689, 820],
33700:[253, 496, 690, 824],
33800:[254, 496, 691, 827],
33900:[255, 497, 692, 831],
34000:[255, 498, 693, 835],
34100:[256, 499, 694, 839],
34200:[256, 500, 696, 842],
34300:[257, 501, 697, 846],
34400:[258, 502, 699, 849],
34500:[258, 503, 700, 853],
34600:[259, 504, 702, 857],
34700:[259, 506, 703, 860],
34800:[260, 507, 705, 864],
34900:[261, 508, 706, 867],
35000:[261, 509, 708, 871],
35100:[262, 511, 710, 873],
35200:[263, 512, 712, 876],
35300:[264, 514, 714, 878],
35400:[265, 515, 716, 880],
35500:[266, 517, 718, 883],
35600:[268, 518, 720, 885],
35700:[269, 520, 722, 887],
35800:[270, 521, 724, 890],
35900:[271, 523, 726, 892],
36000:[272, 525, 728, 894],
36100:[273, 527, 730, 897],
36200:[275, 529, 733, 899],
36300:[276, 531, 735, 902],
36400:[277, 533, 737, 905],
36500:[279, 534, 740, 907],
36600:[280, 536, 742, 910],
36700:[281, 538, 744, 912],
36800:[283, 540, 747, 915],
36900:[284, 542, 749, 918],
37000:[285, 544, 751, 920],
37100:[286, 546, 753, 923],
37200:[288, 548, 756, 925],
37300:[289, 550, 758, 928],
37400:[290, 552, 760, 931],
37500:[292, 553, 762, 933],
37600:[293, 555, 765, 936],
37700:[294, 557, 767, 939],
37800:[296, 559, 769, 941],
37900:[297, 561, 772, 944],
38000:[299, 563, 774, 947],
38100:[300, 565, 776, 950],
38200:[302, 567, 779, 952],
38300:[303, 569, 781, 955],
38400:[305, 571, 783, 958],
38500:[306, 572, 785, 960],
38600:[307, 574, 788, 963],
38700:[309, 576, 790, 966],
38800:[310, 578, 792, 969],
38900:[312, 580, 794, 971],
39000:[313, 582, 797, 974],
39100:[314, 584, 799, 977],
39200:[316, 586, 802, 979],
39300:[317, 588, 804, 982],
39400:[318, 590, 806, 985],
39500:[320, 591, 809, 987],
39600:[321, 593, 811, 990],
39700:[322, 595, 813, 992],
39800:[324, 597, 816, 995],
39900:[325, 599, 818, 998],
40000:[326, 601, 821, 1000],
40100:[327, 603, 823, 1003],
40200:[329, 605, 825, 1005],
40300:[330, 606, 828, 1008],
40400:[331, 608, 830, 1010],
40500:[333, 610, 832, 1013],
40600:[334, 612, 834, 1015],
40700:[335, 614, 837, 1018],
40800:[337, 615, 839, 1021],
40900:[338, 617, 841, 1023],
41000:[340, 619, 843, 1026],
41100:[341, 621, 845, 1029],
41200:[343, 623, 848, 1031],
41300:[344, 625, 850, 1034],
41400:[345, 626, 852, 1036],
41500:[347, 628, 854, 1039],
41600:[348, 630, 857, 1041],
41700:[349, 632, 859, 1044],
41800:[351, 634, 861, 1047],
41900:[352, 636, 864, 1049],
42000:[353, 638, 866, 1052],
42100:[354, 640, 868, 1055],
42200:[356, 642, 871, 1057],
42300:[357, 644, 873, 1060],
42400:[359, 646, 875, 1062],
42500:[360, 648, 878, 1065],
42600:[361, 649, 880, 1068],
42700:[363, 651, 882, 1070],
42800:[364, 653, 885, 1073],
42900:[366, 655, 887, 1075],
43000:[367, 657, 889, 1078],
43100:[369, 659, 891, 1081],
43200:[370, 661, 894, 1083],
43300:[372, 663, 896, 1086],
43400:[373, 665, 898, 1088],
43500:[375, 667, 901, 1091],
43600:[376, 669, 903, 1094],
43700:[378, 671, 905, 1096],
43800:[379, 672, 908, 1099],
43900:[381, 674, 910, 1101],
44000:[382, 676, 912, 1104],
44100:[383, 678, 914, 1107],
44200:[385, 680, 917, 1109],
44300:[386, 682, 919, 1112],
44400:[388, 684, 921, 1115],
44500:[389, 686, 924, 1117],
44600:[391, 688, 926, 1120],
44700:[392, 690, 928, 1123],
44800:[393, 692, 931, 1125],
44900:[395, 694, 933, 1128],
45000:[396, 696, 935, 1131],
45100:[397, 698, 937, 1134],
45200:[399, 700, 940, 1136],
45300:[400, 702, 942, 1139],
45400:[402, 704, 944, 1142],
45500:[403, 706, 947, 1144],
45600:[405, 708, 949, 1147],
45700:[406, 710, 951, 1149],
45800:[408, 712, 953, 1152],
45900:[409, 714, 956, 1155],
46000:[411, 715, 958, 1157],
46100:[412, 717, 960, 1159],
46200:[413, 718, 962, 1162],
46300:[414, 720, 964, 1164],
46400:[415, 721, 966, 1167],
46500:[416, 723, 968, 1169],
46600:[418, 725, 971, 1171],
46700:[419, 726, 973, 1174],
46800:[420, 728, 975, 1176],
46900:[421, 729, 977, 1179],
47000:[422, 731, 979, 1181],
47100:[423, 732, 981, 1183],
47200:[424, 734, 983, 1185],
47300:[425, 735, 985, 1188],
47400:[426, 737, 987, 1190],
47500:[427, 738, 989, 1192],
47600:[428, 740, 991, 1194],
47700:[429, 741, 993, 1196],
47800:[430, 743, 994, 1199],
47900:[431, 744, 996, 1201],
48000:[432, 746, 998, 1203],
48100:[433, 747, 1000, 1205],
48200:[434, 749, 1002, 1208],
48300:[435, 750, 1004, 1210],
48400:[436, 752, 1006, 1212],
48500:[437, 753, 1008, 1214],
48600:[438, 755, 1010, 1217],
48700:[439, 756, 1011, 1219],
48800:[440, 758, 1013, 1221],
48900:[441, 759, 1015, 1223],
49000:[442, 761, 1017, 1226],
49100:[443, 762, 1019, 1228],
49200:[444, 764, 1021, 1231],
49300:[445, 765, 1023, 1233],
49400:[446, 767, 1025, 1235],
49500:[447, 768, 1027, 1237],
49600:[448, 770, 1029, 1240],
49700:[449, 771, 1030, 1242],
49800:[450, 773, 1032, 1244],
49900:[451, 774, 1034, 1247],
50000:[451, 776, 1036, 1249],
50100:[452, 778, 1038, 1251],
50200:[453, 779, 1040, 1254],
50300:[454, 781, 1042, 1256],
50400:[455, 782, 1044, 1258],
50500:[456, 784, 1046, 1260],
50600:[457, 785, 1048, 1263],
50700:[458, 787, 1050, 1265],
50800:[459, 789, 1052, 1267],
50900:[460, 790, 1054, 1270],
51000:[461, 792, 1056, 1272],
51100:[462, 794, 1058, 1274],
51200:[463, 795, 1060, 1277],
51300:[464, 797, 1062, 1279],
51400:[465, 798, 1064, 1281],
51500:[466, 800, 1066, 1284],
51600:[467, 801, 1068, 1286],
51700:[468, 803, 1070, 1289],
51800:[469, 804, 1072, 1291],
51900:[470, 806, 1074, 1293],
52000:[471, 807, 1076, 1296],
52100:[472, 809, 1078, 1298],
52200:[473, 810, 1080, 1301],
52300:[474, 812, 1082, 1303],
52400:[475, 813, 1084, 1305],
52500:[476, 815, 1086, 1308],
52600:[477, 817, 1088, 1310],
52700:[478, 818, 1090, 1312],
52800:[479, 820, 1092, 1315],
52900:[480, 821, 1094, 1317],
53000:[481, 823, 1096, 1319],
53100:[482, 825, 1098, 1321],
53200:[483, 826, 1100, 1324],
53300:[484, 828, 1102, 1326],
53400:[485, 829, 1104, 1328],
53500:[486, 831, 1106, 1331],
53600:[487, 832, 1108, 1333],
53700:[488, 834, 1110, 1335],
53800:[489, 835, 1112, 1338],
53900:[490, 837, 1114, 1340],
54000:[491, 838, 1116, 1343],
54100:[492, 839, 1118, 1345],
54200:[493, 841, 1120, 1347],
54300:[494, 842, 1121, 1350],
54400:[495, 843, 1123, 1352],
54500:[495, 845, 1125, 1354],
54600:[496, 846, 1127, 1356],
54700:[497, 848, 1129, 1358],
54800:[498, 849, 1130, 1360],
54900:[499, 850, 1132, 1363],
55000:[500, 852, 1134, 1365],
55100:[501, 853, 1136, 1367],
55200:[502, 855, 1138, 1369],
55300:[503, 856, 1139, 1371],
55400:[503, 858, 1141, 1373],
55500:[504, 859, 1143, 1376],
55600:[505, 861, 1145, 1378],
55700:[506, 862, 1146, 1380],
55800:[507, 864, 1148, 1382],
55900:[508, 865, 1150, 1384],
56000:[509, 867, 1152, 1386],
56100:[510, 868, 1154, 1388],
56200:[511, 870, 1156, 1390],
56300:[512, 871, 1158, 1392],
56400:[512, 873, 1159, 1395],
56500:[513, 874, 1161, 1397],
56600:[514, 876, 1163, 1399],
56700:[515, 877, 1165, 1401],
56800:[516, 878, 1167, 1403],
56900:[517, 880, 1169, 1405],
57000:[518, 881, 1171, 1408],
57100:[519, 882, 1173, 1410],
57200:[520, 884, 1175, 1412],
57300:[521, 885, 1176, 1414],
57400:[522, 887, 1178, 1416],
57500:[523, 888, 1180, 1419],
57600:[524, 889, 1182, 1421],
57700:[525, 891, 1184, 1423],
57800:[526, 892, 1186, 1425],
57900:[527, 894, 1187, 1427],
58000:[528, 895, 1189, 1429],
58100:[529, 896, 1191, 1431],
58200:[530, 898, 1193, 1433],
58300:[531, 899, 1194, 1435],
58400:[532, 901, 1196, 1438],
58500:[533, 902, 1198, 1440],
58600:[534, 903, 1200, 1442],
58700:[535, 905, 1202, 1444],
58800:[536, 906, 1203, 1446],
58900:[536, 908, 1205, 1448],
59000:[537, 909, 1207, 1451],
59100:[538, 910, 1209, 1453],
59200:[539, 912, 1211, 1455],
59300:[540, 913, 1212, 1458],
59400:[541, 915, 1214, 1460],
59500:[542, 916, 1216, 1462],
59600:[543, 917, 1218, 1464],
59700:[544, 919, 1219, 1466],
59800:[544, 920, 1221, 1469],
59900:[545, 921, 1223, 1471],
60000:[546, 923, 1225, 1473],
60100:[547, 924, 1227, 1475],
60200:[548, 926, 1229, 1477],
60300:[549, 927, 1231, 1479],
60400:[550, 929, 1232, 1482],
60500:[551, 930, 1234, 1484],
60600:[552, 932, 1236, 1486],
60700:[552, 933, 1238, 1488],
60800:[553, 935, 1240, 1490],
60900:[554, 936, 1242, 1492],
61000:[555, 938, 1244, 1494],
61100:[556, 939, 1246, 1496],
61200:[557, 941, 1248, 1498],
61300:[558, 942, 1250, 1501],
61400:[559, 944, 1251, 1503],
61500:[560, 945, 1253, 1505],
61600:[560, 947, 1255, 1507],
61700:[561, 948, 1257, 1509],
61800:[562, 950, 1259, 1512],
61900:[563, 951, 1261, 1514],
62000:[564, 952, 1262, 1516],
62100:[565, 953, 1264, 1518],
62200:[566, 955, 1266, 1520],
62300:[567, 956, 1268, 1523],
62400:[568, 958, 1270, 1525],
62500:[568, 959, 1271, 1527],
62600:[569, 960, 1273, 1529],
62700:[570, 962, 1275, 1532],
62800:[571, 963, 1277, 1534],
62900:[572, 965, 1279, 1536],
63000:[573, 966, 1281, 1538],
63100:[574, 967, 1283, 1540],
63200:[575, 969, 1285, 1542],
63300:[576, 970, 1287, 1545],
63400:[577, 972, 1288, 1547],
63500:[578, 973, 1290, 1549],
63600:[579, 975, 1292, 1551],
63700:[580, 976, 1294, 1554],
63800:[581, 978, 1296, 1556],
63900:[582, 979, 1298, 1558],
64000:[583, 981, 1299, 1560],
64100:[584, 982, 1301, 1562],
64200:[585, 984, 1303, 1564],
64300:[586, 985, 1305, 1567],
64400:[587, 987, 1307, 1569],
64500:[588, 988, 1308, 1571],
64600:[589, 990, 1310, 1573],
64700:[589, 991, 1312, 1576],
64800:[590, 992, 1314, 1578],
64900:[591, 994, 1316, 1580],
65000:[592, 995, 1318, 1582],
65100:[593, 996, 1320, 1584],
65200:[594, 998, 1322, 1586],
65300:[595, 999, 1323, 1589],
65400:[596, 1001, 1325, 1591],
65500:[596, 1002, 1327, 1593],
65600:[597, 1004, 1329, 1595],
65700:[598, 1005, 1331, 1598],
65800:[599, 1007, 1333, 1600],
65900:[600, 1008, 1334, 1602],
66000:[601, 1010, 1336, 1604],
66100:[602, 1011, 1338, 1606],
66200:[603, 1013, 1340, 1608],
66300:[604, 1014, 1342, 1611],
66400:[605, 1016, 1343, 1613],
66500:[606, 1017, 1345, 1615],
66600:[607, 1019, 1347, 1617],
66700:[608, 1020, 1349, 1620],
66800:[609, 1021, 1351, 1622],
66900:[610, 1023, 1353, 1624],
67000:[611, 1024, 1355, 1626],
67100:[612, 1026, 1357, 1628],
67200:[613, 1027, 1359, 1631],
67300:[614, 1029, 1361, 1633],
67400:[615, 1030, 1363, 1635],
67500:[616, 1032, 1365, 1637],
67600:[617, 1033, 1367, 1640],
67700:[618, 1035, 1369, 1642],
67800:[619, 1036, 1371, 1644],
67900:[620, 1038, 1373, 1647],
68000:[621, 1040, 1375, 1649],
68100:[622, 1042, 1377, 1651],
68200:[623, 1043, 1379, 1654],
68300:[624, 1045, 1381, 1656],
68400:[625, 1046, 1383, 1658],
68500:[626, 1048, 1385, 1660],
68600:[627, 1049, 1387, 1663],
68700:[628, 1051, 1389, 1665],
68800:[629, 1052, 1391, 1667],
68900:[629, 1054, 1393, 1669],
69000:[630, 1055, 1395, 1672],
69100:[631, 1057, 1397, 1674],
69200:[632, 1058, 1399, 1677],
69300:[633, 1060, 1401, 1679],
69400:[634, 1061, 1403, 1681],
69500:[635, 1063, 1405, 1684],
69600:[636, 1064, 1407, 1686],
69700:[637, 1066, 1409, 1689],
69800:[638, 1067, 1411, 1691],
69900:[639, 1069, 1413, 1693],
70000:[640, 1070, 1414, 1696],
70100:[641, 1071, 1416, 1698],
70200:[642, 1073, 1418, 1701],
70300:[643, 1074, 1420, 1703],
70400:[644, 1076, 1422, 1705],
70500:[645, 1077, 1424, 1708],
70600:[646, 1079, 1426, 1710],
70700:[647, 1080, 1428, 1712],
70800:[648, 1082, 1430, 1715],
70900:[649, 1083, 1432, 1717],
71000:[650, 1085, 1434, 1719],
71100:[651, 1087, 1436, 1721],
71200:[652, 1088, 1438, 1724],
71300:[653, 1090, 1440, 1726],
71400:[654, 1091, 1442, 1728],
71500:[655, 1093, 1444, 1731],
71600:[656, 1094, 1446, 1733],
71700:[657, 1096, 1448, 1735],
71800:[658, 1098, 1449, 1738],
71900:[659, 1099, 1451, 1740],
72000:[660, 1101, 1453, 1742],
72100:[661, 1103, 1455, 1744],
72200:[662, 1104, 1457, 1747],
72300:[663, 1106, 1459, 1749],
72400:[664, 1107, 1461, 1751],
72500:[665, 1109, 1463, 1754],
72600:[666, 1110, 1465, 1756],
72700:[667, 1112, 1467, 1758],
72800:[668, 1113, 1469, 1761],
72900:[669, 1115, 1471, 1763],
73000:[670, 1116, 1473, 1765],
73100:[671, 1118, 1475, 1767],
73200:[672, 1119, 1477, 1770],
73300:[673, 1121, 1479, 1772],
73400:[674, 1122, 1481, 1774],
73500:[675, 1124, 1483, 1777],
73600:[676, 1125, 1484, 1779],
73700:[677, 1127, 1486, 1781],
73800:[678, 1128, 1488, 1783],
73900:[678, 1130, 1490, 1786],
74000:[679, 1131, 1492, 1788],
74100:[680, 1132, 1494, 1790],
74200:[681, 1134, 1496, 1793],
74300:[682, 1135, 1498, 1795],
74400:[683, 1137, 1500, 1797],
74500:[684, 1138, 1502, 1799],
74600:[685, 1140, 1504, 1802],
74700:[686, 1141, 1506, 1804],
74800:[687, 1143, 1508, 1806],
74900:[688, 1144, 1510, 1809],
75000:[689, 1146, 1512, 1811],
75100:[690, 1148, 1514, 1813],
75200:[691, 1149, 1516, 1816],
75300:[692, 1151, 1518, 1818],
75400:[693, 1152, 1520, 1820],
75500:[694, 1154, 1522, 1822],
75600:[695, 1155, 1524, 1825],
75700:[696, 1157, 1526, 1827],
75800:[697, 1159, 1528, 1829],
75900:[698, 1160, 1530, 1831],
76000:[699, 1162, 1532, 1834],
76100:[700, 1164, 1534, 1836],
76200:[701, 1165, 1536, 1839],
76300:[702, 1167, 1538, 1841],
76400:[703, 1168, 1540, 1843],
76500:[704, 1170, 1542, 1846],
76600:[705, 1171, 1544, 1848],
76700:[706, 1173, 1546, 1851],
76800:[707, 1174, 1548, 1853],
76900:[708, 1176, 1549, 1855],
77000:[709, 1177, 1551, 1858],
77100:[710, 1179, 1553, 1860],
77200:[711, 1180, 1555, 1863],
77300:[712, 1182, 1557, 1865],
77400:[713, 1183, 1559, 1867],
77500:[714, 1185, 1561, 1870],
77600:[715, 1186, 1563, 1872],
77700:[716, 1188, 1565, 1874],
77800:[717, 1189, 1567, 1877],
77900:[718, 1191, 1569, 1879],
78000:[719, 1192, 1571, 1881],
78100:[720, 1194, 1573, 1883],
78200:[721, 1195, 1575, 1886],
78300:[722, 1197, 1577, 1888],
78400:[723, 1198, 1579, 1890],
78500:[724, 1200, 1581, 1893],
78600:[725, 1201, 1583, 1895],
78700:[726, 1203, 1584, 1897],
78800:[727, 1204, 1586, 1900],
78900:[728, 1206, 1588, 1902],
79000:[728, 1207, 1590, 1904],
79100:[729, 1208, 1592, 1906],
79200:[730, 1210, 1594, 1909],
79300:[731, 1211, 1596, 1911],
79400:[732, 1213, 1598, 1913],
79500:[733, 1214, 1600, 1916],
79600:[734, 1216, 1602, 1918],
79700:[735, 1217, 1604, 1920],
79800:[736, 1219, 1606, 1923],
79900:[737, 1220, 1608, 1925],
80000:[738, 1222, 1610, 1927],
80100:[739, 1224, 1612, 1929],
80200:[740, 1225, 1614, 1932],
80300:[741, 1227, 1616, 1934],
80400:[742, 1228, 1618, 1936],
80500:[743, 1230, 1620, 1939],
80600:[744, 1231, 1622, 1941],
80700:[745, 1233, 1624, 1943],
80800:[746, 1234, 1626, 1945],
80900:[747, 1236, 1628, 1948],
81000:[748, 1238, 1630, 1950],
81100:[749, 1240, 1632, 1952],
81200:[750, 1241, 1634, 1955],
81300:[751, 1243, 1636, 1957],
81400:[752, 1244, 1638, 1959],
81500:[753, 1246, 1640, 1961],
81600:[754, 1247, 1642, 1964],
81700:[755, 1249, 1644, 1966],
81800:[756, 1250, 1646, 1968],
81900:[757, 1252, 1648, 1971],
82000:[758, 1253, 1649, 1973],
82100:[759, 1255, 1651, 1975],
82200:[760, 1256, 1653, 1978],
82300:[761, 1258, 1655, 1980],
82400:[762, 1259, 1657, 1982],
82500:[763, 1261, 1659, 1984],
82600:[764, 1262, 1661, 1987],
82700:[765, 1264, 1663, 1989],
82800:[765, 1265, 1665, 1991],
82900:[766, 1267, 1667, 1993],
83000:[767, 1268, 1669, 1996],
83100:[768, 1269, 1671, 1998],
83200:[769, 1271, 1673, 2001],
83300:[770, 1272, 1675, 2003],
83400:[771, 1274, 1677, 2005],
83500:[772, 1275, 1679, 2008],
83600:[773, 1277, 1681, 2010],
83700:[774, 1278, 1683, 2013],
83800:[775, 1280, 1684, 2015],
83900:[776, 1281, 1686, 2017],
84000:[777, 1283, 1688, 2020],
84100:[778, 1285, 1690, 2022],
84200:[779, 1286, 1692, 2025],
84300:[780, 1288, 1694, 2027],
84400:[781, 1289, 1696, 2029],
84500:[782, 1291, 1698, 2032],
84600:[783, 1292, 1700, 2034],
84700:[784, 1294, 1702, 2036],
84800:[785, 1295, 1704, 2039],
84900:[786, 1297, 1706, 2041],
85000:[787, 1299, 1708, 2043],
85100:[788, 1301, 1710, 2045],
85200:[789, 1302, 1712, 2048],
85300:[790, 1304, 1714, 2050],
85400:[791, 1305, 1716, 2052],
85500:[792, 1307, 1718, 2055],
85600:[793, 1308, 1719, 2057],
85700:[794, 1310, 1721, 2059],
85800:[795, 1311, 1723, 2062],
85900:[796, 1313, 1725, 2064],
86000:[797, 1314, 1727, 2066],
86100:[798, 1316, 1729, 2068],
86200:[799, 1317, 1731, 2071],
86300:[800, 1319, 1733, 2073],
86400:[801, 1320, 1735, 2075],
86500:[802, 1322, 1737, 2078],
86600:[803, 1323, 1739, 2080],
86700:[804, 1325, 1741, 2082],
86800:[805, 1326, 1743, 2085],
86900:[806, 1328, 1745, 2087],
87000:[807, 1329, 1747, 2089],
87100:[808, 1330, 1749, 2091],
87200:[809, 1332, 1751, 2094],
87300:[810, 1333, 1753, 2096],
87400:[811, 1335, 1755, 2098],
87500:[812, 1336, 1757, 2101],
87600:[813, 1338, 1759, 2103],
87700:[814, 1339, 1761, 2105],
87800:[814, 1341, 1763, 2107],
87900:[815, 1342, 1765, 2110],
88000:[816, 1344, 1767, 2112],
88100:[817, 1346, 1769, 2114],
88200:[818, 1347, 1771, 2117],
88300:[819, 1349, 1773, 2119],
88400:[820, 1350, 1775, 2121],
88500:[821, 1352, 1777, 2123],
88600:[822, 1353, 1779, 2126],
88700:[823, 1355, 1781, 2128],
88800:[824, 1357, 1783, 2130],
88900:[825, 1358, 1784, 2133],
89000:[826, 1360, 1786, 2135],
89100:[827, 1362, 1788, 2137],
89200:[828, 1363, 1790, 2140],
89300:[829, 1365, 1792, 2142],
89400:[830, 1366, 1794, 2144],
89500:[831, 1368, 1796, 2146],
89600:[832, 1369, 1798, 2149],
89700:[833, 1371, 1800, 2151],
89800:[834, 1372, 1802, 2153],
89900:[835, 1374, 1804, 2155],
90000:[836, 1375, 1806, 2158],
90100:[837, 1377, 1808, 2160],
90200:[838, 1378, 1810, 2163],
90300:[839, 1380, 1812, 2165],
90400:[840, 1381, 1814, 2167],
90500:[841, 1383, 1816, 2170],
90600:[842, 1384, 1818, 2172],
90700:[843, 1386, 1819, 2175],
90800:[844, 1387, 1821, 2177],
90900:[845, 1389, 1823, 2179],
91000:[846, 1390, 1825, 2182],
91100:[847, 1391, 1827, 2184],
91200:[848, 1393, 1829, 2187],
91300:[849, 1394, 1831, 2189],
91400:[850, 1396, 1833, 2191],
91500:[851, 1397, 1835, 2194],
91600:[852, 1399, 1837, 2196],
91700:[853, 1400, 1839, 2198],
91800:[854, 1402, 1841, 2201],
91900:[855, 1403, 1843, 2203],
92000:[856, 1405, 1845, 2205],
92100:[857, 1406, 1847, 2207],
92200:[858, 1408, 1849, 2210],
92300:[859, 1409, 1851, 2212],
92400:[860, 1411, 1853, 2214],
92500:[861, 1412, 1855, 2217],
92600:[862, 1414, 1857, 2219],
92700:[863, 1415, 1859, 2221],
92800:[864, 1417, 1861, 2224],
92900:[864, 1418, 1863, 2226],
93000:[865, 1420, 1865, 2228],
93100:[866, 1422, 1867, 2230],
93200:[867, 1423, 1869, 2233],
93300:[868, 1425, 1871, 2235],
93400:[869, 1426, 1873, 2237],
93500:[870, 1428, 1875, 2240],
93600:[871, 1429, 1877, 2242],
93700:[872, 1431, 1879, 2244],
93800:[873, 1432, 1881, 2247],
93900:[874, 1434, 1883, 2249],
94000:[875, 1436, 1884, 2251],
94100:[876, 1438, 1886, 2253],
94200:[877, 1439, 1888, 2256],
94300:[878, 1441, 1890, 2258],
94400:[879, 1442, 1892, 2260],
94500:[880, 1444, 1894, 2263],
94600:[881, 1445, 1896, 2265],
94700:[882, 1447, 1898, 2267],
94800:[883, 1448, 1900, 2269],
94900:[884, 1450, 1902, 2272],
95000:[885, 1451, 1904, 2274],
95100:[886, 1453, 1906, 2276],
95200:[887, 1454, 1908, 2279],
95300:[888, 1456, 1910, 2281],
95400:[889, 1457, 1912, 2283],
95500:[890, 1459, 1914, 2285],
95600:[891, 1460, 1916, 2288],
95700:[892, 1462, 1918, 2290],
95800:[893, 1463, 1919, 2292],
95900:[894, 1465, 1921, 2295],
96000:[895, 1466, 1923, 2297],
96100:[896, 1467, 1925, 2299],
96200:[897, 1469, 1927, 2302],
96300:[898, 1470, 1929, 2304],
96400:[899, 1472, 1931, 2306],
96500:[900, 1473, 1933, 2308],
96600:[901, 1475, 1935, 2311],
96700:[902, 1476, 1937, 2313],
96800:[903, 1478, 1939, 2315],
96900:[904, 1479, 1941, 2317],
97000:[905, 1481, 1943, 2320],
97100:[906, 1483, 1945, 2322],
97200:[907, 1484, 1947, 2325],
97300:[908, 1486, 1949, 2327],
97400:[909, 1487, 1951, 2329],
97500:[910, 1489, 1953, 2332],
97600:[911, 1490, 1954, 2334],
97700:[912, 1492, 1956, 2337],
97800:[913, 1493, 1958, 2339],
97900:[913, 1495, 1960, 2341],
98000:[914, 1497, 1962, 2344],
98100:[915, 1499, 1964, 2346],
98200:[916, 1500, 1966, 2349],
98300:[917, 1502, 1968, 2351],
98400:[918, 1503, 1970, 2353],
98500:[919, 1505, 1972, 2356],
98600:[920, 1506, 1974, 2358],
98700:[921, 1508, 1976, 2360],
98800:[922, 1509, 1978, 2363],
98900:[923, 1511, 1980, 2365],
99000:[924, 1512, 1982, 2367],
99100:[925, 1514, 1984, 2369],
99200:[926, 1515, 1986, 2372],
99300:[927, 1517, 1988, 2374],
99400:[928, 1518, 1990, 2376],
99500:[929, 1520, 1992, 2379],
99600:[930, 1521, 1994, 2381],
99700:[931, 1523, 1996, 2383],
99800:[932, 1524, 1998, 2386],
99900:[933, 1526, 2000, 2388],
};
const OR_YT=[0.9, 1.32, 1.74, 2.02];

const TABLES_2025 = {
  AB: T_AB,
  BC: T_BC,
  MB: T_MB,
  NB: T_NB,
  NL: T_NL,
  NS: T_NS,
  NT: T_NT,
  NU: T_NU,
  ON: T_ON,
  PE: T_PE,
  SK: T_SK,
  YT: T_YT,
};

const OVER_RATES_2025 = {
  AB: OR_AB,
  BC: OR_BC,
  MB: OR_MB,
  NB: OR_NB,
  NL: OR_NL,
  NS: OR_NS,
  NT: OR_NT,
  NU: OR_NU,
  ON: OR_ON,
  PE: OR_PE,
  SK: OR_SK,
  YT: OR_YT,
};

function lookupCSG2025(prov, numChildren, annualIncome) {
  if(prov === "QC") return null;
  const table = TABLES_2025[prov];
  const overRates = OVER_RATES_2025[prov];
  if(!table || !overRates) return null;
  if(annualIncome < 16000) return 0;
  const idx = Math.min(numChildren - 1, 3);
  if(annualIncome <= 150000) {
    const bracket = Math.floor(annualIncome / 100) * 100;
    const row = table[bracket];
    const nextRow = table[bracket + 100];
    if(!row) return null;
    if(!nextRow) return row[idx];
    const frac = (annualIncome - bracket) / 100;
    const val = row[idx] + (nextRow[idx] - row[idx]) * frac;
    if(numChildren >= 5) {
      const inc34 = row[3] - row[2];
      return Math.round(val + inc34 * (numChildren - 4) * 0.85);
    }
    return Math.round(val);
  } else {
    // Over $150,000: base + rate% of excess (rate is monthly %, per official table note)
    const t150 = table[150000];
    if(!t150) return null;
    const base = t150[idx];
    const excess = annualIncome - 150000;
    const rate = overRates[Math.min(numChildren - 1, 3)];
    return Math.round(base + (rate / 100) * excess);
  }
}

export { lookupCSG2025, TABLES_2025, OVER_RATES_2025, T_AB, T_BC, T_MB, T_NB, T_NL, T_NS, T_NT, T_NU, T_ON, T_PE, T_SK, T_YT };